export const casinoHome = {
  sports: {
    Cricket: {
      href: "/exchange/Cricket",
      code: "",
      casino: "",
      provider: "Exchange",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/sports/cricket.webp",
      alt: "Cricket",
      name: "Cricket",
    },
    Soccer: {
      href: "/exchange/Soccer",
      code: "",
      casino: "",
      provider: "Exchange",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/sports/football.webp",
      alt: "Football",
      name: "Football",
    },
    Tennis: {
      href: "/exchange/Tennis",
      code: "",
      casino: "",
      provider: "Exchange",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/sports/tennis.webp",
      alt: "Tennis",
      name: "Tennis",
    },
    Horse: {
      href: "/exchange/Horse racing",
      code: "",
      casino: "",
      provider: "Exchange",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/sports/horse.webp",
      alt: "Horse Racing",
      name: "Horse Racing",
    },
    Greyhound: {
      href: "/exchange/Greyhound Racing",
      code: "",
      casino: "",
      provider: "Exchange",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/sports/greyhound.webp",
      alt: "Greyhound Racing",
      name: "Greyhound Racing",
    },
  },

  liveCasino: {
    BlackjackA: {
      href: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/blackjack-a.webp",
      alt: "Blackjack A",
      name: "Blackjack A",
    },
    DragonTiger: {
      href: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/dragon-tiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    // Cards32: {
    //   href: "/casino/aggapmac88gaming-32-cards",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/32cards.webp",
    //   alt: "32 Cards",
    //   name: "32 Cards",
    // },
    // SuperOver: {
    //   href: "/casino/aggapmac88gaming-super-over",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/SuperOver.webp",
    //   alt: "Super Over",
    //   name: "Super Over",
    // },
    // SicBo: {
    //   href: "/casino/aggapmac88gaming-sic-bo",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/SicBo.webp",
    //   alt: "Sic Bo",
    //   name: "Sic Bo",
    // },
    // Baccarat: {
    //   href: "/casino/aggapmac88gaming-baccarat-one-day",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/Baccarat-mac88.webp",
    //   alt: "Baccarat",
    //   name: "Baccarat",
    // },
    // Roulette: {
    //   href: "/casino/aggapmac88gaming-roulette",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "roulette",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/livecasino/Roulette-mac88.webp",
    //   alt: "Roulette",
    //   name: "Roulette",
    // },
    // Poker1Day: {
    //   href: "/casino/aggapmac88gaming-poker-1-day",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/Poker1Day.webp",
    //   alt: "Poker 1-Day",
    //   name: "Poker 1-Day",
    // },
    // Day1DragonTiger: {
    //   href: "/casino/aggapmac88gaming-1-day-dragon-tiger",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/1DayDragonTiger.webp",
    //   alt: "1 Day Dragon Tiger",
    //   name: "1 Day Dragon Tiger",
    // },
    LightningRoulette: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/lightning-roulette.webp",
      alt: "Lightning Roulette",
      name: "Lightning Roulette",
    },
    // SuperAndarBahar: {
    //   href: "/casino/aggapevolutiongaming-super-andar-bahar",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/super-andar-bahar.webp",
    //   alt: "Super Andar Bahar",
    //   name: "Super Andar Bahar",
    // },
    BacBo: {
      href: "/casino/ezgevo-bac-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/bac-bo.webp",
      alt: "Bac Bo",
      name: "Bac Bo",
    },
    CrazyTime: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/crazy-time.webp",
      alt: "Crazy Time",
      name: "Crazy Time",
    },
  },

  topGames: {
    // TowerX: {
    //   href: "/casino/aggapsmartsoftgaming-towerx",
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Evolution",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/topgames/TowerX.webp",
    //   alt: "TowerX",
    //   name: "TowerX",
    // },

    DragonTiger: {
      href: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/dragon-tiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    // Teenpatti2020: {
    //   href: "/casino/aggapmac88gaming-20-20-teenpatti",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "./images/casino-home/topgames/newTopGameImages/Teenpatti2020.webp",
    //   alt: "20-20 Teenpatti",
    //   name: "Teen patti 20-20",
    // },
    // Lucky7: {
    //   href: "/casino/aggapmac88gaming-lucky7",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lucky7",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/newTopGameImages/Lucky7.webp",
    //   alt: "Lucky 7",
    //   name: "Lucky 7",
    // },
    // SuperOver: {
    //   href: "/casino/aggapmac88gaming-super-over-u5188",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "poker",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/Super-Over.webp",
    //   alt: "Super Over",
    //   name: "Super Over",
    // },
    // Poker2020: {
    //   href: "/casino/aggapmac88gaming-poker-20-20",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "poker",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/newTopGameImages/2020Poker.webp",
    //   alt: "Poker 20-20",
    //   name: "Poker 20-20",
    // },
    // Lottery: {
    //   href: "/casino/aggapmac88gaming-lottery",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/Lottery-mac88.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // TestTeenpatti: {
    //   href: "/casino/aggapmac88gaming-test-teenpatti",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "./images/casino-home/topgames/newTopGameImages/TestTeenpatti.webp",
    //   alt: "Test Teenpatti",
    //   name: "Test Teenpatti",
    // },
    // VRTrio: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-trio",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "others",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/Trio.webp",
    //   alt: "VR Trio",
    //   name: "VR Trio",
    // },
    // VR29cardbacarrat: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "baccarat",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/newTopGameImages/29Baccarat.webp",
    //   alt: "VR 29 card bacarrat",
    //   name: "VR 29 card baccarat",
    // },
    // Player6Poker: {
    //   href: "/casino/aggapmac88gaming-6-player-poker",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "poker",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/newTopGameImages/6PlayerPoker.webp",
    //   alt: "6 Player Poker",
    //   name: "6 Player Poker",
    // },
    // OneDayBaccarat: {
    //   href: "/casino/aggapmac88gaming-baccarat-one-day",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "./images/casino-home/topgames/newTopGameImages/1DayBaccarat.webp",
    //   alt: "Baccarat",
    //   name: "1 day Baccarat",
    // },
    // VRDragonTiger: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragontiger",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/newTopGameImages/DragonTiger.webp",
    //   alt: "VR Dragon Tiger",
    //   name: "VR Dragon Tiger",
    // },
    // VR2CardTP: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "teenpatti",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "/images/casino-home/topgames/newTopGameImages/2CardTeenpatti.webp",
    //   alt: "VR 2 Card TP",
    //   name: "VR 2 Card TP",
    // },
    // VRPoker: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-poker",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "poker",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/Poker.webp",
    //   alt: "VR Poker",
    //   name: "VR Poker",
    // },
    // VRAutoRoulette: {
    //   href: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "roulette",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/topgames/AutoRoulette.webp",
    //   alt: "VR Auto Roulette",
    //   name: "VR Auto Roulette",
    // },
  },

  trendingNow: {
    aviator: {
      href: "/casino/spribe/aviator",
      code: "",
      casino: "spribe",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/trending/aviatornewi.webp",
      alt: "Aviator",
      name: "Aviator",
    },
    // ColorPrediction: {
    //   href: "/casino/aggapjiligaming-color-prediction",
    //   code: "",
    //   casino: "Jili",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/colorpredictioni.webp",
    //   alt: "Color Prediction",
    //   name: "Color Prediction",
    // },
    // chickenroad1: {
    //   href: "/casino/aggapinoutgames-chicken-road",
    //   code: "",
    //   casino: "spribe",
    //   provider: "spribe",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/chicken.webp",
    //   alt: "Chicken Road",
    //   name: "Chicken Road",
    // },
    // chickenroad2: {
    //   href: "/casino/aggapinoutgames-chicken-road-2",
    //   code: "",
    //   casino: "spribe",
    //   provider: "spribe",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/chicken2.webp",
    //   alt: "Chicken Road 2",
    //   name: "Chicken Road 2",
    // },
    // Mines: {
    //   href: "/casino/aggapmac88gamingvirtual-mines",
    //   code: "",
    //   casino: "ALT_GAMING_GAP",
    //   provider: "mac88",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/minesnewi.webp",
    //   alt: "Mines",
    //   name: "Mines",
    // },
    // plinko: {
    //   href: "/casino/aggapmac88gamingvirtual-plinko",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/plinkonewi.webp",
    //   alt: "Plinko",
    //   name: "Plinko",
    // },
    // limbo: {
    //   href: "/casino/aggapmac88gamingvirtual-limbo",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/limbo.webp",
    //   alt: "Limbo",
    //   name: "Limbo",
    // },
    EZMarbleRace: {
      href: "/casino/ezg-ez-marble-race-monaco",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/trending/marbel-race.webp",
      alt: "EZ Marble Race Monaco",
      name: "EZ Marble Race Monaco",
    },
    // BetWithStreamers: {
    //   href: "/casino/ezg-bet-with-streamers",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/betwith-streamer.webp",
    //   alt: "Bet With Streamers",
    //   name: "Bet With Streamers",
    // },
    // Vortex: {
    //   href: "/casino/aggapmac88gamingvirtual-vortex",
    //   code: "",
    //   casino: "Mac88 Gaming Virtual",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/vortex.webp",
    //   alt: "Vortex",
    //   name: "Vortex",
    // },
    // Dice: {
    //   href: "/casino/aggapmac88gamingvirtual-dice",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/dice.webp",
    //   alt: "Dice",
    //   name: "Dice",
    // },
    // Diamonds: {
    //   href: "/casino/aggapmac88gamingvirtual-diamonds",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/diamonds.webp",
    //   alt: "Diamonds",
    //   name: "Diamonds",
    // },
    // Pushpa: {
    //   href: "/casino/aggapcrash88gaming-pushpa",
    //   code: "",
    //   casino: "CRASH88 Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/pushpa.webp",
    //   alt: "Pushpa",
    //   name: "Pushpa",
    // },

    // pappu: {
    //   href: "/casino/aggapjiligaming-pappu",
    //   code: "",
    //   casino: "spribe",
    //   provider: "spribe",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/pappu.webp",
    //   alt: "Pappu",
    //   name: "Pappu",
    // },
    // HiLowMini: {
    //   href: "/casino/aggapyuvigames-hi-low-mini",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/HiLowMini.webp",
    //   alt: "Hi Low Mini",
    //   name: "Hi Low Mini",
    // },
    miniRoulette: {
      href: "/casino/spribe/miniroulette",
      code: "miniroulette",
      casino: "spribe",
      provider: "miniroulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/trending/mini-roulette.webp",
      alt: "mini roulette",
      name: "Mini Roulette",
    },

    CockFightPHI: {
      href: "/casino/awc-cock-fight-phi",
      code: "",
      casino: "AE Sexy",
      provider: "WorldCasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/trending/cock-fight-phi.webp",
      alt: "Cock Fight PHI",
      name: "Cock Fight PHI",
    },
    // Hamsta: {
    //   href: "/casino/aggapturbogames-hamsta-u1400",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Hamsta.webp",
    //   alt: "Hamsta",
    //   name: "Hamsta",
    // },
    // JewelClicker: {
    //   href: "/casino/aggapturbogames-jewel-clicker-u7152",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/JewelClicker.webp",
    //   alt: "Jewel Clicker",
    //   name: "Jewel Clicker",
    // },
    // rockPaperScissors: {
    //   href: "/casino/aggapcrash88gaming-rock-paper-scissors",
    //   code: "",
    //   casino: "CRASH88",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/rock-paper-scissors.webp",
    //   alt: "Rock Paper Scissors",
    //   name: "Rock Paper Scissors",
    // },
    // MineIsland: {
    //   href: "/casino/aggapsmartsoftgaming-mine-island-u8087",
    //   code: "",
    //   casino: "Smartsoft Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/MineIsland.webp",
    //   alt: "Mine Island",
    //   name: "Mine Island",
    // },
    // CoinFlip: {
    //   href: "/casino/aggapfungames-coin-flip",
    //   code: "",
    //   casino: "Fun Games",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/coin-flip.webp",
    //   alt: "Coin Flip",
    //   name: "Coin Flip",
    // },
    // FortuneWheel: {
    //   href: "/casino/aggapfungames-fortune-wheel",
    //   code: "",
    //   casino: "Fun Games",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/trending/fortune-wheel.webp",
    //   alt: "Fortune Wheel",
    //   name: "Fortune Wheel",
    // },
    // FruitTowers: {
    //   href: "/casino/aggapturbogames-fruit-towers-u6548",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/FruitTower.webp",
    //   alt: "Fruit Towers",
    //   name: "Fruit Towers",
    // },
  },

  gameShows: {
    BlackjackA: {
      href: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/blackjack-a.webp",
      alt: "Blackjack A",
      name: "Blackjack A",
    },
    DragonTiger: {
      href: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/dragon-tiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    LightningRoulette: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/lightning-roulette.webp",
      alt: "Lightning Roulette",
      name: "Lightning Roulette",
    },
    // SuperAndarBahar: {
    //   href: "/casino/aggapevolutiongaming-super-andar-bahar",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/livecasino/super-andar-bahar.webp",
    //   alt: "Super Andar Bahar",
    //   name: "Super Andar Bahar",
    // },
    BacBo: {
      href: "/casino/ezgevo-bac-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/bac-bo.webp",
      alt: "Bac Bo",
      name: "Bac Bo",
    },
    CrazyTime: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Ezugi",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/livecasino/crazy-time.webp",
      alt: "Crazy Time",
      name: "Crazy Time",
    },
  },

  playNGo: {
    // BookOfDead: {
    //   href: "/casino/aggapplayngo-book-of-dead",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/BookofDead.webp",
    //   alt: "book of dead",
    //   name: "Book of Dead",
    // },
    // LegacyOfDead: {
    //   href: "/casino/aggapplayngo-legacy-of-dead",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/LegacyOfDead.webp",
    //   alt: "Legacy of Dead",
    //   name: "Legacy of Dead",
    // },
    // RiseOfOlympus100: {
    //   href: "/casino/aggapplayngo-rise-of-olympus-100",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/RiseOfOlympus100.webp",
    //   alt: "Rise of Olympus 100",
    //   name: "Rise of Olympus 100",
    // },
    // MoonPrincess: {
    //   href: "/casino/aggapplayngo-moon-princess",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/MoonPrincess.webp",
    //   alt: "Moon Princess",
    //   name: "Moon Princess",
    // },
    // Reactoonz: {
    //   href: "/casino/aggapplayngo-reactoonz",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/Reactoonz.webp",
    //   alt: "Reactoonz",
    //   name: "Reactoonz",
    // },
    // Reactoonz2: {
    //   href: "/casino/aggapplayngo-reactoonz-2",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/Reactoonz2.webp",
    //   alt: "Reactoonz 2",
    //   name: "Reactoonz 2",
    // },
    // AliceCooperAndTheTomeOfMadness: {
    //   href: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "/images/casino-home/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
    //   alt: "Alice Cooper And The Tome Of Madness",
    //   name: "Alice Cooper And The Tome Of Madness",
    // },
    // FireJoker: {
    //   href: "/casino/aggapplayngo-fire-joker",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/FireJoker.webp",
    //   alt: "Fire Joker",
    //   name: "Fire Joker",
    // },
    // DiamondVortex: {
    //   href: "/casino/aggapplayngo-diamond-vortex",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/DiamondVortex.webp",
    //   alt: "diamond-vortex",
    //   name: "Diamond Vortex",
    // },
    // GoldenTicket: {
    //   href: "/casino/aggapplayngo-golden-ticket",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/GoldenTicket.webp",
    //   alt: "Golden Ticket",
    //   name: "Golden Ticket",
    // },
    // LordMerlinAndTheLadyOfTheLake: {
    //   href: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "/images/casino-home/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
    //   alt: "Lord Merlin and The Lady of The Lake",
    //   name: "Lord Merlin and The Lady of The Lake",
    // },
    // HugoLegacy: {
    //   href: "/casino/aggapplayngo-hugo-legacy",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/HugoLegacy.webp",
    //   alt: "hugo legacy",
    //   name: "Hugo Legacy",
    // },
    // Sabaton: {
    //   href: "/casino/aggapplayngo-sabaton",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/Sabaton.webp",
    //   alt: "Sabaton",
    //   name: "Sabaton",
    // },
    // AnimalMadness: {
    //   href: "/casino/aggapplayngo-animal-madness",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/AnimalMadness.webp",
    //   alt: "animal madness",
    //   name: "Animal Madness",
    // },
    // BattleRoyal: {
    //   href: "/casino/aggapplayngo-battle-royal",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/play-n-go/BattleRoyal.webp",
    //   alt: "battle royal",
    //   name: "Battle Royal",
    // },
  },

  habanero: {
    HotHotFruit: {
      href: "/casino/qt-hot-hot-fruit",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/HotHotFruit.webp",
      alt: "Hot Hot Fruit",
      name: "Hot Hot Fruit",
    },
    Lucky5Lions: {
      href: "/casino/qt-5-lucky-lions",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/5LuckyLions.webp",
      alt: "5 Lucky Lions",
      name: "5 Lucky Lions",
    },
    KoiGate: {
      href: "/casino/qt-koi-gate",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/KoiGate.webp",
      alt: "Koi Gate",
      name: "Koi Gate",
    },
    EgyptianDreamsDeluxe: {
      href: "/casino/qt-egyptian-dreams-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/EgyptianDreamsDeluxe.webp",
      alt: "Egyptian Dreams Deluxe",
      name: "Egyptian Dreams Deluxe",
    },
    SantasVillage: {
      href: "/casino/qt-santas-village",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/SantasVillage.webp",
      alt: "Santa’s Village",
      name: "Santa’s Village",
    },
    FaCaiShen: {
      href: "/casino/qt-fa-cai-shen",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/FaCaiShen.webp",
      alt: "Fa Cai Shen",
      name: "Fa Cai Shen",
    },
    BirdOfThunder: {
      href: "/casino/qt-bird-of-thunder",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/BirdofThunder.webp",
      alt: "Bird of Thunder",
      name: "Bird of Thunder",
    },
    FourDivineBeasts: {
      href: "/casino/qt-four-divine-beasts",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/FourDivineBeasts.webp",
      alt: "Four Divine Beasts",
      name: "Four Divine Beasts",
    },
    MountMazuma: {
      href: "/casino/qt-mount-mazuma",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/MountMazuma.webp",
      alt: "Mount Mazuma",
      name: "Mount Mazuma",
    },
    Presto: {
      href: "/casino/qt-presto",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/Presto.webp",
      alt: "Presto",
      name: "Presto",
    },
    RollingRoger: {
      href: "/casino/qt-rolling-roger",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/RollingRoger.webp",
      alt: "Rolling Roger",
      name: "Rolling Roger",
    },
    PumpkinPatch: {
      href: "/casino/qt-pumpkin-patch",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/PumpkinPatch.webp",
      alt: "Pumpkin Patch",
      name: "Pumpkin Patch",
    },
    ColossalGems: {
      href: "/casino/qt-colossal-gems",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/ColossalGems.webp",
      alt: "Colossal Gems",
      name: "Colossal Gems",
    },
    OrbsOfAtlantis: {
      href: "/casino/qt-orbs-of-atlantis",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/habanero/OrbsOfAtlantis.webp",
      alt: "Orbs Of Atlantis",
      name: "Orbs Of Atlantis",
    },
    // ArcaneElements: {
    //   href: "/casino/qt-arcane-elements",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "habanero",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/habanero/ArcaneElements.webp",
    //   alt: "Arcane Elements",
    //   name: "Arcane Elements",
    // },
  },

  dragoonSoft: {
    // Golf: {
    //   href: "/casino/aggapdrgs-golf",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/Golf.webp",
    //   alt: "Golf",
    //   name: "Golf",
    // },
    // GrandSheriff: {
    //   href: "/casino/aggapdrgs-grand-sheriff",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/GrandSheriff.webp",
    //   alt: "Grand Sheriff",
    //   name: "Grand Sheriff",
    // },
    // GreatLion: {
    //   href: "/casino/aggapdrgs-great-lion",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/GreatLion.webp",
    //   alt: "Great Lion",
    //   name: "Great Lion",
    // },
    // FruitsBar: {
    //   href: "/casino/aggapdrgs-fruits-bar",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/FruitsBar.webp",
    //   alt: "Fruits Bar",
    //   name: "Fruits Bar",
    // },
    // JinHouYe: {
    //   href: "/casino/aggapdrgs-jin-hou-ye",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/JinHouYe.webp",
    //   alt: "Jin Hou Ye",
    //   name: "Jin Hou Ye",
    // },
    // RichLion: {
    //   href: "/casino/aggapdrgs-rich-lion",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/RichLion.webp",
    //   alt: "Rich Lion",
    //   name: "Rich Lion",
    // },
    // Roman: {
    //   href: "/casino/aggapdrgs-roman",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/Roman.webp",
    //   alt: "Roman",
    //   name: "Roman",
    // },
    // Zeus: {
    //   href: "/casino/aggapdrgs-zeus",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/Zeus.webp",
    //   alt: "Zeus",
    //   name: "Zeus",
    // },
    // GoldenEgg: {
    //   href: "/casino/aggapdrgs-golden-egg",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/GoldenEgg.webp",
    //   alt: "Golden Egg",
    //   name: "Golden Egg",
    // },
    // BengalTiger: {
    //   href: "/casino/aggapdrgs-bengal-tiger",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/BengalTiger.webp",
    //   alt: "Bengal Tiger",
    //   name: "Bengal Tiger",
    // },
    // BonusCat: {
    //   href: "/casino/aggapdrgs-bonus-cat",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/BonusCat.webp",
    //   alt: "Bonus Cat",
    //   name: "Bonus Cat",
    // },
    // Arab: {
    //   href: "/casino/aggapdrgs-arab",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/Arab.webp",
    //   alt: "Arab",
    //   name: "Arab",
    // },
    // DiamondMogul: {
    //   href: "/casino/aggapdrgs-diamond-mogul",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/DiamondMogul.webp",
    //   alt: "Diamond Mogul",
    //   name: "Diamond Mogul",
    // },
    // EgyptOracle: {
    //   href: "/casino/aggapdrgs-egypt-oracle",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/EgyptOracle.webp",
    //   alt: "Egypt Oracle",
    //   name: "Egypt Oracle",
    // },
    // Pandaria: {
    //   href: "/casino/aggapdrgs-pandaria",
    //   code: "",
    //   casino: "Slots",
    //   provider: "ALT_GAMING_GAP",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/dragoon-soft/Pandaria.webp",
    //   alt: "Pandaria",
    //   name: "Pandaria",
    // },
  },

  hacksaw: {
    // ZeZeus: {
    //   href: "/casino/aggaphacksawgaming-ze-zeus",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/ZeZeus.webp",
    //   alt: "Ze Zeus",
    //   name: "Ze Zeus",
    // },
    // WarriorWays: {
    //   href: "/casino/aggaphacksawgaming-warrior-ways",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/WarriorWays.webp",
    //   alt: "Warrior Ways",
    //   name: "Warrior Ways",
    // },
    // TimeSpinners: {
    //   href: "/casino/aggaphacksawgaming-time-spinners",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/TimeSpinners.webp",
    //   alt: "Time Spinners",
    //   name: "Time Spinners",
    // },
    // RocketReels: {
    //   href: "/casino/aggaphacksawgaming-rocket-reels",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/RocketReels.webp",
    //   alt: "Rocket Reels",
    //   name: "Rocket Reels",
    // },
    // KeepemCool: {
    //   href: "/casino/aggaphacksawgaming-keepem-cool",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/KeepemCool.webp",
    //   alt: "Keep'em Cool",
    //   name: "Keep'em Cool",
    // },
    // Itero: {
    //   href: "/casino/aggaphacksawgaming-itero",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/Itero.webp",
    //   alt: "Itero",
    //   name: "Itero",
    // },
    // FranksFarm: {
    //   href: "/casino/aggaphacksawgaming-franks-farm",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/FranksFarm.webp",
    //   alt: "Frank's Farm",
    //   name: "Frank's Farm",
    // },
    // CashQuest: {
    //   href: "/casino/aggaphacksawgaming-cash-quest",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/CashQuest.webp",
    //   alt: "Cash Quest",
    //   name: "Cash Quest",
    // },
    // BuffaloStackNSync: {
    //   href: "/casino/aggaphacksawgaming-buffalo-stacknsync",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/BuffaloStackNSync.webp",
    //   alt: "Buffalo Stack'n'Sync",
    //   name: "Buffalo Stack'n'Sync",
    // },
    // Bloodthirst: {
    //   href: "/casino/aggaphacksawgaming-bloodthirst",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/Bloodthirst.webp",
    //   alt: "Bloodthirst",
    //   name: "Bloodthirst",
    // },
    // AlphaEagle: {
    //   href: "/casino/aggaphacksawgaming-alpha-eagle",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/AlphaEagle.webp",
    //   alt: "Alpha Eagle",
    //   name: "Alpha Eagle",
    // },
    // DarkSummoning: {
    //   href: "/casino/aggaphacksawgaming-dark-summoning",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/DarkSummoning.webp",
    //   alt: "Dark Summoning",
    //   name: "Dark Summoning",
    // },
    // XmasDrop: {
    //   href: "/casino/aggaphacksawgaming-xmas-drop",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/XmasDrop.webp",
    //   alt: "Xmas Drop",
    //   name: "Xmas Drop",
    // },
    // TigerScratch: {
    //   href: "/casino/aggaphacksawgaming-tiger-scratch",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/TigerScratch.webp",
    //   alt: "Tiger Scratch",
    //   name: "Tiger Scratch",
    // },
    // Wild2Die2: {
    //   href: "/casino/aggaphacksawgaming-2-wild-2-die",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/hacksaw/2Wild2Die.webp",
    //   alt: "2 Wild 2 Die",
    //   name: "2 Wild 2 Die",
    // },
  },

  instantWin: {
    LuckyNumbersx12: {
      href: "/casino/qt-lucky-numbers-x12",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/LuckyNumbersx12.webp",
      alt: "Lucky Numbers x12",
      name: "Lucky Numbers x12",
      providerName: "WorldCasino",
    },
    LuckyNumbersx16: {
      href: "/casino/qt-lucky-numbers-x16",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/LuckyNumbersx16.webp",
      alt: "Lucky Numbers x16",
      name: "Lucky Numbers x16",
      providerName: "WorldCasino",
    },
    LuckyNumbersx20: {
      href: "/casino/qt-lucky-numbers-x20",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/LuckyNumbersx20.webp",
      alt: "Lucky Numbers x20",
      name: "Lucky Numbers x20",
      providerName: "WorldCasino",
    },
    BookOfPower: {
      href: "/casino/qt-book-of-power",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/BookOfPower.webp",
      alt: "Book Of Power",
      name: "Book Of Power",
      providerName: "WorldCasino",
    },
    CursedSeas: {
      href: "/casino/qt-cursed-seas",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/CursedSeas.webp",
      alt: "Cursed Seas",
      name: "Cursed Seas",
      providerName: "WorldCasino",
    },
    DogTownDeal: {
      href: "/casino/qt-dog-town-deal",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/DogTownDeal.webp",
      alt: "Dog Town Deal",
      name: "Dog Town Deal",
      providerName: "WorldCasino",
    },
    EForce: {
      href: "/casino/qt-e-force",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/EForce.webp",
      alt: "E-Force",
      name: "E-Force",
      providerName: "WorldCasino",
    },
    LeprechaunCharms: {
      href: "/casino/qt-leprechaun-charms",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/LeprechaunCharms.webp",
      alt: "Leprechaun Charms",
      name: "Leprechaun Charms",
      providerName: "WorldCasino",
    },
    MidasGoldenTouch: {
      href: "/casino/qt-midas-golden-touch",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/MidasGoldenTouch.webp",
      alt: "Midas Golden Touch",
      name: "Midas Golden Touch",
      providerName: "WorldCasino",
    },
    MoneyTrain2: {
      href: "/casino/qt-money-train-2",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/MoneyTrain2.webp",
      alt: "Money Train 2",
      name: "Money Train 2",
      providerName: "WorldCasino",
    },
    MoneyTrain3: {
      href: "/casino/qt-money-train-3",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/MoneyTrain3.webp",
      alt: "Money Train 3",
      name: "Money Train 3",
      providerName: "WorldCasino",
    },
    PlinkoGo: {
      href: "/casino/qt-plinko-go",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/PlinkoGo.webp",
      alt: "Plinko Go",
      name: "Plinko Go",
      providerName: "WorldCasino",
    },
    Ragnawolves: {
      href: "/casino/qt-ragnawolves",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/Ragnawolves.webp",
      alt: "Ragnawolves",
      name: "Ragnawolves",
      providerName: "WorldCasino",
    },
    RoyalPotato: {
      href: "/casino/qt-royal-potato",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/RoyalPotato.webp",
      alt: "Royal Potato",
      name: "Royal Potato",
      providerName: "WorldCasino",
    },
    SharkWash: {
      href: "/casino/qt-shark-wash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/SharkWash.webp",
      alt: "Shark Wash",
      name: "Shark Wash",
      providerName: "WorldCasino",
    },
    Whacked: {
      href: "/casino/qt-whacked",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/Whacked.webp",
      alt: "Whacked!",
      name: "Whacked!",
      providerName: "WorldCasino",
    },
    WildChapo: {
      href: "/casino/qt-wild-chapo",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/WildChapo.webp",
      alt: "Wild Chapo",
      name: "Wild Chapo",
      providerName: "WorldCasino",
    },
    WildYield: {
      href: "/casino/qt-wild-yield",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "instantWin",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/instant-win-qt/WildYield.webp",
      alt: "Wild Yield",
      name: "Wild Yield",
      providerName: "WorldCasino",
    },
  },

  crashGames: {
    // Aviator: {
    //   href: "/casino/aggapmac88gamingvirtual-aviator-x",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   category: "crashGames",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/crash-qt/Aviator.webp",
    //   alt: "Aviator",
    //   name: "Aviator",
    //   providerName: "WorldCasino",
    // },
    // CricketX: {
    //   href: "/casino/aggapsmartsoftgaming-cricketx",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "ALT_GAMING_GAP",
    //   category: "crashGames",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/crash-qt/Cricketx.webp",
    //   alt: "CricketX",
    //   name: "CricketX",
    //   providerName: "SmartSoft",
    // },
    // JetX: {
    //   href: "/casino/aggapsmartsoftgaming-jetx",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "ALT_GAMING_GAP",
    //   category: "crashGames",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/crash-qt/Jetx.webp",
    //   alt: "JetX",
    //   name: "JetX",
    //   providerName: "SmartSoft",
    // },
    CabinCrashers: {
      href: "/casino/qt-cabin-crashers",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CabinCrashers.webp",
      alt: "Cabin Crashers",
      name: "Cabin Crashers",
      providerName: "WorldCasino",
    },
    CashorCrash: {
      href: "/casino/qt-cash-or-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CashorCrash.webp",
      alt: "Cash or Crash",
      name: "Cash or Crash",
      providerName: "WorldCasino",
    },
    CoyoteCrash: {
      href: "/casino/qt-coyote-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CoyoteCrash.webp",
      alt: "Coyote Crash",
      name: "Coyote Crash",
      providerName: "WorldCasino",
    },
    CrashoutFirework: {
      href: "/casino/qt-crashout-firework",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CrashoutFirework.webp",
      alt: "Crashout - Firework",
      name: "Crashout - Firework",
      providerName: "WorldCasino",
    },
    CrashX: {
      href: "/casino/qt-crashx",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CrashX.webp",
      alt: "CrashX",
      name: "CrashX",
      providerName: "WorldCasino",
    },
    CrashXFootballEdition: {
      href: "/casino/qt-crashx-football-edition",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/CrashXFootballEdition.webp",
      alt: "CrashX Football Edition",
      name: "CrashX Football Edition",
      providerName: "WorldCasino",
    },
    FootballManager: {
      href: "/casino/qt-football-manager",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/FootballManager.webp",
      alt: "Football Manager",
      name: "Football Manager",
      providerName: "WorldCasino",
    },
    GemHunterCrash: {
      href: "/casino/qt-gem-hunter-crash",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/GemHunterCrash.webp",
      alt: "Gem Hunter Crash",
      name: "Gem Hunter Crash",
      providerName: "WorldCasino",
    },
    GoblinRun: {
      href: "/casino/qt-goblin-run",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/GoblinRun.webp",
      alt: "Goblin Run",
      name: "Goblin Run",
      providerName: "WorldCasino",
    },
    HighStriker: {
      href: "/casino/qt-high-striker",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/HighStriker.webp",
      alt: "High Striker",
      name: "High Striker",
      providerName: "WorldCasino",
    },
    JungleRun: {
      href: "/casino/qt-jungle-run",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/JungleRun.webp",
      alt: "Jungle Run",
      name: "Jungle Run",
      providerName: "WorldCasino",
    },
    LuckyCrumbling: {
      href: "/casino/qt-lucky-crumbling",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/LuckyCrumbling.webp",
      alt: "Lucky Crumbling",
      name: "Lucky Crumbling",
      providerName: "WorldCasino",
    },
    Maverick: {
      href: "/casino/qt-maverick",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/Maverick.webp",
      alt: "Maverick",
      name: "Maverick",
      providerName: "WorldCasino",
    },
    SpaceXY: {
      href: "/casino/qt-space-xy",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "crashGames",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/crash-qt/SpaceXY.webp",
      alt: "Space XY",
      name: "Space XY",
      providerName: "WorldCasino",
    },
  },

  pinkyXStake: {
    Dice: {
      href: "/casino/spribe-dice",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    // Wheel: {
    //   href: "/casino/aggapinoutgames-wheel",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Wheel.webp",
    //   alt: "Wheel",
    //   name: "Wheel",
    // },
    Limbo: {
      href: "/casino/aura-limbo",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
    Baccarat: {
      href: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    // Blackjack: {
    //   href: "/casino/ezg-blackjack-1",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Blackjack.webp",
    //   alt: "Blackjack",
    //   name: "Blackjack",
    // },
    // Crash: {
    //   href: "/casino/aggapinoutgames-crash",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Crash.webp",
    //   alt: "Crash",
    //   name: "Crash",
    // },
    // Diamonds: {
    //   href: "/casino/aggapcrash88gaming-diamonds",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Diamonds.webp",
    //   alt: "Diamonds",
    //   name: "Diamonds",
    // },

    Keno: {
      href: "/casino/spribe-keno",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Keno.webp",
      alt: "Keno",
      name: "Keno",
    },

    Mines: {
      href: "/casino/spribe-mines",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    Plinko: {
      href: "/casino/spribe-plinko",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Plinko.webp",
      alt: "Plinko",
      name: "Plinko",
    },
    // RockPaperScissors: {
    //   href: "/casino/aggapminicrash-mini-rock-paper-scissors",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/RockPaperScissors.webp",
    //   alt: "Rock Paper Scissors",
    //   name: "Rock Paper Scissors",
    // },
    Roulette: {
      href: "/casino/ezg-italian-roulette",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Roulette.webp",
      alt: "Roulette",
      name: "Roulette",
    },
    // VideoPoker: {
    //   href: "/casino/aggapjiligaming-video-poker",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/VideoPoker.webp",
    //   alt: "Video Poker",
    //   name: "Video Poker",
    // },

    Dice: {
      href: "/casino/spribe-dice",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    // Wheel: {
    //   href: "/casino/aggapinoutgames-wheel",
    //   code: "",
    //   casino: "yuvi games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "pinkyXStake",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/pinky-stake/Wheel.webp",
    //   alt: "Wheel",
    //   name: "Wheel",
    // },
    Limbo: {
      href: "/casino/aura-limbo",
      code: "",
      casino: "yuvi games",
      provider: "ALT_GAMING_GAP",
      category: "pinkyXStake",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/pinky-stake/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
  },

  slots: {
    // GoldenShisa: {
    //   href: "/casino/aggaponetouch-golden-shisa",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   category: "slots",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/slots-qt/GoldenShisa.webp",
    //   alt: "Golden Shisa",
    //   name: "Golden Shisa",
    //   providerName: "WorldCasino",
    // },
    CaptainGlumPirateHunter: {
      href: "/casino/ qt-captain-glum-pirate-hunter",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/CaptainGlumPirateHunter.webp",
      alt: "Captain Glum: Pirate Hunter",
      name: "Captain Glum: Pirate Hunter",
      providerName: "WorldCasino",
    },
    DevourTheWeak: {
      href: "/casino/qt-devour-the-weak",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/DevourTheWeak.webp",
      alt: "Devour the Weak",
      name: "Devour the Weak",
      providerName: "WorldCasino",
    },
    Disturbed: {
      href: "/casino/qt-disturbed",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/Disturbed.webp",
      alt: "Disturbed",
      name: "Disturbed",
      providerName: "WorldCasino",
    },
    Luchamigos: {
      href: "/casino/qt-luchamigos",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/Luchamigos.webp",
      alt: "Luchamigos",
      name: "Luchamigos",
      providerName: "WorldCasino",
    },
    NiceCatchDoublemax: {
      href: "/casino/qt-nice-catch-doublemax",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/NiceCatchDoublemax.webp",
      alt: "Nice Catch Doublemax",
      name: "Nice Catch Doublemax",
      providerName: "WorldCasino",
    },
    MayanStackways: {
      href: "/casino/qt-mayan-stackways",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/MayanStackways.webp",
      alt: "Mayan Stackways",
      name: "Mayan Stackways",
      providerName: "WorldCasino",
    },
    NaughtyWukong: {
      href: "/casino/qt-naughty-wukong",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/NaughtyWukong.webp",
      alt: "Naughty Wukong",
      name: "Naughty Wukong",
      providerName: "WorldCasino",
    },
    GerardsGambit: {
      href: "/casino/qt-gerards-gambit",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/GerardsGambit.webp",
      alt: "Gerard's Gambit",
      name: "Gerard's Gambit",
      providerName: "WorldCasino",
    },
    KissMyChainsaw: {
      href: "/casino/qt-kiss-my-chainsaw",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/KissMyChainsaw.webp",
      alt: "Kiss My Chainsaw",
      name: "Kiss My Chainsaw",
      providerName: "WorldCasino",
    },
    RoninsHonour: {
      href: "/casino/qt-ronins-honour",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/RoninsHonour.webp",
      alt: "Ronin's Honour",
      name: "Ronin's Honour",
      providerName: "WorldCasino",
    },
    HolyHandGrenade: {
      href: "/casino/qt-holy-hand-grenade",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/HolyHandGrenade.webp",
      alt: "Holy Hand Grenade",
      name: "Holy Hand Grenade",
      providerName: "WorldCasino",
    },
    VegasHotspots: {
      href: "/casino/qt-vegas-hotspots",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/VegasHotspots.webp",
      alt: "Vegas Hotspots",
      name: "Vegas Hotspots",
      providerName: "WorldCasino",
    },
    TheWildos: {
      href: "/casino/qt-the-wildos",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "slots",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/slots-qt/TheWildos.webp",
      alt: "The Wildos",
      name: "The Wildos",
      providerName: "WorldCasino",
    },
    // WildBandolier: {
    //   href: "/casino/qt-wild-bandolier",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   category: "slots",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/slots-qt/WildBandolier.webp",
    //   alt: "Wild Bandolier",
    //   name: "Wild Bandolier",
    //   providerName: "WorldCasino",
    // },
  },

  vrSports: {
    KnockoutFootballRush: {
      href: "/casino/qt-knockout-football-rush",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "vrSports",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/vr-sports/KnockoutFootballRush.webp",
      alt: "Knockout Football Rush",
      name: "Knockout Football Rush",
    },
    // SpinoCricket: {
    //   href: "/casino/qt-spino-cricket",
    //   code: "",
    //   casino: "Qtech",
    //   provider: "WorldCasino",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/SpinoCricket.webp",
    //   alt: "Spino Cricket",
    //   name: "Spino Cricket",
    // },
    // GoldenRace: {
    //   href: "/casino/aggapgoldenrace-golden-race",
    //   code: "",
    //   casino: "Golden Race",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/GoldenRace.webp",
    //   alt: "Golden Race",
    //   name: "Golden Race",
    // },
    GoalBlitz: {
      href: "/casino/qt-goal-blitz",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      category: "vrSports",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/vr-sports/GoalBlitz.webp",
      alt: "Goal Blitz",
      name: "Goal Blitz",
    },
    // Steeplechase: {
    //   href: "/casino/aggappragmaticplay2-steeplechase",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/Steeplechase.webp",
    //   alt: "Steeplechase",
    //   name: "Steeplechase",
    // },
    // Force1: {
    //   href: "/casino/aggappragmaticplay2-force-1",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/Force1.webp",
    //   alt: "Force 1",
    //   name: "Force 1",
    // },
    // FantasticLeague: {
    //   href: "/casino/aggappragmaticplay2-fantastic-league",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/FantasticLeague.webp",
    //   alt: "Fantastic League",
    //   name: "Fantastic League",
    // },
    // GreyhoundRacing: {
    //   href: "/casino/aggappragmaticplay2-greyhound-racing",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/GreyhoundRacing.webp",
    //   alt: "Greyhound Racing",
    //   name: "Greyhound Racing",
    // },
    // PenaltyShootout: {
    //   href: "/casino/aggappragmaticplay2-penalty-shootout",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/PenaltyShootout.webp",
    //   alt: "Penalty Shootout",
    //   name: "Penalty Shootout",
    // },
    // HorseRacing: {
    //   href: "/casino/aggappragmaticplay2-horse-racing",
    //   code: "",
    //   casino: "Pragmatic Play",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/HorseRacing.webp",
    //   alt: "Horse Racing",
    //   name: "Horse Racing",
    // },
    // Streak: {
    //   href: "/casino/aggapparlaybay-streak",
    //   code: "",
    //   casino: "Parlaybay",
    //   provider: "ALT_GAMING_GAP",
    //   category: "vrSports",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/vr-sports/Streak.webp",
    //   alt: "Streak",
    //   name: "Streak",
    // },
  },

  lottery: {
    BingoBillionLlamaCaleta: {
      href: "/casino/aggapcaletagaming-bingo-billion-llama",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/BingoBillionLlama.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    FastKenoTVBet: {
      href: "/casino/aggaptvbet-fast-keno",
      code: "",
      casino: "TVBet",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/FastKeno.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    FootballLottoCaleta: {
      href: "/casino/aggapcaletagaming-football-lotto",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/FootballLotto.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    HalloweenLottoCaleta: {
      href: "/casino/aggapcaletagaming-halloween-lotto",
      code: "",
      casino: "Caleta",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/HalloweenLotto.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    KenoTVBet: {
      href: "/casino/aggaptvbet-keno",
      code: "",
      casino: "TVBet",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/Keno.webp",
      alt: "Lottery",
      name: "Lottery",
    },
    // LotteryTableRoyal: {
    //   href: "/casino/aggaproyalgaming-lottery",
    //   code: "",
    //   casino: "royal gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/Lottery.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    MagicIdolPopok: {
      href: "/casino/aggappopokinstant-magic-idol",
      code: "",
      casino: "Popok Instant",
      provider: "ALT_GAMING_GAP",
      category: "lottery",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/lottery/MagicIdol.webp",
      alt: "Lottery",
      name: "Lottery",
    },

    // RedHotLinePopok: {
    //   href: "/casino/aggappopokinstant-red-hot-line",
    //   code: "",
    //   casino: "Popok Instant",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/RedHotLine.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // SpinStrikeTurbo: {
    //   href: "/casino/aggapturbogames-spin-strike",
    //   code: "",
    //   casino: "Turbo Games",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/SpinStrike.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // LotteryMac88: {
    //   href: "/casino/aggapmac88gaming-lottery",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/LotteryMac88.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // VRLotteryRoyal: {
    //   href: "/casino/aggaproyalgamingvirtual-vr-lottery",
    //   code: "",
    //   casino: "royal gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/VRLottery.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // WheelHacksaw: {
    //   href: "/casino/aggaphacksawgaming-wheel",
    //   code: "",
    //   casino: "Hacksaw Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/Wheel.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // Wheel94Hacksaw: {
    //   href: "/casino/aggaphacksawgaming-wheel-92",
    //   code: "",
    //   casino: "Hacksaw Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/Wheel92.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
    // Wheel92Hacksaw: {
    //   href: "/casino/aggaphacksawgaming-wheel-94",
    //   code: "",
    //   casino: "Hacksaw Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/lottery/Wheel94.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    // },
  },

  lobbies: {
    Mac88: {
      href: "mac88",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Mac88.webp",
      alt: "Mac88",
      name: "Mac88",
    },
    Spribe: {
      href: "spribe",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Spribe.webp",
      alt: "Spribe",
      name: "Spribe",
    },
    Mac88VR: {
      href: "mac88VR",
      code: "",
      casino: "Mac88 Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Mac88VR.webp",
      alt: "Mac88",
      name: "Mac88",
    },
    Evolution: {
      href: "evolution",
      code: "",
      casino: "Evolution",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Evolution.webp",
      alt: "Evolution",
      name: "Evolution",
    },
    Turbo: {
      href: "turbo",
      code: "",
      casino: "Turbo",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/TurboGame.webp",
      alt: "Turbo",
      name: "Turbo",
    },
    // SmartSoft: {
    //   href: "smartSoft",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/casino-lobby/SmartSoft.webp",
    //   alt: "SmartSoft",
    //   name: "SmartSoft",
    // },
    Ezugi: {
      href: "ezugi",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Ezugi.webp",
      alt: "Ezugi",
      name: "Ezugi",
    },
    Jili: {
      href: "jili",
      code: "",
      casino: "Jili",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Jili.webp",
      alt: "Jili",
      name: "Jili",
    },
    AeSexy: {
      href: "/casino/aesexy",
      code: "",
      casino: "AeSexy",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/AeSexy.webp",
      alt: "AeSexy",
      name: "AeSexy",
    },
    // RelaxGaming: {
    //   href: "relaxGaming",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/casino-lobby/RelaxGaming.webp",
    //   alt: "Relax Gaming",
    //   name: "Relax Gaming",
    // },
    Kingmaker: {
      href: "kingmaker",
      code: "",
      casino: "Kingmaker",
      provider: "Kingmaker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Kingmaker.webp",
      alt: "Kingmaker",
      name: "Kingmaker",
    },
    AuraGaming: {
      href: "auragaming",
      code: "",
      casino: "Aura",
      provider: "Aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/AuraGaming.webp",
      alt: "Aura Gaming",
      name: "Aura Gaming",
    },
    Netent: {
      href: "netent",
      code: "",
      casino: "Netent",
      provider: "Netent",
      category: "netent",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/NetEnt.webp",
      alt: "Netent",
      name: "Netent",
    },
    RedTiger: {
      href: "redtiger",
      code: "",
      casino: "Red Tiger",
      provider: "Red Tiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/RedTiger.webp",
      alt: "Red Tiger",
      name: "Red Tiger",
    },
    Qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "Qtech",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Qtech.webp",
      alt: "Qtech",
      name: "Qtech",
    },
    // Slots: {
    //   href: "/casinos",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Slots",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/casino-home/casino-lobby/Slots.webp",
    //   alt: "Slots",
    //   name: "Slots",
    // },

  
    XPG: {
      href: "xpg",
      code: "",
      casino: "XPG",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/XPG.webp",
      alt: "XPG",
      name: "XPG",
    },
    Worldcasino: {
      href: "/casino/worldcasino",
      code: "",
      casino: "Worldcasino",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Worldcasino.webp",
      alt: "Worldcasino",
      name: "Worldcasino",
    },
    Powergames: {
      href: "powergames",
      code: "",
      casino: "Powergames",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Powergames.webp",
      alt: "Powergames",
      name: "Powergames",
    },
    Hacksaw: {
      href: "hacksaw",
      code: "",
      casino: "Hacksaw",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Hacksaw.webp",
      alt: "Hacksaw",
      name: "Hacksaw",
    },
    PlayNGo: {
      href: "playNGo",
      code: "",
      casino: "Play'n Go",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/PlaynGo.webp",
      alt: "Play'n Go",
      name: "Play'n Go",
    },
    Habanero: {
      href: "habanero",
      code: "",
      casino: "Habanero",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/Habanero.webp",
      alt: "Habanero",
      name: "Habanero",
    },
    DragoonSoft: {
      href: "dragoonSoft",
      code: "",
      casino: "Dragoon Soft",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/casino-home/casino-lobby/DragoonSoft.webp",
      alt: "Dragoon Soft",
      name: "Dragoon Soft",
    },
  },

  casinoLobbies: {
    Spribe: {
      href: "spribe",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Spribe.webp",
      alt: "Spribe",
      name: "Spribe",
    },
    Evolution: {
      href: "/casino/evolution",
      code: "",
      casino: "Evolution",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Evolution.webp",
      alt: "Evolution",
      name: "Evolution",
    },
    Ezugi: {
      href: "/casino/ezugi",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Ezugi.webp",
      alt: "Ezugi",
      name: "Ezugi",
    },
    Kingmaker: {
      href: "kingmaker",
      code: "",
      casino: "Kingmaker",
      provider: "Kingmaker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Kingmaker.webp",
      alt: "Kingmaker",
      name: "Kingmaker",
    },
    AuraGaming: {
      href: "auragaming",
      code: "",
      casino: "Aura",
      provider: "Aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/AuraGaming.webp",
      alt: "Aura Gaming",
      name: "Aura Gaming",
    },
    Netent: {
      href: "netent",
      code: "",
      casino: "Netent",
      provider: "Netent",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Netent.webp",
      alt: "Netent",
      name: "Netent",
    },
    RedTiger: {
      href: "redtiger",
      code: "",
      casino: "Red Tiger",
      provider: "Red Tiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/RedTiger.webp",
      alt: "Red Tiger",
      name: "Red Tiger",
    },
    Qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "Qtech",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Qtech.webp",
      alt: "Qtech",
      name: "Qtech",
    },
    // Slots: {
    //   href: "/casinos",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Slots",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino-home/providers/Slots.webp",
    //   alt: "Slots",
    //   name: "Slots",
    // },

 
    XPG: {
      href: "/casino/xpg",
      code: "",
      casino: "XPG",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/XPG.webp",
      alt: "XPG",
      name: "XPG",
    },
    Worldcasino: {
      href: "/casino/worldcasino",
      code: "",
      casino: "Worldcasino",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Worldcasino.webp",
      alt: "Worldcasino",
      name: "Worldcasino",
    },
    Powergames: {
      href: "/casino/powergames",
      code: "",
      casino: "Powergames",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/Powergames.webp",
      alt: "Powergames",
      name: "Powergames",
    },
    AeSexy: {
      href: "/casino/aesexy",
      code: "",
      casino: "AeSexy",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/casino-home/providers/AeSexy.webp",
      alt: "AeSexy",
      name: "AeSexy",
    },
  },
};

export const casinoPageData = {
  ezugi: {
    roulette: {
      // FiestaRoulette: {
      //   href: "/casino/ezg-fiesta-roulette",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "roulette",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/roulette/FiestaRoulette.webp",
      //   alt: "Fiesta Roulette",
      //   name: "Fiesta Roulette",
      // },
      ItalianRoulette: {
        href: "/casino/ezg-italian-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/ItalianRoulette.webp",
        alt: "italian roulette",
        name: "Italian Roulette",
      },
      NamasteRoulette: {
        href: "/casino/ezg-namaste-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/NamasteRoulette.webp",
        alt: "Namaste Roulette",
        name: "Namaste Roulette",
      },
      // OracleBlaze: {
      //   href: "/casino/ezg-oracle-blaze-roulette",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "roulette",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/roulette/OracleBlaze.webp",
      //   alt: "Oracle Blaze",
      //   name: "Oracle Blaze",
      // },
      OracleRoulette360: {
        href: "/casino/ezg-oracle-roulette-2",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/OracleRoulette360.webp",
        alt: "Oracle Roulette 360",
        name: "Oracle Roulette 360",
      },
      // PortomasoRealCasinoRoulette: {
      //   href: "/casino/ezg-portomaso-roulette-1",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "roulette",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl:
      //     "/images/casino/ezugi/roulette/PortomasoRealCasinoRoulette.webp",
      //   alt: "Portomaso Real Casino Roulette",
      //   name: "Portomaso Real Casino Roulette",
      // },
      PortomasoRealCasinoRoulette2: {
        href: "/casino/ezg-portomaso-roulette-2",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/ezugi/roulette/PortomasoRealCasinoRoulette2.webp",
        alt: "Portomaso Real Casino Roulette 2",
        name: "Portomaso Real Casino Roulette 2",
      },
      PrestigeAutoRoulette: {
        href: "/casino/ezg-prestige-auto-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/PrestigeAutoRoulette.webp",
        alt: "Prestige Auto Roulette",
        name: "Prestige Auto Roulette",
      },
      RuletadelSol: {
        href: "/casino/ezg-ruleta-del-sol",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/RuletadelSol.webp",
        alt: "Ruleta del Sol",
        name: "Ruleta del Sol",
      },
      SpeedAutoRoulette: {
        href: "/casino/ezg-ruleta-del-sol",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/SpeedAutoRoulette.webp",
        alt: "Speed Auto Roulette",
        name: "Speed Auto Roulette",
      },
      TürkçeRulet: {
        href: "/casino/ezg-turkish-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/TürkçeRulet.webp",
        alt: "Türkçe Rulet",
        name: "Türkçe Rulet",
      },
      AutoRoulette: {
        href: "/casino/ezg-auto-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/AutoRoulette.webp",
        alt: "Auto Roulette",
        name: "Auto Roulette",
      },
      CasinoMarinaRouletteEz: {
        href: "/casino/ezg-casino-marina-roulette-1",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/CasinoMarinaRoulette.webp",
        alt: "Casino Marina Roulette",
        name: "Casino Marina Roulette",
      },
      CasinoMarinaRoulette2: {
        href: "/casino/ezg-casino-marina-roulette-2",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/CasinoMarinaRoulette2.webp",
        alt: "Casino Marina Roulette 2",
        name: "Casino Marina Roulette 2",
      },
      DiamondRouletteEz: {
        href: "/casino/ezg-diamond-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/DiamondRoulette.webp",
        alt: "Diamond Roulette",
        name: "Diamond Roulette",
      },
    },
    blackjack: {
      // Blackjack1: {
      //   href: "/casino/ezg-blackjack-1",
      //   code: "",
      //   casino: "evolution",
      //   provider: "evolution",
      //   category: "blackjack",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/blackjack/Blackjack1.webp",
      //   alt: "Blackjack 1",
      //   name: "Blackjack 1",
      // },
      Blackjack2: {
        href: "/casino/ezg-rumba-blackjack-2",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/Blackjack2.webp",
        alt: "Blackjack 2",
        name: "Blackjack 2",
      },
      Blackjack7: {
        href: "/casino/ezg-blackjack-7",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/Blackjack7.webp",
        alt: "Blackjack 7",
        name: "Blackjack 7",
      },
      BlackjackGold1: {
        href: "/casino/ezg-gold-blackjack-1",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold1.webp",
        alt: "Blackjack Gold 1",
        name: "Blackjack Gold 1",
      },
      BlackjackGold3: {
        href: "/casino/ezg-gold-blackjack-3",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold3.webp",
        alt: "Blackjack Gold 3",
        name: "Blackjack Gold 3",
      },
      BlackjackGold4: {
        href: "/casino/ezg-gold-blackjack-4",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold4.webp",
        alt: "Blackjack Gold 4",
        name: "Blackjack Gold 4",
      },
      BlackjackGold5: {
        href: "/casino/ezg-gold-blackjack-5",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackGold5.webp",
        alt: "Blackjack Gold 5",
        name: "Blackjack Gold 5",
      },
      BlackjackPlatinum1: {
        href: "/casino/ezg-platinium-blackjack-1",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackPlatinum1.webp",
        alt: "Blackjack Platinum 1",
        name: "Blackjack Platinum 1",
      },
      BlackjackPlatinum2: {
        href: "/casino/ezg-platinium-blackjack-2",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackPlatinum2.webp",
        alt: "Blackjack Platinum 2",
        name: "Blackjack Platinum 2",
      },
      BlackjackSalonPrivé: {
        href: "/casino/ezg-salon-prive-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackjackSalonPrivé.webp",
        alt: "Blackjack Salon Privé",
        name: "Blackjack Salon Privé",
      },
      BlackRussianBlackjack: {
        href: "/casino/ezg-russian-blackjack-1",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/BlackRussianBlackjack.webp",
        alt: "Russian Blackjack 1",
        name: "Russian Blackjack 1",
      },
      DiamondVIPBlackjack: {
        href: "/casino/ezg-vip-diamond-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/DiamondVIPBlackjack.webp",
        alt: "Diamond VIP Blackjack",
        name: "Diamond VIP Blackjack",
      },
      FiestaBlackjackUnlimited: {
        href: "/casino/ezg-fiesta-unlimited-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/FiestaBlackjackUnlimited.webp",
        alt: "Fiesta Blackjack Unlimited",
        name: "Fiesta Blackjack Unlimited",
      },
      ItalianBlackjack: {
        href: "/casino/ezg-italian-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/ItalianBlackjack.webp",
        alt: "Italian Blackjack",
        name: "Italian Blackjack",
      },
      RumbaBlackjack1: {
        href: "/casino/ezg-rumba-blackjack-1",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack1.webp",
        alt: "Rumba Blackjack 1",
        name: "Rumba Blackjack 1",
      },
      RumbaBlackjack2: {
        href: "/casino/ezg-rumba-blackjack-2",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack2.webp",
        alt: "Rumba Blackjack 2",
        name: "Rumba Blackjack 2",
      },
      RumbaBlackjack3: {
        href: "/casino/ezg-rumba-blackjack-3",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack3.webp",
        alt: "Rumba Blackjack 3",
        name: "Rumba Blackjack 3",
      },
      RumbaBlackjack4: {
        href: "/casino/ezg-rumba-blackjack-4",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/RumbaBlackjack4.webp",
        alt: "Rumba Blackjack 4",
        name: "Rumba Blackjack 4",
      },
      TurkishBlackjack2: {
        href: "/casino/ezg-turkish-blackjack-2",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/TurkishBlackjack2.webp",
        alt: "Turkish Blackjack 2",
        name: "Turkish Blackjack 2",
      },
      UnlimitedBlackjack: {
        href: "/casino/ezg-unlimited-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/blackjack/UnlimitedBlackjack.webp",
        alt: "Unlimited Blackjack",
        name: "Unlimited Blackjack",
      },
    },
    andarbahar: {
      andarbahar: {
        href: "/casino/ezg-andar-bahar",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "andarbahar",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/andarbahar/AndarBahar.webp",
        alt: "Andar Bahar",
        name: "Andar Bahar",
      },
      // OTTAndarBahar: {
      //   href: "/casino/ez-ott-andar-bahar-marina",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "andarbahar",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/andarbahar/OttAndarBahar.webp",
      //   alt: "OTT Andar Bahar",
      //   name: "OTT Andar Bahar",
      // },
    },
    baccarat: {
      Baccarat: {
        href: "/casino/ezg-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/Baccarat.webp",
        alt: "Baccarat",
        name: "Baccarat",
      },
      // BaccaratKnockOut: {
      //   href: "/casino/ez-baccarat-knock-out",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "baccarat",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/baccarat/BaccaratKnockOut.webp",
      //   alt: "Baccarat Knock Out",
      //   name: "Baccarat Knock Out",
      // },
      // BaccaratNoCommission: {
      //   href: "/casino/ez-baccarat-no-commission",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "baccarat",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/baccarat/BaccaratNoCommission.webp",
      //   alt: "Baccarat No Commission",
      //   name: "Baccarat No Commission",
      // },
      // BaccaratSuper6: {
      //   href: "/casino/ez-baccarat-super-6",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "ezugi",
      //   category: "baccarat",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/ezugi/baccarat/BaccaratSuper6.webp",
      //   alt: "Baccarat Super 6",
      //   name: "Baccarat Super 6",
      // },
      CasinoMarinaBaccarat1: {
        href: "/casino/ezg-casino-marina-baccarat-1",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat1.webp",
        alt: "Casino Marina Baccarat 1",
        name: "Casino Marina Baccarat 1",
      },
      CasinoMarinaBaccarat2: {
        href: "/casino/ezg-casino-marina-baccarat-2",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat2.webp",
        alt: "Casino Marina Baccarat 2",
        name: "Casino Marina Baccarat 2",
      },
      CasinoMarinaBaccarat3: {
        href: "/casino/ezg-casino-marina-baccarat-3",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat3.webp",
        alt: "Casino Marina Baccarat 3",
        name: "Casino Marina Baccarat 3",
      },
      CasinoMarinaBaccarat4: {
        href: "/casino/ezg-casino-marina-baccarat-4",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/CasinoMarinaBaccarat4.webp",
        alt: "Casino Marina Baccarat 4",
        name: "Casino Marina Baccarat 4",
      },
      CricketWar: {
        href: "/casino/ezg-cricket-war",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/CricketWar.webp",
        alt: "Cricket War",
        name: "Cricket War",
      },
      DragonTiger: {
        href: "/casino/ezg-dragon-tiger",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/DragonTiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      DragonRoulette: {
        href: "/casino/ezg-dragon-tiger",
        code: "",
        casino: "ezugi",
        provider: "",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/xpg/baccarat/DragonRoulette.webp",
        alt: "Dragon Roulette",
        name: "Dragon Roulette",
      },
      FiestaBaccarat: {
        href: "/casino/ezg-fiesta-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/FiestaBaccarat.webp",
        alt: "Fiesta Baccarat",
        name: "Fiesta Baccarat",
      },
      FortuneBaccarat: {
        href: "/casino/ezg-fortune-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/FortuneBaccarat.webp",
        alt: "Fortune Baccarat",
        name: "Fortune Baccarat",
      },
      SpeedCricketBaccarat: {
        href: "/casino/ezg-speed-cricket-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/baccarat/SpeedCricketBaccarat.webp",
        alt: "Speed Cricket Baccarat",
        name: "Speed Cricket Baccarat",
      },
      NoCommissionBaccarat: {
        href: "/casino/ezg-no-commission-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/NoCommissionBaccarat.webp",
        alt: "No Commission Baccarat",
        name: "No Commission Baccarat",
      },
    },
    lucky7: {
      lucky7: {
        href: "/casino/ezg-lucky-7",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "lucky7",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/lucky7/lucky7.webp",
        alt: "Lucky 7",
        name: "Lucky 7",
      },
    },
    cards32: {
      cards32: {
        href: "/casino/ezg-32-cards",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "cards32",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/card32/32cards.webp",
        alt: "32 Cards",
        name: "32 Cards",
      },
    },
    lottery: {
      BetonNumbers: {
        href: "/casino/ezg-bet-on-numbers-hd",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "lottery",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/lottery/BetonNumbers.webp",
        alt: "Bet On Numbers",
        name: "Bet On Numbers",
      },
    },
    poker: {
      BetonTeenPatti: {
        href: "/casino/ezg-bet-on-teen-patti",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/poker/BetonTeenPatti.webp",
        alt: "Bet on Teen Patti",
        name: "Bet on Teen Patti",
      },
      CasinoHoldem: {
        href: "/casino/ezg-casino-holdem",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/poker/CasinoHoldem.webp",
        alt: "Casino Holdem",
        name: "Casino Holdem",
      },
      OneDayTeenPatti: {
        href: "/casino/ezg-one-day-teen-patti",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/poker/OneDayTeenPatti.webp",
        alt: "One Day Teen Patti",
        name: "One Day Teen Patti",
      },
      TeenPatti3Card: {
        href: "/casino/ezg-teen-patti-3-card",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/poker/TeenPatti3Card.webp",
        alt: "Teen Patti 3 Card",
        name: "Teen Patti 3 Card",
      },
    },
    craps: {
      FortuneBaccaratCr: {
        href: "/casino/ezg-fortune-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/FortuneBaccarat.webp",
        alt: "Fortune Baccarat",
        name: "Fortune Baccarat",
      },
      OneDayTeenPattiCr: {
        href: "/casino/ezg-one-day-teen-patti",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/OneDayTeenPatti.webp",
        alt: "One Day Teen Patti",
        name: "One Day Teen Patti",
      },
      SalonPriveBlackjackCr: {
        href: "/casino/ezg-salon-prive-blackjack",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/SalonPriveBlackjack.webp",
        alt: "Salon Prive Blackjack",
        name: "Salon Prive Blackjack",
      },
      SicBoCr: {
        href: "/casino/ezg-sic-bo",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/SicBo.webp",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
      UltimateSicBoCr: {
        href: "/casino/ezg-ultimate-sic-bo",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/UltimateSicBo.webp",
        alt: "Ultimate Sic Bo",
        name: "Ultimate Sic Bo",
      },
      VIPFortuneBaccaratCr: {
        href: "/casino/ezg-vip-fortune-baccarat",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/VIPFortuneBaccarat.webp",
        alt: "VIP Fortune Baccarat",
        name: "VIP Fortune Baccarat",
      },
    },
    sicbo: {
      sicbo: {
        href: "/casino/ezg-sic-bo",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "sicbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/sicbo/Sicbo.webp",
        alt: "Sicbo",
        name: "Sicbo",
      },
      UltimateSicBo: {
        href: "/casino/ezg-ultimate-sic-bo",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "sicbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/sicbo/UltimateSicBo.webp",
        alt: "Ultimate Sic Bo",
        name: "Ultimate Sic Bo",
      },
    },
  },

  evolution: {
    roulette: {
      SpeedRoulette: {
        href: "/casino/ezgevo-speed-roulette",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/roulette/SpeedRoulette.webp",
        alt: "Speed Roulette",
        name: "Speed Roulette",
      },
      AmericanRoulette: {
        href: "/casino/ezgevo-american-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/AmericanRoulette.webp",
        alt: "American Roulette",
        name: "American Roulette",
      },
      DoubleBallRouletteEvo: {
        href: "/casino/ezgevo-double-ball-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/DoubleBallRoulette.webp",
        alt: "Double Ball Roulette",
        name: "Double Ball Roulette",
      },
      FirstPersonAmericanRoulette: {
        href: "/casino/ezgevo-first-person-american-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/roulette/FirstPersonAmericanRoulette.webp",
        alt: "First Person American Roulette",
        name: "First Person American Roulette",
      },
      FirstPersonLightningRoulette: {
        href: "/casino/ezgevo-first-person-lightning-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/roulette/FirstPersonLightningRoulette.webp",
        alt: "First Person lightning Roulette",
        name: "First Person lightning Roulette",
      },
      FirstPersonRoulette: {
        href: "/casino/ezgevo-first-person-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/FirstPersonRoulette.webp",
        alt: "First Person Roulette",
        name: "First Person Roulette",
      },
      ImmersiveRouletteEvo: {
        href: "/casino/ezgevo-immersive-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/ImmersiveRoulette.webp",
        alt: "Immersive Roulette",
        name: "Immersive Roulette",
      },
      InstantRouletteEvo: {
        href: "/casino/ezgevo-instant-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/InstantRoulette.webp",
        alt: "Instant Roulette",
        name: "Instant Roulette",
      },
      LightningRoulette: {
        href: "/casino/ezgevo-lightning-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/LightningRoulette.webp",
        alt: "Lightning Roulette",
        name: "Lightning Roulette",
      },
      Roulette: {
        href: "/casino/ezgevo-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/Roulette.webp",
        alt: "Roulette",
        name: "Roulette",
      },
      SalonPrivatRoulette: {
        href: "/casino/ezgevo-salon-prive-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/SalonPrivatRoulette.webp",
        alt: "Salon Privé Roulette",
        name: "Salon Privé Roulette",
      },
      SpeedAutoRouletteEvo: {
        href: "/casino/ezgevo-speed-auto-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/SpeedAutoRoulette.webp",
        alt: "Speed Auto Roulette",
        name: "Speed Auto Roulette",
      },
      SpeedRouletteEvo: {
        href: "/casino/ezgevo-speed-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/SpeedRoulette.webp",
        alt: "Speed Roulette",
        name: "Speed Roulette",
      },
      TurkishLightningRoulette: {
        href: "/casino/ezgevo-turkish-lightning-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/roulette/TurkishLightningRoulette.webp",
        alt: "Turkish Lightning Roulette",
        name: "Turkish Lightning Roulette",
      },
      VIPRoulette: {
        href: "/casino/ezgevo-vip-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/roulette/VIPRoulette.webp",
        alt: "VIP Roulette",
        name: "VIP Roulette",
      },
    },
    blackjack: {
      BlackjackSilverA: {
        href: "/casino/ezgevo-blackjack-silver-a",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverA.webp",
        alt: "Blackjack Silver A",
        name: "Blackjack Silver A",
      },
      BlackjackSilverB: {
        href: "/casino/ezgevo-blackjack-silver-b",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverB.webp",
        alt: "Blackjack Silver B",
        name: "Blackjack Silver B",
      },
      BlackjackSilverC: {
        href: "/casino/ezgevo-blackjack-silver-c",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverC.webp",
        alt: "Blackjack Silver C",
        name: "Blackjack Silver C",
      },
      BlackjackSilverD: {
        href: "/casino/ezgevo-blackjack-silver-d",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverD.webp",
        alt: "Blackjack Silver D",
        name: "Blackjack Silver D",
      },
      BlackjackSilverE: {
        href: "/casino/ezgevo-blackjack-silver-e",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverE.webp",
        alt: "Blackjack Silver E",
        name: "Blackjack Silver E",
      },
      BlackjackSilverF: {
        href: "/casino/ezgevo-blackjack-silver-f",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverF.webp",
        alt: "Blackjack Silver F",
        name: "Blackjack Silver F",
      },
      BlackjackSilverG: {
        href: "/casino/ezgevo-blackjack-silver-g",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackSilverG.webp",
        alt: "Blackjack Silver G",
        name: "Blackjack Silver G",
      },
      BlackjackVIP1: {
        href: "/casino/ezgevo-blackjack-vip-1",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP1.webp",
        alt: "Blackjack VIP 1",
        name: "Blackjack VIP 1",
      },
      BlackjackVIP2: {
        href: "/casino/ezgevo-blackjack-vip-2",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP2.webp",
        alt: "Blackjack VIP 2",
        name: "Blackjack VIP 2",
      },
      BlackjackVIP3: {
        href: "/casino/ezgevo-blackjack-vip-3",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP3.webp",
        alt: "Blackjack VIP 3",
        name: "Blackjack VIP 3",
      },
      BlackjackVIP4: {
        href: "/casino/ezgevo-blackjack-vip-4",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP4.webp",
        alt: "Blackjack VIP 4",
        name: "Blackjack VIP 4",
      },
      BlackjackVIP5: {
        href: "/casino/ezgevo-blackjack-vip-5",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackVIP5.webp",
        alt: "Blackjack VIP 5",
        name: "Blackjack VIP 5",
      },
      FirstPersonBlackjack: {
        href: "/casino/ezgevo-first-person-blackjack-u7366",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/FirstPersonBlackjack.webp",
        alt: "First Person Blackjack",
        name: "First Person Blackjack",
      },
      FirstPersonLightningBlackjack: {
        href: "/casino/ezgevo-first-person-lightning-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/blackjack/FirstPersonLightningBlackjack.webp",
        alt: "First Person Lightning Blackjack",
        name: "First Person Lightning Blackjack",
      },
      InfiniteBlackjack: {
        href: "/casino/ezgevo-infinite-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/InfiniteBlackjack.webp",
        alt: "Infinite Blackjack",
        name: "Infinite Blackjack",
      },
      LightningBlackjack: {
        href: "/casino/ezgevo-infinite-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/LightningBlackjack.webp",
        alt: "Lightning Blackjack",
        name: "Lightning Blackjack",
      },
      PowerBlackjack: {
        href: "/casino/ezgevo-power-blackjack",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/PowerBlackjack.webp",
        alt: "Power Blackjack",
        name: "Power Blackjack",
      },
      BlackjackA: {
        href: "/casino/ezgevo-blackjack-a",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackA.webp",
        alt: "Blackjack A",
        name: "Blackjack A",
      },
      BlackjackB: {
        href: "/casino/ezgevo-blackjack-b",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackB.webp",
        alt: "Blackjack B",
        name: "Blackjack B",
      },
      BlackjackC: {
        href: "/casino/ezgevo-blackjack-c",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackC.webp",
        alt: "Blackjack C",
        name: "Blackjack C",
      },
      BlackjackParty: {
        href: "/casino/ezgevo-blackjack-party",
        code: "",
        casino: "evolution",
        provider: "ezugi",
        category: "blackjack",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/blackjack/BlackjackParty.webp",
        alt: "Blackjack Party",
        name: "Blackjack Party",
      },
    },
    baccarat: {
      BaccaratA: {
        href: "/casino/ezgevo-speed-baccarat-a",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/BaccaratA.webp",
        alt: "Baccarat A",
        name: "Baccarat A",
      },
      BaccaratB: {
        href: "/casino/ezgevo-speed-baccarat-b",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/BaccaratB.webp",
        alt: "Baccarat B",
        name: "Baccarat B",
      },
      BaccaratC: {
        href: "/casino/ezgevo-speed-baccarat-c",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/BaccaratC.webp",
        alt: "Baccarat C",
        name: "Baccarat C",
      },
      BaccaratControlSqueeze: {
        href: "/casino/ezgevo-baccarat-control-squeeze",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/BaccaratControlSqueeze.webp",
        alt: "Baccarat Control Squeeze",
        name: "Baccarat Control Squeeze",
      },
      BaccaratSqueeze: {
        href: "/casino/ezgevo-baccarat-squeeze",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/BaccaratSqueeze.webp",
        alt: "Baccarat Squeeze",
        name: "Baccarat Squeeze",
      },
      FirstPersonBaccarat: {
        href: "/casino/ezgevo-first-person-baccarat",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/FirstPersonBaccarat.webp",
        alt: "First Person Baccarat",
        name: "First Person Baccarat",
      },
      FirstPersonGoldenWealthBaccarat: {
        href: "/casino/ezgevo-first-person-golden-wealth-baccarat",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/baccarat/FirstPersonGoldenWealthBaccarat.webp",
        alt: "First Person Golden Wealth Baccarat",
        name: "First Person Golden Wealth Baccarat",
      },
      FirstPersonLightningBaccarat: {
        href: "/casino/ezgevo-first-person-lightning-baccarat",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/baccarat/FirstPersonLightningBaccarat.webp",
        alt: "First Person Lightning Baccarat",
        name: "First Person Lightning Baccarat",
      },
      GoldenWealthBaccarat: {
        href: "/casino/ezgevo-golden-wealth-baccarat",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/GoldenWealthBaccarat.webp",
        alt: "Golden Wealth Baccarat",
        name: "Golden Wealth Baccarat",
      },
      LightningBaccarat: {
        href: "/casino/ezgevo-lightning-baccarat",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "baccarat",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/baccarat/LightningBaccarat.webp",
        alt: "Lightning Baccarat",
        name: "Lightning Baccarat",
      },
    },
    poker: {
      Hand2CasinoHoldem: {
        href: "/casino/ezgevo-2-hand-casino-holdem",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/2HandCasinoHoldem.webp",
        alt: "2 Hand Casino Holdem",
        name: "2 Hand Casino Holdem",
      },
      CasinoHoldem: {
        href: "/casino/ezgevo-casino-holdem-evo",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/CasinoHoldem.webp",
        alt: "Casino Hold'em-EVO",
        name: "Casino Hold'em-EVO",
      },
      FootballStudio: {
        href: "/casino/ezgevo-football-studio",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/FootballStudio.webp",
        alt: "Football studio",
        name: "Football studio",
      },
      SideBetCity: {
        href: "/casino/ezgevo-side-bet-city",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/SideBetCity.webp",
        alt: "Side Bet City",
        name: "Side Bet City",
      },
      TexasHoldemBonusPoker: {
        href: "/casino/ezgevo-texas-holdem-bonus-poker",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/TexasHoldemBonusPoker.webp",
        alt: "Texas Hold'em Bonus Poker",
        name: "Texas Hold'em Bonus Poker",
      },
      ThreeCardPoker: {
        href: "/casino/ezgevo-three-card-poker",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "poker",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/poker/ThreeCardPoker.webp",
        alt: "Three Card Pokerr",
        name: "Three Card Pokerr",
      },
    },
    craps: {
      CricketWarCr: {
        href: "/casino/ezgevo-cash-or-crash",
        code: "",
        casino: "ezugi",
        provider: "ezugi",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/ezugi/craps/CricketWar.webp",
        alt: "Cricket War",
        name: "Cricket War",
      },
      CashOrCrashCr: {
        href: "/casino/ezgevo-cash-or-crash",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/CashOrCrash.webp",
        alt: "Cash or Crash",
        name: "Cash or Crash",
      },
      Craps: {
        href: "/casino/ezgevo-craps",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/Craps.webp",
        alt: "Craps",
        name: "Craps",
      },
      CrazyTimeCr: {
        href: "/casino/ezgevo-crazy-time",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/CrazyTime.webp",
        alt: "Crazy Time",
        name: "Crazy Time",
      },
      DoubleBallRouletteCr: {
        href: "/casino/ezgevo-double-ball-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/DoubleBallRoulette.webp",
        alt: "Double Ball Roulette",
        name: "Double Ball Roulette",
      },
      FirstPersonAmericanRouletteCr: {
        href: "/casino/ezgevo-first-person-american-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/craps/FirstPersonAmericanRoulette.webp",
        alt: "First Person American Roulette",
        name: "First Person American Roulette",
      },
      FirstpersonCraps: {
        href: "/casino/ezgevo-first-person-craps",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/FirstpersonCraps.webp",
        alt: "First Person Craps",
        name: "First Person Craps",
      },
      GonzosTreasureHuntCr: {
        href: "/casino/ezgevo-gonzos-treasure-hunt",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/GonzosTreasureHunt.webp",
        alt: "Gonzo's Treasure Hunt",
        name: "Gonzo's Treasure Hunt",
      },
      InstantRouletteCr: {
        href: "/casino/ezgevo-instant-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/InstantRoulette.webp",
        alt: "Instant Roulette",
        name: "Instant Roulette",
      },
      LightningBlackjackCr: {
        href: "/casino/ezgevo-lightning-blackjack",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/LightningBlackjack.webp",
        alt: "Lightning Blackjack",
        name: "Lightning Blackjack",
      },
      PowerBlackjackCr: {
        href: "/casino/ezgevo-power-blackjack",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/PowerBlackjack.webp",
        alt: "Power Blackjack",
        name: "Power Blackjack",
      },
      SpeedRouletteCr: {
        href: "/casino/ezgevo-speed-roulette",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/SpeedRoulette.webp",
        alt: "Speed Roulette",
        name: "Speed Roulette",
      },
      TexasHoldemBonusCr: {
        href: "/casino/ezgevo-texas-holdem-bonus-poker",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/TexasHoldemBonus.webp",
        alt: "Texas Hold'em Bonus Poker",
        name: "Texas Hold'em Bonus Poker",
      },
      TripleCardPokerCr: {
        href: "/casino/qtechevolutiongaming-triple-card-poker",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "craps",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/craps/TripleCardPoker.webp",
        alt: "Triple Card Poker",
        name: "Triple Card Poker",
      },
    },
    sicbo: {
      DragonTigerSB: {
        href: "/casino/ezgevo-dragon-tiger-evo",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "sicbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/sicbo/DragonTiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      FirstPersonDragonTiger: {
        href: "/casino/ezgevo-first-person-dragon-tiger",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "sicbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/sicbo/FirstPersonDragonTiger.webp",
        alt: "First Person Dragon Tiger",
        name: "First Person Dragon Tiger",
      },
      SuperSicBo: {
        href: "/casino/ezgevo-super-sic-bo",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "sicbo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/sicbo/SuperSicBo.webp",
        alt: "Super Sic Bo",
        name: "Super Sic Bo",
      },
    },
    gameshow: {
      CashOrCrashGS: {
        href: "/casino/ezgevo-cash-or-crash",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/CashOrCrash.webp",
        alt: "Cash or Crash",
        name: "Cash or Crash",
      },
      CrazyTimeGS: {
        href: "/casino/ezgevo-crazy-time",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/CrazyTime.webp",
        alt: "Crazy Time",
        name: "Crazy Time",
      },
      DreamCatcherGS: {
        href: "/casino/ezgevo-dream-catcher",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/DreamCatcher.webp",
        alt: "Dream Catcher",
        name: "Dream Catcher",
      },
      FirstPersonDreamCatcherGS: {
        href: "/casino/ezgevo-first-person-dream-catcher",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl:
          "/images/casino/evolution/game-shows/FirstPersonDreamCatcher.webp",
        alt: "First Person Dream Catcher",
        name: "First Person Dream Catcher",
      },
      FirstPersonMegaballGS: {
        href: "/casino/ezgevo-first-person-mega-ball",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/FirstPersonMegaball.webp",
        alt: "First Person Mega Ball",
        name: "First Person Mega Ball",
      },
      FirstPersonTopCardGS: {
        href: "/casino/ezgevo-first-person-top-card",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/FirstPersonTopCard.webp",
        alt: "First Person Top Card",
        name: "First Person Top Card",
      },
      FootballStudioGS: {
        href: "/casino/ezgevo-football-studio",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/FootballStudio.webp",
        alt: "Football Studio",
        name: "Football Studio",
      },
      GonzosTreasureHuntGS: {
        href: "/casino/ezgevo-gonzos-treasure-hunt",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/GonzosTreasureHunt.webp",
        alt: "Gonzo's Treasure Hunt",
        name: "Gonzo's Treasure Hunt",
      },
      LightningDiceGS: {
        href: "/casino/ezgevo-lightning-dice",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/LightningDice.webp",
        alt: "Lightning Dice",
        name: "Lightning Dice",
      },
      MegaBallGS: {
        href: "/casino/ezgevo-mega-ball",
        code: "",
        casino: "ezugi",
        provider: "evolution",
        category: "gameshow",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/evolution/game-shows/MegaBall.webp",
        alt: "Mega Ball",
        name: "Mega Ball",
      },
    },
  },

 


  // xpg: {
  //   roulette: {
  //     FastRoulette: {
  //       href: "/casino/xpg-fast-roulette",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "roulette",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/roulette/Fast-Roulette.webp",
  //       alt: "Fast Roulette",
  //       name: "Fast Roulette",
  //     },
  //     GalaxyAutoRoulette: {
  //       href: "/casino/xpg-galaxy-auto-roulette",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "roulette",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/roulette/GalaxyAutoRoulette.webp",
  //       alt: "Galaxy Auto Roulette",
  //       name: "Galaxy Auto Roulette",
  //     },
  //     autorouletteXPG: {
  //       href: "/casino/xpg-auto-roulette",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "roulette",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/roulette/autoroulette.webp",
  //       alt: "Auto Roulette",
  //       name: "Auto Roulette",
  //     },
  //   },
  //   blackjack: {
  //     UltimatedBlackjack: {
  //       href: "/casino/xpg-unlimited-blackjack",
  //       code: "",
  //       casino: "xpg",
  //       provider: "xpg",
  //       category: "blackjack",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/blackjack/UltimatedBlackjack.webp",
  //       alt: "Ultimated Blackjack",
  //       name: "Ultimated Blackjack",
  //     },
  //     VipBlackjack: {
  //       href: "/casino/xpg-w-vip-blackjack",
  //       code: "",
  //       casino: "xpg",
  //       provider: "xpg",
  //       category: "blackjack",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/blackjack/VipBlackjack.webp",
  //       alt: "VIP Blackjack",
  //       name: "VIP Blackjack",
  //     },
  //   },
  //   baccarat: {
  //     FastBaccarat: {
  //       href: "/casino/xpg-fast-baccarat",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "baccarat",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/baccarat/FastBaccarat.webp",
  //       alt: "Fast Baccarat",
  //       name: "Fast Baccarat",
  //     },
  //     VipGoldBaccarat: {
  //       href: "/casino/xpg-vip-gold-baccarat",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "baccarat",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/baccarat/VipGoldBaccarat.webp",
  //       alt: "Vip Gold Baccarat",
  //       name: "Vip Gold Baccarat",
  //     },
  //   },
  //   cards32: {
  //     cards32xpg: {
  //       href: "/casino/xpg-32-cards-u2119",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "cards32",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/cards32/32Cards.webp",
  //       alt: "32 Cards",
  //       name: "32 Cards",
  //     },
  //   },
  //   sicbo: {
  //     SicBoXPG: {
  //       href: "/casino/xpg-sicbo",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "xpg",
  //       category: "sicbo",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/xpg/sicbo/SicBo.webp",
  //       alt: "Sic Bo",
  //       name: "Sic Bo",
  //     },
  //   },
  // },

  // powergames: {
  //   powergames: {
  //     CaribbeanPoker: {
  //       href: "/casino/pg-caribbean-poker",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/CaribbeanPoker.webp",
  //       alt: "Caribbean Poker",
  //       name: "Caribbean Poker",
  //     },
  //     dice3d: {
  //       href: "/casino/pg-dice-3d",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/dice3d.webp",
  //       alt: "Dice 3d",
  //       name: "Dice 3d",
  //     },
  //     egyptslots: {
  //       href: "/casino/pg-egypt-slots",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/egyptslots.webp",
  //       alt: "Egypt Slots",
  //       name: "Egypt Slots",
  //     },
  //     fruitslots: {
  //       href: "/casino/pg-fruit-slots",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/fruitslots.webp",
  //       alt: "Fruit Slots",
  //       name: "Fruit Slots",
  //     },
  //     headortails: {
  //       href: "/casino/pg-heads-or-tails",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/headortails.webp",
  //       alt: "Head or Tails",
  //       name: "Head or Tails",
  //     },
  //     keno: {
  //       href: "/casino/pg-keno",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/keno.webp",
  //       alt: "Keno",
  //       name: "Keno",
  //     },
  //     parisslots: {
  //       href: "/casino/pg-paris-slots",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/parisslots.webp",
  //       alt: "Paris Slots",
  //       name: "Paris Slots",
  //     },
  //     slots3d: {
  //       href: "/casino/pg-slots-3d",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/slots3d.webp",
  //       alt: "Slots 3D",
  //       name: "Slots 3D",
  //     },
  //     videopoker: {
  //       href: "/casino/pg-video-poker",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/videopoker.webp",
  //       alt: "Video Poker",
  //       name: "Video Poker",
  //     },
  //     wheeloffortune: {
  //       href: "/casino/pg-wheel-of-fortune",
  //       code: "",
  //       casino: "ezugi",
  //       provider: "powergames",
  //       category: "powergames",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/power-games/wheel-of-fortune.webp",
  //       alt: "Wheel Of Fortune",
  //       name: "Wheel Of Fortune",
  //     },
  //   },
  // },

  auragaming: {
    improvedExperience: {
      DreamCatcher: {
        code: "98567",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Dream Catcher",
        name: "Dream Catcher",
        category: "improvedExperience",
        providerName: "aura",
        imgUrl: "/images/aura/DreamCatcher.jpg",
        href: "/casino/aura-dream-catcher",
      },
      TeenpattiT20: {
        code: "56768",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti T20",
        name: "Teenpatti T20",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiT20.jpg",
        href: "/casino/aura-teenpatti-t20",
      },
      DragonTiger: {
        code: "98790",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/DragonTiger.jpg",
        href: "/casino/aura-dragon-tiger",
      },
      UpDown7: {
        code: "98789",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "7 Up Down",
        name: "7 Up Down",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/7UpDown.jpg",
        href: "/casino/aura-7-up-down",
      },
      HiLow: {
        code: "56968\n",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Hi Low",
        name: "Hi Low",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/HiLow.jpg",
        href: "/casino/aura-hi-low",
      },
      CardTeenpatti2: {
        code: "67660",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "2 Card Teenpatti",
        name: "2 Card Teenpatti",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/2CardsTeenpatti.jpg",
        href: "/casino/aura-2-card-teenpatti",
      },
      CasinoWar: {
        code: "67580",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Casino War",
        name: "Casino War",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/CasinoWar.jpg",
        href: "/casino/aura-casino-war",
      },
      MuflisTeenpatti: {
        code: "67600",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Muflis Teenpatti",
        name: "Muflis Teenpatti",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/MuflisTeenpatti.jpg",
        href: "/casino/aura-muflis-teenpatti",
      },
      AndarBahar: {
        code: "87564",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Andar Bahar",
        name: "Andar Bahar",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/AndarBahar.jpg",
        href: "/casino/aura-andar-bahar",
      },
      QueenRace: {
        code: "67620",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Queen Race",
        name: "Queen Race",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/QueenRace.jpg",
        href: "/casino/aura-queen-race",
      },
      Poker2020: {
        code: "67567",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Poker 20-20",
        name: "Poker 20-20",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/Poker20-20.jpg",
        href: "/casino/aura-poker-20-20",
      },
      BollywoodCasino: {
        code: "67570",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Bollywood Casino",
        name: "Bollywood Casino",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/BollywoodCasino.jpg",
        href: "/casino/aura-bollywood-casino",
      },
      Teenpatti1Day: {
        code: "56767",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti 1 Day",
        name: "Teenpatti 1 Day",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiOneDay.jpg",
        href: "/casino/aura-teenpatti-1-Day",
      },
      Roulette: {
        code: "98788",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Roulette",
        name: "Roulette",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/Roulette.jpg",
        href: "/casino/aura-roulette",
      },
      AmarAkbarAnthony: {
        code: "98791",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Amar Akbar Anthony",
        name: "Amar Akbar Anthony",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/AmarAkbarAnthony.jpg",
        href: "/casino/aura-amar-akbar-anthony",
      },
      TeenpattiTest: {
        code: "67630",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti Test",
        name: "Teenpatti Test",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiTest.jpg",
        href: "/casino/aura-teenpatti-test",
      },
      Sicbo: {
        code: "98566",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Sicbo",
        name: "Sicbo",
        category: "improvedExperience",

        providerName: "aura",
        imgUrl: "/images/aura/Sicbo.jpg",
        href: "/casino/aura-sicbo",
      },
    },
    cardGames: {
      Poker: {
        code: "67564",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Poker",
        name: "Poker",
        providerName: "aura",
        imgUrl: "/images/aura/Poker.jpg",
        href: "/casino/aura-poker",
        category: "cardGames",
      },
      SuperOver: {
        code: "67720",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Super Over",
        name: "Super Over",
        providerName: "aura",
        imgUrl: "/images/aura/SuperOver.jpg",
        href: "/casino/aura-sper-over",
        category: "cardGames",
      },
      Matka: {
        code: "92037",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Matka",
        name: "Matka",
        providerName: "aura",
        imgUrl: "/images/aura/Matka(Virtual).jpg",
        href: "/casino/aura-matka",
        category: "cardGames",
      },
      Baccarat: {
        code: "92038",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Baccarat",
        name: "Baccarat",
        providerName: "aura",
        imgUrl: "/images/aura/Baccarat.jpg",
        href: "/casino/aura-baccarat",
        category: "cardGames",
      },
      Trio: {
        code: "67610",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Trio",
        name: "Trio",
        providerName: "aura",
        imgUrl: "/images/aura/Trio.jpg",
        href: "/casino/aura-trio",
        category: "cardGames",
      },
      CardsJudgement3: {
        code: "67670",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "3 Cards Judgement",
        name: "3 Cards Judgement",
        providerName: "aura",
        imgUrl: "/images/aura/3CardsJudgement.jpg",
        href: "/casino/aura-3-cards-judgement",
        category: "cardGames",
      },
      Race2020: {
        code: "90100",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Race 20-20",
        name: "Race 20-20",
        providerName: "aura",
        imgUrl: "/images/aura/Race20-20.jpg",
        href: "/casino/aura-race-20-20",
        category: "cardGames",
      },
      CardBaccarat29: {
        code: "67690",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "29 Card Baccarat",
        name: "29 Card Baccarat",
        providerName: "aura",
        imgUrl: "/images/aura/29CardBaccarat.jpg",
        href: "/casino/aura-29-card-baccarat",
        category: "cardGames",
      },
      TeenpattiOpen: {
        code: "67640",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti Open",
        name: "Teenpatti Open",
        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiOpen.jpg",
        href: "/casino/aura-teenpatti-open",
        category: "cardGames",
      },
      Raceto17: {
        code: "67710",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Race to 17",
        name: "Race to 17",
        providerName: "aura",
        imgUrl: "/images/aura/Raceto17.jpg",
        href: "/casino/aura-race-to-17",
        category: "cardGames",
      },
      Sixplayerpoker: {
        code: "67565",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Six player poker",
        name: "Six player poker",
        providerName: "aura",
        imgUrl: "/images/aura/Sixplayerpoker.jpg",
        href: "/casino/aura-six-player-poker",
        category: "cardGames",
      },
      CasinoMeter: {
        code: "67575",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Casino Meter",
        name: "Casino Meter",
        providerName: "aura",
        imgUrl: "/images/aura/CasinoMeter.jpg",
        href: "/casino/aura-casino-meter",
        category: "cardGames",
      },
      TheTrap: {
        code: "67680",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "The Trap",
        name: "The Trap",
        providerName: "aura",
        imgUrl: "/images/aura/TheTrap.jpg",
        href: "/casino/aura-the-trap",
        category: "cardGames",
      },
    },
    virtualCardGames: {
      upNDown7Virtual: {
        code: "98793",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "7 up & Down (Virtual)",
        name: "7 up & Down (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/7up&Down(Virtual).jpg",
        href: "/casino/aura-7-up-&-down-virtual",
        category: "virtualCardGames",
      },
      DragonTigerVirtual: {
        code: "98794",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Dragon Tiger (Virtual)",
        name: "Dragon Tiger (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/DragonTiger(Virtual).jpg",
        href: "/casino/aura-dragon-tiger-virtual",
        category: "virtualCardGames",
      },
      TeenpattiT20Virtual: {
        code: "56769",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti T20 (Virtual)",
        name: "Teenpatti T20 (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiT20(Virtual).jpg",
        href: "/casino/aura-teenpatti-t20-virtual",
        category: "virtualCardGames",
      },
      HiLowVirtual: {
        code: "56969",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Hi Low (Virtual)",
        name: "Hi Low (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/HiLow(Virtual).jpg",
        href: "/casino/aura-hi-low-virtual",
        category: "virtualCardGames",
      },
      AmarAkbarAnthonyVirtual: {
        code: "98795",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Amar Akbar Anthony (Virtual)",
        name: "Amar Akbar Anthony (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/AmarAkbarAnthony(Virtual).jpg",
        href: "/casino/aura-amar-akbar-anthony-virtual",
        category: "virtualCardGames",
      },
      RouletteVirtual: {
        code: "98792",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Roulette (Virtual)",
        name: "Roulette (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Roulette(Virtual).jpg",
        href: "/casino/aura-roulette-virtual",
        category: "virtualCardGames",
      },
      AndarBaharVirtual: {
        code: "87565",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Andar Bahar (Virtual)",
        name: "Andar Bahar (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/AndarBahar(Virtual).jpg",
        href: "/casino/aura-andar-bahar-virtual",
        category: "virtualCardGames",
      },
      cardscasinoVirtual32: {
        code: "56966",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "32 cards casino (Virtual)",
        name: "32 cards casino (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/32cardscasino(Virtual).jpg",
        href: "/casino/aura-32-cards-casino-virtual",
        category: "virtualCardGames",
      },
      MatkaVirtual: {
        code: "92036",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Matka (Virtual)",
        name: "Matka (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Matka(Virtual).jpg",
        href: "/casino/aura-matka-virtual",
        category: "virtualCardGames",
      },
      TeenpattiOneDayVirtual: {
        code: "56766",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti One-Day (Virtual)",
        name: "Teenpatti One-Day (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiOneDay(Virtual).jpg",
        href: "/casino/aura-teenpatti-one-day-virtual",
        category: "virtualCardGames",
      },
      PokerVirtual: {
        code: "67563",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Poker  (Virtual)",
        name: "Poker  (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Poker(Virtual).jpg",
        href: "/casino/aura-poker-virtual",
        category: "virtualCardGames",
      },
      SixplayerpokerVirtual: {
        code: "67566",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Six player poker (Virtual)",
        name: "Six player poker (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Sixplayerpoker(Virtual).jpg",
        href: "/casino/aura-six-player-poker-virtual",
        category: "virtualCardGames",
      },
      Race2020Virtual: {
        code: "90101",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Race 20-20 (Virtual)",
        name: "Race 20-20 (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Race20-20(Virtual).jpg",
        href: "/casino/aura-Race-20-20-virtual",
        category: "virtualCardGames",
      },
      MuflisTeenpattivirtual: {
        code: "67601",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Muflis Teenpatti (virtual)",
        name: "Muflis Teenpatti (virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/MuflisTeenpatti(virtual).jpg",
        href: "/casino/aura-muflis-teenpatti-virtual",
        category: "virtualCardGames",
      },
      Poker2020Virtual: {
        code: "67568",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Poker 20-20 (Virtual)",
        name: "Poker 20-20 (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Poker20-20(Virtual).jpg",
        href: "/casino/aura-poker-20-20-virtual",
        category: "virtualCardGames",
      },
      Triovirtual: {
        code: "67611",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Trio (virtual)",
        name: "Trio (virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Trio(virtual).jpg",
        href: "/casino/aura-trio-virtual",
        category: "virtualCardGames",
      },
      CasinoMeterVirtual: {
        code: "67576",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Casino Meter (Virtual)",
        name: "Casino Meter (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/CasinoMeter(Virtual).jpg",
        href: "/casino/aura-casino-meter-virtual",
        category: "virtualCardGames",
      },
      TeenpattiTestvirtual: {
        code: "67631",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti Test (virtual)",
        name: "Teenpatti Test (virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiTest(virtual).jpg",
        href: "/casino/aura-teenpatti-test-virtual",
        category: "virtualCardGames",
      },
      TeenpattiOpenvirtual: {
        code: "67641",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Teenpatti Open (virtual)",
        name: "Teenpatti Open (virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/TeenpattiOpen(virtual).jpg",
        href: "/casino/aura-teenpatti-open-virtual",
        category: "virtualCardGames",
      },
      CasinoWarVirtual: {
        code: "67581",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Casino War (Virtual)",
        name: "Casino War (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/CasinoWar(Virtual).jpg",
        href: "/casino/aura-casino-war-virtual",
        category: "virtualCardGames",
      },
      BaccaratVirtual: {
        code: "92039",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Baccarat (Virtual)",
        name: "Baccarat (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/Baccarat(Virtual).jpg",
        href: "/casino/aura-baccarat-virtual",
        category: "virtualCardGames",
      },
      BollywoodCasinoVirtual: {
        code: "67571",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Bollywood Casino (Virtual)",
        name: "Bollywood Casino (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/BollywoodCasino(Virtual).jpg",
        href: "/casino/aura-bollywood-casino-virtual",
        category: "virtualCardGames",
      },
      QueenRaceVirtual: {
        code: "67621",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Queen Race (Virtual)",
        name: "Queen Race (Virtual)",
        providerName: "aura",
        imgUrl: "/images/aura/QueenRace.jpg",
        href: "/casino/aura-queen-race-virtual",
        category: "virtualCardGames",
      },
    },
    instantGames: {
      Blastoff: {
        category: "instantGames",
        code: "67722",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Blastoff",
        name: "Blastoff",
        providerName: "aura",
        imgUrl: "/images/aura/Blastoff.jpg",
        href: "/casino/aura-blastoff",
      },
      FortuneWheel: {
        category: "instantGames",
        code: "70001",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Fortune Wheel",
        name: "Fortune Wheel",
        providerName: "aura",
        imgUrl: "/images/aura/FortuneWheel.jpg",
        href: "/casino/aura-fortune-wheel",
      },
      CoinToss: {
        category: "instantGames",
        code: "70003",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Coin Toss",
        name: "Coin Toss",
        providerName: "aura",
        imgUrl: "/images/aura/CoinToss.jpg",
        href: "/casino/aura-coin-toss",
      },
      Limbo: {
        category: "instantGames",
        code: "70004",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Limbo",
        name: "Limbo",
        providerName: "aura",
        imgUrl: "/images/aura/Limbo.jpg",
        href: "/casino/aura-limbo",
      },
      SlotGame: {
        category: "instantGames",
        code: "70005",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Slot Game",
        name: "Slot Game",
        providerName: "aura",
        imgUrl: "/images/aura/SlotGame.jpg",
        href: "/casino/aura-slot-game",
      },
      RockPaperScissors: {
        category: "instantGames",
        code: "70006",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Rock Paper Scissors",
        name: "Rock Paper Scissors",
        providerName: "aura",
        imgUrl: "/images/aura/RockPaperScissors.jpg",
        href: "/casino/aura-rock-paper-scissors",
      },
      Cricket: {
        category: "instantGames",
        code: "70008",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Cricket",
        name: "Cricket",
        providerName: "aura",
        imgUrl: "/images/aura/Cricket.jpg",
        href: "/casino/aura-cricket",
      },
      ClassicDice: {
        category: "instantGames",
        code: "70009",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Classic Dice",
        name: "Classic Dice",
        providerName: "aura",
        imgUrl: "/images/aura/ClassicDice.jpg",
        href: "/casino/aura-classic-dice",
      },
      Aviator: {
        category: "instantGames",
        code: "67722",
        casino: "aura",
        provider: "aura",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Aviator",
        name: "Aviator",
        providerName: "aura",
        imgUrl: "/images/aura/Aviator.jpg",
        href: "/casino/aura-aviator",
      },
    },
    mines: {
      mines: {
        category: "instantGames",
        code: "70011",
        casino: "aura",
        provider: "aura",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Mines",
        name: "Mines",
        providerName: "aura",
        imgUrl: "/images/aura/Mines.jpg",
        href: "/casino/aura-mines",
      },
    },
  },

  kingmaker: {
    kingmaker: {
      CardPoker5: {
        href: "/casino/km-5-card-poker",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/5-card-poker.jpg",
        homeUrl: "",
        name: "Card Poker",
        providerName: "Kingmaker",
      },
      up7down7: {
        href: "/casino/km-7-up-7-down",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/7-up-7-down.jpg",
        homeUrl: "",
        name: "7 up 7 down",
        providerName: "Kingmaker",
      },
      cards32: {
        href: "/casino/km-32-cards",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/32-cards.jpg",
        homeUrl: "",
        name: "32 Cards",
        providerName: "Kingmaker",
      },
      AndarBahar: {
        href: "/casino/km-andar-bahar",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/andar-bahar.jpg",
        homeUrl: "",
        name: "Andar Bahar",
        providerName: "Kingmaker",
      },
      Baccarat: {
        href: "/casino/km-baccarat",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/baccarat.jpg",
        homeUrl: "",
        name: "Baccarat",
        providerName: "Kingmaker",
      },
      BaiBuu: {
        href: "/casino/km-bai-buu",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/bai-buu.jpg",
        homeUrl: "",
        name: "Bai Buu",
        providerName: "Kingmaker",
      },
      BaiCao: {
        href: "/casino/km-bai-cao",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/bai-cao.jpg",
        homeUrl: "",
        name: "Bai Cao",
        providerName: "Kingmaker",
      },
      Belangkai2: {
        href: "/casino/km-belangkai-2",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/belangkai-2.jpg",
        homeUrl: "",
        name: "Belangkai 2",
        providerName: "Kingmaker",
      },
      Blackjack: {
        href: "/casino/km-blackjack",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/blackjack.jpg",
        homeUrl: "",
        name: "Blackjack",
        providerName: "Kingmaker",
      },
      BolaGolek: {
        href: "/casino/km-bola-golek",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/bola-golek.jpg",
        homeUrl: "",
        name: "Bola Golek",
        providerName: "Kingmaker",
      },
      BolaTangkas: {
        href: "/casino/km-bola-tangkas",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/bola-tangkas.jpg",
        homeUrl: "",
        name: "Bola Tangkas",
        providerName: "Kingmaker",
      },
      BonusDice: {
        href: "/casino/km-bonus-dice",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/bonus-dice.jpg",
        homeUrl: "",
        name: "Bonus Dice",
        providerName: "Kingmaker",
      },
      CardHiLo: {
        href: "/casino/km-card-hi-lo",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/card-hi-lo.jpg",
        homeUrl: "",
        name: "Card Hi Lo",
        providerName: "Kingmaker",
      },
      CashRocket: {
        href: "/casino/km-cash-rocket",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/cash-rocket.jpg",
        homeUrl: "",
        name: "Cash Rocket",
        providerName: "Kingmaker",
      },
      CleopatrasTreasure: {
        href: "/casino/km-cleopatras-treasure",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/cleopatras-treasure.jpg",
        homeUrl: "",
        name: "Cleopatras Treasure",
        providerName: "Kingmaker",
      },
      CockfightingArena: {
        href: "/casino/km-cockfighting-arena",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/cockfighting-arena.jpg",
        homeUrl: "",
        name: "Cockfighting Arena",
        providerName: "Kingmaker",
      },
      CoinPusher: {
        href: "/casino/km-coin-pusher",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/coin-pusher.jpg",
        homeUrl: "",
        name: "Coin Pusher",
        providerName: "Kingmaker",
      },
      CoinToss: {
        href: "/casino/km-coin-toss",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/coin-toss.jpg",
        homeUrl: "",
        name: "Coin Toss",
        providerName: "Kingmaker",
      },
      ColorGame: {
        href: "/casino/km-color-game",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/color-game.jpg",
        homeUrl: "",
        name: "Color Game",
        providerName: "Kingmaker",
      },
      DotaHiLo: {
        href: "/casino/km-dota-hi-lo",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/dota-hi-lo.jpg",
        homeUrl: "",
        name: "Dota Hi Lo",
        providerName: "Kingmaker",
      },
      DragonTiger2: {
        href: "/casino/km-dragon-tiger-2",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/dragon-tiger-2.jpg",
        homeUrl: "",
        name: "Dragon Tiger 2",
        providerName: "Kingmaker",
      },
      EliteAviatorClub: {
        href: "/casino/km-elite-aviator-club",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/elite-aviator-club.jpg",
        homeUrl: "",
        name: "Elite Aviator Club",
        providerName: "Kingmaker",
      },
      EuropeanRoulette: {
        href: "/casino/km-european-roulette",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/european-roulette.jpg",
        homeUrl: "",
        name: "European Roulette",
        providerName: "Kingmaker",
      },
      FanTvanClassic: {
        href: "/casino/km-fan-tvan-classic",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/fan-tvan-classic.jpg",
        homeUrl: "",
        name: "Fan Tan Classic",
        providerName: "Kingmaker",
      },
      FishPrawnCrab2: {
        href: "/casino/km-fish-prawn-crab-2",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/fish-prawn-crab-2.jpg",
        homeUrl: "",
        name: "Fish Prawn Crab 2",
        providerName: "Kingmaker",
      },
      FruitRoulette: {
        href: "/casino/km-fruit-roulette",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/fruit-roulette.jpg",
        homeUrl: "",
        name: "FruitRoulette",
        providerName: "Kingmaker",
      },
      GemsOfValhalla: {
        href: "/casino/km-gems-of-valhalla",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/gems-of-valhalla.jpg",
        homeUrl: "",
        name: "Gems Of Valhalla",
        providerName: "Kingmaker",
      },
      Heist: {
        href: "/casino/km-heist",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/heist.jpg",
        homeUrl: "",
        name: "heist",
        providerName: "Kingmaker",
      },
      InterstellarRun: {
        href: "/casino/km-interstellar-run",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/interstellar-run.jpg",
        homeUrl: "",
        name: "InterstellarRun",
        providerName: "Kingmaker",
      },
      JackpotJump: {
        href: "/casino/km-jackpot-jump",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/jackpot-jump.jpg",
        homeUrl: "",
        name: "Jackpot Jump",
        providerName: "Kingmaker",
      },
      JhandiMunda: {
        href: "/casino/km-jhandi-munda",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/jhandi-munda.jpg",
        homeUrl: "",
        name: "Jhandi Munda",
        providerName: "Kingmaker",
      },
      KMPokDeng: {
        href: "/casino/km-km-pok-deng",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/km-pok-deng.jpg",
        homeUrl: "",
        name: "KM Pok Deng",
        providerName: "Kingmaker",
      },
      KMPowerBall: {
        href: "/casino/km-km-power-ball",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/km-power-ball.jpg",
        homeUrl: "",
        name: "KM Power Ball",
        providerName: "Kingmaker",
      },
      KMVirtualHorseRacing: {
        href: "/casino/km-km-virtual-horse-racing",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/km-virtual-horse-racing.jpg",
        homeUrl: "",
        name: "KM Virtual Horse Racing",
        providerName: "Kingmaker",
      },
      Ludo: {
        href: "/casino/km-ludo",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/ludo.jpg",
        homeUrl: "",
        name: "Ludo",
        providerName: "Kingmaker",
      },
      MarbleRacing: {
        href: "/casino/km-marble-racing",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/marble-racing.jpg",
        homeUrl: "",
        name: "Marble Racing",
        providerName: "Kingmaker",
      },
      MaxKeno: {
        href: "/casino/km-max-keno",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/max-keno.jpg",
        homeUrl: "",
        name: "Max Keno",
        providerName: "Kingmaker",
      },
      MonkeyKingRoulette: {
        href: "/casino/km-monkey-king-roulette",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/monkey-king-roulette.jpg",
        homeUrl: "",
        name: "Monkey King Roulette",
        providerName: "Kingmaker",
      },
      OlympusGlory: {
        href: "/casino/km-olympus-glory",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/olympus-glory.jpg",
        homeUrl: "",
        name: "Olympus Glory",
        providerName: "Kingmaker",
      },
      PaiKang: {
        href: "/casino/km-pai-kang",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/pai-kang.jpg",
        homeUrl: "",
        name: "Pai Kang",
        providerName: "Kingmaker",
      },
      PenguinPanic: {
        href: "/casino/km-penguin-panic",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/penguin-panic.jpg",
        homeUrl: "",
        name: "Penguin Panic",
        providerName: "Kingmaker",
      },
      Plinko: {
        href: "/casino/km-plinko",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/plinko.jpg",
        homeUrl: "",
        name: "Plinko",
        providerName: "Kingmaker",
      },
      PokerRoulette: {
        href: "/casino/km-poker-roulette",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/poker-roulette.jpg",
        homeUrl: "",
        name: "Poker Roulette",
        providerName: "Kingmaker",
      },
      Pusoy: {
        href: "/casino/km-pusoy",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/pusoy.jpg",
        homeUrl: "",
        name: "Pusoy",
        providerName: "Kingmaker",
      },
      RoosterBlitz: {
        href: "/casino/km-rooster-blitz",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/rooster-blitz.jpg",
        homeUrl: "",
        name: "Rooster Blitz",
        providerName: "Kingmaker",
      },
      SicBo: {
        href: "/casino/km-sicbo",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/sicbo.jpg",
        homeUrl: "",
        name: "Rooster Blitz",
        providerName: "Kingmaker",
      },
      SugarBlast: {
        href: "/casino/km-sugar-blast",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/sugar-blast.jpg",
        homeUrl: "",
        name: "Sugar Blast",
        providerName: "Kingmaker",
      },
      SugarBlastFrenzy: {
        href: "/casino/km-sugar-blast-frenzy",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/sugar-blast-frenzy.jpg",
        homeUrl: "",
        name: "Sugar Blast Frenzy",
        providerName: "Kingmaker",
      },
      TaiXiu: {
        href: "/casino/km-tai-xiu",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/tai-xiu.jpg",
        homeUrl: "",
        name: "Tai Xiu",
        providerName: "Kingmaker",
      },
      TeenPatti: {
        href: "/casino/km-teen-patti",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/teen-patti.jpg",
        homeUrl: "",
        name: "Teen Patti",
        providerName: "Kingmaker",
      },
      ThaiFishPrawnCrab: {
        href: "/casino/km-thai-fish-prawn-crab",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/thai-fish-prawn-crab.jpg",
        homeUrl: "",
        name: "Thai Fish Prawn Crab",
        providerName: "Kingmaker",
      },
      ThaiHiLo2: {
        href: "/casino/km-thai-hi-lo-2",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/thai-hi-lo-2.jpg",
        homeUrl: "",
        name: "Thai Hi Lo 2",
        providerName: "Kingmaker",
      },
      Tongits: {
        href: "/casino/km-tongits",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/tongits.jpg",
        homeUrl: "",
        name: "Tongits",
        providerName: "Kingmaker",
      },
      TripleChance: {
        href: "/casino/km-triple-chance",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/triple-chance.jpg",
        homeUrl: "",
        name: "Triple Chance",
        providerName: "Kingmaker",
      },
      VideoPoker: {
        href: "/casino/km-video-poker",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/video-poker.jpg",
        homeUrl: "",
        name: "Video Poker",
        providerName: "Kingmaker",
      },
      VietFishPrawnCrab: {
        href: "/casino/km-viet-fish-prawn-crab",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/viet-fish-prawn-crab.jpg",
        homeUrl: "",
        name: "Viet Fish Prawn Crab",
        providerName: "Kingmaker",
      },
      VirtualAnimalRace: {
        href: "/casino/km-virtual-animal-race",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/virtual-animal-race.jpg",
        homeUrl: "",
        name: "Virtual Animal Race",
        providerName: "Kingmaker",
      },
      VirtualGreyhoundRacing: {
        href: "/casino/km-virtual-greyhound-racing",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/virtual-greyhound-racing.jpg",
        homeUrl: "",
        name: "Virtual Greyhound Racing",
        providerName: "Kingmaker",
      },
      VirtualTreadmillRacing: {
        href: "/casino/km-virtual-treadmill-racing",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/virtual-treadmill-racing.jpg",
        homeUrl: "",
        name: "Virtual Treadmill Racing",
        providerName: "Kingmaker",
      },
      XocLightning: {
        href: "/casino/km-xoc-lightning",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "kingmaker",
        imgUrl: "/images/kingmaker/xoc-lightning.jpg",
        homeUrl: "",
        name: "Xoc Lightning",
        providerName: "Kingmaker",
      },
    },
    mines: {
      Goldmines: {
        href: "/casino/km-gold-mines",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "mines",
        imgUrl: "/images/kingmaker/gold-mines.jpg",
        homeUrl: "",
        name: "Gold Mines",
        providerName: "Kingmaker",
      },
      Minesweeper: {
        href: "/casino/km-minesweeper",
        code: "",
        casino: "Kingmaker",
        provider: "Kingmaker",
        category: "mines",
        imgUrl: "/images/kingmaker/minesweeper.jpg",
        homeUrl: "",
        name: "Minesweeper",
        providerName: "Kingmaker",
      },
    },
  },

  spribe: {
    crash: {
      aviator: {
        href: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        category: "crash",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Aviator.webp",
        alt: "aviator",
        name: "Aviator",
      },
    },
    mines: {
      Mines: {
        href: "/casino/spribe/mines",
        code: "mines",
        casino: "spribe",
        provider: "mines",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Mines.webp",
        alt: "mines",
        name: "Mines",
      },
    },
    hiLo: {
      hilo: {
        href: "/casino/spribe/hilo",
        code: "hilo",
        casino: "spribe",
        provider: "hilo",
        category: "hiLo",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Hilo.webp",
        alt: "hilo",
        name: "Hilo",
      },
    },
    roulette: {
      miniroulette: {
        href: "/casino/spribe/miniroulette",
        code: "miniroulette",
        casino: "spribe",
        provider: "miniroulette",
        category: "roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/MiniRoulettenOld.webp",
        alt: "mini roulette",
        name: "Mini Roulette",
      },
    },
    others: {
      goal: {
        href: "/casino/spribe/goal",
        code: "goal",
        casino: "spribe",
        provider: "goal",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Goal.webp",
        alt: "goal",
        name: "Goal",
      },
      dice: {
        href: "/casino/spribe/dice",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Dice.webp",
        alt: "dice",
        name: "Dice",
      },
      plinko: {
        href: "/casino/spribe/plinko",
        code: "plinko",
        casino: "spribe",
        provider: "plinko",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Plinko.webp",
        alt: "plinko",
        name: "Plinko",
      },
      hotline: {
        href: "/casino/spribe/hotline",
        code: "hotline",
        casino: "spribe",
        provider: "hotline",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Hotline.webp",
        alt: "hotline",
        name: "Hotline",
      },
      keno: {
        href: "/casino/spribe/keno",
        code: "keno",
        casino: "spribe",
        provider: "keno",
        category: "others",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/spribe/Keno.webp",
        alt: "keno",
        name: "Keno",
      },
    },
  },

  netent: {
    netent: {
      asgardianstones: {
        href: "/casino/ezgne-asgardian-stones",
        code: "1100096",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/AsgardianStones.webp",
        alt: "Asgardian Stones",
        name: "Asgardian Stones",
      },
      SecretsOfAtlantis: {
        href: "/casino/ezgne-secrets-of-atlantis",
        code: "1100106",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/SecretsOfAtlantis.webp",
        alt: "Secrets of Atlantis",
        name: "Secrets of Atlantis",
      },
      SteamTower: {
        href: "/casino/ezgne-steam-tower",
        code: "1100043",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/SteamTower.webp",
        alt: "Steam Tower",
        name: "Steam Tower",
      },
      DivinieFortuneMegaways: {
        href: "/casino/ezgne-divine-fortune-megaways",
        code: "1100089",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/DivineFortuneMegaways.webp",
        alt: "Divine Fortune Megaways",
        name: "Divine Fortune Megaways",
      },
      FruitShopMegaways: {
        href: "/casino/ezgne-fruit-shop-megaways",
        code: "1100094",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/FruitShopMegaways.webp",
        alt: "Fruit Shop Megaways",
        name: "Fruit Shop Megaways",
      },
      GorillaKingdom: {
        href: "/casino/ezgne-gorilla-kingdom",
        code: "1100088",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/GorillaKingdom.webp",
        alt: "Gorilla Kingdom",
        name: "Gorilla Kingdom",
      },
      AlohaChristmas: {
        href: "/casino/ezgne-aloha-christmas",
        code: "1100032",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/AlohaChristmas.webp",
        alt: "Aloha! Christmas",
        name: "Aloha! Christmas",
      },
      AlohaClusterPays: {
        href: "/casino/ezgne-aloha-cluster-pays",
        code: "1100033",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/AlohaClusterPays.webp",
        alt: "Aloha! Cluster Pays",
        name: "Aloha! Cluster Pays",
      },
      WildWildWestTheGreatTrainHeist: {
        href: "/casino/ezgne-wild-wild-west-the-great-train-heist",
        code: "1100038",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/WildWildWestTheGreatTrainHeist.webp",
        alt: "Wild Wild West: The Great Train Heist",
        name: "Wild Wild West: The Great Train Heist",
      },
      TwinSpinMegaways: {
        href: "/casino/ezgne-twin-spin-megaways",
        code: "1100039",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/TwinSpinMegaways.webp",
        alt: "Twin Spin Megaways",
        name: "Twin Spin Megaways",
      },
      TurnYourFortune: {
        href: "/casino/ezgne-turn-your-fortune",
        code: "1100041",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/TurnYourFortune.webp",
        alt: "Turn Your Fortune",
        name: "Turn Your Fortune",
      },
      PyramidQuestForImmortality: {
        href: "/casino/ezgne-pyramid-quest-for-immortality",
        code: "1100078",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/PyramidQuestForImmortality.webp",
        alt: "Pyramid: Quest for Immortality",
        name: "Pyramid: Quest for Immortality",
      },
      PiggyRiches: {
        href: "/casino/ezgne-piggy-riches",
        code: "1100080",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/PiggyRiches.webp",
        alt: "Piggy Riches",
        name: "Piggy Riches",
      },
      DarkKingForbiddenRiches: {
        href: "/casino/ezgne-dark-king-forbidden-riches",
        code: "1100081",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/DarkKingForbiddenRiches.webp",
        alt: "Dark King: Forbidden Riches",
        name: "Dark King: Forbidden Riches",
      },
      JingleSpin: {
        href: "/casino/ezgne-jingle-spin",
        code: "1100082",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/JingleSpin.webp",
        alt: "Jingle Spin",
        name: "Jingle Spin",
      },
      JackHammer: {
        href: "/casino/ezgne-jack-hammer",
        code: "1100084",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/JackHammer.webp",
        alt: "Jack Hammer",
        name: "Jack Hammer",
      },
      DeadorAlive: {
        href: "/casino/ezgne-dead-or-alive",
        code: "1100085",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/DeadOrAlive.webp",
        alt: "Dead or Alive",
        name: "Dead or Alive",
      },
      DeadorAlive2: {
        href: "/casino/ezgne-dead-or-alive-2",
        code: "1100087",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/DeadOrAlive2.webp",
        alt: "Dead or Alive 2",
        name: "Dead or Alive 2",
      },
      JackandtheBeanstalk: {
        href: "/casino/ezgne-jack-and-the-beanstalk",
        code: "1100086",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/JackAndTheBeanstalk.webp",
        alt: "Jack and the Beanstalk",
        name: "Jack and the Beanstalk",
      },
      ElementsTheAwakening: {
        href: "/casino/ezgne-elements-the-awakening",
        code: "1100091",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/ElementsTheAwakening.webp",
        alt: "Elements: The Awakening",
        name: "Elements: The Awakening",
      },
      FinnandtheSwirlySpin: {
        href: "/casino/ezgne-finn-and-the-swirly-spin",
        code: "1100093",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/FinnAndTheSwirlySpin.webp",
        alt: "Finn and the Swirly Spin",
        name: "Finn and the Swirly Spin",
      },
      FruitShop: {
        href: "/casino/ezgne-fruit-shop",
        code: "1100095",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/FruitShop.webp",
        alt: "Fruit Shop",
        name: "Fruit Shop",
      },
      DeadorAlive2FeatureBuy: {
        href: "/casino/ezgne-dead-or-alive-2-feature-buy",
        code: "1100100",
        casino: "ezugi",
        provider: "NetEnt",
        category: "netent",
        homeUrl: "/Slots",
        imgUrl: "/images/casino/netent/DeadOrAlive2FeatureBuy.webp",
        alt: "Dead or Alive 2 Feature Buy",
        name: "Dead or Alive 2 Feature Buy",
      },
    },
  },

  redtiger: {
    redtiger: {
      DragonsLuck: {
        href: "/casino/ezgrt-dragons-luck",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DragonsLuck.webp",
        alt: "Dragon's Luck",
        name: "Dragon's Luck",
      },
      DragonsLuckPowerReels: {
        href: "/casino/ezgrt-dragons-luck-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DragonsLuckPowerReels.webp",
        alt: "Dragon's Luck Power Reels",
        name: "Dragon's Luck Power Reels",
      },
      Nights10001: {
        href: "/casino/ezgrt-10001-nights",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/10001Nights.webp",
        alt: "10,001 Nights",
        name: "10,001 Nights",
      },
      GodOfWealth: {
        href: "/casino/ezgrt-god-of-wealth",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GodOfWealth.webp",
        alt: "God Of Wealth",
        name: "God Of Wealth",
      },
      PiratesPlentyBattleforGold: {
        href: "/casino/ezgrt-pirates-plenty-battle-for-gold",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PiratesPlentyBattleforGold.webp",
        alt: "Pirates' Plenty Battle for Gold",
        name: "Pirates' Plenty Battle for Gold",
      },
      ChineseTreasures: {
        href: "/casino/ezgrt-chinese-treasures",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ChineseTreasures.webp",
        alt: "Chinese Treasures",
        name: "Chinese Treasures",
      },
      FortuneHouse: {
        href: "/casino/ezgrt-fortune-house",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/FortuneHouse.webp",
        alt: "Fortune House",
        name: "Fortune House",
      },
      DragonsFire: {
        href: "/casino/ezgrt-dragons-fire",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DragonsFire.webp",
        alt: "Dragon's Fire",
        name: "Dragon's Fire",
      },
      MagicGate: {
        href: "/casino/ezgrt-magic-gate",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MagicGate.webp",
        alt: "Magic Gate",
        name: "Magic Gate",
      },
      LuckyFortuneCat: {
        href: "/casino/ezgrt-lucky-fortune-cat",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LuckyFortuneCat.webp",
        alt: "Lucky Fortune Cat",
        name: "Lucky Fortune Cat",
      },
      DragonsLuckDeluxe: {
        href: "/casino/ezgrt-dragons-luck-deluxe",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DragonsLuckDeluxe.webp",
        alt: "Dragon's Luck Deluxe",
        name: "Dragon's Luck Deluxe",
      },
      EpicJourney: {
        href: "/casino/ezgrt-epic-journey",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/EpicJourney.webp",
        alt: "Epic Journey",
        name: "Epic Journey",
      },
      PhoenixFirePowerReels: {
        href: "/casino/ezgrt-phoenix-fire-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PhoenixFirePowerReels.webp",
        alt: "Phoenix Fire Power Reels",
        name: "Phoenix Fire Power Reels",
      },
      GoldenTemple: {
        href: "/casino/ezgrt-golden-temple",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GoldenTemple.webp",
        alt: "Golden Temple",
        name: "Golden Temple",
      },
      PiratesPlenty: {
        href: "/casino/ezgrt-pirates-plenty",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PiratesPlenty.webp",
        alt: "Pirates' Plenty",
        name: "Pirates' Plenty",
      },
      GoldenOffer: {
        href: "/casino/ezgrt-golden-offer",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GoldenOffer.webp",
        alt: "Golden Offer",
        name: "Golden Offer",
      },
      RAsLegend: {
        href: "/casino/ezgrt-ras-legend",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RAsLegend.webp",
        alt: "RA's Legend",
        name: "RA's Legend",
      },
      GonzosQuestMegaways: {
        href: "/casino/ezgrt-gonzos-quest-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GonzosQuestMegaways.webp",
        alt: "Gonzo's Quest Megaways",
        name: "Gonzo's Quest Megaways",
      },
      RainbowJackpots: {
        href: "/casino/ezgrt-rainbow-jackpots",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RainbowJackpots.webp",
        alt: "Rainbow Jackpots",
        name: "Rainbow Jackpots",
      },
      MegaPyramid: {
        href: "/casino/ezgrt-mega-pyramid",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MegaPyramid.webp",
        alt: "Mega Pyramid",
        name: "Mega Pyramid",
      },
      WarOfGods: {
        href: "/casino/ezgrt-war-of-gods",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WarOfGods.webp",
        alt: "War Of Gods",
        name: "War Of Gods",
      },
      Strike777: {
        href: "/casino/ezgrt-777-strike",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/777Strike.webp",
        alt: "777 Strike",
        name: "777 Strike",
      },
      AncientsBlessing: {
        href: "/casino/ezgrt-ancients-blessing",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/AncientsBlessing.webp",
        alt: "Ancients Blessing",
        name: "Ancients Blessing",
      },
      AurumCodex: {
        href: "/casino/ezgrt-aurum-codex",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/AurumCodex.webp",
        alt: "Aurum Codex",
        name: "Aurum Codex",
      },
      BettyBorisandBoo: {
        href: "/casino/ezgrt-betty-boris-and-boo",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/BettyBorisandBoo.webp",
        alt: "Betty, Boris and Boo",
        name: "Betty, Boris and Boo",
      },
      ZeusLightningPowerReels: {
        href: "/casino/ezgrt-zeus-lightning-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ZeusLightningPowerReels.webp",
        alt: "Zeus Lightning Power Reels",
        name: "Zeus Lightning Power Reels",
      },
      WingsofRa: {
        href: "/casino/ezgrt-wings-of-ra",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WingsofRa.webp",
        alt: "Wings of Ra",
        name: "Wings of Ra",
      },
      ThorsVengeance: {
        href: "/casino/ezgrt-thors-vengeance",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ThorsVengeance.webp",
        alt: "Thor's Vengeance",
        name: "Thor's Vengeance",
      },
      RegalStreak: {
        href: "/casino/ezgrt-regal-streak",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RegalStreak.webp",
        alt: "Regal Streak",
        name: "Regal Streak",
      },
      RegalBeasts: {
        href: "/casino/ezgrt-regal-beasts",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RegalBeasts.webp",
        alt: "Regal Beasts",
        name: "Regal Beasts",
      },
      ReelKingMega: {
        href: "/casino/ezgrt-reel-king-mega",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ReelKingMega.webp",
        alt: "Reel King Mega",
        name: "Reel King Mega",
      },
      ReelKeeper: {
        href: "/casino/ezgrt-reel-keeper",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ReelKeeper.webp",
        alt: "Reel Keeper",
        name: "Reel Keeper",
      },
      RainbowJackpotsPowerLines: {
        href: "/casino/ezgrt-rainbow-jackpots-power-lines",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RainbowJackpotsPowerLines.webp",
        alt: "Rainbow Jackpots Power Lines",
        name: "Rainbow Jackpots Power Lines",
      },
      MysteryReels: {
        href: "/casino/ezgrt-mystery-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MysteryReels.webp",
        alt: "Mystery Reels",
        name: "Mystery Reels",
      },
      PiggyRichesMegaways: {
        href: "/casino/ezgrt-piggy-riches-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PiggyRichesMegaways.webp",
        alt: "Piggy Riches Megaways",
        name: "Piggy Riches Megaways",
      },
      JingleBells: {
        href: "/casino/ezgrt-jingle-bells",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/JingleBells.webp",
        alt: "Jingle Bells",
        name: "Jingle Bells",
      },
      JackinaPot: {
        href: "/casino/ezgrt-jack-in-a-pot",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/JackinaPot.webp",
        alt: "Jack in a Pot",
        name: "Jack in a Pot",
      },
      FiveStar: {
        href: "/casino/ezgrt-five-star",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/FiveStar.webp",
        alt: "Five Star",
        name: "Five Star",
      },
      BountyRaid: {
        href: "/casino/ezgrt-bounty-raid",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/BountyRaid.webp",
        alt: "Bounty Raid",
        name: "Bounty Raid",
      },
      CashUltimate: {
        href: "/casino/ezgrt-cash-ultimate",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CashUltimate.webp",
        alt: "Cash Ultimate",
        name: "Cash Ultimate",
      },
      CashVolt: {
        href: "/casino/ezgrt-cash-volt",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CashVolt.webp",
        alt: "Cash Volt",
        name: "Cash Volt",
      },
      DynamiteRiches: {
        href: "/casino/ezgrt-dynamite-riches",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DynamiteRiches.webp",
        alt: "Dynamite Riches",
        name: "Dynamite Riches",
      },
      DiamondBlitz: {
        href: "/casino/ezgrt-diamond-blitz",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DiamondBlitz.webp",
        alt: "Diamond Blitz",
        name: "Diamond Blitz",
      },
      DragonsFireMegaways: {
        href: "/casino/ezgrt-dragons-fire-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DragonsFireMegaways.webp",
        alt: "Dragon's Fire Megaways",
        name: "Dragon's Fire Megaways",
      },
      Squad4: {
        href: "/casino/ezgrt-4-squad",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/4Squad.webp",
        alt: "4 Squad",
        name: "4 Squad",
      },
      AgentRoyale: {
        href: "/casino/ezgrt-agent-royale",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/AgentRoyale.webp",
        alt: "Agent Royale",
        name: "Agent Royale",
      },
      Families5: {
        href: "/casino/ezgrt-5-families",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/5Families.webp",
        alt: "5 Families",
        name: "5 Families",
      },
      ArcadeBomb: {
        href: "/casino/ezgrt-arcade-bomb",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ArcadeBomb.webp",
        alt: "Arcade Bomb",
        name: "Arcade Bomb",
      },
      CinderellasBall: {
        href: "/casino/ezgrt-cinderellas-ball",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CinderellasBall.webp",
        alt: "Cinderella`s Ball",
        name: "Cinderella`s Ball",
      },
      Atlantis: {
        href: "/casino/ezgrt-atlantis",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/Atlantis.webp",
        alt: "Atlantis",
        name: "Atlantis",
      },
      AztecSpins: {
        href: "/casino/ezgrt-aztec-spins",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/AztecSpins.webp",
        alt: "Aztec Spins",
        name: "Aztec Spins",
      },
      ClashoftheBeasts: {
        href: "/casino/ezgrt-clash-of-the-beasts",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ClashoftheBeasts.webp",
        alt: "Clash of the Beasts",
        name: "Clash of the Beasts",
      },
      CirquedelaFortune: {
        href: "/casino/ezgrt-cirque-de-la-fortune",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CirquedelaFortune.webp",
        alt: "Cirque de la Fortune",
        name: "Cirque de la Fortune",
      },
      CrazyGenie: {
        href: "/casino/ezgrt-crazy-genie",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CrazyGenie.webp",
        alt: "Crazy Genie",
        name: "Crazy Genie",
      },
      CrystalMirror: {
        href: "/casino/ezgrt-crystal-mirror",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/CrystalMirror.webp",
        alt: "Crystal Mirror",
        name: "Crystal Mirror",
      },
      DevilsNumber: {
        href: "/casino/ezgrt-devils-number",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DevilsNumber.webp",
        alt: "Devil`s Number",
        name: "Devil`s Number",
      },
      DaVincisMystery: {
        href: "/casino/ezgrt-da-vincis-mystery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DaVincisMystery.webp",
        alt: "Da Vinci`s Mystery",
        name: "Da Vinci`s Mystery",
      },
      DiceDiceDice: {
        href: "/casino/ezgrt-dice-dice-dice",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/DiceDiceDice.webp",
        alt: "Dice Dice Dice",
        name: "Dice Dice Dice",
      },
      FiveStarsPowerReels: {
        href: "/casino/ezgrt-five-stars-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/FiveStarsPowerReels.webp",
        alt: "Five Stars Power Reels",
        name: "Five Stars Power Reels",
      },
      GemsGoneWild: {
        href: "/casino/ezgrt-gems-gone-wild",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GemsGoneWild.webp",
        alt: "Gems Gone Wild",
        name: "Gems Gone Wild",
      },
      GemsGoneWildPowerReels: {
        href: "/casino/ezgrt-gems-gone-wild-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GemsGoneWildPowerReels.webp",
        alt: "Gems Gone Wild Power Reels",
        name: "Gems Gone Wild Power Reels",
      },
      GoldenCryptex: {
        href: "/casino/ezgrt-golden-cryptex",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GoldenCryptex.webp",
        alt: "Golden Cryptex",
        name: "Golden Cryptex",
      },
      GoldenLeprechaunMegaways: {
        href: "/casino/ezgrt-golden-leprechaun-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GoldenLeprechaunMegaways.webp",
        alt: "Golden Leprechaun Megaways",
        name: "Golden Leprechaun Megaways",
      },
      GrandWheel: {
        href: "/casino/ezgrt-grand-wheel",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GrandWheel.webp",
        alt: "Grand Wheel",
        name: "Grand Wheel",
      },
      GoldenTsar: {
        href: "/casino/ezgrt-golden-tsar",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/GoldenTsar.webp",
        alt: "Golden Tsar",
        name: "Golden Tsar",
      },
      HoardofPoseidon: {
        href: "/casino/ezgrt-hoard-of-poseidon",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/HoardofPoseidon.webp",
        alt: "Hoard of Poseidon",
        name: "Hoard of Poseidon",
      },
      JewelScarabs: {
        href: "/casino/ezgrt-jewel-scarabs",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/JewelScarabs.webp",
        alt: "Jewel Scarabs",
        name: "Jewel Scarabs",
      },
      LegendofAthena: {
        href: "/casino/ezgrt-legend-of-athena",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LegendofAthena.webp",
        alt: "Legend of Athena",
        name: "Legend of Athena",
      },
      JingleBellsPowerReels: {
        href: "/casino/ezgrt-jingle-bells-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/JingleBellsPowerReels.webp",
        alt: "Jingle Bells Power Reels",
        name: "Jingle Bells Power Reels",
      },
      LuckyHalloween: {
        href: "/casino/ezgrt-lucky-halloween",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LuckyHalloween.webp",
        alt: "Lucky Halloween",
        name: "Lucky Halloween",
      },
      LuckyLittleDevil: {
        href: "/casino/ezgrt-lucky-little-devil",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LuckyLittleDevil.webp",
        alt: "Lucky Little Devil",
        name: "Lucky Little Devil",
      },
      LuckyValentine: {
        href: "/casino/ezgrt-lucky-valentine",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LuckyValentine.webp",
        alt: "Lucky Valentine",
        name: "Lucky Valentine",
      },
      LuckyWizard: {
        href: "/casino/ezgrt-lucky-wizard",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/LuckyWizard.webp",
        alt: "Lucky Wizard",
        name: "Lucky Wizard",
      },
      Masquerade: {
        href: "/casino/ezgrt-masquerade",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/Masquerade.webp",
        alt: "Masquerade",
        name: "Masquerade",
      },
      MayanGods: {
        href: "/casino/ezgrt-mayan-gods",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MayanGods.webp",
        alt: "Mayan Gods",
        name: "Mayan Gods",
      },
      MegaDragon: {
        href: "/casino/ezgrt-mega-dragon",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MegaDragon.webp",
        alt: "Mega Dragon",
        name: "Mega Dragon",
      },
      MegaJade: {
        href: "/casino/ezgrt-mega-jade",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MegaJade.webp",
        alt: "Mega Jade",
        name: "Mega Jade",
      },
      MegaRise: {
        href: "/casino/ezgrt-mega-rise",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MegaRise.webp",
        alt: "Mega Rise",
        name: "Mega Rise",
      },
      MultiplierRiches: {
        href: "/casino/ezgrt-multiplier-riches",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MultiplierRiches.webp",
        alt: "Multiplier Riches",
        name: "Multiplier Riches",
      },
      MysteryReelsMegaways: {
        href: "/casino/ezgrt-mystery-reels-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/MysteryReelsMegaways.webp",
        alt: "Mystery Reels Megaways",
        name: "Mystery Reels Megaways",
      },
      NinjaWays: {
        href: "/casino/ezgrt-ninja-ways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/NinjaWays.webp",
        alt: "Ninja Ways",
        name: "Ninja Ways",
      },
      PathofDestiny: {
        href: "/casino/ezgrt-path-of-destiny",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PathofDestiny.webp",
        alt: "Path of Destiny",
        name: "Path of Destiny",
      },
      PersianFortune: {
        href: "/casino/ezgrt-persian-fortune",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/PersianFortune.webp",
        alt: "Persian Fortune",
        name: "Persian Fortune",
      },
      ReelHeist: {
        href: "/casino/ezgrt-reel-heist",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ReelHeist.webp",
        alt: "Reel Heist",
        name: "Reel Heist",
      },
      RobinHoodsWildForest: {
        href: "/casino/ezgrt-robin-hoods-wild-forest",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/RobinHoodsWildForest.webp",
        alt: "Robin Hood`s Wild Forest",
        name: "Robin Hood`s Wild Forest",
      },
      SnowWildAndThe7Features: {
        href: "/casino/ezgrt-snow-wild-and-the-7-features",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/SnowWildAndThe7Features.webp",
        alt: "Snow Wild And The 7 Features",
        name: "Snow Wild And The 7 Features",
      },
      SylvanSpirits: {
        href: "/casino/ezgrt-sylvan-spirits",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/SylvanSpirits.webp",
        alt: "Sylvan Spirits",
        name: "Sylvan Spirits",
      },
      TheGreatestTrainRobbery: {
        href: "/casino/ezgrt-the-greatest-train-robbery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/TheGreatestTrainRobbery.webp",
        alt: "The Greatest Train Robbery",
        name: "The Greatest Train Robbery",
      },
      TheWildHatter: {
        href: "/casino/ezgrt-the-wild-hatter",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/TheWildHatter.webp",
        alt: "The Wild Hatter",
        name: "The Wild Hatter",
      },
      ThorsLightning: {
        href: "/casino/ezgrt-thors-lightning",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/ThorsLightning.webp",
        alt: "Thor`s Lightning",
        name: "Thor`s Lightning",
      },
      TikiFruits: {
        href: "/casino/ezgrt-tiki-fruits",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/TikiFruits.webp",
        alt: "Tiki Fruits",
        name: "Tiki Fruits",
      },
      VaultCracker: {
        href: "/casino/ezgrt-vault-cracker",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/VaultCracker.webp",
        alt: "Vault Cracker",
        name: "Vault Cracker",
      },
      TotemLightning: {
        href: "/casino/ezgrt-totem-lightning",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/TotemLightning.webp",
        alt: "Totem Lightning",
        name: "Totem Lightning",
      },
      WellofWishes: {
        href: "/casino/ezgrt-well-of-wishes",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WellofWishes.webp",
        alt: "Well of Wishes",
        name: "Well of Wishes",
      },
      VaultofAnubis: {
        href: "/casino/ezgrt-vault-of-anubis",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/VaultofAnubis.webp",
        alt: "Vault of Anubis",
        name: "Vault of Anubis",
      },
      WildOClock: {
        href: "/casino/ezgrt-wild-oclock",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WildOClock.webp",
        alt: "Wild O`Clock",
        name: "Wild O`Clock",
      },
      WildCatsMultiline: {
        href: "/casino/ezgrt-wild-cats-multiline",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WildCatsMultiline.webp",
        alt: "Wild Cats Multiline",
        name: "Wild Cats Multiline",
      },
      YucatansMystery: {
        href: "/casino/ezgrt-yucatans-mystery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/YucatansMystery.webp",
        alt: "Yucatan`s Mystery",
        name: "Yucatan`s Mystery",
      },
      WildWildChest: {
        href: "/casino/ezgrt-wild-wild-chest",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WildWildChest.webp",
        alt: "Wild Wild Chest",
        name: "Wild Wild Chest",
      },
      WinEscalator: {
        href: "/casino/ezgrt-win-escalator",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/WinEscalator.webp",
        alt: "Win Escalator",
        name: "Win Escalator",
      },
    },
    mines: {
      TreasureMine: {
        href: "/casino/ezgrt-treasure-mine",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "mines",
        homeUrl: "/slots-games",
        imgUrl: "/images/casino/redtiger/TreasureMine.webp",
        alt: "Treasure Mine",
        name: "Treasure Mine",
      },
    },
  },

  // jili: {
  //   jili: {
  //     PirateQueen: {
  //       code: "98567",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Pirate Queen",
  //       name: "Pirate Queen",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/PirateQueen.webp",
  //       href: "/casino/aggapjiligaming-pirate-queen",
  //     },
  //     WildRacer: {
  //       code: "56768",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Wild Racer",
  //       name: "Wild Racer",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/WildRacer.webp",
  //       href: "/casino/aggapjiligaming-wild-racer",
  //     },
  //     NekoFortune: {
  //       code: "98790",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Neko Fortune",
  //       name: "Neko Fortune",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/nekofortune.webp",
  //       href: "/casino/aggapjiligaming-neko-fortune",
  //     },
  //     Samba: {
  //       code: "98789",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Samba",
  //       name: "Samba",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/Samba.webp",
  //       href: "/casino/aggapjiligaming-samba",
  //     },
  //     WorldCup: {
  //       code: "56968",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "World Cup",
  //       name: "World Cup",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/WorldCup.webp",
  //       href: "/casino/aggapjiligaming-world-cup",
  //     },
  //     BonusHunter: {
  //       code: "67660",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Bonus Hunter",
  //       name: "Bonus Hunter",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/BonusHunter.webp",
  //       href: "/casino/aggapjiligaming-bonus-hunter",
  //     },
  //     JILICAISHEN: {
  //       code: "67580",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "JILI CAISHEN",
  //       name: "JILI CAISHEN",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/jiliCaishe.webp",
  //       href: "/casino/aggapjiligaming-jili-caishen",
  //     },
  //     MayanEmpire: {
  //       code: "67600",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Mayan Empire",
  //       name: "Mayan Empire",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/Mayanempire.webp",
  //       href: "/casino/aggapjiligaming-mayan-empire",
  //     },
  //     BoneFortune: {
  //       code: "87564",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Bone Fortune",
  //       name: "Bone Fortune",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/BoneFortune.webp",
  //       href: "/casino/aggapjiligaming-bone-fortune",
  //     },
  //     GoldRush: {
  //       code: "67620",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Gold Rush",
  //       name: "Gold Rush",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/GoldRush.webp",
  //       href: "/casino/aggapjiligaming-gold-rush",
  //     },
  //     HappyTaxi: {
  //       code: "67567",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Happy Taxi",
  //       name: "Happy Taxi",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/HappyTaxi.webp",
  //       href: "/casino/aggapjiligaming-happy-taxi",
  //     },
  //     ThorX: {
  //       code: "67570",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Thor X",
  //       name: "Thor X",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/ThorX.webp",
  //       href: "/casino/aggapjiligaming-thor-x",
  //     },
  //     BookofGold: {
  //       code: "56767",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Book of Gold",
  //       name: "Book of Gold",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/bookofGold.jpg",
  //       href: "/casino/aggapjiligaming-book-of-gold",
  //     },
  //     Medusa: {
  //       code: "98788",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Medusa",
  //       name: "Medusa",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/medusa.jpg",
  //       href: "/casino/aggapjiligaming-medusa",
  //     },
  //     GoGoalBingo: {
  //       code: "98791",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Go Goal Bingo",
  //       name: "Go Goal Bingo",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/gogoalbingo.jpg",
  //       href: "/casino/aggapjiligaming-go-goal-bingo",
  //     },
  //     ColorGame: {
  //       code: "67630",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Color Game",
  //       name: "Color Game",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/colorgame.jpg",
  //       href: "/casino/aggapjiligaming-color-game",
  //     },
  //     JackpotBingo: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Jackpot Bingo",
  //       name: "Jackpot Bingo",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/jackpotbingo.jpg",
  //       href: "/casino/aggapjiligaming-jackpot-bingo",
  //     },
  //     LuckyBingo: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Lucky Bingo",
  //       name: "Lucky Bingo",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/luckybingo.jpg",
  //       href: "/casino/aggapjiligaming-lucky-bingo",
  //     },
  //     WinDrop: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Win Drop",
  //       name: "Win Drop",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/windrop.jpg",
  //       href: "/casino/aggapjiligaming-win-drop",
  //     },
  //     FortuneBingo: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Fortune Bingo",
  //       name: "Fortune Bingo",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/fortunebingo.jpg",
  //       href: "/casino/aggapjiligaming-fortune-bingo",
  //     },
  //     Baccarat: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Baccarat",
  //       name: "Baccarat",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/baccarat.jpg",
  //       href: "/casino/aggapjiligaming-baccarat",
  //     },
  //     iRichBingo: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "iRich Bingo",
  //       name: "iRich Bingo",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/iRichBingo.jpg",
  //       href: "/casino/aggapjiligaming-irich-bingo",
  //     },
  //     // DragonTiger: {
  //     //   code: "98566",
  //     //   casino: "aura",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   alt: "Dragon & Tiger",
  //     //   name: "Dragon & Tiger",
  //     //   providerName: "Jili Gaming",
  //     //   imgUrl: "../images/evolution/DragonTiger.webp",
  //     //   href: "/casino/aggapjiligaming-dragon-and-tiger",
  //     // },
  //     BigSmall: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Big Small",
  //       name: "Big Small",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/Bigsmall.jpg",
  //       href: "/casino/aggapjiligaming-big-small",
  //     },
  //     GoldenJoker: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Golden Joker",
  //       name: "Golden Joker",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/goldenjoker.jpg",
  //       href: "/casino/aggapjiligaming-golden-joker",
  //     },
  //     MasterTiger: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Master Tiger",
  //       name: "Master Tiger",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/mastertiger.jpg",
  //       href: "/casino/aggapjiligaming-master-tiger",
  //     },
  //     WildAce: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Wild Ace",
  //       name: "Wild Ace",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/Wildace.jpg",
  //       href: "/casino/aggapjiligaming-wild-ace",
  //     },
  //     Crazy777: {
  //       code: "98566",
  //       casino: "aura",
  //       provider: "ALT_GAMING_GAP",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Crazy 777",
  //       name: "Crazy 777",
  //       providerName: "Jili Gaming",
  //       imgUrl: "../images/alt-gaming/jili-game/Crazy777.jpg",
  //       href: "/casino/aggapjiligaming-crazy777",
  //     },
  //     Coin3Treasures: {
  //       href: "/casino/aggapjiligaming-3-coin-treasures",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/3-coin-treasures.webp",
  //       alt: "3 coin treasures",
  //       name: "3 coin treasures",
  //     },
  //     Lucky3Piggy: {
  //       href: "/casino/aggapjiligaming-3-lucky-piggy",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/3-lucky-piggy.webp",
  //       alt: "3 lucky piggy",
  //       name: "3 lucky piggy",
  //     },
  //     Pot3Dragons: {
  //       href: "/casino/aggapjiligaming-3-pot-dragons",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/3-pot-dragons.webp",
  //       alt: "3 pot dragons",
  //       name: "3 pot dragons",
  //     },
  //     AgentAce: {
  //       href: "/casino/aggapjiligaming-agent-ace",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/agent-ace.webp",
  //       alt: "agent ace",
  //       name: "agent ace",
  //     },
  //     AliBaba: {
  //       href: "/casino/aggapjiligaming-ali-baba",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/ali-baba.webp",
  //       alt: "ali baba",
  //       name: "ali baba",
  //     },
  //     ArenaFighter: {
  //       href: "/casino/aggapjiligaming-arena-fighter",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/arena-fighter.webp",
  //       alt: "arena fighter",
  //       name: "arena fighter",
  //     },
  //     AztecPriestess: {
  //       href: "/casino/aggapjiligaming-aztec-priestess",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/aztec-priestess.webp",
  //       alt: "aztec priestess",
  //       name: "aztec priestess",
  //     },
  //     BanglaBeauty: {
  //       href: "/casino/aggapjiligaming-bangla-beauty",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/bangla-beauty.webp",
  //       alt: "bangla beauty",
  //       name: "bangla beauty",
  //     },
  //     BaoBoonChin: {
  //       href: "/casino/aggapjiligaming-bao-boon-chin",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/bao-boon-chin.webp",
  //       alt: "bao boon chin",
  //       name: "bao boon chin",
  //     },
  //     BoneFortune: {
  //       href: "/casino/aggapjiligaming-bone-fortune",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/bone-fortune.webp",
  //       alt: "bone fortune",
  //       name: "bone fortune",
  //     },
  //     BonusHunter: {
  //       href: "/casino/aggapjiligaming-bonus-hunter",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/bonus-hunter.webp",
  //       alt: "bonus h1unter",
  //       name: "bonus hunter",
  //     },
  //     BookOfGold: {
  //       href: "/casino/aggapjiligaming-book-of-gold",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/book-of-gold.webp",
  //       alt: "book of gold",
  //       name: "book of gold",
  //     },
  //     BoxingKing: {
  //       href: "/casino/aggapjiligaming-boxing-king",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/boxing-king.webp",
  //       alt: "boxing king",
  //       name: "boxing king",
  //     },
  //     BubbleBeauty: {
  //       href: "/casino/aggapjiligaming-bubble-beauty",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/bubble-beauty.webp",
  //       alt: "bubble beauty",
  //       name: "bubble beauty",
  //     },
  //     CargeBuffalo: {
  //       href: "/casino/aggapjiligaming-charge-buffalo",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/charge-buffalo.webp",
  //       alt: "charge buffalo",
  //       name: "charge buffalo",
  //     },
  //     ChargeBuffaloAscent: {
  //       href: "/casino/aggapjiligaming-charge-buffalo-ascent",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/charge-buffalo-ascent.webp",
  //       alt: "charge buffalo ascent",
  //       name: "charge buffalo ascent",
  //     },
  //     Chinshihuang: {
  //       href: "/casino/aggapjiligaming-chin-shi-huang",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/chin-shi-huang.webp",
  //       alt: "",
  //       name: "Chin Shi Huang",
  //     },
  //     CrazyFafafa: {
  //       href: "/casino/aggapjiligaming-crazy-fafafa",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/crazy-fafafa.webp",
  //       alt: "crazy fafafa",
  //       name: "crazy fafafa",
  //     },
  //     CrazyHunter: {
  //       href: "/casino/aggapjiligaming-crazy-hunter",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/crazy-hunter.webp",
  //       alt: "crazy hunter",
  //       name: "crazy hunter",
  //     },
  //     Crazy777: {
  //       href: "/casino/aggapjiligaming-crazy777",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/crazy777.webp",
  //       alt: "",
  //       name: "Crazy777",
  //     },
  //     CricketKing18: {
  //       href: "/casino/aggapjiligaming-cricket-king-18",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/cricket-king-18.webp",
  //       alt: "cricket king 18",
  //       name: "cricket king 18",
  //     },
  //     CricketSah75: {
  //       href: "/casino/aggapjiligaming-cricket-sah-75",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/cricket-sah-75.webp",
  //       alt: "cricket sah 75",
  //       name: "cricket sah 75",
  //     },
  //     Dabanggg: {
  //       href: "/casino/aggapjiligaming-dabanggg",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/dabanggg.webp",
  //       alt: "dabanggg",
  //       name: "dabanggg",
  //     },
  //     DevilFire2: {
  //       href: "/casino/aggapjiligaming-devil-fire-2",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/devil-fire-2.webp",
  //       alt: "devil fire 2",
  //       name: "devil fire 2",
  //     },
  //     DiamondParty: {
  //       href: "/casino/aggapjiligaming-diamondparty",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/diamond-party.webp",
  //       alt: "diamond party",
  //       name: "diamond party",
  //     },
  //     DragonTreasure: {
  //       href: "/casino/aggapjiligaming-dragon-treasure",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/dragon-treasure.webp",
  //       alt: "dragon treasure",
  //       name: "dragon treasure",
  //     },
  //     EgyptsGlow: {
  //       href: "/casino/aggapjiligaming-egypts-glow",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/egypts-glow.webp",
  //       alt: "egypt's glow",
  //       name: "egypt's glow",
  //     },
  //     FaFaFa: {
  //       href: "/casino/aggapjiligaming-fa-fa-fa",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fa-fa-fa.webp",
  //       alt: "fa fa fa",
  //       name: "fa fa fa",
  //     },
  //     Fengshen: {
  //       href: "/casino/aggapjiligaming-fengshen",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fengshen.webp",
  //       alt: "fengshen",
  //       name: "fengshen",
  //     },
  //     FortuneGems: {
  //       href: "/casino/aggapjiligaming-fortune-gems",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fortune-gems.webp",
  //       alt: "fortune gems",
  //       name: "fortune gems",
  //     },
  //     FortuneGems2: {
  //       href: "/casino/aggapjiligaming-fortune-gems-2",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fortune-gems-2.webp",
  //       alt: "fortune gems 2",
  //       name: "fortune gems 2",
  //     },
  //     FortuneGems3: {
  //       href: "/casino/aggapjiligaming-fortune-gems-3",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fortune-gems-3.webp",
  //       alt: "fortune gems 3",
  //       name: "fortune gems 3",
  //     },
  //     FortuneMonkey: {
  //       href: "/casino/aggapjiligaming-fortune-monkey",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fortune-monkey.webp",
  //       alt: "fortune monkey",
  //       name: "fortune monkey",
  //     },
  //     FortuneTree: {
  //       href: "/casino/aggapjiligaming-fortune-tree",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/fortune-tree.webp",
  //       alt: "",
  //       name: "Fortune Tree",
  //     },
  //     GemParty: {
  //       href: "/casino/aggapjiligaming-gem-party",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/gem-party.webp",
  //       alt: "",
  //       name: "Gem Party",
  //     },
  //     GodOfMartial: {
  //       href: "/casino/aggapjiligaming-god-of-martial",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/god-of-martial.webp",
  //       alt: "",
  //       name: "God Of Martial",
  //     },
  //     GoldRush: {
  //       href: "/casino/aggapjiligaming-gold-rush",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/gold-rush.webp",
  //       alt: "gold rush",
  //       name: "gold rush",
  //     },
  //     GoldenBank: {
  //       href: "/casino/aggapjiligaming-crazy-golden-bank",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/golden-bank.webp",
  //       alt: "golden bank",
  //       name: "golden bank",
  //     },
  //     GoldenEmpire: {
  //       href: "/casino/aggapjiligaming-golden-empire",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/golden-empire.webp",
  //       alt: "golden empire",
  //       name: "golden empire",
  //     },
  //     GoldenJoker: {
  //       href: "/casino/aggapjiligaming-golden-joker",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/golden-joker.webp",
  //       alt: "golden joker",
  //       name: "golden joker",
  //     },
  //     GoldenQueen: {
  //       href: "/casino/aggapjiligaming-golden-queen",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/golden-queen.webp",
  //       alt: "golden queen",
  //       name: "golden queen",
  //     },
  //     GoldenTemple: {
  //       href: "/casino/aggapjiligaming-golden-temple",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/golden-temple.webp",
  //       alt: "golden temple",
  //       name: "golden temple",
  //     },
  //     HappyTaxi: {
  //       href: "/casino/aggapjiligaming-happy-taxi",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/happy-taxi.webp",
  //       alt: "happy taxi",
  //       name: "happy taxi",
  //     },
  //     HawaiiBeauty: {
  //       href: "/casino/aggapjiligaming-hawaii-beauty",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/hawaii-beauty.webp",
  //       alt: "hawaii beauty",
  //       name: "hawaii beauty",
  //     },
  //     HotChili: {
  //       href: "/casino/aggapjiligaming-hot-chilli",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/hot-chilli.webp",
  //       alt: "Hot Chilli",
  //       name: "Hot Chilli",
  //     },
  //     HyperBrust: {
  //       href: "/casino/aggapjiligaming-hyper-burst",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/hyper-burst.webp",
  //       alt: "Hyper Burst",
  //       name: "Hyper Burst",
  //     },
  //     JiliCaishen: {
  //       href: "/casino/aggapjiligaming-jili-caishen",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/jili-caishen.webp",
  //       alt: "jili caishen",
  //       name: "jili caishen",
  //     },
  //     JungleKing: {
  //       href: "/casino/aggapjiligaming-jungle-king",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/jungle-king.webp",
  //       alt: "jungle king",
  //       name: "jungle king",
  //     },
  //     KingArthur: {
  //       href: "/casino/aggapjiligaming-king-arthur",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/king-arthur.webp",
  //       alt: "king arthur",
  //       name: "king arthur",
  //     },
  //     LegacyOfEgypt: {
  //       href: "/casino/aggapjiligaming-legacy-of-egypt",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/legacy-of-egypt.webp",
  //       alt: "legacy of egypt",
  //       name: "legacy of egypt",
  //     },
  //     LuckyBall: {
  //       href: "/casino/aggapjiligaming-lucky-ball",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/lucky-ball.webp",
  //       alt: "lucky ball",
  //       name: "lucky ball",
  //     },
  //     LuckyComing: {
  //       href: "/casino/aggapjiligaming-lucky-coming",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/lucky-coming.webp",
  //       alt: "lucky coming",
  //       name: "lucky coming",
  //     },
  //     MagicLamp: {
  //       href: "/casino/aggapjiligaming-magic-lamp",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/magic-lamp.webp",
  //       alt: "magic lamp",
  //       name: "magic lamp",
  //     },
  //     MasterTiger: {
  //       href: "/casino/aggapjiligaming-master-tiger",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/master-tiger.webp",
  //       alt: "master tiger",
  //       name: "master tiger",
  //     },
  //     MayanEmpire: {
  //       href: "/casino/aggapjiligaming-mayan-empire",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/mayan-empire.webp",
  //       alt: "mayan empire",
  //       name: "mayan empire",
  //     },
  //     Medusa: {
  //       href: "/casino/aggapjiligaming-medusa",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/medusa.webp",
  //       alt: "medusa",
  //       name: "medusa",
  //     },
  //     MegaAce: {
  //       href: "/casino/aggapjiligaming-mega-ace",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/mega-ace.webp",
  //       alt: "mega ace",
  //       name: "mega ace",
  //     },
  //     MoneyComing: {
  //       href: "/casino/aggapjiligaming-money-coming",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/money-coming.webp",
  //       alt: "money coming",
  //       name: "money coming",
  //     },
  //     MoneyComingExpandedBets: {
  //       href: "/casino/aggapjiligaming-money-coming-expand-bets",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/money-coming-expanded-bets.webp",
  //       alt: "money coming expanded bets",
  //       name: "money coming expanded bets",
  //     },
  //     MonkeyParty: {
  //       href: "/casino/aggapjiligaming-monkey-party",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/monkey-party.webp",
  //       alt: "monkey party",
  //       name: "monkey party",
  //     },
  //     NekoFortune: {
  //       href: "/casino/aggapjiligaming-neko-fortune",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/neko-fortune.webp",
  //       alt: "neko fortune",
  //       name: "neko fortune",
  //     },
  //     NightCity: {
  //       href: "/casino/aggapjiligaming-night-city",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/night-city.webp",
  //       alt: "night city",
  //       name: "night city",
  //     },
  //     PartyNight: {
  //       href: "/casino/aggapjiligaming-party-night",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/party-night.webp",
  //       alt: "party night",
  //       name: "party night",
  //     },
  //     PartyStar: {
  //       href: "/casino/aggapjiligaming-party-star",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/party-star.webp",
  //       alt: "party star",
  //       name: "party star",
  //     },
  //     PharaohTreasure: {
  //       href: "/casino/aggapjiligaming-pharaoh-treasure",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/pharaoh-treasure.webp",
  //       alt: "pharaoh treasure",
  //       name: "pharaoh treasure",
  //     },
  //     PirateQueen: {
  //       href: "/casino/aggapjiligaming-pirate-queen",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/pirate-queen.webp",
  //       alt: "pirate queen",
  //       name: "pirate queen",
  //     },
  //     Poseidon: {
  //       href: "/casino/aggapjiligaming-poseidon",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/poseidon.webp",
  //       alt: "poseidon",
  //       name: "poseidon",
  //     },
  //     PotionWizard: {
  //       href: "/casino/aggapjiligaming-potion-wizard",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/potion-wizard.webp",
  //       alt: "potion wizard",
  //       name: "potion wizard",
  //     },
  //     RomaX: {
  //       href: "/casino/aggapjiligaming-romax",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/roma-x.webp",
  //       alt: "romax",
  //       name: "romax",
  //     },
  //     Samba: {
  //       href: "/casino/aggapjiligaming-samba",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/samba.webp",
  //       alt: "samba",
  //       name: "samba",
  //     },
  //     SecretTreasure: {
  //       href: "/casino/aggapjiligaming-secret-treasure",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/secret-treasure.webp",
  //       alt: "secret treasure",
  //       name: "secret treasure",
  //     },
  //     ShanghaiBeauty: {
  //       href: "/casino/aggapjiligaming-shanghai-beauty",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/shanghai-beauty.webp",
  //       alt: "Shanghai Beauty",
  //       name: "Shanghai Beauty",
  //     },
  //     SinCity: {
  //       href: "/casino/aggapjiligaming-sin-city",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/sin-city.webp",
  //       alt: "sin city",
  //       name: "sin city",
  //     },
  //     SuperAce: {
  //       href: "/casino/aggapjiligaming-super-ace",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/super-ace.webp",
  //       alt: "super ace",
  //       name: "super ace",
  //     },
  //     SuperAceDeluxe: {
  //       href: "/casino/aggapjiligaming-super-ace-deluxe",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/super-ace-deluxe.webp",
  //       alt: "super ace deluxe",
  //       name: "super ace deluxe",
  //     },
  //     SuperRich: {
  //       href: "/casino/aggapjiligaming-super-rich",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/super-rich.webp",
  //       alt: "super rich",
  //       name: "super rich",
  //     },
  //     SweetLand: {
  //       href: "/casino/aggapjiligaming-sweet-land",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/sweet-land.webp",
  //       alt: "sweet land",
  //       name: "sweet land",
  //     },
  //     ThorX: {
  //       href: "/casino/aggapjiligaming-thor-x",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/thor-x.webp",
  //       alt: "thor x",
  //       name: "thor x",
  //     },
  //     TrialOfPhoenix: {
  //       href: "/casino/aggapjiligaming-trial-of-phoenix",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/trial-of-phoenix.webp",
  //       alt: "trial of phoenix",
  //       name: "trial of phoenix",
  //     },
  //     TwinWins: {
  //       href: "/casino/aggapjiligaming-twin-wins",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/twin-wins.webp",
  //       alt: "twin wins",
  //       name: "twin wins",
  //     },
  //     WarOfDragons: {
  //       href: "/casino/aggapjiligaming-war-of-dragons",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/war-of-dragons.webp",
  //       alt: "war of dragons",
  //       name: "war of dragons",
  //     },
  //     WildAce: {
  //       href: "/casino/aggapjiligaming-wild-ace",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/wild-ace.webp",
  //       alt: "wild ace",
  //       name: "wild ace",
  //     },
  //     WildRacer: {
  //       href: "/casino/aggapjiligaming-wild-racer",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/wild-racer.webp",
  //       alt: "wild racer",
  //       name: "wild racer",
  //     },
  //     WitchesNight: {
  //       href: "/casino/aggapjiligaming-witches-night",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/witches-night.webp",
  //       alt: "witches night",
  //       name: "witches night",
  //     },
  //     WorldCup: {
  //       href: "/casino/aggapjiligaming-world-cup",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/world-cup.webp",
  //       alt: "world cup",
  //       name: "world cup",
  //     },
  //     Xiyangyang: {
  //       href: "/casino/aggapjiligaming-xiyangyang",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/xiyangyang.webp",
  //       alt: "xiyangyang",
  //       name: "xiyangyang",
  //     },
  //     Zeus: {
  //       href: "/casino/aggapjiligaming-zeus",
  //       code: "",
  //       casino: "Slots",
  //       provider: "Jili",
  //       category: "jili",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/jili-games/zeus.webp",
  //       alt: "zeus",
  //       name: "zeus",
  //     },
  //   },
  // },

  hacksaw: {
    hacksaw: {
      SCRATCHPlatinum: {
        href: "/casino/qt-scratch-platinum",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/SCRATCHPlatinum.webp",
        alt: "SCRATCH! Platinum",
        name: "SCRATCH! Platinum",
      },
      SCRATCHGold: {
        href: "/casino/qt-scratch-gold",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/SCRATCHGold.webp",
        alt: "SCRATCH! Gold",
        name: "SCRATCH! Gold",
      },
      SCRATCHSilver: {
        href: "/casino/qt-scratch-silver",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/SCRATCHSilver.webp",
        alt: "SCRATCH! Silver",
        name: "SCRATCH! Silver",
      },
      SCRATCHBronze: {
        href: "/casino/qt-scratch-bronze",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/SCRATCHBronze.webp",
        alt: "SCRATCH! Bronze",
        name: "SCRATCH! Bronze",
      },
      // SnowScratcher: {
      //   href: "/casino/aggaphacksawgaming-snow-scratcher",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SnowScratcher.webp",
      //   alt: "Snow Scratcher",
      //   name: "Snow Scratcher",
      // },
      // SummerScratch: {
      //   href: "/casino/aggaphacksawgaming-summer-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SummerScratch.webp",
      //   alt: "Summer Scratch",
      //   name: "Summer Scratch",
      // },
      // Express200Scratch: {
      //   href: "/casino/qt-express-200-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Express200Scratch.webp",
      //   alt: "Express 200 Scratch",
      //   name: "Express 200 Scratch",
      // },
      // ScratchyMini: {
      //   href: "/casino/aggaphacksawgaming-scratchy-mini",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ScratchyMini.webp",
      //   alt: "Scratchy Mini",
      //   name: "Scratchy Mini",
      // },
      // Scratchy: {
      //   href: "/casino/aggaphacksawgaming-scratchy",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Scratchy.webp",
      //   alt: "Scratchy",
      //   name: "Scratchy",
      // },
      // ScratchyBig: {
      //   href: "/casino/aggaphacksawgaming-scratchy-big",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ScratchyBig.webp",
      //   alt: "Scratchy Big",
      //   name: "Scratchy Big",
      // },
      // KingTreasure: {
      //   href: "/casino/aggaphacksawgaming-king-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/KingTreasure.webp",
      //   alt: "King Treasure",
      //   name: "King Treasure",
      // },
      // QueenTreasure: {
      //   href: "/casino/aggaphacksawgaming-queen-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/QueenTreasure.webp",
      //   alt: "Queen Treasure",
      //   name: "Queen Treasure",
      // },
      // PrinceTreasure: {
      //   href: "/casino/aggaphacksawgaming-prince-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/PrinceTreasure.webp",
      //   alt: "Prince Treasure",
      //   name: "Prince Treasure",
      // },
      // HappyScratch: {
      //   href: "/casino/aggaphacksawgaming-happy-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Happyscratch.webp",
      //   alt: "Happy Scratch",
      //   name: "Happy Scratch",
      // },
      // LOVEIsAllYouNeed: {
      //   href: "/casino/aggaphacksawgaming-love-is-all-you-need",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LoveIsAllYouNeed.webp",
      //   alt: "LOVE is all you need",
      //   name: "LOVE is all you need",
      // },
      // LuckyScratch: {
      //   href: "/casino/aggaphacksawgaming-lucky-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Luckyscratch.webp",
      //   alt: "Lucky Scratch",
      //   name: "Lucky Scratch",
      // },
      // CashPool: {
      //   href: "/casino/aggaphacksawgaming-cash-pool",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Cashpool.webp",
      //   alt: "Cash Pool",
      //   name: "Cash Pool",
      // },
      // CashScratch: {
      //   href: "/casino/aggaphacksawgaming-cash-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashScratch.webp",
      //   alt: "Cash Scratch",
      //   name: "Cash Scratch",
      // },
      // ChaosCrewScratch: {
      //   href: "/casino/aggaphacksawgaming-chaos-crew-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ChaosCrewScratch.webp",
      //   alt: "Chaos Crew Scratch",
      //   name: "Chaos Crew Scratch",
      // },
      // DreamCarUrban: {
      //   href: "/casino/aggaphacksawgaming-dream-car-urban",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DreamCarUrban.webp",
      //   alt: "Dream Car Urban",
      //   name: "Dream Car Urban",
      // },
      // DreamCarSUV: {
      //   href: "/casino/aggaphacksawgaming-dream-car-suv",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DreamCarSUV.webp",
      //   alt: "Dream Car SUV",
      //   name: "Dream Car SUV",
      // },
      // DreamCarSpeed: {
      //   href: "/casino/aggaphacksawgaming-dream-car-speed",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DreamCarSpeed.webp",
      //   alt: "Dream Car Speed",
      //   name: "Dream Car Speed",
      // },
      // EggstraCash: {
      //   href: "/casino/aggaphacksawgaming-eggstra-cash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/EggstraCash.webp",
      //   alt: "Eggstra Cash",
      //   name: "Eggstra Cash",
      // },
      // FootballScratch: {
      //   href: "/casino/aggaphacksawgaming-football-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FootballScratch.webp",
      //   alt: "Football Scratch",
      //   name: "Football Scratch",
      // },
      // GoldRush: {
      //   href: "/casino/aggaphacksawgaming-gold-rush",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GoldRush.webp",
      //   alt: "Gold Rush",
      //   name: "Gold Rush",
      // },
      // RubyRush: {
      //   href: "/casino/aggaphacksawgaming-ruby-rush",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RubyRush.webp",
      //   alt: "Ruby Rush",
      //   name: "Ruby Rush",
      // },
      // DiamondRush: {
      //   href: "/casino/aggaphacksawgaming-diamond-rush",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DiamondRush.webp",
      //   alt: "Diamond Rush",
      //   name: "Diamond Rush",
      // },
      // LuckyShot: {
      //   href: "/casino/aggaphacksawgaming-lucky-shot",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LuckyShot.webp",
      //   alt: "Lucky Shot",
      //   name: "Lucky Shot",
      // },
      // CashVaultI: {
      //   href: "/casino/aggaphacksawgaming-cash-vault-i",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashVaultI.webp",
      //   alt: "Cash Vault I",
      //   name: "Cash Vault I",
      // },
      // CashVaultII: {
      //   href: "/casino/aggaphacksawgaming-cash-vault-ii",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashVaultII.webp",
      //   alt: "Cash Vault II",
      //   name: "Cash Vault II",
      // },
      // CrazyDonuts: {
      //   href: "/casino/aggaphacksawgaming-crazy-donuts",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CrazyDonuts.webp",
      //   alt: "Crazy Donuts",
      //   name: "Crazy Donuts",
      // },
      // LuckyNumbersX8: {
      //   href: "/casino/aggaphacksawgaming-lucky-numbers-x8",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LuckyNumbersX8.webp",
      //   alt: "Lucky Numbers x8",
      //   name: "Lucky Numbers x8",
      // },
      // LuckyNumbersX12: {
      //   href: "/casino/aggaphacksawgaming-lucky-numbers-x12",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LuckyNumbersX12.webp",
      //   alt: "Lucky Numbers x12",
      //   name: "Lucky Numbers x12",
      // },
      // LuckyNumbersX16: {
      //   href: "/casino/aggaphacksawgaming-lucky-numbers-x16",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LuckyNumbersX16.webp",
      //   alt: "Lucky Numbers x16",
      //   name: "Lucky Numbers x16",
      // },
      // LuckyNumbersX20: {
      //   href: "/casino/aggaphacksawgaming-lucky-numbers-x20",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LuckyNumbersx20.webp",
      //   alt: "Lucky Numbers x20",
      //   name: "Lucky Numbers x20",
      // },
      // ItsBananas: {
      //   href: "/casino/aggaphacksawgaming-its-bananas",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Itsbananas.webp",
      //   alt: "It's bananas",
      //   name: "It's bananas",
      // },
      // DoubleSalary1Year: {
      //   href: "/casino/qt-double-salary-1-year",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DoubleSalary1Year.webp",
      //   alt: "Double Salary - 1 Year",
      //   name: "Double Salary - 1 Year",
      // },
      // ShaveTheBeard: {
      //   href: "/casino/aggaphacksawgaming-shave-the-beard",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ShaveTheBeard.webp",
      //   alt: "Shave the Beard",
      //   name: "Shave the Beard",
      // },
      // CutTheGrass: {
      //   href: "/casino/aggaphacksawgaming-cut-the-grass",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CutTheGrass.webp",
      //   alt: "Cut the Grass",
      //   name: "Cut the Grass",
      // },
      Scratchem: {
        href: "/casino/qt-scratchem",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/Scratchem.webp",
        alt: "Scratch’em",
        name: "Scratch’em",
      },
      // KoiCash: {
      //   href: "/casino/aggaphacksawgaming-koi-cash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/KoiCash.webp",
      //   alt: "Koi Cash",
      //   name: "Koi Cash",
      // },
      // BreakTheIce: {
      //   href: "/casino/aggaphacksawgaming-break-the-ice",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BreakTheIce.webp",
      //   alt: "Break the Ice",
      //   name: "Break the Ice",
      // },
      // GoldCoins: {
      //   href: "/casino/aggaphacksawgaming-gold-coins",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GoldCoins.webp",
      //   alt: "Gold Coins",
      //   name: "Gold Coins",
      // },
      // FrogsScratch: {
      //   href: "/casino/aggaphacksawgaming-frogs-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FrogsScratch.webp",
      //   alt: "Frogs Scratch",
      //   name: "Frogs Scratch",
      // },
      // ShaveTheSheep: {
      //   href: "/casino/aggaphacksawgaming-shave-the-sheep",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ShaveTheSheep.webp",
      //   alt: "Shave the Sheep",
      //   name: "Shave the Sheep",
      // },
      // SpookyScaryScratchy: {
      //   href: "/casino/aggaphacksawgaming-spooky-scary-scratchy",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SpookyScaryScratchy.webp",
      //   alt: "Spooky Scary Scratchy",
      //   name: "Spooky Scary Scratchy",
      // },
      // ThePerfectScratch: {
      //   href: "/casino/aggaphacksawgaming-the-perfect-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ThePerfectScratch.webp",
      //   alt: "The perfect Scratch",
      //   name: "The perfect Scratch",
      // },
      // TigerScratch: {
      //   href: "/casino/aggaphacksawgaming-tiger-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TigerScratch.webp",
      //   alt: "Tiger Scratch",
      //   name: "Tiger Scratch",
      // },
      // RatRiches: {
      //   href: "/casino/aggaphacksawgaming-rat-riches",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RatRiches.webp",
      //   alt: "Rat Riches",
      //   name: "Rat Riches",
      // },
      // StackEmScratch: {
      //   href: "/casino/aggaphacksawgaming-stackem-scratch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/StackEmScratch.webp",
      //   alt: "Stack'Em Scratch",
      //   name: "Stack'Em Scratch",
      // },
      // GoPanda: {
      //   href: "/casino/aggaphacksawgaming-go-panda",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GoPanda.webp",
      //   alt: "Go Panda",
      //   name: "Go Panda",
      // },
      // WantedDeadOrAWild: {
      //   href: "/casino/aggaphacksawgaming-wanted-dead-or-a-wild",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/WantedDeadOrAWild.webp",
      //   alt: "Wanted Dead or a Wild",
      //   name: "Wanted Dead or a Wild",
      // },
      // Wild2Die2: {
      //   href: "/casino/aggaphacksawgaming-2-wild-2-die",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/2Wild2Die.webp",
      //   alt: "2 Wild 2 Die",
      //   name: "2 Wild 2 Die",
      // },
      Coins: {
        href: "/casino/qt-coins",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/Coins.webp",
        alt: "Coins",
        name: "Coins",
      },
      // Colors: {
      //   href: "/casino/aggaphacksawgaming-colors",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Colors.webp",
      //   alt: "Colors",
      //   name: "Colors",
      // },
      // Blocks: {
      //   href: "/casino/aggaphacksawgaming-blocks",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Blocks.webp",
      //   alt: "Blocks",
      //   name: "Blocks",
      // },
      Boxes: {
        href: "/casino/qt-boxes",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/Boxes.webp",
        alt: "Boxes",
        name: "Boxes",
      },
      // HiLo: {
      //   href: "/casino/aggaphacksawgaming-hi-lo",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/HiLo.webp",
      //   alt: "Hi-Lo",
      //   name: "Hi-Lo",
      // },
      // Lines: {
      //   href: "/casino/aggaphacksawgaming-lines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Lines.webp",
      //   alt: "Lines",
      //   name: "Lines",
      // },
      Plinko: {
        href: "/casino/qt-plinko",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/Plinko.webp",
        alt: "Plinko",
        name: "Plinko",
      },
      // TwentyOne: {
      //   href: "/casino/aggaphacksawgaming-twenty-one",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TwentyOne.webp",
      //   alt: "Twenty-One",
      //   name: "Twenty-One",
      // },
      // Wheel: {
      //   href: "/casino/aggaphacksawgaming-wheel",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Wheel.webp",
      //   alt: "Wheel",
      //   name: "Wheel",
      // },
      // XmasDrop: {
      //   href: "/casino/aggaphacksawgaming-xmas-drop",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/XmasDrop.webp",
      //   alt: "Xmas Drop",
      //   name: "Xmas Drop",
      // },
      // DarkSummoning: {
      //   href: "/casino/aggaphacksawgaming-dark-summoning",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DarkSummoning.webp",
      //   alt: "Dark Summoning",
      //   name: "Dark Summoning",
      // },
      // ImmortalDesire: {
      //   href: "/casino/aggaphacksawgaming-immortal-desire",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ImmortalDesire.webp",
      //   alt: "Immortal Desire",
      //   name: "Immortal Desire",
      // },
      // EyeOfThePanda: {
      //   href: "/casino/aggaphacksawgaming-eye-of-the-panda",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/EyeOfThePanda.webp",
      //   alt: "Eye of the Panda",
      //   name: "Eye of the Panda",
      // },
      // ChaosCrewII: {
      //   href: "/casino/aggaphacksawgaming-chaos-crew-ii",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ChaosCrewII.webp",
      //   alt: "Chaos Crew II",
      //   name: "Chaos Crew II",
      // },
      // BennyTheBeer: {
      //   href: "/casino/aggaphacksawgaming-benny-the-beer",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BennyTheBeer.webp",
      //   alt: "Benny the Beer",
      //   name: "Benny the Beer",
      // },
      // Densho: {
      //   href: "/casino/aggaphacksawgaming-densho",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Densho.webp",
      //   alt: "Densho",
      //   name: "Densho",
      // },
      // LeBandit: {
      //   href: "/casino/aggaphacksawgaming-le-bandit",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LeBandit.webp",
      //   alt: "Le Bandit",
      //   name: "Le Bandit",
      // },
      // RoninStackways: {
      //   href: "/casino/aggaphacksawgaming-ronin-stackways",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RoninStackways.webp",
      //   alt: "Ronin Stackways",
      //   name: "Ronin Stackways",
      // },
      // Dropem: {
      //   href: "/casino/aggaphacksawgaming-dropem",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Dropem.webp",
      //   alt: "Drop'EM",
      //   name: "Drop'EM",
      // },
      // VendingMachine: {
      //   href: "/casino/aggaphacksawgaming-vending-machine",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/VendingMachine.webp",
      //   alt: "Vending Machine",
      //   name: "Vending Machine",
      // },
      // BeastBelow: {
      //   href: "/casino/aggaphacksawgaming-beast-below",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BeastBelow.webp",
      //   alt: "Beast Below",
      //   name: "Beast Below",
      // },
      // MightyMasks: {
      //   href: "/casino/aggaphacksawgaming-mighty-masks",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/MightyMasks.webp",
      //   alt: "Mighty Masks",
      //   name: "Mighty Masks",
      // },
      // AlphaEagle: {
      //   href: "/casino/aggaphacksawgaming-alpha-eagle",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/AlphaEagle.webp",
      //   alt: "Alpha Eagle",
      //   name: "Alpha Eagle",
      // },
      // AztecTwist: {
      //   href: "/casino/aggaphacksawgaming-aztec-twist",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/AztecTwist.webp",
      //   alt: "Aztec Twist",
      //   name: "Aztec Twist",
      // },
      // Bloodthirst: {
      //   href: "/casino/aggaphacksawgaming-bloodthirst",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Bloodthirst.webp",
      //   alt: "Bloodthirst",
      //   name: "Bloodthirst",
      // },
      // BookOfTime: {
      //   href: "/casino/aggaphacksawgaming-book-of-time",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BookOfTime.webp",
      //   alt: "Book of Time",
      //   name: "Book of Time",
      // },
      // BornWild: {
      //   href: "/casino/aggaphacksawgaming-born-wild",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BornWild.webp",
      //   alt: "Born Wild",
      //   name: "Born Wild",
      // },
      // BreakBones: {
      //   href: "/casino/aggaphacksawgaming-break-bones",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BreakBones.webp",
      //   alt: "Break Bones",
      //   name: "Break Bones",
      // },
      // BuffaloStackNSync: {
      //   href: "/casino/aggaphacksawgaming-buffalo-stacknsync",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BuffaloStackNSync.webp",
      //   alt: "Buffalo Stack'n'Sync",
      //   name: "Buffalo Stack'n'Sync",
      // },
      // Cubes: {
      //   href: "/casino/aggaphacksawgaming-cubes",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Cubes.webp",
      //   alt: "Cubes",
      //   name: "Cubes",
      // },
      // Cubes2: {
      //   href: "/casino/aggaphacksawgaming-cubes-2",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Cubes2.webp",
      //   alt: "Cubes 2",
      //   name: "Cubes 2",
      // },
      // CursedSeas: {
      //   href: "/casino/aggaphacksawgaming-cursed-seas",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CursedSeas.webp",
      //   alt: "Cursed Seas",
      //   name: "Cursed Seas",
      // },
      // CashCompass: {
      //   href: "/casino/aggaphacksawgaming-cash-compass",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashCompass.webp",
      //   alt: "Cash Compass",
      //   name: "Cash Compass",
      // },
      // CashQuest: {
      //   href: "/casino/aggaphacksawgaming-cash-quest",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashQuest.webp",
      //   alt: "Cash Quest",
      //   name: "Cash Quest",
      // },
      // ChaosCrew: {
      //   href: "/casino/aggaphacksawgaming-chaos-crew",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ChaosCrew.webp",
      //   alt: "Chaos Crew",
      //   name: "Chaos Crew",
      // },
      // DorkUnit: {
      //   href: "/casino/aggaphacksawgaming-dork-unit",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DorkUnit.webp",
      //   alt: "Dork Unit",
      //   name: "Dork Unit",
      // },
      // DoubleRainbow: {
      //   href: "/casino/aggaphacksawgaming-double-rainbow",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DoubleRainbow.webp",
      //   alt: "Double Rainbow",
      //   name: "Double Rainbow",
      // },
      // FearTheDark: {
      //   href: "/casino/aggaphacksawgaming-fear-the-dark",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FearTheDark.webp",
      //   alt: "Fear the Dark",
      //   name: "Fear the Dark",
      // },
      // ForestFortune: {
      //   href: "/casino/aggaphacksawgaming-forest-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ForestFortune.webp",
      //   alt: "Forest Fortune",
      //   name: "Forest Fortune",
      // },
      // FranksFarm: {
      //   href: "/casino/aggaphacksawgaming-franks-farm",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FranksFarm.webp",
      //   alt: "Frank's Farm",
      //   name: "Frank's Farm",
      // },
      // FruitDuel: {
      //   href: "/casino/aggaphacksawgaming-fruit-duel",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FruitDuel.webp",
      //   alt: "Fruit Duel",
      //   name: "Fruit Duel",
      // },
      // Frutz: {
      //   href: "/casino/aggaphacksawgaming-frutz",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Frutz.webp",
      //   alt: "Frutz",
      //   name: "Frutz",
      // },
      // GladiatorLegends: {
      //   href: "/casino/aggaphacksawgaming-gladiator-legends",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GladiatorLegends.webp",
      //   alt: "Gladiator Legends",
      //   name: "Gladiator Legends",
      // },
      // GronksGems: {
      //   href: "/casino/aggaphacksawgaming-gronks-gems",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GronksGems.webp",
      //   alt: "Gronk's Gems",
      //   name: "Gronk's Gems",
      // },
      // HandOfAnubis: {
      //   href: "/casino/aggaphacksawgaming-hand-of-anubis",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/HandOfAnubis.webp",
      //   alt: "Hand Of Anubis",
      //   name: "Hand Of Anubis",
      // },
      // HarvestWilds: {
      //   href: "/casino/aggaphacksawgaming-harvest-wilds",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/HarvestWilds.webp",
      //   alt: "Harvest Wilds",
      //   name: "Harvest Wilds",
      // },
      // HopNpop: {
      //   href: "/casino/aggaphacksawgaming-hopnpop",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/HopNpop.webp",
      //   alt: "Hop'n'pop",
      //   name: "Hop'n'pop",
      // },
      // Itero: {
      //   href: "/casino/aggaphacksawgaming-itero",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Itero.webp",
      //   alt: "Itero",
      //   name: "Itero",
      // },
      // JokerBombs: {
      //   href: "/casino/aggaphacksawgaming-joker-bombs",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/JokerBombs.webp",
      //   alt: "Joker Bombs",
      //   name: "Joker Bombs",
      // },
      // KeepemCool: {
      //   href: "/casino/aggaphacksawgaming-keepem-cool",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/KeepemCool.webp",
      //   alt: "Keep'em Cool",
      //   name: "Keep'em Cool",
      // },
      // KingCarrot: {
      //   href: "/casino/aggaphacksawgaming-king-carrot",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/KingCarrot.webp",
      //   alt: "King Carrot",
      //   name: "King Carrot",
      // },
      // LetItSnow: {
      //   href: "/casino/aggaphacksawgaming-let-it-snow",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LetItSnow.webp",
      //   alt: "Let it Snow",
      //   name: "Let it Snow",
      // },
      // MagicPiggy: {
      //   href: "/casino/aggaphacksawgaming-magic-piggy",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/MagicPiggy.webp",
      //   alt: "Magic Piggy",
      //   name: "Magic Piggy",
      // },
      // MayanStackways: {
      //   href: "/casino/aggaphacksawgaming-mayan-stackways",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/MayanStackways.webp",
      //   alt: "Mayan Stackways",
      //   name: "Mayan Stackways",
      // },
      MiamiMultiplier: {
        href: "/casino/qt-miami-multiplier",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/MiamiMultiplier.webp",
        alt: "Miami Multiplier",
        name: "Miami Multiplier",
      },
      // MysteryMotel: {
      //   href: "/casino/aggaphacksawgaming-mystery-motel",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/MysteryMotel.webp",
      //   alt: "Mystery Motel",
      //   name: "Mystery Motel",
      // },
      // OmNom: {
      //   href: "/casino/aggaphacksawgaming-omnom",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/OmNom.webp",
      //   alt: "OmNom",
      //   name: "OmNom",
      // },
      // OutlawsInc: {
      //   href: "/casino/aggaphacksawgaming-outlaws-inc",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/OutlawsInc.webp",
      //   alt: "Outlaws Inc",
      //   name: "Outlaws Inc",
      // },
      // PugLife: {
      //   href: "/casino/aggaphacksawgaming-pug-life",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/PugLife.webp",
      //   alt: "Pug Life",
      //   name: "Pug Life",
      // },
      // RIPCity: {
      //   href: "/casino/aggaphacksawgaming-rip-city",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RIPCity.webp",
      //   alt: "RIP City",
      //   name: "RIP City",
      // },
      // RocketReels: {
      //   href: "/casino/aggaphacksawgaming-rocket-reels",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RocketReels.webp",
      //   alt: "Rocket Reels",
      //   name: "Rocket Reels",
      // },
      // Rotten: {
      //   href: "/casino/aggaphacksawgaming-rotten",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Rotten.webp",
      //   alt: "Rotten",
      //   name: "Rotten",
      // },
      // StackEM: {
      //   href: "/casino/aggaphacksawgaming-stackem",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/StackEM.webp",
      //   alt: "Stack'EM",
      //   name: "Stack'EM",
      // },
      Stickem: {
        href: "/casino/qt-stick-em",
        code: "",
        casino: "Slots",
        provider: "Hacksaw",
        category: "hacksaw",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/hacksaw/Stickem.webp",
        alt: "Stick ‘em",
        name: "Stick ‘em",
      },
      // Stormforged: {
      //   href: "/casino/aggaphacksawgaming-stormforged",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Stormforged.webp",
      //   alt: "Stormforged",
      //   name: "Stormforged",
      // },
      // TastyTreats: {
      //   href: "/casino/aggaphacksawgaming-tasty-treats",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TastyTreats.webp",
      //   alt: "Tasty Treats",
      //   name: "Tasty Treats",
      // },
      // TempleOfTorment: {
      //   href: "/casino/aggaphacksawgaming-temple-of-torment",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TempleOfTorment.webp",
      //   alt: "Temple of Torment",
      //   name: "Temple of Torment",
      // },
      // TheBoweryBoys: {
      //   href: "/casino/aggaphacksawgaming-the-bowery-boys",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TheBoweryBoys.webp",
      //   alt: "The Bowery Boys",
      //   name: "The Bowery Boys",
      // },
      // TheRespinners: {
      //   href: "/casino/aggaphacksawgaming-the-respinners",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TheRespinners.webp",
      //   alt: "The Respinners",
      //   name: "The Respinners",
      // },
      // TimeSpinners: {
      //   href: "/casino/aggaphacksawgaming-time-spinners",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TimeSpinners.webp",
      //   alt: "Time Spinners",
      //   name: "Time Spinners",
      // },
      // ToshiVideoClub: {
      //   href: "/casino/aggaphacksawgaming-toshi-video-club",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ToshiVideoClub.webp",
      //   alt: "Toshi Video Club",
      //   name: "Toshi Video Club",
      // },
      // UndeadFortune: {
      //   href: "/casino/aggaphacksawgaming-undead-fortune",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/UndeadFortune.webp",
      //   alt: "Undead Fortune",
      //   name: "Undead Fortune",
      // },
      // WarriorWays: {
      //   href: "/casino/aggaphacksawgaming-warrior-ways",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/WarriorWays.webp",
      //   alt: "Warrior Ways",
      //   name: "Warrior Ways",
      // },
      // Xpander: {
      //   href: "/casino/aggaphacksawgaming-xpander",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Xpander.webp",
      //   alt: "Xpander",
      //   name: "Xpander",
      // },
      // FeelTheBeat: {
      //   href: "/casino/aggaphacksawgaming-feel-the-beat",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FeelTheBeat.webp",
      //   alt: "Feel the Beat",
      //   name: "Feel the Beat",
      // },
      // BeamBoys: {
      //   href: "/casino/aggaphacksawgaming-beam-boys",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BeamBoys.webp",
      //   alt: "Beam Boys",
      //   name: "Beam Boys",
      // },
      // Baccarat: {
      //   href: "/casino/aggaphacksawgaming-baccarat",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Baccarat.webp",
      //   alt: "Baccarat",
      //   name: "Baccarat",
      // },
      // FistOfDestruction: {
      //   href: "/casino/aggaphacksawgaming-fist-of-destruction",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FistOfDestruction.webp",
      //   alt: "Fist of Destruction",
      //   name: "Fist of Destruction",
      // },
      // DawnOfKings: {
      //   href: "/casino/aggaphacksawgaming-dawn-of-kings",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DawnOfKings.webp",
      //   alt: "Dawn of Kings",
      //   name: "Dawn of Kings",
      // },
      // BouncyBombs: {
      //   href: "/casino/aggaphacksawgaming-bouncy-bombs",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/BouncyBombs.webp",
      //   alt: "Bouncy Bombs",
      //   name: "Bouncy Bombs",
      // },
      // RustyAndCurly: {
      //   href: "/casino/aggaphacksawgaming-rusty-and-curly",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RustyAndCurly.webp",
      //   alt: "Rusty and Curly",
      //   name: "Rusty and Curly",
      // },
      // ScratchAMillion: {
      //   href: "/casino/qtechhacksawgaming-scratch-a-million-u8239",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ScratchAMillion.webp",
      //   alt: "Scratch a Million",
      //   name: "Scratch a Million",
      // },
      // InstaCubes: {
      //   href: "/casino/qtechhacksawgaming-insta-cubes-u4725",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/InstaCubes.webp",
      //   alt: "Insta Cubes",
      //   name: "Insta Cubes",
      // },
      // LePharaoh: {
      //   href: "/casino/aggaphacksawgaming-le-pharaoh",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LePharaoh.webp",
      //   alt: "Le Pharaoh",
      //   name: "Le Pharaoh",
      // },
      // OctoAttack: {
      //   href: "/casino/aggaphacksawgaming-octo-attack",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/OctoAttack.webp",
      //   alt: "Octo Attack",
      //   name: "Octo Attack",
      // },
      // EvilEyes: {
      //   href: "/casino/aggaphacksawgaming-evil-eyes",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/EvilEyes.webp",
      //   alt: "Evil Eyes",
      //   name: "Evil Eyes",
      // },
      // SpeedCrash: {
      //   href: "/casino/aggaphacksawgaming-speed-crash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SpeedCrash.webp",
      //   alt: "Speed Crash",
      //   name: "Speed Crash",
      // },
      // Limbo: {
      //   href: "/casino/aggaphacksawgaming-limbo",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Limbo.webp",
      //   alt: "Limbo",
      //   name: "Limbo",
      // },
      // DonnyDough: {
      //   href: "/casino/aggaphacksawgaming-donny-dough",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DonnyDough.webp",
      //   alt: "Donny Dough",
      //   name: "Donny Dough",
      // },
      // DragonsDomain: {
      //   href: "/casino/aggaphacksawgaming-dragons-domain",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DragonsDomain.webp",
      //   alt: "Dragon's Domain",
      //   name: "Dragon's Domain",
      // },
      // SixSixSix: {
      //   href: "/casino/aggaphacksawgaming-sixsixsix",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SixSixSix.webp",
      //   alt: "SixSixSix",
      //   name: "SixSixSix",
      // },
      // Dice: {
      //   href: "/casino/aggaphacksawgaming-dice",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Dice.webp",
      //   alt: "Dice",
      //   name: "Dice",
      // },
      // TaiTheToad: {
      //   href: "/casino/aggaphacksawgaming-tai-the-toad",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TaiTheToad.webp",
      //   alt: "Tai the Toad",
      //   name: "Tai the Toad",
      // },
      // TwistedLab: {
      //   href: "/casino/aggaphacksawgaming-twisted-lab",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/TwistedLabs.webp",
      //   alt: "Twisted Lab",
      //   name: "Twisted Lab",
      // },
      // ZeZeus: {
      //   href: "/casino/aggaphacksawgaming-ze-zeus",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ZeZeus.webp",
      //   alt: "Ze Zeus",
      //   name: "Ze Zeus",
      // },
      // CursedCrypt: {
      //   href: "/casino/aggaphacksawgaming-cursed-crypt",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CursedCrypt.webp",
      //   alt: "Cursed Crypt",
      //   name: "Cursed Crypt",
      // },
      // SlayersInc: {
      //   href: "/casino/aggaphacksawgaming-slayers-inc",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SlayersInc.webp",
      //   alt: "Slayers Inc",
      //   name: "Slayers Inc",
      // },
      // JellySlice: {
      //   href: "/casino/aggaphacksawgaming-jelly-slice",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/JellySlice.webp",
      //   alt: "Jelly Slice",
      //   name: "Jelly Slice",
      // },
      // KeepEm: {
      //   href: "/casino/aggaphacksawgaming-keepem",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/KeepEm.webp",
      //   alt: "Keep'Em",
      //   name: "Keep'Em",
      // },
      // DivineDrop: {
      //   href: "/casino/aggaphacksawgaming-divine-drop",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DivineDrop.webp",
      //   alt: "Divine Drop",
      //   name: "Divine Drop",
      // },
      // OrbOfDestiny: {
      //   href: "/casino/aggaphacksawgaming-orb-of-destiny",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/OrbOfDestiny.webp",
      //   alt: "Orb of Destiny",
      //   name: "Orb of Destiny",
      // },
      // CashCrew: {
      //   href: "/casino/aggaphacksawgaming-cash-crew",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CashCrew.webp",
      //   alt: "Cash Crew",
      //   name: "Cash Crew",
      // },
      // CloudPrincess: {
      //   href: "/casino/aggaphacksawgaming-cloud-princess",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/CloudPrincess.webp",
      //   alt: "Cloud Princess",
      //   name: "Cloud Princess",
      // },
      // GetTheCheese: {
      //   href: "/casino/aggaphacksawgaming-get-the-cheese",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/GetTheCheese.webp",
      //   alt: "Get The Cheese",
      //   name: "Get The Cheese",
      // },
      // RiseOfYmir: {
      //   href: "/casino/aggaphacksawgaming-rise-of-ymir",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/RiseOfYmir.webp",
      //   alt: "Rise of Ymir",
      //   name: "Rise of Ymir",
      // },
      // WingsOfHorus: {
      //   href: "/casino/aggaphacksawgaming-wings-of-horus",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/WingsOfHorus.webp",
      //   alt: "Wings of Horus",
      //   name: "Wings of Horus",
      // },
      // DuelAtDawn: {
      //   href: "/casino/aggaphacksawgaming-duel-at-dawn",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DuelAtDawn.webp",
      //   alt: "Duel at Dawn",
      //   name: "Duel at Dawn",
      // },
      // SnowSlingers: {
      //   href: "/casino/aggaphacksawgaming-snow-slingers",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/SnowSlingers.webp",
      //   alt: "Snow Slingers",
      //   name: "Snow Slingers",
      // },
      // ShaolinMaster: {
      //   href: "/casino/aggaphacksawgaming-shaolin-master",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/ShaolinMaster.webp",
      //   alt: "Shaolin Master",
      //   name: "Shaolin Master",
      // },
      // DonutDivision: {
      //   href: "/casino/aggaphacksawgaming-donut-division",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/DonutDivision.webp",
      //   alt: "Donut Division",
      //   name: "Donut Division",
      // },
      // FireMyLaser: {
      //   href: "/casino/aggaphacksawgaming-fire-my-laser",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FireMyLaser.webp",
      //   alt: "Fire My Laser",
      //   name: "Fire My Laser",
      // },
      // Klowns: {
      //   href: "/casino/aggaphacksawgaming-klowns",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/Klowns.webp",
      //   alt: "Klowns",
      //   name: "Klowns",
      // },
      // LeViking: {
      //   href: "/casino/aggaphacksawgaming-le-viking",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/LeViking.webp",
      //   alt: "Le Viking",
      //   name: "Le Viking",
      // },
      // PhoenixDuelReels: {
      //   href: "/casino/aggaphacksawgaming-phoenix-duelreels",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/PhoenixDuelReels.webp",
      //   alt: "Phoenix DuelReels",
      //   name: "Phoenix DuelReels",
      // },
      // MarlinMasters: {
      //   href: "/casino/aggaphacksawgaming-marlin-masters",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/MarlinMasters.webp",
      //   alt: "Marlin Masters",
      //   name: "Marlin Masters",
      // },
      // FRKNBananas: {
      //   href: "/casino/aggaphacksawgaming-frkn-bananas",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/FRKNBananas.webp",
      //   alt: "FRKN Bananas",
      //   name: "FRKN Bananas",
      // },
      // HoundsOfHell: {
      //   href: "/casino/aggaphacksawgaming-hounds-of-hell",
      //   code: "",
      //   casino: "Slots",
      //   provider: "Hacksaw",
      //   category: "hacksaw",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/hacksaw/HoundsOfHell.webp",
      //   alt: "Hounds of Hell",
      //   name: "Hounds of Hell",
      // },
    },
    // mines: {
    //   MinesHS: {
    //     href: "/casino/aggaphacksawgaming-mines-dare2win",
    //     code: "",
    //     casino: "Slots",
    //     provider: "Hacksaw",
    //     category: "mines",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/hacksaw/Mines.webp",
    //     alt: "Mines",
    //     name: "Mines",
    //   },
    // },
  },

  turbo: {
    // turbo: {
    //   Catanza: {
    //     href: "/casino/aggapturbogames-catanza",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Catanza.jpg",
    //     alt: "Catanza",
    //     name: "Catanza",
    //   },
    //   CricketBoom: {
    //     href: "/casino/aggapturbogames-cricket-boom",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/CricketBoom.jpg",
    //     alt: "Cricket Boom",
    //     name: "Cricket Boom",
    //   },
    //   Neko: {
    //     href: "/casino/aggapturbogames-neko",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Neko.jpg",
    //     alt: "Neko",
    //     name: "Neko",
    //   },
    //   PandaBao: {
    //     href: "/casino/aggapturbogames-panda-bao",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/PandaBao.jpg",
    //     alt: "Panda Bao",
    //     name: "Panda Bao",
    //   },
    //   RingsOfOlympus: {
    //     href: "/casino/aggapturbogames-rings-of-olympus",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/RingsOfOlympus.jpg",
    //     alt: "Rings Of Olympus",
    //     name: "Rings Of Olympus",
    //   },
    //   BallAndBall: {
    //     href: "/casino/aggapturbogames-ball-and-ball",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Ball&Ball.webp",
    //     alt: "Ball & Ball",
    //     name: "Ball & Ball",
    //   },
    //   Bayraktar: {
    //     href: "/casino/aggapturbogames-bayraktar",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Bayraktar.webp",
    //     alt: "Bayraktar",
    //     name: "Bayraktar",
    //   },
    //   Bubbles: {
    //     href: "/casino/aggapturbogames-bubbles",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Bubbles.webp",
    //     alt: "Bubbles",
    //     name: "Bubbles",
    //   },
    //   DiceTwice: {
    //     href: "/casino/aggapturbogames-dice-twice",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/DiceTwice.webp",
    //     alt: "Dice Twice",
    //     name: "Dice Twice",
    //   },
    //   DogsStreet: {
    //     href: "/casino/aggapturbogames-dogs-street",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/DogsStreet.webp",
    //     alt: "Dogs' Street",
    //     name: "Dogs' Street",
    //   },
    //   DoubleRoll: {
    //     href: "/casino/aggapturbogames-double-roll",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/DoubleRoll.webp",
    //     alt: "Double Roll",
    //     name: "Double Roll",
    //   },
    //   FastFielder: {
    //     href: "/casino/aggapturbogames-fast-fielder",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/FastFielder.webp",
    //     alt: "Fast Fielder",
    //     name: "Fast Fielder",
    //   },
    //   FruitTowers: {
    //     href: "/casino/aggapturbogames-fruit-towers",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/FruitTowers.webp",
    //     alt: "Fruit Towers",
    //     name: "Fruit Towers",
    //   },
    //   Hamsta: {
    //     href: "/casino/aggapturbogames-hamsta",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Hamsta.webp",
    //     alt: "Hamsta",
    //     name: "Hamsta",
    //   },
    //   JavelinX: {
    //     href: "/casino/aggapturbogames-javelinx",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/JavelinX.webp",
    //     alt: "JavelinX",
    //     name: "JavelinX",
    //   },
    //   LimboRider: {
    //     href: "/casino/aggapturbogames-limbo-rider",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/LimboRider.webp",
    //     alt: "Limbo Rider",
    //     name: "Limbo Rider",
    //   },
    //   Neko: {
    //     href: "/casino/aggapturbogames-neko",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Neko.webp",
    //     alt: "Neko",
    //     name: "Neko",
    //   },
    //   SaveThePrincess: {
    //     href: "/casino/aggapturbogames-save-the-princess",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/SaveThePrincess.webp",
    //     alt: "Save the Princess",
    //     name: "Save the Princess",
    //   },
    //   SpinStrike: {
    //     href: "/casino/aggapturbogames-spin-strike",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/SpinStrike.webp",
    //     alt: "Spin Strike",
    //     name: "Spin Strike",
    //   },
    //   Stairs: {
    //     href: "/casino/aggapturbogames-fury-stairs",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Stairs.webp",
    //     alt: "Stairs",
    //     name: "Stairs",
    //   },
    //   TradingDice: {
    //     href: "/casino/aggapturbogames-trading-dice",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/TradingDice.webp",
    //     alt: "Trading Dice",
    //     name: "Trading Dice",
    //   },
    //   Towers: {
    //     href: "/casino/aggapturbogames-towers",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Towers.webp",
    //     alt: "Towers",
    //     name: "Towers",
    //   },
    //   TurboPlinko: {
    //     href: "/casino/aggapturbogames-turbo-plinko",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/TurboPlinko.webp",
    //     alt: "Turbo Plinko",
    //     name: "Turbo Plinko",
    //   },
    //   WicketBlast: {
    //     href: "/casino/aggapturbogames-wicket-blast",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/WicketBlast.webp",
    //     alt: "Wicket Blast",
    //     name: "Wicket Blast",
    //   },
    //   MagicKeno: {
    //     href: "/casino/aggapturbogames-magic-keno",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/MagicKeno.webp",
    //     alt: "Magic Keno",
    //     name: "Magic Keno",
    //   },
    //   Vortex: {
    //     href: "/casino/aggapturbogames-vortex",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Vortex.webp",
    //     alt: "Vortex",
    //     name: "Vortex",
    //   },
    //   TakeMyPlinko: {
    //     href: "/casino/aggapturbogames-take-my-plinko",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/TakeMyPlinko.webp",
    //     alt: "Take My Plinko",
    //     name: "Take My Plinko",
    //   },
    //   DiceThrice: {
    //     href: "/casino/aggapturbogames-dice-thrice",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/DiceThrice.webp",
    //     alt: "Dice Thrice",
    //     name: "Dice Thrice",
    //   },
    //   PumpedX: {
    //     href: "/casino/aggapturbogames-pumpedx",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/PumpedX.webp",
    //     alt: "PumpedX",
    //     name: "PumpedX",
    //   },
    //   DonnyKing: {
    //     href: "/casino/aggapturbogames-donny-king",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/DonnyKing.webp",
    //     alt: "Donny King",
    //     name: "Donny King",
    //   },
    //   CrystalPoker: {
    //     href: "/casino/aggapturbogames-crystal-poker",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/CrystalPoker.webp",
    //     alt: "Crystal Poker",
    //     name: "Crystal Poker",
    //   },
    //   JewelClicker: {
    //     href: "/casino/aggapturbogames-jewel-clicker",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "turbo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/JewelClicker.webp",
    //     alt: "Jewel Clicker",
    //     name: "Jewel Clicker",
    //   },
    // },
    // crash: {
    //   aero: {
    //     href: "/casino/aggapturbogames-aero",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "crash",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/Aero.webp",
    //     alt: "Aero",
    //     name: "Aero",
    //   },
    // },
    mines: {
      // MinesTurbo: {
      //   href: "/casino/aggapturbogames-mines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "mines",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/Mines.webp",
      //   alt: "Mines",
      //   name: "Mines",
      // },
      // TurboMines: {
      //   href: "/casino/aggapturbogames-turbo-mines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "mines",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/TurboMines.webp",
      //   alt: "Turbo Mines",
      //   name: "Turbo Mines",
      // },
      // Tap1Mines: {
      //   href: "/casino/aggapturbogames-1tap-mines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "mines",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/1TapMines(InstantWin).webp",
      //   alt: "1Tap Mines",
      //   name: "1Tap Mines",
      // },
      Tap1MinesIW: {
        href: "/casino/qt-1tap-mines",
        code: "",
        casino: "Slots",
        provider: "TurboGames",
        category: "mines",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/turbo/1TapMines.webp",
        alt: "1Tap Mines (Instant Win)",
        name: "1Tap Mines (Instant Win)",
      },
      // MultiplayerMines: {
      //   href: "/casino/aggapturbogames-multiplayer-mines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "mines",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/MultiplayerMines.webp",
      //   alt: "Multiplayer Mines",
      //   name: "Multiplayer Mines",
      // },
      // BookOfMines: {
      //   href: "/casino/aggapturbogames-book-of-mines",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "mines",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/BookOfMines.webp",
      //   alt: "Book of Mines",
      //   name: "Book of Mines",
      // },
    },
    hiLo: {
      // HiLo: {
      //   href: "/casino/aggapturbogames-hi-lo",
      //   code: "",
      //   casino: "Slots",
      //   provider: "TurboGames",
      //   category: "hiLo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/turbo/Hi-Lo.webp",
      //   alt: "Hi-Lo",
      //   name: "Hi-Lo",
      // },
    },
    // crashX: {
    //   crashX: {
    //     href: "/casino/aggapturbogames-crash-x",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "crashX",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/CrashX.webp",
    //     alt: "Crash X",
    //     name: "Crash X",
    //   },
    //   CrashXFootballEdition: {
    //     href: "/casino/aggapturbogames-crash-x-football-edition",
    //     code: "",
    //     casino: "Slots",
    //     provider: "TurboGames",
    //     category: "crashX",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/turbo/CrashXFootballEdition.webp",
    //     alt: "Crash X Football Edition",
    //     name: "Crash X Football Edition",
    //   },
    // },
  },

  playNGo: {
    playNGo: {
      // SuperWheel: {
      //   href: "/casino/aggapplayngo-super-wheel",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SuperWheel.webp",
      //   alt: "super wheel",
      //   name: "Super Wheel",
      // },
      // MoneyWheel: {
      //   href: "/casino/aggapplayngo-money-wheel",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoneyWheel.webp",
      //   alt: "money wheel",
      //   name: "Money Wheel",
      // },
      // RainforestMagicBingo: {
      //   href: "/casino/aggapplayngo-rainforest-magic-bingo",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RainforestMagicBingo.webp",
      //   alt: "rainforest magic bingo",
      //   name: "Rainforest Magic Bingo",
      // },
      // SweetAlchemyBingo: {
      //   href: "/casino/aggapplayngo-sweet-alchemy-bingo",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SweetAlchemyBingo.webp",
      //   alt: "sweet alchemy bingo",
      //   name: "Sweet Alchemy Bingo",
      // },
      // VikingRunecraftBingo: {
      //   href: "/casino/aggapplayngo-viking-runecraft-bingo",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/VikingRunecraftBingo.webp",
      //   alt: "viking runecraft bingo",
      //   name: "Viking Runecraft Bingo",
      // },
      // Clown3MontyII: {
      //   href: "/casino/aggapplayngo-3-clown-monty-ii",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/3ClownMontyII.webp",
      //   alt: "3 clown monty ii",
      //   name: "3 Clown Monty II",
      // },
      // PandasticAdventure: {
      //   href: "/casino/aggapplayngo-pandastic-adventure",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PandasticAdventure.webp",
      //   alt: "pandastic adventure",
      //   name: "Pandastic Adventure",
      // },
      // TalesOfMithruneSynsFortune: {
      //   href: "/casino/aggapplayngo-tales-of-mithrune-syns-fortune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TalesofMithruneSynsFortune.webp",
      //   alt: "tales of mithrune syn's fortune",
      //   name: "Tales of Mithrune Syn's Fortune",
      // },
      // VikingRunecraft100: {
      //   href: "/casino/aggapplayngo-viking-runecraft-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/VikingRunecraft100.webp",
      //   alt: "viking runecraft 100",
      //   name: "Viking Runecraft 100",
      // },
      // Gargantoonz: {
      //   href: "/casino/aggapplayngo-gargantoonz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Gargantoonz.webp",
      //   alt: "gargantoonz",
      //   name: "Gargantoonz",
      // },
      // MegaDonFeedingFrenzy: {
      //   href: "/casino/aggapplayngo-mega-don-feeding-frenzy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MegaDonFeedingFrenzy.webp",
      //   alt: "mega don feeding frenzy",
      //   name: "Mega Don: Feeding Frenzy",
      // },
      // InvadingVegasLasChristmas: {
      //   href: "/casino/aggapplayngo-invading-vegas-las-christmas",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/InvadingVegasLasChristmas.webp",
      //   alt: "invading vegas las christmas",
      //   name: "Invading Vegas: Las Christmas",
      // },
      // LegacyOfDynasties: {
      //   href: "/casino/aggapplayngo-legacy-of-dynasties",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegacyofDynasties.webp",
      //   alt: "legacy of dynasties",
      //   name: "Legacy of Dynasties",
      // },
      // MonkeyBattlefortheScrolls: {
      //   href: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MonkeyBattlefortheScrolls.webp",
      //   alt: "monkey battle for the scrolls",
      //   name: "Monkey: Battle for the Scrolls",
      // },
      // SherwoodGold: {
      //   href: "/casino/aggapplayngo-sherwood-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SherwoodGold.webp",
      //   alt: "sherwood gold",
      //   name: "Sherwood Gold",
      // },
      // RagingRex3: {
      //   href: "/casino/aggapplayngo-raging-rex-3",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RagingRex3.webp",
      //   alt: "raging rex 3",
      //   name: "Raging Rex 3",
      // },
      // RuffHeist: {
      //   href: "/casino/aggapplayngo-ruff-heist",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RuffHeist.webp",
      //   alt: "ruff heist",
      //   name: "Ruff Heist",
      // },
      // PiggyBlitz: {
      //   href: "/casino/aggapplayngo-piggy-blitz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PiggyBlitz.webp",
      //   alt: "piggy blitz",
      //   name: "Piggy Blitz",
      // },
      // ReturnoftheGreenKnight: {
      //   href: "/casino/aggapplayngo-return-of-the-green-knight",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ReturnoftheGreenKnight.webp",
      //   alt: "return of the green knight",
      //   name: "Return of the Green Knight",
      // },
      // TempleOfProsperity: {
      //   href: "/casino/aggapplayngo-temple-of-prosperity",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TempleofProsperity.webp",
      //   alt: "temple of prosperity",
      //   name: "Temple of Prosperity",
      // },
      // ScalesOfDead: {
      //   href: "/casino/aggapplayngo-scales-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ScalesofDead.webp",
      //   alt: "scales of dead",
      //   name: "Scales of Dead",
      // },
      // BoatBonanzaColossalCatch: {
      //   href: "/casino/aggapplayngo-boat-bonanza-colossal-catch",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BoatBonanzaColossalCatch.webp",
      //   alt: "boat bonanza colossal catch",
      //   name: "Boat Bonanza Colossal Catch",
      // },
      // HoneyRush100: {
      //   href: "/casino/aggapplayngo-honey-rush-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HoneyRush100.webp",
      //   alt: "honey rush 100",
      //   name: "Honey Rush 100",
      // },
      // HugoLegacy: {
      //   href: "/casino/aggapplayngo-hugo-legacy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HugoLegacy.webp",
      //   alt: "hugo legacy",
      //   name: "Hugo Legacy",
      // },
      // SweetAlchemy100: {
      //   href: "/casino/aggapplayngo-sweet-alchemy-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SweetAlchemy100.webp",
      //   alt: "sweet alchemy 100",
      //   name: "Sweet Alchemy 100",
      // },
      // ScrollOfSeth: {
      //   href: "/casino/aggapplayngo-scroll-of-seth",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ScrollofSeth.webp",
      //   alt: "scroll of seth",
      //   name: "Scroll of Seth",
      // },
      // MerlinJourneyOfFlame: {
      //   href: "/casino/aggapplayngo-merlin-journey-of-flame",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MerlinJourneyofFlame.webp",
      //   alt: "merlin journey of flame",
      //   name: "Merlin: Journey of Flame",
      // },
      // SparkyAndShortsHiddenJoules: {
      //   href: "/casino/aggapplayngo-sparky-and-shorts-hidden-joules",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SparkyAndShortzHiddenJoules.webp",
      //   alt: "sparky & shorts hidden joules",
      //   name: "Sparky & Shorts Hidden Joules",
      // },
      // FoxMayhem: {
      //   href: "/casino/aggapplayngo-fox-mayhem",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FoxMayhem.webp",
      //   alt: "fox mayhem",
      //   name: "Fox Mayhem",
      // },
      // RichWildeAndTheAmuletOfDead: {
      //   href: "/casino/aggapplayngo-rich-wilde-and-the-amulet-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichWildeandtheAmuletofDead.webp",
      //   alt: "rich wilde and the amulet of dead",
      //   name: "Rich Wilde and the Amulet of Dead",
      // },
      // SweetAlchemy2: {
      //   href: "/casino/aggapplayngo-sweet-alchemy-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SweetAlchemy2.webp",
      //   alt: "sweet alchemy 2",
      //   name: "Sweet Alchemy 2",
      // },
      // RascalRiches: {
      //   href: "/casino/aggapplayngo-rascal-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RascalRiches.webp",
      //   alt: "rascal riches",
      //   name: "Rascal Riches",
      // },
      // Ternion: {
      //   href: "/casino/aggapplayngo-ternion",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Ternion.webp",
      //   alt: "ternion",
      //   name: "Ternion",
      // },
      // VikingRunecraftApocalypse: {
      //   href: "/casino/aggapplayngo-viking-runecraft-apocalypse",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/VikingRunecraftApocalypse.webp",
      //   alt: "viking runecraft apocalypse",
      //   name: "Viking Runecraft: Apocalypse",
      // },
      // Crystal15RosesATaleOfLove: {
      //   href: "/casino/aggapplayngo-15-crystal-roses-a-tale-of-love",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/15CrystalRosesATaleOfLove.webp",
      //   alt: "15 crystal roses a tale of love",
      //   name: "15 Crystal Roses A Tale Of Love",
      // },
      // Dragon24k: {
      //   href: "/casino/aggapplayngo-24k-dragon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/24kDragon.webp",
      //   alt: "24k dragon",
      //   name: "24k Dragon",
      // },
      // Clown3Monty: {
      //   href: "/casino/aggapplayngo-3-clown-monty",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/3ClownMonty.webp",
      //   alt: "3 clown monty",
      //   name: "3 Clown Monty",
      // },
      // Magic5x: {
      //   href: "/casino/aggapplayngo-5x-magic",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/5xMagic.webp",
      //   alt: "5x magic",
      //   name: "5x Magic",
      // },
      // Sins7: {
      //   href: "/casino/aggapplayngo-7-sins",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/7Sins.webp",
      //   alt: "7 sins",
      //   name: "7 Sins",
      // },
      // AceOfSpades: {
      //   href: "/casino/aggapplayngo-ace-of-spades",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AceofSpades.webp",
      //   alt: "ace of spades",
      //   name: "Ace of Spades",
      // },
      // AgentDestiny: {
      //   href: "/casino/aggapplayngo-agent-destiny",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AgentDestiny.webp",
      //   alt: "agent destiny",
      //   name: "Agent Destiny",
      // },
      // AgentOfHearts: {
      //   href: "/casino/aggapplayngo-agent-of-hearts",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AgentofHearts.webp",
      //   alt: "agent of hearts",
      //   name: "Agent of Hearts",
      // },
      // AnimalMadness: {
      //   href: "/casino/aggapplayngo-animal-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AnimalMadness.webp",
      //   alt: "animal madness",
      //   name: "Animal Madness",
      // },
      // AnkhOfAnubis: {
      //   href: "/casino/aggapplayngo-ankh-of-anubis",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AnkhofAnubis.webp",
      //   alt: "ankh of anubis",
      //   name: "Ankh of Anubis",
      // },
      // Annihilator: {
      //   href: "/casino/aggapplayngo-annihilator",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Annihilator.webp",
      //   alt: "annihilator",
      //   name: "Annihilator",
      // },
      // AthenaAscending: {
      //   href: "/casino/aggapplayngo-athena-ascending",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AthenaAscending.webp",
      //   alt: "athena ascending",
      //   name: "Athena Ascending",
      // },
      // AztecIdols: {
      //   href: "/casino/aggapplayngo-aztec-idols",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AztecIdols.webp",
      //   alt: "aztec idols",
      //   name: "Aztec Idols",
      // },
      // AztecWarriorPrincess: {
      //   href: "/casino/aggapplayngo-aztec-warrior-princess",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AztecWarriorPrincess.webp",
      //   alt: "aztec warrior princess",
      //   name: "Aztec Warrior Princess",
      // },
      // BakersTreat: {
      //   href: "/casino/aggapplayngo-bakers-treat",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BakersTreat.webp",
      //   alt: "bakers treat",
      //   name: "Baker's Treat",
      // },
      // BananaRock: {
      //   href: "/casino/aggapplayngo-banana-rock",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BananaRock.webp",
      //   alt: "banana rock",
      //   name: "Banana Rock",
      // },
      // BattleRoyal: {
      //   href: "/casino/aggapplayngo-battle-royal",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BattleRoyal.webp",
      //   alt: "battle royal",
      //   name: "Battle Royal",
      // },
      // BeastsOfFire: {
      //   href: "/casino/aggapplayngo-beasts-of-fire",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BeastsOfFire.webp",
      //   alt: "beasts of fire",
      //   name: "Beasts Of Fire",
      // },
      // BigWin777: {
      //   href: "/casino/aggapplayngo-big-win-777",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BigWin777.webp",
      //   alt: "big win 777",
      //   name: "Big Win 777",
      // },
      // BigWinCat: {
      //   href: "/casino/aggapplayngo-big-win-cat",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BigWinCat.webp",
      //   alt: "big win cat",
      //   name: "Big Win Cat",
      // },
      // BlackMamba: {
      //   href: "/casino/aggapplayngo-black-mamba",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BlackMamba.webp",
      //   alt: "black mamba",
      //   name: "Black Mamba",
      // },
      // BlazinBullfrog: {
      //   href: "/casino/aggapplayngo-blazin-bullfrog",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BlazinBullfrog.webp",
      //   alt: "blazin bullfrog",
      //   name: "Blazin' Bullfrog",
      // },
      // Blinged: {
      //   href: "/casino/aggapplayngo-blinged",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Blinged.webp",
      //   alt: "blinged",
      //   name: "Blinged",
      // },
      // BoatBonanza: {
      //   href: "/casino/aggapplayngo-boat-bonanza",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BoatBonanza.webp",
      //   alt: "boat bonanza",
      //   name: "Boat Bonanza",
      // },
      // BookOfDead: {
      //   href: "/casino/aggapplayngo-book-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BookofDead.webp",
      //   alt: "book of dead",
      //   name: "Book of Dead",
      // },
      // BullInAChinaShop: {
      //   href: "/casino/aggapplayngo-bull-in-a-china-shop",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BullinaChinaShop.webp",
      //   alt: "bull in a china shop",
      //   name: "Bull in a China Shop",
      // },
      // BullInARodeo: {
      //   href: "/casino/aggapplayngo-bull-in-a-rodeo",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BullinaRodeo.webp",
      //   alt: "bull in a rodeo",
      //   name: "Bull in a Rodeo",
      // },
      // CandyIslandPrincess: {
      //   href: "/casino/aggapplayngo-candy-island-princess",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CandyIslandPrincess.webp",
      //   alt: "candy island princess",
      //   name: "Candy Island Princess",
      // },
      // CanineCarnage: {
      //   href: "/casino/aggapplayngo-canine-carnage",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CanineCarnage.webp",
      //   alt: "canine carnage",
      //   name: "Canine Carnage",
      // },
      // CaptainGlumPirateHunter: {
      //   href: "/casino/aggapplayngo-captain-glum-pirate-hunter",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CaptainGlumPirateHunter.webp",
      //   alt: "captain glum pirate hunter",
      //   name: "Captain Glum: Pirate Hunter",
      // },
      // CaptainXenosEarthAdventure: {
      //   href: "/casino/aggapplayngo-captain-xenos-earth-adventure",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CaptainXenosEarthAdventure.webp",
      //   alt: "captain xenos earth adventure",
      //   name: "Captain Xeno's Earth Adventure",
      // },
      // CashACabana: {
      //   href: "/casino/aggapplayngo-cash-a-cabana",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CashaCabana.webp",
      //   alt: "cash a cabana",
      //   name: "Cash-a-Cabana",
      // },
      // CashOfCommand: {
      //   href: "/casino/aggapplayngo-cash-of-command",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CashofCommand.webp",
      //   alt: "cash of command",
      //   name: "Cash of Command",
      // },
      // CashPump: {
      //   href: "/casino/aggapplayngo-cash-pump",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CashPump.webp",
      //   alt: "cash pump",
      //   name: "Cash Pump",
      // },
      // CashVandal: {
      //   href: "/casino/aggapplayngo-cash-vandal",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CashVandal.webp",
      //   alt: "cash vandal",
      //   name: "Cash Vandal",
      // },
      // CatWildeAndTheDoomOfDead: {
      //   href: "/casino/aggapplayngo-cat-wilde-and-the-doom-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CatWildeandtheDoomofDead.webp",
      //   alt: "cat wilde and the doom of dead",
      //   name: "Cat Wilde and the Doom of Dead",
      // },
      // CatWildeAndTheLostChapter: {
      //   href: "/casino/aggapplayngo-cat-wilde-and-the-lost-chapter",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CatWildeandtheLostChapter.webp",
      //   alt: "cat wilde and the lost chapter",
      //   name: "Cat Wilde and the Lost Chapter",
      // },
      // CatWildeAndThePyramidsOfDead: {
      //   href: "/casino/aggapplayngo-cat-wilde-and-the-pyramids-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CatWildeandthePyramidsofDead.webp",
      //   alt: "cat wilde and the pyramids of dead",
      //   name: "Cat Wilde and the Pyramids of Dead",
      // },
      // CatWildeInTheEclipseOfTheSunGod: {
      //   href: "/casino/aggapplayngo-cat-wilde-in-the-eclipse-of-the-sun-god",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl:
      //     "/images/slots/new/play-n-go/CatWildeintheEclipseoftheSunGod.webp",
      //   alt: "cat wilde in the eclipse of the sun god",
      //   name: "Cat Wilde in the Eclipse of the Sun God",
      // },
      // CatsAndCash: {
      //   href: "/casino/aggapplayngo-cats-and-cash",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CatsandCash.webp",
      //   alt: "cats and cash",
      //   name: "Cats and Cash",
      // },
      // ChampionsOfMithrune: {
      //   href: "/casino/aggapplayngo-champions-of-mithrune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ChampionsofMithrune.webp",
      //   alt: "champions of mithrune",
      //   name: "Champions of Mithrune",
      // },
      // CharlieChance: {
      //   href: "/casino/aggapplayngo-charlie-chance",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CharlieChance.webp",
      //   alt: "charlie chance",
      //   name: "Charlie Chance",
      // },
      // CharlieChanceAndTheCurseOfCleopatra: {
      //   href: "/casino/aggapplayngo-charlie-chance-and-the-curse-of-cleopatra",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl:
      //     "/images/slots/new/play-n-go/CharlieChanceandTheCurseofCleopatra.webp",
      //   alt: "charlie chance and the curse of cleopatra",
      //   name: "Charlie Chance and The Curse of Cleopatra",
      // },
      // CharlieChanceInHellToPay: {
      //   href: "/casino/qtechplayngo-charlie-chance-in-hell-to-pay",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CharlieChanceinHelltoPay.webp",
      //   alt: "charlie chance in hell to pay",
      //   name: "Charlie Chance in Hell to Pay",
      // },
      // ChineseNewYear: {
      //   href: "/casino/aggapplayngo-chinese-new-year",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ChineseNewYear.webp",
      //   alt: "chinese new year",
      //   name: "Chinese New Year",
      // },
      // ChronosJoker: {
      //   href: "/casino/aggapplayngo-chronos-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ChronosJoker.webp",
      //   alt: "chronos joker",
      //   name: "Chronos Joker",
      // },
      // ClashOfCamelot: {
      //   href: "/casino/aggapplayngo-clash-of-camelot",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ClashofCamelot.webp",
      //   alt: "clash of camelot",
      //   name: "Clash of Camelot",
      // },
      // CloudQuest: {
      //   href: "/casino/aggapplayngo-cloud-quest",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CloudQuest.webp",
      //   alt: "cloud quest",
      //   name: "Cloud Quest",
      // },
      // CoilsOfCash: {
      //   href: "/casino/aggapplayngo-coils-of-cash",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CoilsofCash.webp",
      //   alt: "coils of cash",
      //   name: "Coils of Cash",
      // },
      // ColtLightning: {
      //   href: "/casino/aggapplayngo-colt-lightning",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ColtLightning.webp",
      //   alt: "colt lightning",
      //   name: "Colt Lightning",
      // },
      // Contact: {
      //   href: "/casino/aggapplayngo-contact",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Contact.webp",
      //   alt: "contact",
      //   name: "Contact",
      // },
      // CopsNRobbers: {
      //   href: "/casino/aggapplayngo-copsnrobbers",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CopsnRobbers.webp",
      //   alt: "copsnrobbers",
      //   name: "Cops'n'Robbers",
      // },
      // CountJokula: {
      //   href: "/casino/aggapplayngo-count-jokula",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CountJokula.webp",
      //   alt: "count jokula",
      //   name: "Count Jokula",
      // },
      // CourtOfHearts: {
      //   href: "/casino/aggapplayngo-court-of-hearts",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CourtofHearts.webp",
      //   alt: "court of hearts",
      //   name: "Court of Hearts",
      // },
      // CoywolfCash: {
      //   href: "/casino/aggapplayngo-coywolf-cash",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CoywolfCash.webp",
      //   alt: "coywolf cash",
      //   name: "Coywolf Cash",
      // },
      // CrazyCows: {
      //   href: "/casino/aggapplayngo-crazy-cows",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CrazyCows.webp",
      //   alt: "crazy cows",
      //   name: "Crazy Cows",
      // },
      // CrystalSun: {
      //   href: "/casino/aggapplayngo-crystal-sun",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CrystalSun.webp",
      //   alt: "crystal sun",
      //   name: "Crystal Sun",
      // },
      // DawnOfEgypt: {
      //   href: "/casino/aggapplayngo-dawn-of-egypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DawnofEgypt.webp",
      //   alt: "dawn of egypt",
      //   name: "Dawn of Egypt",
      // },
      // Demon: {
      //   href: "/casino/aggapplayngo-demon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Demon.webp",
      //   alt: "demon",
      //   name: "Demon",
      // },
      // DerbyWheel: {
      //   href: "/casino/aggapplayngo-derby-wheel",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DerbyWheel.webp",
      //   alt: "derby wheel",
      //   name: "Derby Wheel",
      // },
      // DiamondsOfTheRealm: {
      //   href: "/casino/aggapplayngo-diamonds-of-the-realm",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DiamondsoftheRealm.webp",
      //   alt: "diamonds of the realm",
      //   name: "Diamonds of the Realm",
      // },
      // DiamondVortex: {
      //   href: "/casino/aggapplayngo-diamond-vortex",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DiamondVortex.webp",
      //   alt: "diamond-vortex",
      //   name: "Diamond Vortex",
      // },
      // DiscoDiamonds: {
      //   href: "/casino/aggapplayngo-disco-diamonds",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DiscoDiamonds.webp",
      //   alt: "disco diamonds",
      //   name: "Disco Diamonds",
      // },
      // DivineShowdown: {
      //   href: "/casino/aggapplayngo-divine-showdown",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DivineShowdown.webp",
      //   alt: "divine showdown",
      //   name: "Divine Showdown",
      // },
      // DrToonz: {
      //   href: "/casino/aggapplayngo-dr-toonz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DrToonz.webp",
      //   alt: "dr toonz",
      //   name: "Dr Toonz",
      // },
      // DoomOfEgypt: {
      //   href: "/casino/aggapplayngo-doom-of-egypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DoomofEgypt.webp",
      //   alt: "doom of egypt",
      //   name: "Doom of Egypt",
      // },
      // DragonMaiden: {
      //   href: "/casino/aggapplayngo-dragon-maiden",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DragonMaiden.webp",
      //   alt: "Dragon Maiden",
      //   name: "Dragon Maiden",
      // },
      // DragonShip: {
      //   href: "/casino/aggapplayngo-dragon-ship",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DragonShip.webp",
      //   alt: "Dragon Ship",
      //   name: "Dragon Ship",
      // },
      // EasterEggs: {
      //   href: "/casino/aggapplayngo-easter-eggs",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EasterEggs.webp",
      //   alt: "Easter Eggs",
      //   name: "Easter Eggs",
      // },
      // EnchantedCrystals: {
      //   href: "/casino/aggapplayngo-enchanted-crystals",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EnchantedCrystals.webp",
      //   alt: "Enchanted Crystals",
      //   name: "Enchanted Crystals",
      // },
      // EnchantedMeadow: {
      //   href: "/casino/aggapplayngo-enchanted-meadow",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EnchantedMeadow.webp",
      //   alt: "Enchanted Meadow",
      //   name: "Enchanted Meadow",
      // },
      // Energoonz: {
      //   href: "/casino/aggapplayngo-energoonz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Energoonz.webp",
      //   alt: "Energoonz",
      //   name: "Energoonz",
      // },
      // EyeOfAtum: {
      //   href: "/casino/aggapplayngo-eye-of-atum",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EyeOfAtum.webp",
      //   alt: "Eye Of Atum",
      //   name: "Eye Of Atum",
      // },
      // EyeOfTheKraken: {
      //   href: "/casino/aggapplayngo-eye-of-the-kraken",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EyeOfTheKraken.webp",
      //   alt: "Eye of the Kraken",
      //   name: "Eye of the Kraken",
      // },
      // FatFrankies: {
      //   href: "/casino/aggapplayngo-fat-frankies",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FatFrankies.webp",
      //   alt: "Fat Frankies",
      //   name: "Fat Frankies",
      // },
      // FelineFury: {
      //   href: "/casino/aggapplayngo-feline-fury",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FelineFury.webp",
      //   alt: "Feline Fury",
      //   name: "Feline Fury",
      // },
      // FireJoker: {
      //   href: "/casino/aggapplayngo-fire-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FireJoker.webp",
      //   alt: "Fire Joker",
      //   name: "Fire Joker",
      // },
      // FireJokerFreeze: {
      //   href: "/casino/aggapplayngo-fire-joker-freeze",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FireJokerFreeze.webp",
      //   alt: "Fire Joker Freeze",
      //   name: "Fire Joker Freeze",
      // },
      // FireflyFrenzy: {
      //   href: "/casino/aggapplayngo-firefly-frenzy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FireflyFrenzy.webp",
      //   alt: "Firefly Frenzy",
      //   name: "Firefly Frenzy",
      // },

      // ForgeOfFortunes: {
      //   href: "/casino/aggapplayngo-forge-of-fortunes",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ForgeOfFortunes.webp",
      //   alt: "Forge of Fortunes",
      //   name: "Forge of Fortunes",
      // },
      // ForgeOfGems: {
      //   href: "/casino/aggapplayngo-forge-of-gems",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ForgeOfGems.webp",
      //   alt: "Forge Of Gems",
      //   name: "Forge Of Gems",
      // },
      // FortuneRewind: {
      //   href: "/casino/aggapplayngo-fortune-rewind",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FortuneRewind.webp",
      //   alt: "Fortune Rewind",
      //   name: "Fortune Rewind",
      // },
      // FortunesOfAliBaba: {
      //   href: "/casino/aggapplayngo-fortunes-of-ali-baba",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FortunesOfAliBaba.webp",
      //   alt: "Fortunes of Ali Baba",
      //   name: "Fortunes of Ali Baba",
      // },
      // FreeReelinJoker1000: {
      //   href: "/casino/aggapplayngo-free-reelin-joker-1000",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FreeReelinJoker1000.webp",
      //   alt: "Free Reelin' Joker 1000",
      //   name: "Free Reelin' Joker 1000",
      // },
      // FreeReelinJoker: {
      //   href: "/casino/aggapplayngo-free-reelin-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FreeReelinJoker.webp",
      //   alt: "Free Reelin' Joker",
      //   name: "Free Reelin' Joker",
      // },
      // FrozenGems: {
      //   href: "/casino/aggapplayngo-frozen-gems",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FrozenGems.webp",
      //   alt: "Frozen Gems",
      //   name: "Frozen Gems",
      // },
      // FUERDAI: {
      //   href: "/casino/aggapplayngo-fu-er-dai",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/FUERDAI.webp",
      //   alt: "FU ER DAI",
      //   name: "FU ER DAI",
      // },
      // GameOfGladiators: {
      //   href: "/casino/aggapplayngo-game-of-gladiators",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GameOfGladiators.webp",
      //   alt: "Game of Gladiators",
      //   name: "Game of Gladiators",
      // },
      // GameOfGladiatorsUprising: {
      //   href: "/casino/aggapplayngo-game-of-gladiators",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GameOfGladiatorsUprising.webp",
      //   alt: "Game of Gladiators: Uprising",
      //   name: "Game of Gladiators: Uprising",
      // },
      // GatesOfTroy: {
      //   href: "/casino/aggapplayngo-gates-of-troy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GatesOfTroy.webp",
      //   alt: "Gates of Troy",
      //   name: "Gates of Troy",
      // },
      // Gemix: {
      //   href: "/casino/aggapplayngo-gemix",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Gemix.webp",
      //   alt: "Gemix",
      //   name: "Gemix",
      // },
      // Gemix2: {
      //   href: "/casino/aggapplayngo-gemix-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Gemix2.webp",
      //   alt: "Gemix 2",
      //   name: "Gemix 2",
      // },
      // GerardsGambit: {
      //   href: "/casino/aggapplayngo-gerards-gambit",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GerardsGambit.webp",
      //   alt: "Gerard's Gambit",
      //   name: "Gerard's Gambit",
      // },
      // GhostOfDead: {
      //   href: "/casino/aggapplayngo-ghost-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GhostOfDead.webp",
      //   alt: "Ghost of Dead",
      //   name: "Ghost of Dead",
      // },
      // Gigantoonz: {
      //   href: "/casino/aggapplayngo-gigantoonz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Gigantoonz.webp",
      //   alt: "Gigantoonz",
      //   name: "Gigantoonz",
      // },
      // GoldKing: {
      //   href: "/casino/aggapplayngo-gold-king",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldKing.webp",
      //   alt: "Gold King",
      //   name: "Gold King",
      // },
      // GoldTrophy2: {
      //   href: "/casino/aggapplayngo-gold-trophy-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldTrophy2.webp",
      //   alt: "Gold Trophy 2",
      //   name: "Gold Trophy 2",
      // },
      // GoldVolcano: {
      //   href: "/casino/aggapplayngo-gold-volcano",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldVolcano.webp",
      //   alt: "Gold Volcano",
      //   name: "Gold Volcano",
      // },
      // GoldenCaravan: {
      //   href: "/casino/aggapplayngo-golden-caravan",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenCaravan.webp",
      //   alt: "Golden Caravan",
      //   name: "Golden Caravan",
      // },
      // GoldenColts: {
      //   href: "/casino/aggapplayngo-golden-colts",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenColts.webp",
      //   alt: "Golden Colts",
      //   name: "Golden Colts",
      // },
      // GoldenLegend: {
      //   href: "/casino/aggapplayngo-golden-legend",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenLegend.webp",
      //   alt: "Golden Legend",
      //   name: "Golden Legend",
      // },
      // GoldenOsiris: {
      //   href: "/casino/aggapplayngo-golden-osiris",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenOsiris.webp",
      //   alt: "Golden Osiris",
      //   name: "Golden Osiris",
      // },
      // GoldenTicket: {
      //   href: "/casino/aggapplayngo-golden-ticket",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenTicket.webp",
      //   alt: "Golden Ticket",
      //   name: "Golden Ticket",
      // },
      // GoldenTicket2: {
      //   href: "/casino/aggapplayngo-golden-ticket-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldenTicket2.webp",
      //   alt: "Golden Ticket 2",
      //   name: "Golden Ticket 2",
      // },
      // GrimMuerto: {
      //   href: "/casino/aggapplayngo-grim-muerto",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GrimMuerto.webp",
      //   alt: "Grim Muerto",
      //   name: "Grim Muerto",
      // },
      // HappyHalloween: {
      //   href: "/casino/aggapplayngo-happy-halloween",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HappyHalloween.webp",
      //   alt: "Happy Halloween",
      //   name: "Happy Halloween",
      // },
      // HighwayLegends: {
      //   href: "/casino/aggapplayngo-highway-legends",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HighwayLegends.webp",
      //   alt: "Highway Legends",
      //   name: "Highway Legends",
      // },
      // HolidaySeason: {
      //   href: "/casino/aggapplayngo-holiday-season",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HolidaySeason.webp",
      //   alt: "Holiday Season",
      //   name: "Holiday Season",
      // },
      // HolidaySpirits: {
      //   href: "/casino/aggapplayngo-holiday-spirits",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HolidaySpirits.webp",
      //   alt: "Holiday Spirits",
      //   name: "Holiday Spirits",
      // },
      // HoneyRush: {
      //   href: "/casino/aggapplayngo-honey-rush",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HoneyRush.webp",
      //   alt: "Honey Rush",
      //   name: "Honey Rush",
      // },
      // HooliganHustle: {
      //   href: "/casino/aggapplayngo-hooligan-hustle",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HooliganHustle.webp",
      //   alt: "Hooligan Hustle",
      //   name: "Hooligan Hustle",
      // },
      // HotelYetiWay: {
      //   href: "/casino/aggapplayngo-hotel-yeti-way",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HotelYetiWay.webp",
      //   alt: "Hotel Yeti-Way",
      //   name: "Hotel Yeti-Way",
      // },
      // HouseOfDoom: {
      //   href: "/casino/aggapplayngo-house-of-doom",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HouseofDoom.webp",
      //   alt: "House of Doom",
      //   name: "House of Doom",
      // },
      // HouseOfDoom2TheCrypt: {
      //   href: "/casino/aggapplayngo-house-of-doom-2-the-crypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HouseofDoom2TheCrypt.webp",
      //   alt: "House of Doom 2 The Crypt",
      //   name: "House of Doom 2 The Crypt",
      // },
      // IceJoker: {
      //   href: "/casino/aggapplayngo-ice-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/IceJoker.webp",
      //   alt: "Ice Joker",
      //   name: "Ice Joker",
      // },
      // IdolOfFortune: {
      //   href: "/casino/aggapplayngo-idol-of-fortune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/IdolofFortune.webp",
      //   alt: "Idol of Fortune",
      //   name: "Idol of Fortune",
      // },
      // ImmorTailsOfEgypt: {
      //   href: "/casino/aggapplayngo-immortails-of-egypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ImmorTailsOfEgypt.webp",
      //   alt: "ImmorTails of Egypt",
      //   name: "ImmorTails of Egypt",
      // },
      // ImperialOpera: {
      //   href: "/casino/qtechplayngo-imperial-opera",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ImperialOpera.webp",
      //   alt: "Imperial Opera",
      //   name: "Imperial Opera",
      // },
      // InfernoJoker: {
      //   href: "/casino/aggapplayngo-inferno-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/InfernoJoker.webp",
      //   alt: "Inferno Joker",
      //   name: "Inferno Joker",
      // },
      // InvadingVegas: {
      //   href: "/casino/aggapplayngo-invading-vegas",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/InvadingVegas.webp",
      //   alt: "Invading Vegas",
      //   name: "Invading Vegas",
      // },
      // InfernoStar: {
      //   href: "/casino/aggapplayngo-inferno-star",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/InfernoStar.webp",
      //   alt: "Inferno Star",
      //   name: "Inferno Star",
      // },
      // IrishGold: {
      //   href: "/casino/aggapplayngo-irish-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/IrishGold.webp",
      //   alt: "Irish Gold",
      //   name: "Irish Gold",
      // },
      // IronGirl: {
      //   href: "/casino/aggapplayngo-iron-girl",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/IronGirl.webp",
      //   alt: "Iron Girl",
      //   name: "Iron Girl",
      // },
      // JadeMagician: {
      //   href: "/casino/aggapplayngo-jade-magician",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JadeMagician.webp",
      //   alt: "Jade Magician",
      //   name: "Jade Magician",
      // },
      // JewelBox: {
      //   href: "/casino/aggapplayngo-jewel-box",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JewelBox.webp",
      //   alt: "Jewel Box",
      //   name: "Jewel Box",
      // },
      // JollyRoger: {
      //   href: "/casino/qtechplayngo-jolly-roger",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JollyRoger.webp",
      //   alt: "Jolly Roger",
      //   name: "Jolly Roger",
      // },
      // JollyRoger2: {
      //   href: "/casino/aggapplayngo-jolly-roger-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JollyRoger2.webp",
      //   alt: "Jolly Roger 2",
      //   name: "Jolly Roger 2",
      // },
      // KingsMask: {
      //   href: "/casino/aggapplayngo-kings-mask",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/KingsMask.webp",
      //   alt: "King's Mask",
      //   name: "King's Mask",
      // },
      // LadyOfFortune: {
      //   href: "/casino/aggapplayngo-lady-of-fortune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LadyOfFortune.webp",
      //   alt: "Lady of Fortune",
      //   name: "Lady of Fortune",
      // },
      // LegacyOfDead: {
      //   href: "/casino/aggapplayngo-legacy-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegacyOfDead.webp",
      //   alt: "Legacy of Dead",
      //   name: "Legacy of Dead",
      // },
      // LegacyOfEgypt: {
      //   href: "/casino/aggapplayngo-legacy-of-egypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegacyOfEgypt.webp",
      //   alt: "Legacy of Egypt",
      //   name: "Legacy of Egypt",
      // },
      // LegacyOfInca: {
      //   href: "/casino/aggapplayngo-legacy-of-inca",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegacyOfInca.webp",
      //   alt: "Legacy of Inca",
      //   name: "Legacy of Inca",
      // },
      // LegendOfTheIceDragon: {
      //   href: "/casino/aggapplayngo-legend-of-the-ice-dragon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegendOfTheIceDragon.webp",
      //   alt: "Legend Of The Ice Dragon",
      //   name: "Legend Of The Ice Dragon",
      // },
      // LegionGold: {
      //   href: "/casino/aggapplayngo-legion-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegionGold.webp",
      //   alt: "Legion Gold",
      //   name: "Legion Gold",
      // },
      // LeprechaunGoesEgypt: {
      //   href: "/casino/aggapplayngo-leprechaun-goes-egypt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LeprechaunGoesEgypt.webp",
      //   alt: "Leprechaun goes Egypt",
      //   name: "Leprechaun goes Egypt",
      // },
      // LeprechaunGoesWild: {
      //   href: "/casino/aggapplayngo-leprechaun-goes-wild",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LeprechaunGoesWild.webp",
      //   alt: "Leprechaun Goes Wild",
      //   name: "Leprechaun Goes Wild",
      // },
      // LeprechaunsVault: {
      //   href: "/casino/aggapplayngo-leprechauns-vault",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LeprechaunsVault.webp",
      //   alt: "Leprechaun's Vault",
      //   name: "Leprechaun's Vault",
      // },
      // LordMerlinAndTheLadyOfTheLake: {
      //   href: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
      //   alt: "Lord Merlin and The Lady of The Lake",
      //   name: "Lord Merlin and The Lady of The Lake",
      // },
      // LoveJoker: {
      //   href: "/casino/aggapplayngo-love-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LoveJoker.webp",
      //   alt: "Love Joker",
      //   name: "Love Joker",
      // },
      // Luchamigos: {
      //   href: "/casino/aggapplayngo-luchamigos",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Luchamigos.webp",
      //   alt: "Luchamigos",
      //   name: "Luchamigos",
      // },
      // LuckyDiamonds: {
      //   href: "/casino/aggapplayngo-lucky-diamonds",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LuckyDiamonds.webp",
      //   alt: "Lucky Diamonds",
      //   name: "Lucky Diamonds",
      // },
      // MadameInk: {
      //   href: "/casino/aggapplayngo-madame-ink",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MadameInk.webp",
      //   alt: "Madame Ink",
      //   name: "Madame Ink",
      // },
      // MegaDon: {
      //   href: "/casino/aggapplayngo-mega-don",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MegaDon.webp",
      //   alt: "Mega Don",
      //   name: "Mega Don",
      // },
      // Mahjong88: {
      //   href: "/casino/aggapplayngo-mahjong-88",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Mahjong88.webp",
      //   alt: "Mahjong 88",
      //   name: "Mahjong 88",
      // },
      // Matsuri: {
      //   href: "/casino/aggapplayngo-matsuri",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Matsuri.webp",
      //   alt: "Matsuri",
      //   name: "Matsuri",
      // },
      // MerlinAndIceQueenMorgana: {
      //   href: "/casino/aggapplayngo-merlin-and-ice-queen-morgana",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MerlinAndTheIceQueenMorgana.webp",
      //   alt: "Merlin and Ice Queen Morgana",
      //   name: "Merlin and Ice Queen Morgana",
      // },
      // MerlinsGrimoire: {
      //   href: "/casino/aggapplayngo-merlins-grimoire",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MerlinsGrimoire.webp",
      //   alt: "Merlin's Grimoire",
      //   name: "Merlin's Grimoire",
      // },
      // MermaidsDiamond: {
      //   href: "/casino/aggapplayngo-mermaids-diamond",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MermaidsDiamond.webp",
      //   alt: "Mermaid's Diamond",
      //   name: "Mermaid's Diamond",
      // },
      // MerryXmas: {
      //   href: "/casino/aggapplayngo-merry-xmas",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MerryXmas.webp",
      //   alt: "Merry Xmas",
      //   name: "Merry Xmas",
      // },
      // MinerDonkeyTrouble: {
      //   href: "/casino/aggapplayngo-miner-donkey-trouble",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MinerDonkeyTrouble.webp",
      //   alt: "Miner Donkey Trouble",
      //   name: "Miner Donkey Trouble",
      // },
      // MissionCash: {
      //   href: "/casino/aggapplayngo-mission-cash",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MissionCash.webp",
      //   alt: "Mission Cash",
      //   name: "Mission Cash",
      // },
      // MoonPrincess100: {
      //   href: "/casino/aggapplayngo-moon-princess-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoonPrincess100.webp",
      //   alt: "Moon Princess 100",
      //   name: "Moon Princess 100",
      // },
      // MoonPrincess: {
      //   href: "/casino/aggapplayngo-moon-princess",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoonPrincess.webp",
      //   alt: "Moon Princess",
      //   name: "Moon Princess",
      // },
      // MoonPrincessChristmasKingdom: {
      //   href: "/casino/aggapplayngo-moon-princess-christmas-kingdom",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoonPrincessChristmasKingdom.webp",
      //   alt: "Moon Princess Christmas Kingdom",
      //   name: "Moon Princess Christmas Kingdom",
      // },
      // MoonPrincessTrinity: {
      //   href: "/casino/aggapplayngo-moon-princess-trinity",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoonPrincessTrinity.webp",
      //   alt: "Moon Princess Trinity",
      //   name: "Moon Princess Trinity",
      // },
      // MountM: {
      //   href: "/casino/aggapplayngo-mount-m",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MountM.webp",
      //   alt: "Mount M",
      //   name: "Mount M",
      // },
      // MuertoEnMictlán: {
      //   href: "/casino/aggapplayngo-muerto-en-mictlan",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MuertoEnMictlán.webp",
      //   alt: "Muerto en Mictlán",
      //   name: "Muerto en Mictlán",
      // },
      // MultiFruit81: {
      //   href: "/casino/qtechplayngo-multifruit-81",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MultiFruit81.webp",
      //   alt: "MultiFruit 81",
      //   name: "MultiFruit 81",
      // },
      // MysteryJoker: {
      //   href: "/casino/aggapplayngo-mystery-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MysteryJoker.webp",
      //   alt: "Mystery Joker",
      //   name: "Mystery Joker",
      // },
      // MysteryJoker6000: {
      //   href: "/casino/aggapplayngo-mystery-joker-6000",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MysteryJoker6000.webp",
      //   alt: "Mystery Joker 6000",
      //   name: "Mystery Joker 6000",
      // },
      // Myth: {
      //   href: "/casino/aggapplayngo-myth",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Myth.webp",
      //   alt: "Myth",
      //   name: "Myth",
      // },
      // NaughtyNicksBook: {
      //   href: "/casino/aggapplayngo-naughty-nicks-book",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/NaughtyNicksBook.webp",
      //   alt: "Naughty Nick's Book",
      //   name: "Naughty Nick's Book",
      // },
      // NewYearRiches: {
      //   href: "/casino/aggapplayngo-new-year-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/NewYearRiches.webp",
      //   alt: "New Year Riches",
      //   name: "New Year Riches",
      // },
      // NinjaFruits: {
      //   href: "/casino/aggapplayngo-ninja-fruits",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/NinjaFruits.webp",
      //   alt: "Ninja Fruits",
      //   name: "Ninja Fruits",
      // },
      // OctopusTreasure: {
      //   href: "/casino/aggapplayngo-octopus-treasure",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/OctopusTreasure.webp",
      //   alt: "Octopus Treasure",
      //   name: "Octopus Treasure",
      // },
      // OdinProtectorOfRealms: {
      //   href: "/casino/aggapplayngo-odin-protector-of-realms",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/OdinProtectorOfRealms.webp",
      //   alt: "Odin: Protector of Realms",
      //   name: "Odin: Protector of Realms",
      // },
      // PackAndCash: {
      //   href: "/casino/aggapplayngo-pack-and-cash",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PackAndCash.webp",
      //   alt: "Pack & Cash",
      //   name: "Pack & Cash",
      // },
      // PandorasBoxOfEvil: {
      //   href: "/casino/aggapplayngo-pandoras-box-of-evil",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PandorasBoxOfEvil.webp",
      //   alt: "Pandora's Box of Evil",
      //   name: "Pandora's Box of Evil",
      // },
      // PearlLagoon: {
      //   href: "/casino/aggapplayngo-pearl-lagoon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PearlLagoon.webp",
      //   alt: "Pearl Lagoon",
      //   name: "Pearl Lagoon",
      // },
      // PearlsOfIndia: {
      //   href: "/casino/aggapplayngo-pearls-of-india",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PearlsOfIndia.webp",
      //   alt: "Pearls of India",
      //   name: "Pearls of India",
      // },
      // PerfectGems: {
      //   href: "/casino/aggapplayngo-perfect-gems",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PerfectGems.webp",
      //   alt: "Perfect Gems",
      //   name: "Perfect Gems",
      // },
      // PhoenixReborn: {
      //   href: "/casino/aggapplayngo-phoenix-reborn",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PhoenixReborn.webp",
      //   alt: "Phoenix Reborn",
      //   name: "Phoenix Reborn",
      // },
      // PhotoSafari: {
      //   href: "/casino/aggapplayngo-photo-safari",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PhotoSafari.webp",
      //   alt: "Photo Safari",
      //   name: "Photo Safari",
      // },
      // PiggyBankFarm: {
      //   href: "/casino/aggapplayngo-piggy-bank-farm",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PiggyBankFarm.webp",
      //   alt: "Piggy Bank Farm",
      //   name: "Piggy Bank Farm",
      // },
      // PilgrimOfDead: {
      //   href: "/casino/aggapplayngo-pilgrim-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PilgrimOfDead.webp",
      //   alt: "Pilgrim of Dead",
      //   name: "Pilgrim of Dead",
      // },
      // Pimped: {
      //   href: "/casino/aggapplayngo-pimped",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Pimped.webp",
      //   alt: "Pimped",
      //   name: "Pimped",
      // },
      // PlanetFortune: {
      //   href: "/casino/aggapplayngo-planet-fortune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PlanetFortune.webp",
      //   alt: "Planet Fortune",
      //   name: "Planet Fortune",
      // },
      // PrismOfGems: {
      //   href: "/casino/aggapplayngo-prism-of-gems",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PrismOfGems.webp",
      //   alt: "Prism of Gems",
      //   name: "Prism of Gems",
      // },
      // PrissyPrincess: {
      //   href: "/casino/aggapplayngo-prissy-princess",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PrissyPrincess.webp",
      //   alt: "Prissy Princess",
      //   name: "Prissy Princess",
      // },
      // ProsperityPalace: {
      //   href: "/casino/aggapplayngo-prosperity-palace",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ProsperityPalace.webp",
      //   alt: "Prosperity Palace",
      //   name: "Prosperity Palace",
      // },
      // PueblaParade: {
      //   href: "/casino/aggapplayngo-puebla-parade",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PueblaParade.webp",
      //   alt: "Puebla Parade",
      //   name: "Puebla Parade",
      // },
      // QueensDayTilt: {
      //   href: "/casino/aggapplayngo-queens-day-tilt",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/QueensDayTilt.webp",
      //   alt: "Queens Day Tilt",
      //   name: "Queens Day Tilt",
      // },
      // RabbitHoleRiches: {
      //   href: "/casino/aggapplayngo-rabbit-hole-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RabbitHoleRiches.webp",
      //   alt: "Rabbit Hole Riches",
      //   name: "Rabbit Hole Riches",
      // },
      // RageToRiches: {
      //   href: "/casino/aggapplayngo-rage-to-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RageToRiches.webp",
      //   alt: "Rage to Riches",
      //   name: "Rage to Riches",
      // },
      // RagingRex: {
      //   href: "/casino/aggapplayngo-raging-rex",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RagingRex.webp",
      //   alt: "Raging Rex",
      //   name: "Raging Rex",
      // },
      // RagingRex2: {
      //   href: "/casino/aggapplayngo-raging-rex-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RagingRex2.webp",
      //   alt: "Raging Rex 2",
      //   name: "Raging Rex 2",
      // },
      // RainforestMagic: {
      //   href: "/casino/aggapplayngo-rainforest-magic",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RainforestMagic.webp",
      //   alt: "Rainforest Magic",
      //   name: "Rainforest Magic",
      // },
      // Rally4Riches: {
      //   href: "/casino/aggapplayngo-rally-4-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Rally4Riches.webp",
      //   alt: "Rally 4 Riches",
      //   name: "Rally 4 Riches",
      // },
      // Reactoonz: {
      //   href: "/casino/aggapplayngo-reactoonz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Reactoonz.webp",
      //   alt: "Reactoonz",
      //   name: "Reactoonz",
      // },
      // Reactoonz2: {
      //   href: "/casino/aggapplayngo-reactoonz-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Reactoonz2.webp",
      //   alt: "Reactoonz 2",
      //   name: "Reactoonz 2",
      // },
      // RichWildeAndTheWanderingCity: {
      //   href: "/casino/aggapplayngo-rich-wilde-and-the-wandering-city",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichWildeAndTheWanderingCity.webp",
      //   alt: "Rich Wilde And The Wandering City",
      //   name: "Rich Wilde And The Wandering City",
      // },
      // RichWildeAndTheShieldOfAthena: {
      //   href: "/casino/aggapplayngo-rich-wilde-and-the-shield-of-athena",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichWildeAndTheShieldOfAthena.webp",
      //   alt: "Rich Wilde and the Shield of Athena",
      //   name: "Rich Wilde and the Shield of Athena",
      // },
      // RichesOfRA: {
      //   href: "/casino/aggapplayngo-riches-of-ra",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichesOfRA.webp",
      //   alt: "Riches of RA",
      //   name: "Riches of RA",
      // },
      // RichesOfRobin: {
      //   href: "/casino/aggapplayngo-riches-of-robin",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichesOfRobin.webp",
      //   alt: "Riches of Robin",
      //   name: "Riches of Robin",
      // },
      // RiddleReelsACaseOfRiches: {
      //   href: "/casino/aggapplayngo-riddle-reels-a-case-of-riches",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiddleReelsACaseOfRiches.webp",
      //   alt: "Riddle Reels a case of riches",
      //   name: "Riddle Reels a case of riches",
      // },
      // RingOfOdin: {
      //   href: "/casino/aggapplayngo-ring-of-odin",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RingOfOdin.webp",
      //   alt: "Ring of Odin",
      //   name: "Ring of Odin",
      // },
      // RiseOfAthena: {
      //   href: "/casino/aggapplayngo-rise-of-athena",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfAthena.webp",
      //   alt: "Rise of Athena",
      //   name: "Rise of Athena",
      // },
      // RiseOfDead: {
      //   href: "/casino/aggapplayngo-rise-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfDead.webp",
      //   alt: "Rise of Dead",
      //   name: "Rise of Dead",
      // },
      // RiseOfGodsReckoning: {
      //   href: "/casino/aggapplayngo-rise-of-gods-reckoning",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfGodsReckoning.webp",
      //   alt: "Rise of Gods Reckoning",
      //   name: "Rise of Gods Reckoning",
      // },
      // RiseOfMerlin: {
      //   href: "/casino/aggapplayngo-rise-of-merlin",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfMerlin.webp",
      //   alt: "Rise of Merlin",
      //   name: "Rise of Merlin",
      // },
      // RiseOfOlympus: {
      //   href: "/casino/aggapplayngo-rise-of-olympus",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfOlympus.webp",
      //   alt: "Rise of Olympus",
      //   name: "Rise of Olympus",
      // },
      // RiseOfOlympus100: {
      //   href: "/casino/aggapplayngo-rise-of-olympus-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfOlympus100.webp",
      //   alt: "Rise of Olympus 100",
      //   name: "Rise of Olympus 100",
      // },
      // RoccoGallo: {
      //   href: "/casino/aggapplayngo-rocco-gallo",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RoccoGallo.webp",
      //   alt: "Rocco Gallo",
      //   name: "Rocco Gallo",
      // },
      // RoninsHonour: {
      //   href: "/casino/aggapplayngo-ronins-honour",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RoninsHonour.webp",
      //   alt: "Ronin's Honour",
      //   name: "Ronin's Honour",
      // },
      // Rotiki: {
      //   href: "/casino/aggapplayngo-rotiki",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Rotiki.webp",
      //   alt: "Rotiki",
      //   name: "Rotiki",
      // },
      // RoyalMasquerade: {
      //   href: "/casino/aggapplayngo-royal-masquerade",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RoyalMasquerade.webp",
      //   alt: "Royal Masquerade",
      //   name: "Royal Masquerade",
      // },
      // Sabaton: {
      //   href: "/casino/aggapplayngo-sabaton",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Sabaton.webp",
      //   alt: "Sabaton",
      //   name: "Sabaton",
      // },
      // SafariOfWealth: {
      //   href: "/casino/aggapplayngo-safari-of-wealth",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SafariOfWealth.webp",
      //   alt: "Safari Of Wealth",
      //   name: "Safari Of Wealth",
      // },
      // SailsOfGold: {
      //   href: "/casino/aggapplayngo-sails-of-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SailsOfGold.webp",
      //   alt: "Sails of Gold",
      //   name: "Sails of Gold",
      // },
      // SambaCarnival: {
      //   href: "/casino/aggapplayngo-samba-carnival",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SambaCarnival.webp",
      //   alt: "Samba Carnival",
      //   name: "Samba Carnival",
      // },
      // ScrollOfDead: {
      //   href: "/casino/aggapplayngo-scroll-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ScrollOfDead.webp",
      //   alt: "Scroll of Dead",
      //   name: "Scroll of Dead",
      // },
      // SeaHunter: {
      //   href: "/casino/aggapplayngo-sea-hunter",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SeaHunter.webp",
      //   alt: "Sea Hunter",
      //   name: "Sea Hunter",
      // },
      // SecretOfDead: {
      //   href: "/casino/aggapplayngo-secret-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SecretOfDead.webp",
      //   alt: "Secret Of Dead",
      //   name: "Secret Of Dead",
      // },
      // ShamrockMiner: {
      //   href: "/casino/aggapplayngo-shamrock-miner",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ShamrockMiner.webp",
      //   alt: "Shamrock Miner",
      //   name: "Shamrock Miner",
      // },
      // SistersOfTheSun: {
      //   href: "/casino/aggapplayngo-sisters-of-the-sun",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SistersOfTheSun.webp",
      //   alt: "Sisters of The Sun",
      //   name: "Sisters of The Sun",
      // },
      // SizzlingSpins: {
      //   href: "/casino/aggapplayngo-sizzling-spins",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SizzlingSpins.webp",
      //   alt: "Sizzling Spins",
      //   name: "Sizzling Spins",
      // },
      // Slashimi: {
      //   href: "/casino/aggapplayngo-slashimi",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Slashimi.webp",
      //   alt: "Slashimi",
      //   name: "Slashimi",
      // },
      // SpaceRace: {
      //   href: "/casino/aggapplayngo-space-race",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SpaceRace.webp",
      //   alt: "Space Race",
      //   name: "Space Race",
      // },
      // SparkyAndShortz: {
      //   href: "/casino/aggapplayngo-sparky-and-shortz",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SparkyAndShortz.webp",
      //   alt: "Sparky & Shortz",
      //   name: "Sparky & Shortz",
      // },
      // SpinParty: {
      //   href: "/casino/aggapplayngo-spin-party",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SpinParty.webp",
      //   alt: "Spin Party",
      //   name: "Spin Party",
      // },
      // StarJoker: {
      //   href: "/casino/aggapplayngo-star-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/StarJoker.webp",
      //   alt: "Star Joker",
      //   name: "Star Joker",
      // },
      // StickyJoker: {
      //   href: "/casino/aggapplayngo-sticky-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/StickyJoker.webp",
      //   alt: "Sticky Joker",
      //   name: "Sticky Joker",
      // },
      // StreetMagic: {
      //   href: "/casino/aggapplayngo-street-magic",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/StreetMagic.webp",
      //   alt: "Street Magic",
      //   name: "Street Magic",
      // },
      // SuperFlip: {
      //   href: "/casino/aggapplayngo-super-flip",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SuperFlip.webp",
      //   alt: "Super Flip",
      //   name: "Super Flip",
      // },
      // Sweet27: {
      //   href: "/casino/aggapplayngo-sweet-27",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Sweet27.webp",
      //   alt: "Sweet 27",
      //   name: "Sweet 27",
      // },
      // SweetAlchemy: {
      //   href: "/casino/aggapplayngo-sweet-alchemy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SweetAlchemy.webp",
      //   alt: "Sweet Alchemy",
      //   name: "Sweet Alchemy",
      // },
      // TaleOfKyubiko: {
      //   href: "/casino/aggapplayngo-tale-of-kyubiko",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TaleOfKyubiko.webp",
      //   alt: "Tale Of Kyubiko",
      //   name: "Tale Of Kyubiko",
      // },
      // TalesOfAsgardFreyasWedding: {
      //   href: "/casino/aggapplayngo-tales-of-asgard-freyas-wedding",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TalesOfAsgardFreyasWedding.webp",
      //   alt: "Tales of Asgard Freya's Wedding",
      //   name: "Tales of Asgard Freya's Wedding",
      // },
      // TalesOfAsgardLokisFortune: {
      //   href: "/casino/aggapplayngo-tales-of-asgard-lokis-fortune",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TalesOfAsgardLokisFortune.webp",
      //   alt: "Tales Of Asgard Loki's Fortune",
      //   name: "Tales Of Asgard Loki's Fortune",
      // },
      // Testament: {
      //   href: "/casino/aggapplayngo-testament",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Testament.webp",
      //   alt: "Testament",
      //   name: "Testament",
      // },
      // ThatsRich: {
      //   href: "/casino/aggapplayngo-thats-rich",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ThatsRich.webp",
      //   alt: "That's Rich",
      //   name: "That's Rich",
      // },
      // TheFacesOfFreya: {
      //   href: "/casino/aggapplayngo-the-faces-of-freya",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheFacesOfFreya.webp",
      //   alt: "The Faces of Freya",
      //   name: "The Faces of Freya",
      // },
      // TheGreenKnight: {
      //   href: "/casino/aggapplayngo-the-green-knight",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheGreenKnight.webp",
      //   alt: "The Green Knight",
      //   name: "The Green Knight",
      // },
      // TheLastSundown: {
      //   href: "/casino/aggapplayngo-the-last-sundown",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheLastSundown.webp",
      //   alt: "The Last Sundown",
      //   name: "The Last Sundown",
      // },
      // ThePayingPianoClub: {
      //   href: "/casino/aggapplayngo-the-paying-piano-club",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ThePayingPianoClub.webp",
      //   alt: "The Paying Piano Club",
      //   name: "The Paying Piano Club",
      // },
      // ShimmeringWoods: {
      //   href: "/casino/aggapplayngo-shimmering-woods",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheShimmeringWoods.webp",
      //   alt: "Shimmering Woods",
      //   name: "Shimmering Woods",
      // },
      // TheSwordAndTheGrail: {
      //   href: "/casino/aggapplayngo-the-sword-and-the-grail",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheSwordAndTheGrail.webp",
      //   alt: "The Sword and The Grail",
      //   name: "The Sword and The Grail",
      // },
      // TheWildClass: {
      //   href: "/casino/aggapplayngo-the-wild-class",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheWildClass.webp",
      //   alt: "The Wild Class",
      //   name: "The Wild Class",
      // },
      // ThunderScreech: {
      //   href: "/casino/aggapplayngo-thunder-screech",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ThunderScreech.webp",
      //   alt: "Thunder Screech",
      //   name: "Thunder Screech",
      // },
      // TomeOfMadness: {
      //   href: "/casino/qtechplayngo-tome-of-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TomeOfMadness.webp",
      //   alt: "Tome of Madness",
      //   name: "Tome of Madness",
      // },
      // TrollHunters: {
      //   href: "/casino/aggapplayngo-troll-hunters",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TrollHunters.webp",
      //   alt: "Troll Hunters",
      //   name: "Troll Hunters",
      // },
      // TrollHunters2: {
      //   href: "/casino/aggapplayngo-troll-hunters-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TrollHunters2.webp",
      //   alt: "Troll Hunters 2",
      //   name: "Troll Hunters 2",
      // },
      // USAFlip: {
      //   href: "/casino/aggapplayngo-usa-flip",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/USAFlip.webp",
      //   alt: "USA Flip",
      //   name: "USA Flip",
      // },
      // VikingRunecraft: {
      //   href: "/casino/aggapplayngo-viking-runecraft",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/VikingRunecraft.webp",
      //   alt: "Viking Runecraft",
      //   name: "Viking Runecraft",
      // },
      // WildBandolier: {
      //   href: "/casino/aggapplayngo-wild-bandolier",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildBandolier.webp",
      //   alt: "Wild Bandolier",
      //   name: "Wild Bandolier",
      // },
      // WildBlood: {
      //   href: "/casino/aggapplayngo-wild-blood",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildBlood.webp",
      //   alt: "Wild Blood",
      //   name: "Wild Blood",
      // },
      // WildBlood2: {
      //   href: "/casino/aggapplayngo-wild-blood-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildBlood2.webp",
      //   alt: "Wild Blood 2",
      //   name: "Wild Blood 2",
      // },
      // WildFalls: {
      //   href: "/casino/aggapplayngo-wild-falls",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildFalls.webp",
      //   alt: "Wild Falls",
      //   name: "Wild Falls",
      // },
      // WildFalls2: {
      //   href: "/casino/aggapplayngo-wild-falls-2",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildFalls2.webp",
      //   alt: "Wild Falls 2",
      //   name: "Wild Falls 2",
      // },
      // WildFrames: {
      //   href: "/casino/aggapplayngo-wild-frames",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildFrames.webp",
      //   alt: "Wild Frames",
      //   name: "Wild Frames",
      // },
      // WildMelon: {
      //   href: "/casino/aggapplayngo-wild-melon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildMelon.webp",
      //   alt: "Wild Melon",
      //   name: "Wild Melon",
      // },
      // WildNorth: {
      //   href: "/casino/aggapplayngo-wild-north",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildNorth.webp",
      //   alt: "Wild North",
      //   name: "Wild North",
      // },
      // WildRails: {
      //   href: "/casino/aggapplayngo-wild-rails",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildRails.webp",
      //   alt: "Wild Rails",
      //   name: "Wild Rails",
      // },
      // WildTrigger: {
      //   href: "/casino/aggapplayngo-wild-trigger",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildTrigger.webp",
      //   alt: "Wild Trigger",
      //   name: "Wild Trigger",
      // },
      // WildhoundDerby: {
      //   href: "/casino/aggapplayngo-wildhound-derby",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildhoundDerby.webp",
      //   alt: "Wildhound Derby",
      //   name: "Wildhound Derby",
      // },
      // WinABeest: {
      //   href: "/casino/aggapplayngo-win-a-beest",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WinABeest.webp",
      //   alt: "Win-A-Beest",
      //   name: "Win-A-Beest",
      // },
      // WizardOfGems: {
      //   href: "/casino/aggapplayngo-wizard-of-gems",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WizardOfGems.webp",
      //   alt: "Wizard of Gems",
      //   name: "Wizard of Gems",
      // },
      // XmasJoker: {
      //   href: "/casino/aggapplayngo-xmas-joker-3-reel",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/XmasJoker.webp",
      //   alt: "Xmas Joker",
      //   name: "Xmas Joker",
      // },
      // XmasMagic: {
      //   href: "/casino/aggapplayngo-xmas-magic",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/XmasMagic.webp",
      //   alt: "Xmas Magic",
      //   name: "Xmas Magic",
      // },
      // Hand3CasinoHoldem: {
      //   href: "/casino/aggapplayngo-3-hand-casino-holdem",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/3HandCasinoHoldem.webp",
      //   alt: "3-Hand Casino Hold'em",
      //   name: "3-Hand Casino Hold'em",
      // },
      // BlackJackMH: {
      //   href: "/casino/aggapplayngo-blackjack-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BlackJackMH.webp",
      //   alt: "BlackJack MH",
      //   name: "BlackJack MH",
      // },
      // DeucesWild: {
      //   href: "/casino/aggapplayngo-deuces-wild-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DeucesWild.webp",
      //   alt: "Deuces Wild",
      //   name: "Deuces Wild",
      // },
      // DoubleExposureBlackJackMH: {
      //   href: "/casino/aggapplayngo-double-exposure-blackjack-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DoubleExposureBlackJackMH.webp",
      //   alt: "Double Exposure BlackJack MH",
      //   name: "Double Exposure BlackJack MH",
      // },
      // EuropeanBlackJackMH: {
      //   href: "/casino/aggapplayngo-european-blackjack-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EuropeanBlackJackMH.webp",
      //   alt: "European BlackJack MH",
      //   name: "European BlackJack MH",
      // },
      // EuropeanRoulette: {
      //   href: "/casino/aggapplayngo-european-roulette",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EuropeanRoulettePro.webp",
      //   alt: "European Roulette",
      //   name: "European Roulette",
      // },
      // JacksOrBetterMH: {
      //   href: "/casino/aggapplayngo-jacks-or-better-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JacksOrBetterMH.webp",
      //   alt: "Jacks or Better MH",
      //   name: "Jacks or Better MH",
      // },
      // JokerPokerMH: {
      //   href: "/casino/aggapplayngo-joker-poker-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JokerPokerMH.webp",
      //   alt: "Joker Poker MH",
      //   name: "Joker Poker MH",
      // },
      // Keno: {
      //   href: "/casino/qtechplayngo-keno",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Keno.webp",
      //   alt: "Keno",
      //   name: "Keno",
      // },
      // MiniBaccarat: {
      //   href: "/casino/qtechplayngo-mini-baccarat",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "QTECH",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MiniBaccarat.webp",
      //   alt: "Mini Baccarat",
      //   name: "Mini Baccarat",
      // },
      // SingleDeckBlackJackMH: {
      //   href: "/casino/aggapplayngo-single-deck-blackjack-mh",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SingleDeckBlackJackMH.webp",
      //   alt: "Single Deck BlackJack MH",
      //   name: "Single Deck BlackJack MH",
      // },
      // MoonPrincessPowerOfLove: {
      //   href: "/casino/aggapplayngo-moon-princess-power-of-love",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MoonPrincessPowerOfLove.webp",
      //   alt: "Moon Princess - Power of Love",
      //   name: "Moon Princess - Power of Love",
      // },
      // LoveIsInTheFair: {
      //   href: "/casino/aggapplayngo-love-is-in-the-fair",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LoveIsInTheFair.webp",
      //   alt: "Love is in the Fair",
      //   name: "Love is in the Fair",
      // },
      // CatWildeAndTheIncanQuest: {
      //   href: "/casino/aggapplayngo-cat-wilde-and-the-incan-quest",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CatWildeAndTheIncanQuest.webp",
      //   alt: "Cat Wilde and the Incan Quest",
      //   name: "Cat Wilde and the Incan Quest",
      // },
      // BoatBonanzaDownUnder: {
      //   href: "/casino/aggapplayngo-boat-bonanza-down-under",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BoatBonanzaDownUnder.webp",
      //   alt: "Boat Bonanza Down Under",
      //   name: "Boat Bonanza Down Under",
      // },
      // HugoCarts: {
      //   href: "/casino/aggapplayngo-hugo-carts",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HugoCarts.webp",
      //   alt: "Hugo Carts",
      //   name: "Hugo Carts",
      // },
      // AliceCooperAndTheTomeOfMadness: {
      //   href: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
      //   alt: "Alice Cooper And The Tome Of Madness",
      //   name: "Alice Cooper And The Tome Of Madness",
      // },
      // Snakebite: {
      //   href: "/casino/qt-snakebite",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "WorldCasino",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Snakebite.webp",
      //   alt: "Snakebite",
      //   name: "Snakebite",
      // },
      // kissReelsOfRock: {
      //   href: "/casino/aggapplayngo-kiss-reels-of-rock",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/kissReelsOfRock.webp",
      //   alt: "kiss Reels Of Rock",
      //   name: "kiss Reels Of Rock",
      // },
      // DefLeppardHysteria: {
      //   href: "/casino/aggapplayngo-def-leppard-hysteria",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DefleppardHysteria.webp",
      //   alt: "Def Leppard Hysteria",
      //   name: "Def Leppard Hysteria",
      // },
      // DioKillingTheDragon: {
      //   href: "/casino/aggapplayngo-dio-killing-the-dragon",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DioKillingTheDragon.webp",
      //   alt: "DIO Killing the Dragon",
      //   name: "DIO Killing the Dragon",
      // },
      // DivineDivas: {
      //   href: "/casino/aggapplayngo-divine-divas",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DivineDivas.webp",
      //   alt: "Divine Divas",
      //   name: "Divine Divas",
      // },
      // Gemix100: {
      //   href: "/casino/aggapplayngo-gemix-100",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Gemix100.webp",
      //   alt: "Gemix 100",
      //   name: "Gemix 100",
      // },
      // KingdomBelow: {
      //   href: "/casino/aggapplayngo-kingdom-below",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/KingdomBelow.webp",
      //   alt: "Kingdom Below",
      //   name: "Kingdom Below",
      // },
      // MirrorJoker: {
      //   href: "/casino/aggapplayngo-mirror-joker",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MirrorJoker.webp",
      //   alt: "Mirror Joker",
      //   name: "Mirror Joker",
      // },
      // BuildinBucks: {
      //   href: "/casino/aggapplayngo-buildin-bucks",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BuildinBucks.webp",
      //   alt: "Buildin' Bucks",
      //   name: "Buildin' Bucks",
      // },
      // AnkhOfAnubisAwakening: {
      //   href: "/casino/aggapplayngo-ankh-of-anubis-awakening",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/AnkhOfAnubisAwakening.webp",
      //   alt: "Ankh of Anubis Awakening",
      //   name: "Ankh of Anubis Awakening",
      // },
      // ScourgeOfRome: {
      //   href: "/casino/aggapplayngo-scourge-of-rome",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ScourgeOfRome.webp",
      //   alt: "Scourge of Rome",
      //   name: "Scourge of Rome",
      // },
      // MafiaGold: {
      //   href: "/casino/aggapplayngo-mafia-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MafiaGold.webp",
      //   alt: "Mafia Gold",
      //   name: "Mafia Gold",
      // },
      // RiseOfOlympusOrigin: {
      //   href: "/casino/aggapplayngo-rise-of-olympus-origin",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RiseOfOlympusOrigins.webp",
      //   alt: "Rise of Olympus Origin",
      //   name: "Rise of Olympus Origin",
      // },
      // KingsMaskEclipseOfGods: {
      //   href: "/casino/aggapplayngo-kings-mask-eclipse-of-gods",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/KingsMaskEclipseOfGods.webp",
      //   alt: "King’s Mask Eclipse of Gods",
      //   name: "King’s Mask Eclipse of Gods",
      // },
      // WhisperingWinds: {
      //   href: "/casino/aggapplayngo-whispering-winds",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WhisperingWinds.webp",
      //   alt: "Whispering Winds",
      //   name: "Whispering Winds",
      // },
      // DansbandPaTurne: {
      //   href: "/casino/aggapplayngo-dansband-pa-turne",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/DansbandPaTurne.webp",
      //   alt: "Dansband Pa Turne",
      //   name: "Dansband Pa Turne",
      // },
      // OasisOfDead: {
      //   href: "/casino/aggapplayngo-oasis-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/OasisOfDead.webp",
      //   alt: "Oasis of Dead",
      //   name: "Oasis of Dead",
      // },
      // JourneyToParis: {
      //   href: "/casino/aggapplayngo-journey-to-paris",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JourneyToParis.webp",
      //   alt: "Journey to Paris",
      //   name: "Journey to Paris",
      // },
      // TempleOfTollan: {
      //   href: "/casino/aggapplayngo-temple-of-tollan",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TempleOfTollan.webp",
      //   alt: "Temple of Tollan",
      //   name: "Temple of Tollan",
      // },
      // MerlinRealmOfCharm: {
      //   href: "/casino/aggapplayngo-merlin-realm-of-charm",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MerlinRealmOfCharm.webp",
      //   alt: "Merlin Realm of Charm",
      //   name: "Merlin Realm of Charm",
      // },
      // GoldOfFortuneGod: {
      //   href: "/casino/aggapplayngo-gold-of-fortune-god",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/GoldOfFortuneGod.webp",
      //   alt: "Gold of Fortune God",
      //   name: "Gold of Fortune God",
      // },
      // RichWildeAndTheTomeOfInsanity: {
      //   href: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-insanity",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichWildeAndTheTomeOfInsanity.webp",
      //   alt: "Rich Wilde and the Tome of Insanity",
      //   name: "Rich Wilde and the Tome of Insanity",
      // },
      // ColtLightningFirestorm: {
      //   href: "/casino/aggapplayngo-colt-lightning-firestorm",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ColtLightningFirestorm.webp",
      //   alt: "Colt Lightning Firestorm",
      //   name: "Colt Lightning Firestorm",
      // },
      // SparkOfGenius: {
      //   href: "/casino/aggapplayngo-spark-of-genius",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SparkOfGenius.webp",
      //   alt: "Spark of Genius",
      //   name: "Spark of Genius",
      // },
      // WildSurvivor: {
      //   href: "/casino/aggapplayngo-wild-survivor",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildSurvivor.webp",
      //   alt: "Wild Survivor",
      //   name: "Wild Survivor",
      // },
      // Fulong88: {
      //   href: "/casino/aggapplayngo-fulong-88",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/Fulong88.webp",
      //   alt: "Fulong 88",
      //   name: "Fulong 88",
      // },
      // TheSwordAndTheGrailExcalibur: {
      //   href: "/casino/aggapplayngo-the-sword-and-the-grail-excalibur",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TheSwordAndTheGrailExcalibur.webp",
      //   alt: "The Sword and the Grail Excalibur",
      //   name: "The Sword and the Grail Excalibur",
      // },
      // BoatBonanzaDownUnder: {
      //   href: "/casino/aggapplayngo-boat-bonanza-down-under",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BoatBonanzaDownUnder.webp",
      //   alt: "Boat Bonanza Down Under",
      //   name: "Boat Bonanza Down Under",
      // },
      // TombOfGold: {
      //   href: "/casino/aggapplayngo-tomb-of-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TombOfGold.webp",
      //   alt: "Tomb of Gold",
      //   name: "Tomb of Gold",
      // },
      // MysteryGenieFortunesOfTheLamp: {
      //   href: "/casino/aggapplayngo-mystery-genie-fortunes-of-the-lamp",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MysteryGenieFortunesOfTheLamp.webp",
      //   alt: "Mystery Genie Fortunes of the Lamp",
      //   name: "Mystery Genie Fortunes of the Lamp",
      // },
      // EasterEggspedition: {
      //   href: "/casino/aggapplayngo-easter-eggspedition",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/EasterEggspedition.webp",
      //   alt: "Easter Eggspedition",
      //   name: "Easter Eggspedition",
      // },
      // PiranhaPays: {
      //   href: "/casino/aggapplayngo-piranha-pays",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PiranhaPays.webp",
      //   alt: "Piranha Pays",
      //   name: "Piranha Pays",
      // },
      // ChambersOfAncients: {
      //   href: "/casino/aggapplayngo-chambers-of-ancients",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/ChambersOfAncients.webp",
      //   alt: "Chambers of Ancients",
      //   name: "Chambers of Ancients",
      // },
      // BanquetOfDead: {
      //   href: "/casino/aggapplayngo-banquet-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BanquetOfDead.webp",
      //   alt: "Banquet of Dead",
      //   name: "Banquet of Dead",
      // },
      // LegionGoldUnleashed: {
      //   href: "/casino/aggapplayngo-legion-gold-unleashed",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegionGoldUnleashed.webp",
      //   alt: "Legion Gold Unleashed",
      //   name: "Legion Gold Unleashed",
      // },
      // UndefeatedXerxes: {
      //   href: "/casino/aggapplayngo-undefeated-xerxes",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/UndefeatedXerxes.webp",
      //   alt: "Undefeated Xerxes",
      //   name: "Undefeated Xerxes",
      // },
      // LadyOfFortuneRemastered: {
      //   href: "/casino/aggapplayngo-lady-of-fortune-remastered",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LadyOfFortuneRemastered.webp",
      //   alt: "Lady of Fortune Remastered",
      //   name: "Lady of Fortune Remastered",
      // },
      // SteppingDiamonds: {
      //   href: "/casino/aggapplayngo-stepping-diamonds",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/SteppingDiamonds.webp",
      //   alt: "Stepping Diamonds",
      //   name: "Stepping Diamonds",
      // },
      // BaronLordOfSaturday: {
      //   href: "/casino/aggapplayngo-baron-lord-of-saturday",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BaronLordOfSaturday.webp",
      //   alt: "Baron Lord of Saturday",
      //   name: "Baron Lord of Saturday",
      // },
      // BeastsOfFireMaximum: {
      //   href: "/casino/aggapplayngo-beasts-of-fire-maximum",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BeastsOfFireMaximum.webp",
      //   alt: "Beasts of Fire Maximum",
      //   name: "Beasts of Fire Maximum",
      // },
      // LegionGoldAndTheSphinxOfDead: {
      //   href: "/casino/aggapplayngo-legion-gold-and-the-sphinx-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegionGoldAndTheSphinxOfDead.webp",
      //   alt: "Legion Gold and the Sphinx of Dead",
      //   name: "Legion Gold and the Sphinx of Dead",
      // },
      // PiggyBlitzDiscoGold: {
      //   href: "/casino/aggapplayngo-piggy-blitz-disco-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PiggyBlitzDiscoGold.webp",
      //   alt: "Piggy Blitz Disco Gold",
      //   name: "Piggy Blitz Disco Gold",
      // },
      // RichWildeAndThePearlsOfVishnu: {
      //   href: "/casino/aggapplayngo-rich-wilde-and-the-pearls-of-vishnu",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/RichWildeAndThePearlsOfVishnu.webp",
      //   alt: "Rich Wilde and the Pearls of Vishnu",
      //   name: "Rich Wilde and the Pearls of Vishnu",
      // },
      // BoatBonanzaChristmas: {
      //   href: "/casino/aggapplayngo-boat-bonanza-christmas",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/BoatBonanzaChristmas.webp",
      //   alt: "Boat Bonanza Christmas",
      //   name: "Boat Bonanza Christmas",
      // },
      // WildestGambit: {
      //   href: "/casino/aggapplayngo-wildest-gambit",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/WildestGambit.webp",
      //   alt: "Wildest Gambit",
      //   name: "Wildest Gambit",
      // },
      // LionSagaOdyssey: {
      //   href: "/casino/aggapplayngo-lion-saga-odyssey",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LionSagaOdyssey.webp",
      //   alt: "Lion Saga Odyssey",
      //   name: "Lion Saga Odyssey",
      // },
      // HotDogHeist: {
      //   href: "/casino/aggapplayngo-hot-dog-heist",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/HotDogHeist.webp",
      //   alt: "Hot Dog Heist",
      //   name: "Hot Dog Heist",
      // },
      // JollyRogerWildKraken: {
      //   href: "/casino/aggapplayngo-jolly-roger-wild-kraken",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/JollyRogerWildKraken.webp",
      //   alt: "Jolly Roger Wild Kraken",
      //   name: "Jolly Roger Wild Kraken",
      // },
      // MidnightGold: {
      //   href: "/casino/aggapplayngo-midnight-gold",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MidnightGold.webp",
      //   alt: "Midnight Gold",
      //   name: "Midnight Gold",
      // },
      // TreasuresOfKongar: {
      //   href: "/casino/aggapplayngo-treasures-of-kongar",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TreasuresOfKongar.webp",
      //   alt: "Treasures of Kongar",
      //   name: "Treasures of Kongar",
      // },
      // TowerQuestLegacy: {
      //   href: "/casino/aggapplayngo-tower-quest-legacy",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/TowerQuestLegacy.webp",
      //   alt: "Tower Quest Legacy",
      //   name: "Tower Quest Legacy",
      // },
      // LegacyOfGemsBlitzways: {
      //   href: "/casino/aggapplayngo-legacy-of-gems-blitzways",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegacyOfGemsBlitzways.webp",
      //   alt: "Legacy of Gems Blitzways",
      //   name: "Legacy of Gems Blitzways",
      // },
      // PotionOfMadness: {
      //   href: "/casino/aggapplayngo-potion-of-madness",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/PotionOfMadness.webp",
      //   alt: "Potion of Madness",
      //   name: "Potion of Madness",
      // },
      // InvadingVegasRevengeOnMars: {
      //   href: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/InvadingVegasRevengeOnMars.webp",
      //   alt: "Invading Vegas Revenge on Mars",
      //   name: "Invading Vegas Revenge on Mars",
      // },
      // CrystalHall: {
      //   href: "/casino/aggapplayngo-crystal-hall",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/CrystalHall.webp",
      //   alt: "Crystal Hall",
      //   name: "Crystal Hall",
      // },
      // MythOfDead: {
      //   href: "/casino/aggapplayngo-myth-of-dead",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/MythOfDead.webp",
      //   alt: "Myth of Dead",
      //   name: "Myth of Dead",
      // },
      // LegionGoldVictory: {
      //   href: "/casino/aggapplayngo-legion-gold-victory",
      //   code: "",
      //   casino: "Play'n GO",
      //   provider: "ALT_GAMING_GAP",
      //   category: "playNGo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/play-n-go/LegionGoldVictory.webp",
      //   alt: "Legion Gold Victory",
      //   name: "Legion Gold Victory",
      // },
    },
  },

  // relaxGaming: {
  //   relaxGaming: {
  //     BillAndCoin: {
  //       href: "/casino/qt-bill-and-coin",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BillAndCoin.webp",
  //       alt: "bill and coin",
  //       name: "Bill & Coin",
  //     },
  //     LureOfFortune: {
  //       href: "/casino/qt-lure-of-fortune",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/LureOfFortune.webp",
  //       alt: "lure of fortune",
  //       name: "Lure Of Fortune",
  //     },
  //     TitanStrike: {
  //       href: "/casino/qt-titan-strike",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TitanStrike.webp",
  //       alt: "titan strike",
  //       name: "Titan Strike",
  //     },
  //     MoneyTrain4: {
  //       href: "/casino/qt-money-train-4",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyTrain4.webp",
  //       alt: "money train 4",
  //       name: "Money Train 4",
  //     },
  //     JokerSplit: {
  //       href: "/casino/qt-joker-split",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/JokerSplit.webp",
  //       alt: "joker split",
  //       name: "Joker Split",
  //     },
  //     ToriiTumble: {
  //       href: "/casino/qt-torii-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/ToriiTumble.webp",
  //       alt: "torii tumble",
  //       name: "Torii Tumble",
  //     },
  //     SlothTumble: {
  //       href: "/casino/qt-sloth-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SlothTumble.webp",
  //       alt: "sloth tumble",
  //       name: "Sloth Tumble",
  //     },
  //     SharkWash: {
  //       href: "/casino/qt-shark-wash",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SharkWash.webp",
  //       alt: "shark wash",
  //       name: "Shark Wash",
  //     },
  //     BananaTown: {
  //       href: "/casino/qt-banana-town",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BananaTown.webp",
  //       alt: "banana town",
  //       name: "Banana Town",
  //     },
  //     BeastMode: {
  //       href: "/casino/qt-beast-mode",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BeastMode.webp",
  //       alt: "beast mode",
  //       name: "Beast Mode",
  //     },
  //     BlenderBlitz: {
  //       href: "/casino/qt-blender-blitz",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BlenderBlitz.webp",
  //       alt: "blender blitz",
  //       name: "Blender Blitz",
  //     },
  //     BookOf99: {
  //       href: "/casino/qt-book-of-99",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Bookof99.webp",
  //       alt: "book of 99",
  //       name: "Book of 99",
  //     },
  //     BookOfPower: {
  //       href: "/casino/qt-book-of-power",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BookOfPower.webp",
  //       alt: "book of power",
  //       name: "Book Of Power",
  //     },
  //     CavemanBob: {
  //       href: "/casino/qt-caveman-bob",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/CavemanBob.webp",
  //       alt: "caveman bob",
  //       name: "Caveman Bob",
  //     },
  //     ChipSpin: {
  //       href: "/casino/qt-chip-spin",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/ChipSpin.webp",
  //       alt: "chip spin",
  //       name: "Chip Spin",
  //     },
  //     ClusterTumble: {
  //       href: "/casino/qt-cluster-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/ClusterTumble.webp",
  //       alt: "cluster tumble",
  //       name: "Cluster Tumble",
  //     },
  //     DeadMansTrail: {
  //       href: "/casino/qt-dead-mans-trail",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/DeadMansTrail.webp",
  //       alt: "dead mans trail",
  //       name: "Dead Man's Trail",
  //     },
  //     DeadRidersTrail: {
  //       href: "/casino/qt-dead-riders-trail",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/DeadRidersTrail.webp",
  //       alt: "dead riders trail",
  //       name: "Dead Riders Trail",
  //     },
  //     DeepDescent: {
  //       href: "/casino/qt-deep-descent",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/DeepDescent.webp",
  //       alt: "deep descent",
  //       name: "Deep Descent",
  //     },
  //     DragonsAwakening: {
  //       href: "/casino/qt-dragons-awakening",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/DragonsAwakening.webp",
  //       alt: "dragons awakening",
  //       name: "Dragons Awakening",
  //     },
  //     EmeraldsInfinityReels: {
  //       href: "/casino/qt-emeralds-infinity-reels",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/EmeraldsInfinityReels.webp",
  //       alt: "emeralds infinity reels",
  //       name: "Emerald's Infinity Reels",
  //     },
  //     ErikTheRed: {
  //       href: "/casino/qt-erik-the-red",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/EriktheRed.webp",
  //       alt: "erik the red",
  //       name: "Erik the Red",
  //     },
  //     EpicJoker: {
  //       href: "/casino/qt-epic-joker",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/EpicJoker.webp",
  //       alt: "epic joker",
  //       name: "Epic Joker",
  //     },
  //     FrequentFlyer: {
  //       href: "/casino/qt-frequent-flyer",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/FrequentFlyer.webp",
  //       alt: "frequent flyer",
  //       name: "Frequent Flyer",
  //     },
  //     HazakuraWays: {
  //       href: "/casino/qt-hazakura-ways",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/HazakuraWays.webp",
  //       alt: "hazakura ways",
  //       name: "Hazakura Ways",
  //     },
  //     HeliosFury: {
  //       href: "/casino/qt-helios-fury",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/HeliosFury.webp",
  //       alt: "helios fury",
  //       name: "Helios' Fury",
  //     },
  //     Hellcatraz: {
  //       href: "/casino/qt-hellcatraz",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Hellcatraz.webp",
  //       alt: "hellcatraz",
  //       name: "Hellcatraz",
  //     },
  //     HeroesGathering: {
  //       href: "/casino/qt-heroes-gathering",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/HeroesGathering.webp",
  //       alt: "heroes gathering",
  //       name: "Heroes Gathering",
  //     },
  //     Hex: {
  //       href: "/casino/qt-hex",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Hex.webp",
  //       alt: "hex",
  //       name: "Hex",
  //     },
  //     HorrorHotel: {
  //       href: "/casino/qt-horror-hotel",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/HorrorHotel.webp",
  //       alt: "horror hotel",
  //       name: "Horror Hotel",
  //     },
  //     HotRodRacers: {
  //       href: "/casino/qt-hot-rod-racers",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/HotRodRacers.webp",
  //       alt: "hot rod racers",
  //       name: "Hot Rod Racers",
  //     },
  //     IgniteTheNight: {
  //       href: "/casino/qt-ignite-the-night",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/IgniteTheNight.webp",
  //       alt: "ignite the night",
  //       name: "Ignite The Night",
  //     },
  //     IronBank: {
  //       href: "/casino/qt-iron-bank",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/IronBank.webp",
  //       alt: "iron bank",
  //       name: "Iron Bank",
  //     },
  //     ItsTime: {
  //       href: "/casino/qt-its-time",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/ItsTime.webp",
  //       alt: "its time",
  //       name: "It's Time",
  //     },
  //     JurassicParty: {
  //       href: "/casino/qt-jurassic-party",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/JurassicParty.webp",
  //       alt: "jurassic party",
  //       name: "Jurassic Party",
  //     },
  //     KingOfKings: {
  //       href: "/casino/qt-king-of-kings",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/KingofKings.webp",
  //       alt: "king of kings",
  //       name: "King of Kings",
  //     },
  //     KlusterKrystalsMegaclusters: {
  //       href: "/casino/qt-kluster-krystals-megaclusters",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/KlusterKrystalsMegaclusters.webp",
  //       alt: "kluster krystals megaclusters",
  //       name: "Kluster Krystals Megaclusters",
  //     },
  //     LaFiesta: {
  //       href: "/casino/qt-la-fiesta",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/LaFiesta.webp",
  //       alt: "la fiesta",
  //       name: "La Fiesta",
  //     },
  //     LetsGetReadyToRumble: {
  //       href: "/casino/qt-lets-get-ready-to-rumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/LetsgetreadytoRumble.webp",
  //       alt: "lets get ready to rumble",
  //       name: "Let's get ready to Rumble",
  //     },
  //     MarchingLegions: {
  //       href: "/casino/qt-marching-legions",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MarchingLegions.webp",
  //       alt: "marching legions",
  //       name: "Marching Legions",
  //     },
  //     MegaFlip: {
  //       href: "/casino/qt-mega-flip",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MegaFlip.webp",
  //       alt: "mega flip",
  //       name: "Mega Flip",
  //     },
  //     MegaHeist: {
  //       href: "/casino/qt-mega-heist",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MegaHeist.webp",
  //       alt: "mega heist",
  //       name: "Mega Heist",
  //     },
  //     MegaMasks: {
  //       href: "/casino/qt-mega-masks",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MegaMasks.webp",
  //       alt: "mega masks",
  //       name: "Mega Masks",
  //     },
  //     MegaMine: {
  //       href: "/casino/qt-mega-mine",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MegaMine.webp",
  //       alt: "mega mine",
  //       name: "Mega Mine",
  //     },
  //     MidnightMarauder: {
  //       href: "/casino/qt-midnight-marauder",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MidnightMarauder.webp",
  //       alt: "midnight marauder",
  //       name: "Midnight Marauder",
  //     },
  //     MoneyCart: {
  //       href: "/casino/qt-money-cart",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyCart.webp",
  //       alt: "money cart",
  //       name: "Money Cart",
  //     },
  //     MoneyCart2: {
  //       href: "/casino/qt-money-cart-2",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyCart2.webp",
  //       alt: "money cart 2",
  //       name: "Money Cart 2",
  //     },
  //     MoneyCart3: {
  //       href: "/casino/qt-money-cart-3",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyCart3.webp",
  //       alt: "money cart 3",
  //       name: "Money Cart 3",
  //     },
  //     MoneyTrain: {
  //       href: "/casino/qt-money-train",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyTrain.webp",
  //       alt: "money train",
  //       name: "Money Train",
  //     },
  //     MoneyTrain2: {
  //       href: "/casino/qt-money-train-2",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyTrain2.webp",
  //       alt: "money train 2",
  //       name: "Money Train 2",
  //     },
  //     MoneyTrain3: {
  //       href: "/casino/qt-money-train-3",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MoneyTrain3.webp",
  //       alt: "money train 3",
  //       name: "Money Train 3",
  //     },
  //     MultiplierOdyssey: {
  //       href: "/casino/qt-multiplier-odyssey",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MultiplierOdyssey.webp",
  //       alt: "multiplier odyssey",
  //       name: "Multiplier Odyssey",
  //     },
  //     NetGains: {
  //       href: "/casino/qt-net-gains",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/NetGains.webp",
  //       alt: "net gains",
  //       name: "Net Gains",
  //     },
  //     Plunderland: {
  //       href: "/casino/qt-plunderland",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Plunderland.webp",
  //       alt: "plunderland",
  //       name: "Plunderland",
  //     },
  //     Powerspin: {
  //       href: "/casino/qt-powerspin",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Powerspin.webp",
  //       alt: "powerspin",
  //       name: "Powerspin",
  //     },
  //     RamsesRevenge: {
  //       href: "/casino/qt-ramses-revenge",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/RamsesRevenge.webp",
  //       alt: "ramses revenge",
  //       name: "Ramses Revenge",
  //     },
  //     SailsOfFortune: {
  //       href: "/casino/qt-sails-of-fortune",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SailsOfFortune.webp",
  //       alt: "sails of fortune",
  //       name: "Sails Of Fortune",
  //     },
  //     SnakeArena: {
  //       href: "/casino/qt-snake-arena",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SnakeArena.webp",
  //       alt: "snake arena",
  //       name: "Snake Arena",
  //     },
  //     SantasStack: {
  //       href: "/casino/qt-santas-stack",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SantasStack.webp",
  //       alt: "santas stack",
  //       name: "Santa's Stack",
  //     },
  //     SpaceMiners: {
  //       href: "/casino/qt-space-miners",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SpaceMiners.webp",
  //       alt: "space miners",
  //       name: "Space Miners",
  //     },
  //     TemplarTumble: {
  //       href: "/casino/qt-templar-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TemplarTumble.webp",
  //       alt: "templar tumble",
  //       name: "Templar Tumble",
  //     },
  //     SpiritOfTheBeast: {
  //       href: "/casino/qt-spirit-of-the-beast",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SpiritoftheBeast.webp",
  //       alt: "spirit of the beast",
  //       name: "Spirit of the Beast",
  //     },
  //     TempleTumble: {
  //       href: "/casino/qt-temple-tumble-megaways",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TempleTumbleMegaways.webp",
  //       alt: "temple tumble",
  //       name: "Temple Tumble",
  //     },
  //     TheGreatPigsbyMegaways: {
  //       href: "/casino/qt-the-great-pigsby-megaways",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TheGreatPigsbyMegaways.webp",
  //       alt: "the great pigsby megaways",
  //       name: "The Great Pigsby Megaways",
  //     },
  //     TheGreatPigsby: {
  //       href: "/casino/qt-the-great-pigsby",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TheGreatPigsby.webp",
  //       alt: "the great pigsby",
  //       name: "The Great Pigsby",
  //     },
  //     TigerKingdomInfinityReels: {
  //       href: "/casino/qt-tiger-kingdom-infinity-reels",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TigerKingdomInfinityReels.webp",
  //       alt: "tiger kingdom infinity reels",
  //       name: "Tiger Kingdom Infinity Reels",
  //     },
  //     TNTTumble: {
  //       href: "/casino/qt-tnt-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TNTTumble.webp",
  //       alt: "tnt tumble",
  //       name: "TNT Tumble",
  //     },
  //     TopDawgs: {
  //       href: "/casino/qt-top-dawgdollar",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TopDawg.webp",
  //       alt: "top dawg$",
  //       name: "Top Dawg$",
  //     },
  //     TowerTumble: {
  //       href: "/casino/qt-tower-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TowerTumble.webp",
  //       alt: "tower tumble",
  //       name: "Tower Tumble",
  //     },
  //     TrollsGold: {
  //       href: "/casino/qt-trolls-gold",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TrollsGold.webp",
  //       alt: "trolls gold",
  //       name: "Troll's Gold",
  //     },
  //     VolatileVikings: {
  //       href: "/casino/qt-volatile-vikings",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/VolatileVikings.webp",
  //       alt: "volatile vikings",
  //       name: "Volatile Vikings",
  //     },
  //     WildChapo: {
  //       href: "/casino/qt-wild-chapo",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/WildChapo.webp",
  //       alt: "wild chapo",
  //       name: "Wild Chapo",
  //     },
  //     WildChapo2: {
  //       href: "/casino/qt-wild-chapo-2",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/WildChapo2.webp",
  //       alt: "wild chapo-2",
  //       name: "Wild Chapo 2",
  //     },
  //     Wildchemy: {
  //       href: "/casino/qt-wildchemy",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/Wildchemy.webp",
  //       alt: "wildchemy",
  //       name: "Wildchemy",
  //     },
  //     WildHike: {
  //       href: "/casino/qt-wild-hike",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/WildHike.webp",
  //       alt: "wild hike",
  //       name: "Wild Hike",
  //     },
  //     WildYield: {
  //       href: "/casino/qt-wild-yield",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/WildYield.webp",
  //       alt: "wild yield",
  //       name: "Wild Yield",
  //     },
  //     ZombieCircus: {
  //       href: "/casino/qt-zombie-circus",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/ZombieCircus.webp",
  //       alt: "zombie circus",
  //       name: "Zombie Circus",
  //     },
  //     BlackjackNeo: {
  //       href: "/casino/qt-blackjack-neo",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/BlackjackNeo.webp",
  //       alt: "blackjack neo",
  //       name: "Blackjack Neo",
  //     },
  //     RouletteNouveau: {
  //       href: "/casino/qt-roulette-nouveau",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/RouletteNouveau.webp",
  //       alt: "roulette nouveau",
  //       name: "Roulette Nouveau",
  //     },
  //     MONEYCART4: {
  //       href: "/casino/qt-money-cart-4",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/MONEYCART4.webp",
  //       alt: "money cart 4",
  //       name: "MONEY CART 4",
  //     },
  //     SWEETOPIAROYALE: {
  //       href: "/casino/qt-sweetopia-royale",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SWEETOPIAROYALE.webp",
  //       alt: "sweetopia royale",
  //       name: "SWEETOPIA ROYALE",
  //     },
  //     FIREWINSFACTORY: {
  //       href: "/casino/qt-firewins-factory",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/FIREWINSFACTORY.webp",
  //       alt: "firewins factory",
  //       name: "Firewins Factory",
  //     },
  //     HeroesHunt2MegawaysXmasVersion: {
  //       href: "/casino/qt-heroes-hunt-2-megaways-xmas-version",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl:
  //         "/images/casino/relax-gaming/HeroesHunt2MegawaysXmasVersion.webp",
  //       alt: "heroes hunt 2 megaways - xmas version",
  //       name: "Heroes Hunt 2 Megaways - Xmas Version",
  //     },
  //     TheGreatPigsbyMegapays: {
  //       href: "/casino/qt-the-great-pigsby-megapays",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TheGreatPigsbyMegapays.webp",
  //       alt: "the great pigsby megapays",
  //       name: "The Great Pigsby Megapays",
  //     },
  //     SnakeArenaDreamDrop: {
  //       href: "/casino/qt-snake-arena-dream-drop",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/SnakeArenaDreamDrop.webp",
  //       alt: "snake arena dream drop",
  //       name: "Snake Arena Dream Drop",
  //     },
  //     VolatileVikings2DreamDrop: {
  //       href: "/casino/qt-volatile-vikings-2-dream-drop",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/VolatileVikings2DreamDrop.webp",
  //       alt: "volatile vikings 2 dream drop",
  //       name: "Volatile Vikings 2 Dream Drop",
  //     },
  //     TntTumbleDreamDrop: {
  //       href: "/casino/qt-tnt-tumble-dream-drop",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/TntTumbleDreamDrop.webp",
  //       alt: "tnt tumble dream drop",
  //       name: "Tnt Tumble Dream Drop",
  //     },
  //     NekoNightDreamDrop: {
  //       href: "/casino/qt-neko-night-dream-drop",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/NekoNightDreamDrop.webp",
  //       alt: "neko night dream drop",
  //       name: "Neko Night Dream Drop",
  //     },
  //     WildChapoDreamDrop: {
  //       href: "/casino/qt-wild-chapo-dream-drop",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/WildChapoDreamDrop.webp",
  //       alt: "wild chapo dream drop",
  //       name: "Wild Chapo Dream Drop",
  //     },
  //     // TheTumbles: {
  //     //   href: "/casino/qtechrelaxgaming-the-tumbles",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/TheTumbles.webp",
  //     //   alt: "the tumbles",
  //     //   name: "The Tumbles",
  //     // },
  //     // BoneRaiders: {
  //     //   href: "/casino/qtechrelaxgaming-bone-raiders",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/BoneRaiders.webp",
  //     //   alt: "bone raiders",
  //     //   name: "Bone Raiders",
  //     // },
  //     AtlantisCrush: {
  //       href: "/casino/qt-atlantis-crush",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/AtlantisCrush.webp",
  //       alt: "atlantis crush",
  //       name: "Atlantis Crush",
  //     },
  //     AncientTumble: {
  //       href: "/casino/qt-ancient-tumble",
  //       code: "",
  //       casino: "Relax Gaming",
  //       provider: "WorldCasino",
  //       category: "relaxGaming",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/relax-gaming/AncientTumble.webp",
  //       alt: "ancient tumble",
  //       name: "Ancient Tumble",
  //     },
  //     // EpicDreams: {
  //     //   href: "/casino/qtechrelaxgaming-epic-dreams",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/EpicDreams.webp",
  //     //   alt: "epic dreams",
  //     //   name: "Epic Dreams",
  //     // },
  //     // SultanSpins: {
  //     //   href: "/casino/qtechrelaxgaming-sultan-spins",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/SultanSpins.webp",
  //     //   alt: "sultan spins",
  //     //   name: "Sultan Spins",
  //     // },
  //     // QuackinReels: {
  //     //   href: "/casino/qtechrelaxgaming-quackin-reels",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/QuackinReels.webp",
  //     //   alt: "quackin reels",
  //     //   name: "Quackin' Reels",
  //     // },
  //     // FeatherFury: {
  //     //   href: "/casino/qtechrelaxgaming-feather-fury",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/FeatherFury.webp",
  //     //   alt: "feather fury",
  //     //   name: "Feather Fury",
  //     // },
  //     // MoneySleigh: {
  //     //   href: "/casino/qtechrelaxgaming-money-sleigh",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/MoneySleigh.webp",
  //     //   alt: "money sleigh",
  //     //   name: "Money Sleigh",
  //     // },
  //     // WinterChampions: {
  //     //   href: "/casino/qtechrelaxgaming-winter-champions",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/WinterChampions.webp",
  //     //   alt: "winter champions",
  //     //   name: "Winter Champions",
  //     // },
  //     // Immortal5: {
  //     //   href: "/casino/qtechrelaxgaming-immortal-5",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/Immortal5.webp",
  //     //   alt: "immortal 5",
  //     //   name: "Immortal 5",
  //     // },
  //     // KrakensCove: {
  //     //   href: "/casino/qtechrelaxgaming-krakens-cove",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/KrakensCove.webp",
  //     //   alt: "krakens cove",
  //     //   name: "Kraken's Cove",
  //     // },
  //     // CamelotCash: {
  //     //   href: "/casino/qtechrelaxgaming-camelot-cash",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "WorldCasino",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/CamelotCash.webp",
  //     //   alt: "camelot cash",
  //     //   name: "Camelot Cash",
  //     // },
  //     // GiantsAndSheep: {
  //     //   href: "/casino/qtechrelaxgaming-giants-and-sheep",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "QTECH",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/GiantsAndSheep.webp",
  //     //   alt: "giants and sheep",
  //     //   name: "Giants & Sheep",
  //     // },
  //     // GlyphOfGods: {
  //     //   href: "/casino/qtechrelaxgaming-glyph-of-gods",
  //     //   code: "",
  //     //   casino: "Relax Gaming",
  //     //   provider: "QTECH",
  //     //   category: "relaxGaming",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/relax-gaming/GlyphofGods.webp",
  //     //   alt: "glyph of gods",
  //     //   name: "Glyph of Gods",
  //     // },
  //   },
  // },

  habanero: {
    habanero: {
      FruityMayan: {
        href: "/casino/qt-fruity-mayan",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FruityMayan.webp",
        alt: "Fruity Mayan",
        name: "Fruity Mayan",
      },
      SantasInn: {
        href: "/casino/qt-santas-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SantasInn.webp",
        alt: "Santa's Inn",
        name: "Santa's Inn",
      },
      ZeusDeluxe: {
        href: "/casino/qt-zeus-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ZeusDeluxe.webp",
        alt: "Zeus Deluxe",
        name: "Zeus Deluxe",
      },
      FruityHalloween: {
        href: "/casino/qt-fruity-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FruityHalloween.webp",
        alt: "Fruity Halloween",
        name: "Fruity Halloween",
      },
      SlimeParty: {
        href: "/casino/qt-slime-party",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SlimeParty.webp",
        alt: "Slime Party",
        name: "Slime Party",
      },
      MeowJanken: {
        href: "/casino/qt-meow-janken",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MeowJanken.webp",
        alt: "Meow Janken",
        name: "Meow Janken",
      },
      BikiniIslandDeluxe: {
        href: "/casino/qt-bikini-island-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BikiniIslandDeluxe.webp",
        alt: "Bikini Island Deluxe",
        name: "Bikini Island Deluxe",
      },
      AtomicKittens: {
        href: "/casino/qt-atomic-kittens",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/AtomicKittens.webp",
        alt: "Atomic Kittens",
        name: "Atomic Kittens",
      },
      WitchesTome: {
        href: "/casino/qt-witches-tome",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WitchesTome.webp",
        alt: "Witches Tome",
        name: "Witches Tome",
      },
      LegendOfNezha: {
        href: "/casino/qt-legend-of-nezha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LegendOfNezha.webp",
        alt: "Legend Of Nezha",
        name: "Legend Of Nezha",
      },
      TootyFruityFruits: {
        href: "/casino/qt-tooty-fruity-fruits",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TootyFruityFruits.webp",
        alt: "Tooty Fruity Fruits",
        name: "Tooty Fruity Fruits",
      },
      SirensSpell: {
        href: "/casino/qt-sirenaeurotms-spell",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SirensSpell.webp",
        alt: "Siren’s Spell",
        name: "Siren’s Spell",
      },
      Crystopia: {
        href: "/casino/qt-crystopia",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Crystopia.webp",
        alt: "Crystopia",
        name: "Crystopia",
      },
      Mariachis5: {
        href: "/casino/qt-5-mariachis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/5Mariachis.webp",
        alt: "5 Mariachis",
        name: "5 Mariachis",
      },
      Lucky5Lions: {
        href: "/casino/qt-5-lucky-lions",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/5LuckyLions.webp",
        alt: "5 Lucky Lions",
        name: "5 Lucky Lions",
      },
      Zodiacs12: {
        href: "/casino/qt-12-zodiacs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/12Zodiacs.webp",
        alt: "12 Zodiacs",
        name: "12 Zodiacs",
      },
      ArcaneElements: {
        href: "/casino/qt-arcane-elements",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ArcaneElements.webp",
        alt: "Arcane Elements",
        name: "Arcane Elements",
      },
      BeforeTimeRunsOut: {
        href: "/casino/qt-before-time-runs-out",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BeforeTimeRunsOut.webp",
        alt: "Before Time Runs Out",
        name: "Before Time Runs Out",
      },
      BirdOfThunder: {
        href: "/casino/qt-bird-of-thunder",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BirdofThunder.webp",
        alt: "Bird of Thunder",
        name: "Bird of Thunder",
      },
      BombRunner: {
        href: "/casino/qt-bomb-runner",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BombRunner.webp",
        alt: "Bomb Runner",
        name: "Bomb Runner",
      },
      BombsAway: {
        href: "/casino/qt-bombs-away",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BombsAway.webp",
        alt: "Bombs Away",
        name: "Bombs Away",
      },
      CalaverasExplosivas: {
        href: "/casino/qt-calaveras-explosivas",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CalaverasExplosivas.webp",
        alt: "Calaveras Explosivas",
        name: "Calaveras Explosivas",
      },
      CakeValley: {
        href: "/casino/qt-cake-valley",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CakeValley.webp",
        alt: "Cake Valley",
        name: "Cake Valley",
      },
      CandyTower: {
        href: "/casino/qt-candy-tower",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CandyTower.webp",
        alt: "Candy Tower",
        name: "Candy Tower",
      },
      ChristmasGiftRush: {
        href: "/casino/qt-christmas-gift-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ChristmasGiftRush.webp",
        alt: "Christmas Gift Rush",
        name: "Christmas Gift Rush",
      },
      ColossalGems: {
        href: "/casino/qt-colossal-gems",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ColossalGems.webp",
        alt: "Colossal Gems",
        name: "Colossal Gems",
      },
      CoyoteCrash: {
        href: "/casino/qt-coyote-crash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CoyoteCrash.webp",
        alt: "Coyote Crash",
        name: "Coyote Crash",
      },
      DiscoBeats: {
        href: "/casino/qt-disco-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DiscoBeats.webp",
        alt: "Disco Beats",
        name: "Disco Beats",
      },
      DragonCastle: {
        href: "/casino/qt-dragon-castle",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonCastle.webp",
        alt: "Dragon Castle",
        name: "Dragon Castle",
      },
      DragonsRealm: {
        href: "/casino/qt-dragons-realm",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonsRealm.webp",
        alt: "Dragon's Realm",
        name: "Dragon's Realm",
      },
      DragonsThrone: {
        href: "/casino/qt-dragons-throne",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonsThrone.webp",
        alt: "Dragon’s Throne",
        name: "Dragon’s Throne",
      },
      DragonTigerGate: {
        href: "/casino/qt-dragon-tiger-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonTigerGate.webp",
        alt: "Dragon Tiger Gate",
        name: "Dragon Tiger Gate",
      },
      EgyptianDreamsDeluxe: {
        href: "/casino/qt-egyptian-dreams-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/EgyptianDreamsDeluxe.webp",
        alt: "Egyptian Dreams Deluxe",
        name: "Egyptian Dreams Deluxe",
      },
      FaCaiShen: {
        href: "/casino/qt-fa-cai-shen",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FaCaiShen.webp",
        alt: "Fa Cai Shen",
        name: "Fa Cai Shen",
      },
      FaCaiShenDeluxe: {
        href: "/casino/qt-fa-cai-shen-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FaCaiShenDeluxe.webp",
        alt: "Fa Cai Shen Deluxe",
        name: "Fa Cai Shen Deluxe",
      },
      Fenghuang: {
        href: "/casino/qt-fenghuang",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Fenghuang.webp",
        alt: "Fenghuang",
        name: "Fenghuang",
      },
      FireRooster: {
        href: "/casino/qt-fire-rooster",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FireRooster.webp",
        alt: "Fire Rooster",
        name: "Fire Rooster",
      },
      Fly: {
        href: "/casino/qt-fly-jet",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Fly.webp",
        alt: "Fly",
        name: "Fly",
      },
      FortuneDogs: {
        href: "/casino/qt-fortune-dogs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FortuneDogs.webp",
        alt: "Fortune Dogs",
        name: "Fortune Dogs",
      },
      FourDivineBeasts: {
        href: "/casino/qt-four-divine-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/FourDivineBeasts.webp",
        alt: "Four Divine Beasts",
        name: "Four Divine Beasts",
      },
      Gangsters: {
        href: "/casino/qt-gangsters",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Gangsters.webp",
        alt: "Gangsters",
        name: "Gangsters",
      },
      GoldenUnicornDeluxe: {
        href: "/casino/qt-golden-unicorn-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldenUnicornDeluxe.webp",
        alt: "Golden Unicorn Deluxe",
        name: "Golden Unicorn Deluxe",
      },
      GoldRush: {
        href: "/casino/qt-gold-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldRush.webp",
        alt: "Gold Rush",
        name: "Gold Rush",
      },
      HappiestChristmasTree: {
        href: "/casino/qt-happiest-christmas-tree",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HappiestChristmasTree.webp",
        alt: "Happiest Christmas Tree",
        name: "Happiest Christmas Tree",
      },
      HappyApe: {
        href: "/casino/qt-happy-ape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HappyApe.webp",
        alt: "Happy Ape",
        name: "Happy Ape",
      },
      HeySushi: {
        href: "/casino/qt-hey-sushi",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HeySushi.webp",
        alt: "Hey Sushi",
        name: "Hey Sushi",
      },
      HotHotFruit: {
        href: "/casino/qt-hot-hot-fruit",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotFruit.webp",
        alt: "Hot Hot Fruit",
        name: "Hot Hot Fruit",
      },
      HotHotHalloween: {
        href: "/casino/qt-hot-hot-halloween",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotHalloween.webp",
        alt: "Hot Hot Halloween",
        name: "Hot Hot Halloween",
      },
      IndianCashCatcher: {
        href: "/casino/qt-indian-cash-catcher",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/IndianCashCatcher.webp",
        alt: "Indian Cash Catcher",
        name: "Indian Cash Catcher",
      },
      JellyfishFlow: {
        href: "/casino/qt-jellyfish-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/JellyfishFlow.webp",
        alt: "Jellyfish Flow",
        name: "Jellyfish Flow",
      },
      JellyFishFlowUltra: {
        href: "/casino/qt-jellyfish-flow-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/JellyFishFlowUltra.webp",
        alt: "JellyFish Flow Ultra",
        name: "JellyFish Flow Ultra",
      },
      Jugglenaut: {
        href: "/casino/qt-jugglenaut",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Jugglenaut.webp",
        alt: "Jugglenaut",
        name: "Jugglenaut",
      },
      Jump: {
        href: "/casino/qt-jump",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Jump.webp",
        alt: "Jump",
        name: "Jump",
      },
      KnockoutFootball: {
        href: "/casino/qt-knockout-football",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KnockoutFootball.webp",
        alt: "Knockout Football",
        name: "Knockout Football",
      },
      KnockoutFootballRush: {
        href: "/casino/qt-knockout-football-rush",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KnockoutFootballRush.webp",
        alt: "Knockout Football Rush",
        name: "Knockout Football Rush",
      },
      KoiGate: {
        href: "/casino/qt-koi-gate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KoiGate.webp",
        alt: "Koi Gate",
        name: "Koi Gate",
      },
      LanternLuck: {
        href: "/casino/qt-lantern-luck",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LanternLuck.webp",
        alt: "Lantern Luck",
        name: "Lantern Luck",
      },
      LaughingBuddha: {
        href: "/casino/qt-laughing-buddha",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LaughingBuddha.webp",
        alt: "Laughing Buddha",
        name: "Laughing Buddha",
      },
      LegendaryBeasts: {
        href: "/casino/qt-legendary-beasts",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LegendaryBeasts.webp",
        alt: "Legendary Beasts",
        name: "Legendary Beasts",
      },
      LondonHunter: {
        href: "/casino/qt-london-hunter",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LondonHunter.webp",
        alt: "London Hunter",
        name: "London Hunter",
      },
      LoonyBlox: {
        href: "/casino/qt-loony-blox",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LoonyBlox.webp",
        alt: "Loony Blox",
        name: "Loony Blox",
      },
      LuckyDurian: {
        href: "/casino/qt-lucky-durian",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyDurian.webp",
        alt: "Lucky Durian",
        name: "Lucky Durian",
      },
      LuckyFortuneCat: {
        href: "/casino/qt-lucky-fortune-cat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyFortuneCat.webp",
        alt: "Lucky Fortune Cat",
        name: "Lucky Fortune Cat",
      },
      LuckyLucky: {
        href: "/casino/qt-lucky-lucky",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/LuckyLucky.webp",
        alt: "Lucky Lucky",
        name: "Lucky Lucky",
      },
      MagicOak: {
        href: "/casino/qt-magic-oak",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MagicOak.webp",
        alt: "Magic Oak",
        name: "Magic Oak",
      },
      MarvelousFurlongs: {
        href: "/casino/qt-marvelous-furlongs",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MarvelousFurlongs.webp",
        alt: "Marvelous Furlongs",
        name: "Marvelous Furlongs",
      },
      MightyMedusa: {
        href: "/casino/qt-mighty-medusa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MightyMedusa.webp",
        alt: "Mighty Medusa",
        name: "Mighty Medusa",
      },
      MonsterMashCash: {
        href: "/casino/qt-monster-mash-cash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MonsterMashCash.webp",
        alt: "Monster Mash Cash",
        name: "Monster Mash Cash",
      },
      MountMazuma: {
        href: "/casino/qt-mount-mazuma",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MountMazuma.webp",
        alt: "Mount Mazuma",
        name: "Mount Mazuma",
      },
      MysticFortune: {
        href: "/casino/qt-mystic-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MysticFortune.webp",
        alt: "Mystic Fortune",
        name: "Mystic Fortune",
      },
      MysticFortuneDeluxe: {
        href: "/casino/qt-mystic-fortune-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MysticFortuneDeluxe.webp",
        alt: "Mystic Fortune Deluxe",
        name: "Mystic Fortune Deluxe",
      },
      NaughtySanta: {
        href: "/casino/qt-naughty-santa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NaughtySanta.webp",
        alt: "Naughty Santa",
        name: "Naughty Santa",
      },
      NaughtyWukong: {
        href: "/casino/qt-naughty-wukong",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NaughtyWukong.webp",
        alt: "Naughty Wukong",
        name: "Naughty Wukong",
      },
      NewYearsBash: {
        href: "/casino/qt-new-years-bash",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NewYearsBash.webp",
        alt: "New Year's Bash",
        name: "New Year's Bash",
      },
      NineTails: {
        href: "/casino/qt-nine-tails",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/NineTails.webp",
        alt: "Nine Tails",
        name: "Nine Tails",
      },
      Nuwa: {
        href: "/casino/qt-nuwa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Nuwa.webp",
        alt: "Nuwa",
        name: "Nuwa",
      },
      OrbsOfAtlantis: {
        href: "/casino/qt-orbs-of-atlantis",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/OrbsOfAtlantis.webp",
        alt: "Orbs Of Atlantis",
        name: "Orbs Of Atlantis",
      },
      OceansCall: {
        href: "/casino/qt-oceans-call",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/OceansCall.webp",
        alt: "Ocean's Call",
        name: "Ocean's Call",
      },
      PandaPanda: {
        href: "/casino/qt-panda-panda",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PandaPanda.webp",
        alt: "Panda Panda",
        name: "Panda Panda",
      },
      PoolShark: {
        href: "/casino/qt-pool-shark",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PoolShark.webp",
        alt: "Pool Shark",
        name: "Pool Shark",
      },
      Presto: {
        href: "/casino/qt-presto",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Presto.webp",
        alt: "Presto",
        name: "Presto",
      },
      Prost: {
        href: "/casino/qt-prost",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Prost.webp",
        alt: "Prost",
        name: "Prost",
      },
      PuckerUpPrince: {
        href: "/casino/qt-pucker-up-prince",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PuckerUpPrince.webp",
        alt: "Pucker Up Prince",
        name: "Pucker Up Prince",
      },
      PumpkinPatch: {
        href: "/casino/qt-pumpkin-patch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/PumpkinPatch.webp",
        alt: "Pumpkin Patch",
        name: "Pumpkin Patch",
      },
      RainbowMania: {
        href: "/casino/qt-rainbow-mania",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RainbowMania.webp",
        alt: "Rainbow Mania",
        name: "Rainbow Mania",
      },
      ReturnToTheFeature: {
        href: "/casino/qt-return-to-the-feature",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ReturnToTheFeature.webp",
        alt: "Return To The Feature",
        name: "Return To The Feature",
      },
      RollingRoger: {
        href: "/casino/qt-rolling-roger",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RollingRoger.webp",
        alt: "Rolling Roger",
        name: "Rolling Roger",
      },
      RomanEmpire: {
        href: "/casino/qt-roman-empire",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RomanEmpire.webp",
        alt: "Roman Empire",
        name: "Roman Empire",
      },
      RuffledUp: {
        href: "/casino/qt-ruffled-up",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/RuffledUp.webp",
        alt: "Ruffled Up",
        name: "Ruffled Up",
      },
      SantasVillage: {
        href: "/casino/qt-santas-village",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SantasVillage.webp",
        alt: "Santa’s Village",
        name: "Santa’s Village",
      },
      Scopa: {
        href: "/casino/qt-scopa",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Scopa.webp",
        alt: "Scopa",
        name: "Scopa",
      },
      ScruffyScallywags: {
        href: "/casino/qt-scruffy-scallywags",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ScruffyScallywags.webp",
        alt: "Scruffy Scallywags",
        name: "Scruffy Scallywags",
      },
      ShaolinFortunes: {
        href: "/casino/qt-shaolin-fortunes",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ShaolinFortunes.webp",
        alt: "Shaolin Fortunes",
        name: "Shaolin Fortunes",
      },
      SojuBomb: {
        href: "/casino/qt-soju-bomb",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SojuBomb.webp",
        alt: "Soju Bomb",
        name: "Soju Bomb",
      },
      SOS: {
        href: "/casino/qt-sos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SOS.webp",
        alt: "S.O.S!",
        name: "S.O.S!",
      },
      SpaceGoonz: {
        href: "/casino/qt-space-goonz",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SpaceGoonz.webp",
        alt: "Space Goonz",
        name: "Space Goonz",
      },
      Sparta: {
        href: "/casino/qt-sparta",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Sparta.webp",
        alt: "Sparta",
        name: "Sparta",
      },
      SuperStrike: {
        href: "/casino/qt-super-strike",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SuperStrike.webp",
        alt: "Super Strike",
        name: "Super Strike",
      },
      SuperTwister: {
        href: "/casino/qt-super-twister",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/SuperTwister.webp",
        alt: "Super Twister",
        name: "Super Twister",
      },
      TabernaDeLosMuertos: {
        href: "/casino/qt-taberna-de-los-muertos",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TabernaDeLosMuertos.webp",
        alt: "Taberna De Los Muertos",
        name: "Taberna De Los Muertos",
      },
      TabernaDeLosMuertosUltra: {
        href: "/casino/qt-taberna-de-los-muertos-ultra",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TabernaDeLosMuertosUltra.webp",
        alt: "Taberna De Los Muertos Ultra",
        name: "Taberna De Los Muertos Ultra",
      },
      TaikoBeats: {
        href: "/casino/qt-taiko-beats",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TaikoBeats.webp",
        alt: "Taiko Beats",
        name: "Taiko Beats",
      },
      TechnoTumble: {
        href: "/casino/qt-techno-tumble",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TechnoTumble.webp",
        alt: "Techno Tumble",
        name: "Techno Tumble",
      },
      TheBigDealDeluxe: {
        href: "/casino/qt-the-big-deal-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TheBigDealDeluxe.webp",
        alt: "The Big Deal Deluxe",
        name: "The Big Deal Deluxe",
      },
      TheDeadEscape: {
        href: "/casino/qt-the-dead-escape",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TheDeadEscape.webp",
        alt: "The Dead Escape",
        name: "The Dead Escape",
      },
      TotemTowers: {
        href: "/casino/qt-totem-towers",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TotemTowers.webp",
        alt: "Totem Towers",
        name: "Totem Towers",
      },
      TukTukThailand: {
        href: "/casino/qt-tuk-tuk-thailand",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TukTukThailand.webp",
        alt: "Tuk Tuk Thailand",
        name: "Tuk Tuk Thailand",
      },
      WaysOfFortune: {
        href: "/casino/qt-ways-of-fortune",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WaysOfFortune.webp",
        alt: "Ways Of Fortune",
        name: "Ways Of Fortune",
      },
      WealthInn: {
        href: "/casino/qt-wealth-inn",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WealthInn.webp",
        alt: "Wealth Inn",
        name: "Wealth Inn",
      },
      WickedWitch: {
        href: "/casino/qt-wicked-witch",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WickedWitch.webp",
        alt: "Wicked Witch",
        name: "Wicked Witch",
      },
      WildTrucks: {
        href: "/casino/qt-wild-trucks",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WildTrucks.webp",
        alt: "Wild Trucks",
        name: "Wild Trucks",
      },
      WizardsWantWar: {
        href: "/casino/qt-wizards-want-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WizardsWantWar.webp",
        alt: "Wizards Want War",
        name: "Wizards Want War",
      },
      Zeus: {
        href: "/casino/qt-zeus",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Zeus.webp",
        alt: "Zeus",
        name: "Zeus",
      },
      Hand3Blackjack: {
        href: "/casino/qt-3-hand-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/3HandBlackjack.webp",
        alt: "3 Hand Blackjack",
        name: "3 Hand Blackjack",
      },
      Hand3BlackjackDoubleExposure: {
        href: "/casino/qt-3-hand-blackjack-double-exposure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/3HandBlackjackDoubleExposure.webp",
        alt: "3 Hand Blackjack Double Exposure",
        name: "3 Hand Blackjack Double Exposure",
      },
      AmericanBlackjack: {
        href: "/casino/qt-american-blackjack",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/AmericanBlackjack.webp",
        alt: "American Blackjack",
        name: "American Blackjack",
      },
      Baccarat: {
        href: "/casino/qt-baccarat",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Baccarat.webp",
        alt: "Baccarat",
        name: "Baccarat",
      },
      BaccaratZeroCommission: {
        href: "/casino/qt-baccarat-zero-commission",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/BaccaratZeroCommission.webp",
        alt: "Baccarat Zero Commission",
        name: "Baccarat Zero Commission",
      },
      CaribbeanHoldem: {
        href: "/casino/qt-caribbean-holdem",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CaribbeanHoldem.webp",
        alt: "Caribbean Holdem",
        name: "Caribbean Holdem",
      },
      CaribbeanStud: {
        href: "/casino/qt-caribbean-stud",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/CaribbeanStud.webp",
        alt: "Caribbean Stud",
        name: "Caribbean Stud",
      },
      DragonTiger: {
        href: "/casino/qt-dragon-tiger",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/DragonTiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      EuropeanRoulette: {
        href: "/casino/qt-european-roulette",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/EuropeanRoulette.webp",
        alt: "European Roulette",
        name: "European Roulette",
      },
      SicBo: {
        href: "/casino/qt-sic-bo",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Sicbo.webp",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
      ThreeCardPoker: {
        href: "/casino/qt-three-card-poker",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ThreeCardPoker.webp",
        alt: "Three Card Poker",
        name: "Three Card Poker",
      },
      ThreeCardPokerDeluxe: {
        href: "/casino/qt-three-card-poker-deluxe",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ThreeCardPokerDeluxe.webp",
        alt: "Three Card Poker Deluxe",
        name: "Three Card Poker Deluxe",
      },
      War: {
        href: "/casino/qt-war",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/War.webp",
        alt: "War",
        name: "War",
      },
      ValentineMonchy: {
        href: "/casino/qt-valentine-monchy",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ValentineMonchy.webp",
        alt: "Valentine Monchy",
        name: "Valentine Monchy",
      },
      HotHotSummer: {
        href: "/casino/qt-hot-hot-summer",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/HotHotSummer.webp",
        alt: "Hot Hot Summer",
        name: "Hot Hot Summer",
      },
      // HauntedHarbor: {
      //   href: "/casino/aggaphabanero-haunted-harbor",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/HauntedHarbor.webp",
      //   alt: "Haunted Harbor",
      //   name: "Haunted Harbor",
      // },
      // GloryOfRome: {
      //   href: "/casino/aggaphabanero-glory-of-rome",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "habanero",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/GloryofRome.webp",
      //   alt: "Glory of Rome",
      //   name: "Glory of Rome",
      // },
      KoiKoiTreasure: {
        href: "/casino/qt-koi-koi-treasure",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/KoiKoiTreasure.webp",
        alt: "Koi-Koi Treasure",
        name: "Koi-Koi Treasure",
      },
      WaltzBeauty: {
        href: "/casino/qt-waltz-beauty",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WaltzBeauty.webp",
        alt: "Waltz Beauty",
        name: "Waltz Beauty",
      },
      TotemWarrior: {
        href: "/casino/qt-totem-warrior",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/TotemWarrior.webp",
        alt: "Totem Warrior",
        name: "Totem Warrior",
      },
      ArcticHunt: {
        href: "/casino/qt-arctic-hunt",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/ArcticHunt.webp",
        alt: "Arctic Hunt",
        name: "Arctic Hunt",
      },
      MooMooCow: {
        href: "/casino/qt-moo-moo-cow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/MooMooCow.webp",
        alt: "Moo Moo Cow",
        name: "Moo Moo Cow",
      },
      GoldenTajMahal: {
        href: "/casino/qt-golden-taj-mahal",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/GoldenTajMahal.webp",
        alt: "Golden Taj Mahal",
        name: "Golden Taj Mahal",
      },
      WildFlow: {
        href: "/casino/qt-wild-flow",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/WildFlow.webp",
        alt: "Wild Flow",
        name: "Wild Flow",
      },
      VampiresFate: {
        href: "/casino/qt-vampires-fate",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/VampiresFate.webp",
        alt: "Vampire's Fate",
        name: "Vampire's Fate",
      },
      Jump2: {
        href: "/casino/qt-jump-high-2",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Jump2.webp",
        alt: "Jump! 2",
        name: "Jump! 2",
      },
      Poseidon: {
        href: "/casino/qt-poseidon",
        code: "",
        casino: "Habanero",
        provider: "WorldCasino",
        category: "habanero",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/habanero/Poseidon.webp",
        alt: "Poseidon",
        name: "Poseidon",
      },
      // BabaYaga: {
      //   href: "/casino/aggaphabanero-baba-yaga",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/BabaYaga.webp",
      //   alt: "Baba Yaga",
      //   name: "Baba Yaga",
      // },
      // CarnivalCove: {
      //   href: "/casino/aggaphabanero-carnival-cove",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/CarnivalCove.webp",
      //   alt: "Carnival Cove",
      //   name: "Carnival Cove",
      // },
      // HyperHues: {
      //   href: "/casino/aggaphabanero-hyper-hues",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/HyperHues.webp",
      //   alt: "Hyper Hues",
      //   name: "Hyper Hues",
      // },
      // JapaneseMask: {
      //   href: "/casino/aggaphabanero-japanese-mask",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/JapaneseMask.webp",
      //   alt: "Japanese Mask",
      //   name: "Japanese Mask",
      // },
      // ShamrockQuest: {
      //   href: "/casino/aggaphabanero-shamrock-quest",
      //   code: "",
      //   casino: "Habanero",
      //   provider: "WorldCasino",
      //   category: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/habanero/ShamrockQuest.webp",
      //   alt: "Shamrock Quest",
      //   name: "Shamrock Quest",
      // },
    },
  },

  dragoonSoft: {
    dragoonSoft: {
      // Phoenix: {
      //   href: "/casino/aggapdrgs-phoenix",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Phoenix1.webp",
      //   alt: "Phoenix",
      //   name: "Phoenix",
      // },
      // GetMoney: {
      //   href: "/casino/aggapdrgs-get-money",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GetMoney.webp",
      //   alt: "Get Money",
      //   name: "Get Money",
      // },
      // CoinCat: {
      //   href: "/casino/aggapdrgs-coin-cat",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CoinCat.webp",
      //   alt: "Coin Cat",
      //   name: "Coin Cat",
      // },
      // AceyDeucey: {
      //   href: "/casino/aggapdrgs-acey-deucey",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/AceyDeucey.webp",
      //   alt: "Acey Deucey",
      //   name: "Acey Deucey",
      // },
      // DragonOrCrash: {
      //   href: "/casino/aggapdrgs-dragon-or-crash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DragonOrCrash.webp",
      //   alt: "Dragon or Crash",
      //   name: "Dragon or Crash",
      // },
      // FlyingPhoenix: {
      //   href: "/casino/aggapdrgs-flying-phoenix",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/FlyingPhoenix.webp",
      //   alt: "Flying Phoenix",
      //   name: "Flying Phoenix",
      // },
      // JumpAndJump: {
      //   href: "/casino/aggapdrgs-jump-and-jump",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/JumpAndJump.webp",
      //   alt: "Jump & Jump",
      //   name: "Jump & Jump",
      // },
      // LadderGame: {
      //   href: "/casino/aggapdrgs-ladder-game",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/LadderGame.webp",
      //   alt: "Ladder Game",
      //   name: "Ladder Game",
      // },
      // LetsEnhance: {
      //   href: "/casino/aggapdrgs-lets-enhance",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/LetsEnhance.webp",
      //   alt: "Let's Enhance",
      //   name: "Let's Enhance",
      // },
      // LionsOrb: {
      //   href: "/casino/qtechdragoonsoft-lions-orb",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/LionsOrb.webp",
      //   alt: "Lion's Orb",
      //   name: "Lion's Orb",
      // },
      // NinjaFishing: {
      //   href: "/casino/qtechdragoonsoft-ninja-fishing",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/NinjaFishing.webp",
      //   alt: "Ninja Fishing",
      //   name: "Ninja Fishing",
      // },
      // WonderfulChristmas: {
      //   href: "/casino/qtechdragoonsoft-wonderful-christmas",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/WonderfulChristmas.webp",
      //   alt: "Wonderful Christmas",
      //   name: "Wonderful Christmas",
      // },
      // Golf2: {
      //   href: "/casino/qtechdragoonsoft-golf-2",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Golf2.webp",
      //   alt: "Golf 2",
      //   name: "Golf 2",
      // },
      // DessertParty: {
      //   href: "/casino/qtechdragoonsoft-dessert-party",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Dessertparty.webp",
      //   alt: "Dessert Party",
      //   name: "Dessert Party",
      // },
      // PartyNight: {
      //   href: "/casino/qtechdragoonsoft-party-night",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/PartyNight.webp",
      //   alt: "Party Night",
      //   name: "Party Night",
      // },
      // KingsSword: {
      //   href: "/casino/qtechdragoonsoft-kings-sword",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/KingsSword.webp",
      //   alt: "King's Sword",
      //   name: "King's Sword",
      // },
      // CatFishing: {
      //   href: "/casino/aggapdrgs-cat-fishing",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CatFishing.webp",
      //   alt: "Cat Fishing",
      //   name: "Cat Fishing",
      // },
      // OverlordAndConcubine: {
      //   href: "/casino/aggapdrgs-overlord-and-concubine",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/OverlordAndConcubine.webp",
      //   alt: "Overlord & Concubine",
      //   name: "Overlord & Concubine",
      // },
      // Gods3Fishing: {
      //   href: "/casino/aggapdrgs-3-gods-fishing",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/3GodsFishing.webp",
      //   alt: "3 Gods Fishing",
      //   name: "3 Gods Fishing",
      // },
      // BigHammer: {
      //   href: "/casino/aggapdrgs-big-hammer",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BigHammer.webp",
      //   alt: "Big Hammer",
      //   name: "Big Hammer",
      // },
      // BingoFishing: {
      //   href: "/casino/aggapdrgs-bingo-fishing",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BingoFishing.webp",
      //   alt: "Bingo Fishing",
      //   name: "Bingo Fishing",
      // },
      // CrazyOrb: {
      //   href: "/casino/aggapdrgs-crazy-orb",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CrazyOrb.webp",
      //   alt: "Crazy Orb",
      //   name: "Crazy Orb",
      // },
      // DemonConquered: {
      //   href: "/casino/aggapdrgs-demon-conquered",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DemonConquered.webp",
      //   alt: "Demon Conquered",
      //   name: "Demon Conquered",
      // },
      // DinoHunter: {
      //   href: "/casino/aggapdrgs-dino-hunter",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DinoHunter.webp",
      //   alt: "Dino Hunter",
      //   name: "Dino Hunter",
      // },
      // GodsSlashFish: {
      //   href: "/casino/aggapdrgs-gods-slash-fish",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GodsSlashFish.webp",
      //   alt: "Gods Slash Fish",
      //   name: "Gods Slash Fish",
      // },
      // GoldenZuma: {
      //   href: "/casino/aggapdrgs-golden-zuma",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GoldenZuma.webp",
      //   alt: "Golden Zuma",
      //   name: "Golden Zuma",
      // },
      // LetsShoot: {
      //   href: "/casino/aggapdrgs-lets-shoot",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/LetsShoot.webp",
      //   alt: "Let's Shoot",
      //   name: "Let's Shoot",
      // },
      // OceanLord: {
      //   href: "/casino/aggapdrgs-ocean-lord",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/OceanLord.webp",
      //   alt: "Ocean Lord",
      //   name: "Ocean Lord",
      // },
      // PlantsVsDinos: {
      //   href: "/casino/aggapdrgs-plants-vs-dinos",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/PlantsVsDinos.webp",
      //   alt: "Plants vs. Dinos",
      //   name: "Plants vs. Dinos",
      // },
      // God5Beast: {
      //   href: "/casino/aggapdrgs-5-god-beast",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/5GodBeast.webp",
      //   alt: "5 God Beast",
      //   name: "5 God Beast",
      // },
      // 777: {
      //   href: "/casino/aggapdrgs-777",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/777.webp",
      //   alt: "777",
      //   name: "777",
      // },
      // Alice: {
      //   href: "/casino/aggapdrgs-alice",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Alice.webp",
      //   alt: "Alice",
      //   name: "Alice",
      // },
      // Arab: {
      //   href: "/casino/aggapdrgs-arab",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Arab.webp",
      //   alt: "Arab",
      //   name: "Arab",
      // },
      // BakufuShogun: {
      //   href: "/casino/aggapdrgs-bakufu-shogun",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BakufuShogun.webp",
      //   alt: "Bakufu Shogun",
      //   name: "Bakufu Shogun",
      // },
      // BengalTiger: {
      //   href: "/casino/aggapdrgs-bengal-tiger",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BengalTiger.webp",
      //   alt: "Bengal Tiger",
      //   name: "Bengal Tiger",
      // },
      // BigDiamond: {
      //   href: "/casino/aggapdrgs-big-diamond",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BigDiamond.webp",
      //   alt: "Big Diamond",
      //   name: "Big Diamond",
      // },
      // BonusCat: {
      //   href: "/casino/aggapdrgs-bonus-cat",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BonusCat.webp",
      //   alt: "Bonus Cat",
      //   name: "Bonus Cat",
      // },
      // BoomingGems: {
      //   href: "/casino/aggapdrgs-booming-gems",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BoomingGems.webp",
      //   alt: "Booming Gems",
      //   name: "Booming Gems",
      // },
      // BuffaloBurst: {
      //   href: "/casino/aggapdrgs-buffalo-burst",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BuffaloBurst.webp",
      //   alt: "Buffalo Burst",
      //   name: "Buffalo Burst",
      // },
      // BustTreasury: {
      //   href: "/casino/aggapdrgs-bust-treasury",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/BustTreasury.webp",
      //   alt: "Bust Treasury",
      //   name: "Bust Treasury",
      // },
      // CaishenComing: {
      //   href: "/casino/aggapdrgs-caishen-coming",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CaishenComing.webp",
      //   alt: "Caishen Coming",
      //   name: "Caishen Coming",
      // },
      // CandyDynasty: {
      //   href: "/casino/aggapdrgs-candy-dynasty",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CandyDynasty.webp",
      //   alt: "Candy Dynasty",
      //   name: "Candy Dynasty",
      // },
      // ChefLady: {
      //   href: "/casino/aggapdrgs-chef-lady",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/ChefLady.webp",
      //   alt: "Chef Lady",
      //   name: "Chef Lady",
      // },
      // CoinRat: {
      //   href: "/casino/aggapdrgs-coin-rat",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CoinRat.webp",
      //   alt: "Coin Rat",
      //   name: "Coin Rat",
      // },
      // CrystalFruits: {
      //   href: "/casino/aggapdrgs-crystal-fruits",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CrystalFruits.webp",
      //   alt: "Crystal Fruits",
      //   name: "Crystal Fruits",
      // },
      // Diamond7: {
      //   href: "/casino/aggapdrgs-diamond-7",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Diamond7.webp",
      //   alt: "Diamond 7",
      //   name: "Diamond 7",
      // },
      // DiamondMogul: {
      //   href: "/casino/aggapdrgs-diamond-mogul",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DiamondMogul.webp",
      //   alt: "Diamond Mogul",
      //   name: "Diamond Mogul",
      // },
      // DoggyWealth: {
      //   href: "/casino/aggapdrgs-doggy-wealth",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DoggyWealth.webp",
      //   alt: "Doggy Wealth",
      //   name: "Doggy Wealth",
      // },
      // Dracula: {
      //   href: "/casino/aggapdrgs-dracula",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Dracula.webp",
      //   alt: "Dracula",
      //   name: "Dracula",
      // },
      // Dragonburst: {
      //   href: "/casino/aggapdrgs-dragonburst",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Dragonburst.webp",
      //   alt: "Dragonburst",
      //   name: "Dragonburst",
      // },
      // DragonsTreasure: {
      //   href: "/casino/aggapdrgs-dragons-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DragonsTreasure.webp",
      //   alt: "Dragon's Treasure",
      //   name: "Dragon's Treasure",
      // },
      // EgyptDynasty: {
      //   href: "/casino/aggapdrgs-egypt-dynasty",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/EgyptDynasty.webp",
      //   alt: "Egypt Dynasty",
      //   name: "Egypt Dynasty",
      // },
      // EgyptOracle: {
      //   href: "/casino/aggapdrgs-egypt-oracle",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/EgyptOracle.webp",
      //   alt: "Egypt Oracle",
      //   name: "Egypt Oracle",
      // },
      // FruitsBar: {
      //   href: "/casino/aggapdrgs-fruits-bar",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/FruitsBar.webp",
      //   alt: "Fruits Bar",
      //   name: "Fruits Bar",
      // },
      // FushenComing: {
      //   href: "/casino/aggapdrgs-fushen-coming",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/FushenComing.webp",
      //   alt: "Fushen Coming",
      //   name: "Fushen Coming",
      // },
      // GetHigh: {
      //   href: "/casino/aggapdrgs-get-high",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GetHigh.webp",
      //   alt: "Get High",
      //   name: "Get High",
      // },
      // GiveYouMoney: {
      //   href: "/casino/aggapdrgs-give-you-money",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GiveYouMoney.webp",
      //   alt: "Give You Money",
      //   name: "Give You Money",
      // },
      // Golf: {
      //   href: "/casino/aggapdrgs-golf",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Golf.webp",
      //   alt: "Golf",
      //   name: "Golf",
      // },
      // GrandSheriff: {
      //   href: "/casino/aggapdrgs-grand-sheriff",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GrandSheriff.webp",
      //   alt: "Grand Sheriff",
      //   name: "Grand Sheriff",
      // },
      // GreatLion: {
      //   href: "/casino/aggapdrgs-great-lion",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GreatLion.webp",
      //   alt: "Great Lion",
      //   name: "Great Lion",
      // },
      // GreatestCircus: {
      //   href: "/casino/aggapdrgs-greatest-circus",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GreatestCircus.webp",
      //   alt: "Greatest Circus",
      //   name: "Greatest Circus",
      // },
      // IcyBar: {
      //   href: "/casino/aggapdrgs-icy-bar",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/IcyBar.webp",
      //   alt: "Icy Bar",
      //   name: "Icy Bar",
      // },
      // ImmortalHeroes: {
      //   href: "/casino/aggapdrgs-immortal-heroes",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/ImmortalHeroes.webp",
      //   alt: "Immortal Heroes",
      //   name: "Immortal Heroes",
      // },
      // JinHouYe: {
      //   href: "/casino/aggapdrgs-jin-hou-ye",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/JinHouYe.webp",
      //   alt: "Jin Hou Ye",
      //   name: "Jin Hou Ye",
      // },
      // LuLingQi: {
      //   href: "/casino/aggapdrgs-lu-ling-qi",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/LuLingQi.webp",
      //   alt: "Lu Ling Qi",
      //   name: "Lu Ling Qi",
      // },
      // ManyBeauties: {
      //   href: "/casino/aggapdrgs-many-beauties",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/ManyBeauties.webp",
      //   alt: "Many Beauties",
      //   name: "Many Beauties",
      // },
      // MayaKing: {
      //   href: "/casino/aggapdrgs-maya-king",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MayaKing.webp",
      //   alt: "Maya King",
      //   name: "Maya King",
      // },
      // MidasTouch: {
      //   href: "/casino/aggapdrgs-midas-touch",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MidasTouch.webp",
      //   alt: "Midas Touch",
      //   name: "Midas Touch",
      // },
      // MonkeyKing: {
      //   href: "/casino/aggapdrgs-monkey-king",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MonkeyKing.webp",
      //   alt: "Monkey King",
      //   name: "Monkey King",
      // },
      // OrePower: {
      //   href: "/casino/aggapdrgs-ore-power",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/OrePower.webp",
      //   alt: "Ore Power",
      //   name: "Ore Power",
      // },
      // OverDragonsGate: {
      //   href: "/casino/aggapdrgs-over-dragons-gate",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/OverDragonsGate.webp",
      //   alt: "Over Dragon's Gate",
      //   name: "Over Dragon's Gate",
      // },
      // Pandaria: {
      //   href: "/casino/aggapdrgs-pandaria",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Pandaria.webp",
      //   alt: "Pandaria",
      //   name: "Pandaria",
      // },
      // PirateKing: {
      //   href: "/casino/aggapdrgs-pirate-king",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/PirateKing.webp",
      //   alt: "Pirate King",
      //   name: "Pirate King",
      // },
      // RichDragon: {
      //   href: "/casino/aggapdrgs-rich-dragon",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/RichDragon.webp",
      //   alt: "Rich Dragon",
      //   name: "Rich Dragon",
      // },
      // RichLion: {
      //   href: "/casino/aggapdrgs-rich-lion",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/RichLion.webp",
      //   alt: "Rich Lion",
      //   name: "Rich Lion",
      // },
      // RichNow: {
      //   href: "/casino/aggapdrgs-rich-now",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/RichNow.webp",
      //   alt: "Rich Now",
      //   name: "Rich Now",
      // },
      // RollInMoney: {
      //   href: "/casino/aggapdrgs-roll-in-money",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/RollInMoney.webp",
      //   alt: "Roll in Money",
      //   name: "Roll in Money",
      // },
      // Roman: {
      //   href: "/casino/aggapdrgs-roman",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Roman.webp",
      //   alt: "Roman",
      //   name: "Roman",
      // },
      // StoneHominid: {
      //   href: "/casino/aggapdrgs-stone-hominid",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/StoneHominid.webp",
      //   alt: "Stone Hominid",
      //   name: "Stone Hominid",
      // },
      // TigerLord: {
      //   href: "/casino/aggapdrgs-tiger-lord",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/TigerLord.webp",
      //   alt: "Tiger Lord",
      //   name: "Tiger Lord",
      // },
      // TripleMonkey: {
      //   href: "/casino/aggapdrgs-triple-monkey",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/TripleMonkey.webp",
      //   alt: "Triple Monkey",
      //   name: "Triple Monkey",
      // },
      // TRex: {
      //   href: "/casino/aggapdrgs-t-rex",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/TRex.webp",
      //   alt: "T-Rex",
      //   name: "T-Rex",
      // },
      // UltraTreasure: {
      //   href: "/casino/aggapdrgs-ultra-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/UltraTreasure.webp",
      //   alt: "Ultra Treasure",
      //   name: "Ultra Treasure",
      // },
      // WolfLegend: {
      //   href: "/casino/aggapdrgs-wolf-legend",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/WolfLegend.webp",
      //   alt: "Wolf Legend",
      //   name: "Wolf Legend",
      // },
      // Worldie: {
      //   href: "/casino/aggapdrgs-worldie",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Worldie.webp",
      //   alt: "Worldie",
      //   name: "Worldie",
      // },
      // YouWillWin: {
      //   href: "/casino/aggapdrgs-you-will-win",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/YouWillWin.webp",
      //   alt: "You Will Win",
      //   name: "You Will Win",
      // },
      // Zeus: {
      //   href: "/casino/aggapdrgs-zeus",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/Zeus.webp",
      //   alt: "Zeus",
      //   name: "Zeus",
      // },
      // ZhaoYun: {
      //   href: "/casino/aggapdrgs-zhao-yun",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/ZhaoYun.webp",
      //   alt: "Zhao Yun",
      //   name: "Zhao Yun",
      // },
      // GoldenEgg: {
      //   href: "/casino/aggapdrgs-golden-egg",
      //   code: "",
      //   casino: "Slots",
      //   provider: "ALT_GAMING_GAP",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GoldenEgg.webp",
      //   alt: "Golden Egg",
      //   name: "Golden Egg",
      // },
      // MahjongWin: {
      //   href: "/casino/qtechdragoonsoft-mahjong-win",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MahjongWin.webp",
      //   alt: "Mahjong Win",
      //   name: "Mahjong Win",
      // },
      // SuperHooHeyHow: {
      //   href: "/casino/qtechdragoonsoft-super-hoo-hey-how",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/SuperHooHeyHow.webp",
      //   alt: "Super Hoo Hey How",
      //   name: "Super Hoo Hey How",
      // },
      // MuchRicher: {
      //   href: "/casino/qtechdragoonsoft-much-richer",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MuchRicher.webp",
      //   alt: "Much Richer",
      //   name: "Much Richer",
      // },
      // GoddessOrCrash: {
      //   href: "/casino/qtechdragoonsoft-goddess-or-crash",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/GoddessOrCrash.webp",
      //   alt: "Goddess or Crash",
      //   name: "Goddess or Crash",
      // },
      // FireBallBlazePhoenix: {
      //   href: "/casino/qtechdragoonsoft-fire-ball-blaze-phoenix",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/FireBallBlazePhoenix.webp",
      //   alt: "Fire Ball Blaze Phoenix",
      //   name: "Fire Ball Blaze Phoenix",
      // },
      // MidasHand: {
      //   href: "/casino/qtechdragoonsoft-midas-hand",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/MidasHand.webp",
      //   alt: "Midas Hand",
      //   name: "Midas Hand",
      // },
      // HappyFish: {
      //   href: "/casino/qtechdragoonsoft-happy-fish",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/HappyFish.webp",
      //   alt: "Happy Fish",
      //   name: "Happy Fish",
      // },
      // DancingSamba: {
      //   href: "/casino/qtechdragoonsoft-dancing-samba",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/DancingSamba.webp",
      //   alt: "Dancing Samba",
      //   name: "Dancing Samba",
      // },
      // FortuneTwins: {
      //   href: "/casino/qtechdragoonsoft-fortune-twins",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/FortuneTwins.webp",
      //   alt: "Fortune Twins",
      //   name: "Fortune Twins",
      // },
      // AztecTreasure: {
      //   href: "/casino/qtechdragoonsoft-aztec-treasure",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/AztecTreasure.webp",
      //   alt: "Aztec Treasure",
      //   name: "Aztec Treasure",
      // },
      // OdinTerritory: {
      //   href: "/casino/qtechdragoonsoft-odin-territory",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/OdinTerritory.webp",
      //   alt: "Odin Territory",
      //   name: "Odin Territory",
      // },
      // CrazyBartender: {
      //   href: "/casino/qtechdragoonsoft-crazy-bartender",
      //   code: "",
      //   casino: "Slots",
      //   provider: "QTECH",
      //   category: "dragoonSoft",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/dragoon-soft/CrazyBartender.webp",
      //   alt: "Crazy Bartender",
      //   name: "Crazy Bartender",
      // },
    },
  },

  mac88: {
    // others: {
    //   RockPaperScissors: {
    //     code: "67564",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Rock Paper Scissors",
    //     name: "Rock Paper Scissors",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/rockpaperscissors.webp",
    //     href: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    //   },
    //   Boys5: {
    //     code: "67720",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "5 Boys",
    //     name: "5 Boys",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/5Boys.webp",
    //     href: "/casino/aggapmac88gamingvirtual-5-boys",
    //   },
    //   JetXT: {
    //     code: "92037",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Jet XT",
    //     name: "Jet XT",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/JetXT.webp",
    //     href: "/casino/aggapmac88gamingvirtual-jet-xt",
    //   },
    //   Kitex: {
    //     code: "92038",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Kitex",
    //     name: "Kitex",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/kitex.jpg",
    //     href: "/casino/aggapmac88gamingvirtual-kitex",
    //   },
    //   HiLo: {
    //     code: "67610",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Hi Lo",
    //     name: "Hi Lo",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/HIlo.webp",
    //     href: "/casino/aggapmac88gamingvirtual-hi-lo",
    //   },
    //   PushpaRani: {
    //     code: "67670",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Pushpa Rani",
    //     name: "Pushpa Rani",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/PushpaRani.webp",
    //     href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    //   },
    //   BallbyBallVR: {
    //     code: "90100",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Ball by Ball VR",
    //     name: "Ball by Ball VR",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/BallbyBallVR.webp",
    //     href: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    //   },
    //   XRoulette: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "X Roulette",
    //     name: "X Roulette",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/RouletteX.webp",
    //     href: "/casino/aggapmac88gamingvirtual-x-roulette",
    //   },
    //   Lucky15: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Lucky 15",
    //     name: "Lucky 15",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Lucky15-new.webp",
    //     href: "/casino/aggapmac88gamingvirtual-lucky-15",
    //   },
    //   Vortex: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Vortex",
    //     name: "Vortex",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Vortex.webp",
    //     href: "/casino/aggapmac88gamingvirtual-vortex",
    //   },
    //   BollyKiss: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Bolly Kiss",
    //     name: "Bolly Kiss",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/BollyKiss.webp",
    //     href: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    //   },
    //   // Plinko: {
    //   //   code: "67690",
    //   //   casino: "aura",
    //   //   provider: "ALT_GAMING_GAP",
    //   //   homeUrl: "http://localhost:3000/Casino",
    //   //   alt: "Plinko",
    //   //   name: "Plinko",
    //   //   providerName: "Mac88 Gaming Virtual",
    //   //   imgUrl: "../images/alt-gaming/mac88/Plinko.webp",
    //   //   href: "/casino/aggapmac88gamingvirtual-plinko",
    //   // },
    //   diamonds: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Diamond",
    //     name: "Diamond",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Diamonds.webp",
    //     href: "/casino/aggapmac88gamingvirtual-diamonds",
    //   },
    //   mines: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Mines",
    //     name: "Mines",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Mines.webp",
    //     href: "/casino/aggapmac88gamingvirtual-mines",
    //   },
    //   Limbo: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Limbo",
    //     name: "Limbo",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Limbo.webp",
    //     href: "/casino/aggapmac88gamingvirtual-limbo",
    //   },
    //   CrashX: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Crash X",
    //     name: "Crash X",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/CrashX.webp",
    //     href: "/casino/aggapmac88gamingvirtual-crash-x",
    //   },
    //   Dice: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Dice",
    //     name: "Dice",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/Dice.webp",
    //     href: "/casino/aggapmac88gamingvirtual-dice",
    //   },
    //   AK47VR: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "AK47 VR",
    //     name: "AK47 VR",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/AK47-VR.webp",
    //     href: "/casino/aggapmac88gamingvirtual-ak47-vr",
    //   },
    //   KaunBanegaCrorepatiVR: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Kaun Banega Crorepati VR",
    //     name: "Kaun Banega Crorepati VR",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/CrorepatiVR.webp",
    //     href: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    //   },
    //   CenterCardVR: {
    //     code: "67690",
    //     casino: "aura",
    //     provider: "ALT_GAMING_GAP",
    //     homeUrl: "http://localhost:3000/Casino",
    //     alt: "Center Card VR",
    //     name: "Center Card VR",
    //     providerName: "Mac88 Gaming Virtual",
    //     imgUrl: "../images/alt-gaming/mac88/CenterCardVR.webp",
    //     href: "/casino/aggapmac88gamingvirtual-center-card-vr",
    //   },
    // },
    // dragontiger: {
    //   DragonTiger: {
    //     href: "/casino/aggapmac88gaming-dragon-tiger",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "dragontiger",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/dragon-tiger.webp",
    //     alt: "Dragon Tiger",
    //     name: "Dragon Tiger",
    //   },
    //   DragonTiger2: {
    //     href: "/casino/aggapmac88gaming-dragon-tiger-2",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "dragontiger",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/dragon-tiger-2.webp",
    //     alt: "Dragon Tiger 2",
    //     name: "Dragon Tiger 2",
    //   },
    //   DragonTigerLion: {
    //     href: "/casino/aggapmac88gaming-dtl",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "dragontiger",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/dtl.webp",
    //     alt: "Dragon Tiger Lion",
    //     name: "Dragon Tiger Lion",
    //   },
    //   Day1DragonTiger: {
    //     href: "/casino/aggapmac88gaming-1-day-dragon-tiger",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "dragontiger",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/1-day-dragon-tiger.webp",
    //     alt: "1 Day Dragon Tiger",
    //     name: "1 Day Dragon Tiger",
    //   },
    // },
    // baccarat: {
    //   Baccarat29: {
    //     href: "/casino/aggapmac88gaming-29-baccarat",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "baccarat",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/29-baccarat.webp",
    //     alt: "29 Baccarat",
    //     name: "29 Baccarat",
    //   },
    //   BaccaratOneDay: {
    //     href: "/casino/aggapmac88gaming-baccarat-one-day",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "baccarat",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/baccarat-one-day.webp",
    //     alt: "Baccarat One Day",
    //     name: "Baccarat One Day",
    //   },
    // },
    // sicbo: {
    //   SicBo: {
    //     href: "/casino/aggapmac88gaming-sic-bo",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "baccarat",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/sic-bo.webp",
    //     alt: "Sic Bo",
    //     name: "Sic Bo",
    //   },
    // },
    // roulette: {
    //   Roulette: {
    //     href: "/casino/aggapmac88gaming-roulette",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "roulette",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/roulette.webp",
    //     alt: "Roulette",
    //     name: "Roulette",
    //   },
    // },
    // poker: {
    //   Poker1Day: {
    //     href: "/casino/aggapmac88gaming-poker-1-day",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "poker",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/poker-1-day.webp",
    //     alt: "Poker 1-Day",
    //     name: "Poker 1-Day",
    //   },
    //   Poker2020: {
    //     href: "/casino/aggapmac88gaming-poker-20-20",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "poker",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/poker-20-20.webp",
    //     alt: "Poker 20-20",
    //     name: "Poker 20-20",
    //   },
    //   Player6Poker: {
    //     href: "/casino/aggapmac88gaming-6-player-poker",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "poker",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/6-player-poker.webp",
    //     alt: "6 Player Poker",
    //     name: "6 Player Poker",
    //   },
    // },
    // teenpatti: {
    //   MuflisTeenpatti: {
    //     href: "/casino/aggapmac88gaming-muflis-teenpatti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/muflis-teenpatti.webp",
    //     alt: "Muflis Teenpatti",
    //     name: "Muflis Teenpatti",
    //   },
    //   TwoCardTeenpatti: {
    //     href: "/casino/aggapmac88gaming-two-card-teenpatti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/2-card-teenpatti.webp",
    //     alt: "Two Card Teenpatti",
    //     name: "Two Card Teenpatti",
    //   },
    //   OpenTeenpatti: {
    //     href: "/casino/aggapmac88gaming-open-teen-patti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/open-teen-patti.webp",
    //     alt: "Open Teen patti",
    //     name: "Open Teen patti",
    //   },
    //   TeenpattiOneDay: {
    //     href: "/casino/aggapmac88gaming-teenpatti-one-day",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/teenpatti-one-day.webp",
    //     alt: "Teenpatti One Day",
    //     name: "Teenpatti One Day",
    //   },
    //   TestTeenpatti: {
    //     href: "/casino/aggapmac88gaming-test-teenpatti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/test-teenpatti.webp",
    //     alt: "Test Teenpatti",
    //     name: "Test Teenpatti",
    //   },
    //   Teenpatti2020: {
    //     href: "/casino/aggapmac88gaming-20-20-teenpatti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/20-20-teenpatti.webp",
    //     alt: "20-20 Teenpatti",
    //     name: "20-20 Teenpatti",
    //   },
    //   Teenpatti20202: {
    //     href: "/casino/aggapmac88gaming-20-20-teenpatti-2",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/20-20-teenpatti-2.webp",
    //     alt: "20 20 Teenpatti 2",
    //     name: "20 20 Teenpatti 2",
    //   },
    //   AK47Teenpatti: {
    //     href: "/casino/aggapmac88gaming-ak47-teenpatti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/ak47-teenpatti.webp",
    //     alt: "AK47 Teenpatti",
    //     name: "AK47 Teenpatti",
    //   },
    //   InstantTeenPatti: {
    //     href: "/casino/aggapmac88gaming-instant-teen-patti",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/instant-teen-patti.webp",
    //     alt: "Instant Teen Patti",
    //     name: "Instant Teen Patti",
    //   },
    // },
    // hiLo: {
    //   Highlow: {
    //     href: "/casino/aggapmac88gaming-high-low",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "hiLo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/high-low.webp",
    //     alt: "High low",
    //     name: "High low",
    //   },
    //   HiLo: {
    //     href: "/casino/aggapmac88gamingvirtual-hi-lo",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "hiLo",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/hi-lo.webp",
    //     alt: "Hi Lo",
    //     name: "Hi Lo",
    //   },
    // },

    // lottery: {
    //   LotteryMac88: {
    //     href: "/casino/aggapmac88gaming-lottery",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "lottery",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/lottery/Lottery-Mac88.webp",
    //     alt: "Lottery",
    //     name: "Lottery",
    //     providerName: "lottery",
    //   },
    // },
    // others: {
    //   BollywoodCasinoB: {
    //     href: "/casino/aggapmac88gaming-bollywood-casino-b",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/bollywood-casino-b.webp",
    //     alt: "Bollywood Casino B",
    //     name: "Bollywood Casino B",
    //   },
    //   CasinoWar: {
    //     href: "/casino/aggapmac88gaming-casino-war",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/casino-war.webp",
    //     alt: "Casino War",
    //     name: "Casino War",
    //   },
    //   CenterCard: {
    //     href: "/casino/aggapmac88gaming-center-card",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/center-card.webp",
    //     alt: "Center card",
    //     name: "Center card",
    //   },
    //   Instantworli: {
    //     href: "/casino/aggapmac88gaming-instant-worli",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/instant-worli.webp",
    //     alt: "Instant worli",
    //     name: "Instant worli",
    //   },
    //   NoteNumber: {
    //     href: "/casino/aggapmac88gaming-note-number",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/note-number.webp",
    //     alt: "Note Number",
    //     name: "Note Number",
    //   },
    //   OneCard2020: {
    //     href: "/casino/aggapmac88gaming-one-card-20-20",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/one-card-20-20.webp",
    //     alt: "One Card 20 20",
    //     name: "One Card 20 20",
    //   },
    //   OneCardOneDay: {
    //     href: "/casino/aggapmac88gaming-one-card-one-day",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/one-card-one-day.webp",
    //     alt: "One Card One Day",
    //     name: "One Card One Day",
    //   },
    //   QueenRace: {
    //     href: "/casino/aggapmac88gaming-queen-race",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/queen-race.webp",
    //     alt: "Queen Race",
    //     name: "Queen Race",
    //   },
    //   Race20: {
    //     href: "/casino/aggapmac88gaming-race-20",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/race-20.webp",
    //     alt: "Race 20",
    //     name: "Race 20",
    //   },
    //   Raceto17: {
    //     href: "/casino/aggapmac88gaming-race-to-17",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/race-to-17.webp",
    //     alt: "Race to 17",
    //     name: "Race to 17",
    //   },
    //   Raceto2nd: {
    //     href: "/casino/aggapmac88gaming-race-to-2nd",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/race-to-2nd.webp",
    //     alt: "Race to 2nd",
    //     name: "Race to 2nd",
    //   },
    //   SideBetcity: {
    //     href: "/casino/aggapmac88gaming-side-bet-city",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/side-bet-city.webp",
    //     alt: "Side Bet city",
    //     name: "Side Bet city",
    //   },
    //   CenterCardOneDay: {
    //     href: "/casino/aggapmac88gaming-center-card-one-day",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/center-card-one-day.webp",
    //     alt: "Center Card One Day",
    //     name: "Center Card One Day",
    //   },
    //   Trio: {
    //     href: "/casino/aggapmac88gaming-trio",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/trio.webp",
    //     alt: "Trio",
    //     name: "Trio",
    //   },
    //   WorliMatka: {
    //     href: "/casino/aggapmac88gaming-worli-matka",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/worli-matka.webp",
    //     alt: "Worli Matka",
    //     name: "Worli Matka",
    //   },
    //   Cards3Judgement: {
    //     href: "/casino/aggapmac88gaming-3-cards-judgement",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "others",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/3-cards-judgement.webp",
    //     alt: "3 Cards Judgement",
    //     name: "3 Cards Judgement",
    //   },
    //   AmarAkbarAnthony: {
    //     href: "/casino/aggapmac88gaming-amar-akbar-anthony",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/amar-akbar-anthony.webp",
    //     alt: "Amar Akbar Anthony",
    //     name: "Amar Akbar Anthony",
    //   },
    // },
    // lucky7: {
    //   Lucky7: {
    //     href: "/casino/aggapmac88gaming-lucky7",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "lucky7",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/lucky7.webp",
    //     alt: "Lucky 7",
    //     name: "Lucky 7",
    //   },
    //   Lucky5: {
    //     href: "/casino/aggapmac88gaming-lucky-5",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "lucky7",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/lucky-5.webp",
    //     alt: "Lucky 5",
    //     name: "Lucky 5",
    //   },
    // },
    // andarbahar: {
    //   AndarBahar: {
    //     href: "/casino/aggapmac88gaming-andar-bahar",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "andarbahar",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/andar-bahar.webp",
    //     alt: "Andar Bahar",
    //     name: "Andar Bahar",
    //   },
    //   AndarBahar50: {
    //     href: "/casino/aggapmac88gaming-andar-bahar-50",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "andarbahar",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/andar-bahar-50.webp",
    //     alt: "Andar Bahar 50",
    //     name: "Andar Bahar 50",
    //   },
    // },
    // cards32: {
    //   Cards32: {
    //     href: "/casino/aggapmac88gaming-32-cards",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "teenpatti",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/32-cards.webp",
    //     alt: "32 Cards",
    //     name: "32 Cards",
    //   },
    // },
    // liveGameShows: {
    //   DreamWheel: {
    //     href: "/casino/aggapmac88gaming-dream-wheel",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "liveGameShows",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/dream-wheel.webp",
    //     alt: "Dream Wheel",
    //     name: "Dream Wheel",
    //   },
    //   FootballStudIo: {
    //     href: "/casino/aggapmac88gaming-football-studio",
    //     code: "",
    //     casino: "Mac88",
    //     provider: "ALT_GAMING_GAP",
    //     category: "liveGameShows",
    //     homeUrl: "http://localhost:3000/Casino",
    //     imgUrl: "/images/casino/mac88/football-studio.webp",
    //     alt: "Football StudIo",
    //     name: "Football StudIo",
    //   },
    // },
  },

  // mac88VR: {
  //   lucky7: {
  //     VRLucky7: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-lucky-7",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lucky7",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-lucky-7.webp",
  //       alt: "VR Lucky 7",
  //       name: "VR Lucky 7",
  //     },
  //     Lucky5: {
  //       href: "/casino/aggapmac88gamingvirtual-lucky-5",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lucky7",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/lucky-5.webp",
  //       alt: "Lucky 5",
  //       name: "Lucky 5",
  //     },
  //     Lucky15: {
  //       href: "/casino/aggapmac88gamingvirtual-lucky-15",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lucky7",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/lucky-15.webp",
  //       alt: "Lucky 15",
  //       name: "Lucky 15",
  //     },
  //   },
  //   others: {
  //     CenterCardVR: {
  //       href: "/casino/aggapmac88gamingvirtual-center-card-vr",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/center-card-vr.webp",
  //       alt: "Center Card VR",
  //       name: "Center Card VR",
  //     },
  //     KaunBanegaCrorepatiVR: {
  //       href: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/kaun-banega-crorepati-vr.webp",
  //       alt: "Kaun Banega Crorepati VR",
  //       name: "Kaun Banega Crorepati VR",
  //     },
  //     VRAmarAkbarAnthony: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-amar-akbar-anthony",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-amar-akbar-anthony.webp",
  //       alt: "VR Amar Akbar Anthony",
  //       name: "VR Amar Akbar Anthony",
  //     },
  //     VRBollywoodCasino: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-bollywood-casino",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-bollywood-casino.webp",
  //       alt: "VR Bollywood Casino",
  //       name: "VR Bollywood Casino",
  //     },
  //     VRCasinoMeter: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-casino-meter",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-casino-meter.webp",
  //       alt: "VR Casino Meter",
  //       name: "VR Casino Meter",
  //     },
  //     VRQueenRace: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-queen-race",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-queen-race.webp",
  //       alt: "VR Queen Race",
  //       name: "VR Queen Race",
  //     },
  //     VRRaceT20: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-race-t20",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-race-20.webp",
  //       alt: "VR Race T20",
  //       name: "VR Race T20",
  //     },
  //     VRTrio: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-trio",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-trio.webp",
  //       alt: "VR Trio",
  //       name: "VR Trio",
  //     },
  //     VRWorliMatka: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-worli-matka",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-worli-matka.webp",
  //       alt: "VR Worli Matka",
  //       name: "VR Worli Matka",
  //     },
  //     BallbyBallVR: {
  //       href: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/ball-by-ball-vr.webp",
  //       alt: "Ball by Ball VR",
  //       name: "Ball by Ball VR",
  //     },

  //     RockPaperScissors: {
  //       href: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/rock-paper-scissors.webp",
  //       alt: "Rock Paper Scissors",
  //       name: "Rock Paper Scissors",
  //     },
  //     Boys5: {
  //       href: "/casino/aggapmac88gamingvirtual-5-boys",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/5-boys.webp",
  //       alt: "5 Boys",
  //       name: "5 Boys",
  //     },
  //     Vortex: {
  //       href: "/casino/aggapmac88gamingvirtual-vortex",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vortex.webp",
  //       alt: "Vortex",
  //       name: "Vortex",
  //     },
  //     BollyKiss: {
  //       href: "/casino/aggapmac88gamingvirtual-bolly-kiss",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/bollywood-kiss.webp",
  //       alt: "Bolly Kiss",
  //       name: "Bolly Kiss",
  //     },
  //     Plinko: {
  //       href: "/casino/aggapmac88gamingvirtual-plinko",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/plinko.webp",
  //       alt: "Plinko",
  //       name: "Plinko",
  //     },
  //     diamonds: {
  //       href: "/casino/aggapmac88gamingvirtual-diamonds",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/diamonds.webp",
  //       alt: "Diamond",
  //       name: "Diamond",
  //     },
  //     Limbo: {
  //       href: "/casino/aggapmac88gamingvirtual-limbo",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/limbo.webp",
  //       alt: "Limbo",
  //       name: "Limbo",
  //     },
  //     Dice: {
  //       href: "/casino/aggapmac88gamingvirtual-dice",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/dice.webp",
  //       alt: "Dice",
  //       name: "Dice",
  //     },

  //     // K3Lottery10: {
  //     //   href: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
  //     //   code: "",
  //     //   casino: "Mac88",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   category: "others",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/mac88-vr/centrecard-vr.webp",
  //     //   alt: "K3 Lottery 10",
  //     //   name: "K3 Lottery 10",
  //     // },
  //   },
  //   dragontiger: {
  //     VRDragonTiger: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "dragontiger",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-dragon-tiger.webp",
  //       alt: "VR Dragon Tiger",
  //       name: "VR Dragon Tiger",
  //     },
  //     VR2020DTL: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-20-20-dtl",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-20-20-dtl.webp",
  //       alt: "VR 20-20 DTL",
  //       name: "VR 20-20 DTL",
  //     },
  //   },
  //   teenpatti: {
  //     AK47VR: {
  //       href: "/casino/aggapmac88gamingvirtual-ak47-vr",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/ak47-vr.webp",
  //       alt: "AK47 VR",
  //       name: "AK47 VR",
  //     },
  //     VR2020Teenpatti: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-20-20-teenpatti",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-20-20-teenpatti.webp",
  //       alt: "VR 20-20 Teenpatti",
  //       name: "VR 20-20 Teenpatti",
  //     },
  //     VR2CardTP: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "teenpatti",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-2-card-tp.webp",
  //       alt: "VR 2 Card TP",
  //       name: "VR 2 Card TP",
  //     },
  //   },
  //   cards32: {
  //     VR32Cards: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-32-cards",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "cards32",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-32-cards.webp",
  //       alt: "VR 32 Cards",
  //       name: "VR 32 Cards",
  //     },
  //   },
  //   andarbahar: {
  //     VRAndarBahar: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-andar-bahar",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "andarbahar",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-andar-bahar.webp",
  //       alt: "VR Andar Bahar",
  //       name: "VR Andar Bahar",
  //     },
  //   },
  //   hiLo: {
  //     VRHighlow: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-high-low",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "hiLo",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/high-low-vr.webp",
  //       alt: "VR High low",
  //       name: "VR High low",
  //     },
  //     HiloVR: {
  //       href: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "hiLo",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/hi-lo.webp",
  //       alt: "Hi Lo VR",
  //       name: "Hi Lo VR",
  //     },
  //   },
  //   baccarat: {
  //     VR29cardbacarrat: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "baccarat",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/29-baccarat-vr.webp",
  //       alt: "VR 29 card bacarrat",
  //       name: "VR 29 card bacarrat",
  //     },
  //   },
  //   poker: {
  //     VRPoker: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-poker",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "poker",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-poker.webp",
  //       alt: "VR Poker",
  //       name: "VR Poker",
  //     },
  //   },
  //   roulette: {
  //     // XRoulette: {
  //     //   href: "/casino/aggapmac88gamingvirtual-x-roulette",
  //     //   code: "",
  //     //   casino: "Mac88",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   category: "roulette",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/mac88-vr/x-roulette.webp",
  //     //   alt: "X Roulette",
  //     //   name: "X Roulette",
  //     // },
  //     VRAutoRoulette: {
  //       href: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "roulette",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/vr-auto-roulette.webp",
  //       alt: "VR Auto Roulette",
  //       name: "VR Auto Roulette",
  //     },
  //   },
  //   mines: {
  //     minesMac: {
  //       href: "/casino/aggapmac88gamingvirtual-mines",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "mines",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/mines.webp",
  //       alt: "Mines",
  //       name: "Mines",
  //     },
  //   },
  //   crashX: {
  //     JetXT: {
  //       href: "/casino/aggapmac88gamingvirtual-jet-xt",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/jet-xt.webp",
  //       alt: "Jet XT",
  //       name: "Jet XT",
  //     },
  //     Kitex: {
  //       href: "/casino/aggapmac88gamingvirtual-kitex",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/kitex.webp",
  //       alt: "Kitex",
  //       name: "Kitex",
  //     },
  //     CrashX: {
  //       href: "/casino/aggapmac88gamingvirtual-crash-x",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/crash-x.webp",
  //       alt: "Crash X",
  //       name: "Crash X",
  //     },
  //     // AviatorX2: {
  //     //   href: "/casino/aggapmac88gamingvirtual-aviatorx2",
  //     //   code: "",
  //     //   casino: "Mac88",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   category: "crashX",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/mac88-vr/aviatorX2.webp",
  //     //   alt: "AviatorX2",
  //     //   name: "AviatorX2",
  //     // },
  //   },
  //   crash: {
  //     PushpaRani: {
  //       href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crash",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/mac88-vr/pushpa-rani.webp",
  //       alt: "Pushpa Rani",
  //       name: "Pushpa Rani",
  //     },
  //   },
  // },

  // smartSoft: {
  //   crashX: {
  //     JetX: {
  //       href: "/casino/aggapsmartsoftgaming-jetx",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/JetXOld.webp",
  //       alt: "JetX",
  //       name: "JetX",
  //       providerName: "SmartSoft",
  //     },
  //     Cappadocia: {
  //       href: "/casino/aggapsmartsoftgaming-cappadocia",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/Cappadocia.webp",
  //       alt: "Cappadocia",
  //       name: "Cappadocia",
  //       providerName: "SmartSoft",
  //     },
  //     JetX3: {
  //       href: "/casino/aggapsmartsoftgaming-jetx3",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/JetX3.webp",
  //       alt: "JetX3",
  //       name: "JetX3",
  //       providerName: "SmartSoft",
  //     },
  //     CricketX: {
  //       href: "/casino/aggapsmartsoftgaming-cricketx",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/CricketX.webp",
  //       alt: "CricketX",
  //       name: "CricketX",
  //       providerName: "SmartSoft",
  //     },
  //     FootballX: {
  //       href: "/casino/aggapsmartsoftgaming-footballx",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/FootballX.webp",
  //       alt: "FootballX",
  //       name: "FootballX",
  //       providerName: "SmartSoft",
  //     },
  //     TowerX: {
  //       href: "/casino/aggapsmartsoftgaming-towerx",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crashX",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/TowerX.webp",
  //       alt: "TowerX",
  //       name: "TowerX",
  //       providerName: "SmartSoft",
  //     },
  //   },
  //   others: {
  //     // SpinX: {
  //     //   href: "/casino/aggapsmartsoftgaming-spinx",
  //     //   code: "",
  //     //   casino: "SmartSoft",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   category: "others",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   imgUrl: "/images/casino/smartsoft/SpinX.webp",
  //     //   alt: "SpinX",
  //     //   name: "SpinX",
  //     //   providerName: "SmartSoft",
  //     // },
  //     PlinkoX: {
  //       href: "/casino/aggapsmartsoftgaming-plinkox",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/PlinkoX.webp",
  //       alt: "PlinkoX",
  //       name: "PlinkoX",
  //       providerName: "SmartSoft",
  //     },
  //     HunterX: {
  //       href: "/casino/aggapsmartsoftgaming-hunter-x",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/CrazyHuntX.webp",
  //       alt: "Hunter X",
  //       name: "Hunter X",
  //       providerName: "SmartSoft",
  //     },
  //     Jokers4Bonuses: {
  //       href: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/Jokers4Bonuses.webp",
  //       alt: "Joker's 4 Bonuses",
  //       name: "Joker's 4 Bonuses",
  //       providerName: "SmartSoft",
  //     },
  //     Samurai: {
  //       href: "/casino/aggapsmartsoftgaming-samurai",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/Samurai.webp",
  //       alt: "Samurai",
  //       name: "Samurai",
  //       providerName: "SmartSoft",
  //     },
  //     BurningIce: {
  //       href: "/casino/aggapsmartsoftgaming-burning-ice",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/BurningIce.webp",
  //       alt: "Burning Ice",
  //       name: "Burning Ice",
  //       providerName: "SmartSoft",
  //     },
  //     BurningIce10: {
  //       href: "/casino/aggapsmartsoftgaming-burning-ice-10",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/BurningIce10.webp",
  //       alt: "Burning Ice 10",
  //       name: "Burning Ice 10",
  //       providerName: "SmartSoft",
  //     },
  //     BurningIce40: {
  //       href: "/casino/aggapsmartsoftgaming-burning-ice-40",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/BurningIce40.webp",
  //       alt: "Burning Ice 40",
  //       name: "Burning Ice 40",
  //       providerName: "SmartSoft",
  //     },
  //     Vampires: {
  //       href: "/casino/aggapsmartsoftgaming-vampires",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/Vampires.webp",
  //       alt: "Vampires",
  //       name: "Vampires",
  //       providerName: "SmartSoft",
  //     },
  //     MultiHot5: {
  //       href: "/casino/aggapsmartsoftgaming-multi-hot-5",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/MultiHot5.webp",
  //       alt: "Multi Hot 5",
  //       name: "Multi Hot 5",
  //       providerName: "SmartSoft",
  //     },
  //     WildJungle: {
  //       href: "/casino/aggapsmartsoftgaming-wild-jungle",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/WildJungle.webp",
  //       alt: "Wild Jungle",
  //       name: "Wild Jungle",
  //       providerName: "SmartSoft",
  //     },
  //     GeniesBonanza: {
  //       href: "/casino/aggapsmartsoftgaming-genies-bonanza",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/GeniesBonanza.webp",
  //       alt: "Genie's Bonanza",
  //       name: "Genie's Bonanza",
  //       providerName: "SmartSoft",
  //     },
  //     MultiHotWays: {
  //       href: "/casino/aggapsmartsoftgaming-multi-hot-ways",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "others",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/MultiHotWays.webp",
  //       alt: "Multi Hot Ways",
  //       name: "Multi Hot Ways",
  //       providerName: "SmartSoft",
  //     },
  //   },
  //   crash: {
  //     Balloon: {
  //       href: "/casino/aggapsmartsoftgaming-baloon",
  //       code: "",
  //       casino: "SmartSoft",
  //       provider: "ALT_GAMING_GAP",
  //       category: "crash",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/smartsoft/Balloon.webp",
  //       alt: "Balloon",
  //       name: "Balloon",
  //       providerName: "SmartSoft",
  //     },
  //   },
  // },

  // lottery: {
  //   lottery: {
  //     LotteryTableRoyal: {
  //       href: "/casino/aggaproyalgaming-lottery",
  //       code: "",
  //       casino: "royal gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Lottery-Table-Royal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     VRLotteryRoyal: {
  //       href: "/casino/aggaproyalgamingvirtual-vr-lottery",
  //       code: "",
  //       casino: "royal gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/VRLottery-Royal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     LotteryMac88: {
  //       href: "/casino/aggapmac88gaming-lottery",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Lottery-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },

  //     KenoTVBet: {
  //       href: "/casino/aggaptvbet-keno",
  //       code: "",
  //       casino: "TVBet",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Keno-TVBet.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     FastKenoTVBet: {
  //       href: "/casino/aggaptvbet-fast-keno",
  //       code: "",
  //       casino: "TVBet",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/FastKeno-TVBet.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     WheelHacksaw: {
  //       href: "/casino/aggaphacksawgaming-wheel",
  //       code: "",
  //       casino: "Hacksaw Gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Wheel-Hacksaw.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     Wheel94Hacksaw: {
  //       href: "/casino/aggaphacksawgaming-wheel-92",
  //       code: "",
  //       casino: "Hacksaw Gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Wheel94-Hacksaw.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     Wheel92Hacksaw: {
  //       href: "/casino/aggaphacksawgaming-wheel-94",
  //       code: "",
  //       casino: "Hacksaw Gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Wheel92-Hacksaw.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     SpinStrikeTurbo: {
  //       href: "/casino/aggapturbogames-spin-strike",
  //       code: "",
  //       casino: "Turbo Games",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/SpinStrike-Turbo.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     HalloweenLottoCaleta: {
  //       href: "/casino/aggapcaletagaming-halloween-lotto",
  //       code: "",
  //       casino: "Caleta",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/HalloweenLotto-Caleta.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     BingoBillionLlamaCaleta: {
  //       href: "/casino/aggapcaletagaming-bingo-billion-llama",
  //       code: "",
  //       casino: "Caleta",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/BingoBillionLlama-Caleta.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     FootballLottoCaleta: {
  //       href: "/casino/aggapcaletagaming-football-lotto",
  //       code: "",
  //       casino: "Caleta",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/FootballLotto-Caleta.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     MagicIdolPopok: {
  //       href: "/casino/aggappopokinstant-magic-idol",
  //       code: "",
  //       casino: "Popok Instant",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/MagicIdol-Popok.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     RedHotLinePopok: {
  //       href: "/casino/aggappopokinstant-red-hot-line",
  //       code: "",
  //       casino: "Popok Instant",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/RedHotLine-Popok.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     DoubleWheelPascal: {
  //       href: "/casino/aggappascal-double-wheel",
  //       code: "",
  //       casino: "Pascal",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/DoubleWheel-Pascal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     DreamWheelPascal: {
  //       href: "/casino/aggappascal-dream-wheel",
  //       code: "",
  //       casino: "Pascal",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/DreamWheel-Pascal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     x50Wheel: {
  //       href: "/casino/aggappascal-x50-wheel",
  //       code: "",
  //       casino: "Pascal",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/x50Wheel-Pascal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     CrystalCrush: {
  //       href: "/casino/aggappascal-crystal-crush",
  //       code: "",
  //       casino: "Pascal",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/CrystalCrush-Pascal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     LuckyLotto: {
  //       href: "/casino/aggappascal-lucky-lotto",
  //       code: "",
  //       casino: "Pascal",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/LuckyLotto-Pascal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     KenoJili: {
  //       href: "/casino/aggapjiligaming-keno",
  //       code: "",
  //       casino: "JiLi Gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Keno-Jili.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },

  //     LotteryLDRoyal: {
  //       href: "/casino/aggaproyalgaming-lottery-u8365",
  //       code: "",
  //       casino: "royal gaming",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/Lottery-LD-Royal.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     VR5DLottery1: {
  //       href: "/casino/aggapmac88gamingvirtual-5d-lottery-1",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/VR5DLottery1-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     VR5DLottery3: {
  //       href: "/casino/aggapmac88gamingvirtual-5d-lottery-3",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/VR5DLottery3-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     VR5DLottery5: {
  //       href: "/casino/aggapmac88gamingvirtual-5d-lottery-5",
  //       code: "",
  //       casino: "Mac88",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/VR5DLottery5-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     VR5DLottery10: {
  //       href: "/casino/aggapmac88gamingvirtual-5d-lottery-10",
  //       code: "",
  //       casino: "Mac88 Gaming Virtual",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/VR5DLottery10-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     K3Lottery1: {
  //       href: "/casino/aggapmac88gamingvirtual-k3-lottery-1",
  //       code: "",
  //       casino: "Mac88 Gaming Virtual",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/K3Lottery1-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     K3Lottery3: {
  //       href: "/casino/aggapmac88gamingvirtual-k3-lottery-3",
  //       code: "",
  //       casino: "Mac88 Gaming Virtual",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/K3Lottery3-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     K3Lottery5: {
  //       href: "/casino/aggapmac88gamingvirtual-k3-lottery-5",
  //       code: "",
  //       casino: "Mac88 Gaming Virtual",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/K3Lottery5-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     K3Lottery10: {
  //       href: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
  //       code: "",
  //       casino: "Mac88 Gaming Virtual",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/K3Lottery10-Mac88.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //     MegaFireBlazeLuckyBallBrasileiro: {
  //       href: "/casino/aggapplaytechlive-mega-fire-blaze-lucky-ball-brasileiro",
  //       code: "",
  //       casino: "Playtech Live",
  //       provider: "ALT_GAMING_GAP",
  //       category: "lottery",
  //       homeUrl: "http://localhost:3000/Casino",
  //       imgUrl: "/images/casino/lottery/MegaFireBlazeLBB-Playtech.webp",
  //       alt: "Lottery",
  //       name: "Lottery",
  //       providerName: "lottery",
  //     },
  //   },
  // },

  instantGames: {
    instantGames: {
      LuckyNumbersx8: {
        href: "/casino/qt-lucky-numbers-x8",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LuckyNumbersx8.webp",
        alt: "Lucky Numbers x8",
        name: "Lucky Numbers x8",
        providerName: "WorldCasino",
      },
      LuckyNumbersx12: {
        href: "/casino/qt-lucky-numbers-x12",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LuckyNumbersx12.webp",
        alt: "Lucky Numbers x12",
        name: "Lucky Numbers x12",
        providerName: "WorldCasino",
      },
      LuckyNumbersx16: {
        href: "/casino/qt-lucky-numbers-x16",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LuckyNumbersx16.webp",
        alt: "Lucky Numbers x16",
        name: "Lucky Numbers x16",
        providerName: "WorldCasino",
      },
      LuckyNumbersx20: {
        href: "/casino/qt-lucky-numbers-x20",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LuckyNumbersx20.webp",
        alt: "Lucky Numbers x20",
        name: "Lucky Numbers x20",
        providerName: "WorldCasino",
      },
      CursedSeas: {
        href: "/casino/qt-cursed-seas",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/CursedSeas.webp",
        alt: "Cursed Seas",
        name: "Cursed Seas",
        providerName: "WorldCasino",
      },
      DogTownDeal: {
        href: "/casino/qt-dog-town-deal",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/DogTownDeal.webp",
        alt: "Dog Town Deal",
        name: "Dog Town Deal",
        providerName: "WorldCasino",
      },
      EForce: {
        href: "/casino/qt-e-force",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/EForce.webp",
        alt: "E-Force",
        name: "E-Force",
        providerName: "WorldCasino",
      },
      BookOfPower: {
        href: "/casino/qt-book-of-power",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/BookOfPower.webp",
        alt: "Book Of Power",
        name: "Book Of Power",
        providerName: "WorldCasino",
      },
      LeprechaunCharms: {
        href: "/casino/qt-leprechaun-charms",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LeprechaunCharms.webp",
        alt: "Leprechaun Charms",
        name: "Leprechaun Charms",
        providerName: "WorldCasino",
      },
      PlinkoGo: {
        href: "/casino/qt-plinko-go",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/PlinkoGo.webp",
        alt: "Plinko Go",
        name: "Plinko Go",
        providerName: "WorldCasino",
      },
      Whacked: {
        href: "/casino/qt-whacked",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Whacked.webp",
        alt: "Whacked!",
        name: "Whacked!",
        providerName: "WorldCasino",
      },
      Ragnawolves: {
        href: "/casino/qt-ragnawolves",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Ragnawolves.webp",
        alt: "Ragnawolves",
        name: "Ragnawolves",
        providerName: "WorldCasino",
      },
      SharkWash: {
        href: "/casino/qt-shark-wash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/SharkWash.webp",
        alt: "Shark Wash",
        name: "Shark Wash",
        providerName: "WorldCasino",
      },
      MoneyTrain3: {
        href: "/casino/qt-money-train-3",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MoneyTrain3.webp",
        alt: "Money Train 3",
        name: "Money Train 3",
        providerName: "WorldCasino",
      },
      MidasGoldenTouch: {
        href: "/casino/qt-midas-golden-touch",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MidasGoldenTouch.webp",
        alt: "Midas Golden Touch",
        name: "Midas Golden Touch",
        providerName: "WorldCasino",
      },
      RoyalPotato: {
        href: "/casino/qt-royal-potato",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/RoyalPotato.webp",
        alt: "Royal Potato",
        name: "Royal Potato",
        providerName: "WorldCasino",
      },
      MoneyTrain2: {
        href: "/casino/qt-money-train-2",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MoneyTrain2.webp",
        alt: "Money Train 2",
        name: "Money Train 2",
        providerName: "WorldCasino",
      },
      WildYield: {
        href: "/casino/qt-wild-yield",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/WildYield.webp",
        alt: "Wild Yield",
        name: "Wild Yield",
        providerName: "WorldCasino",
      },
      WildChapo: {
        href: "/casino/qt-wild-chapo",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/WildChapo.webp",
        alt: "Wild Chapo",
        name: "Wild Chapo",
        providerName: "WorldCasino",
      },
      RaptorDoublemax: {
        href: "/casino/qt-raptor-doublemax",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/RaptorDoublemax.webp",
        alt: "Raptor Doublemax",
        name: "Raptor Doublemax",
        providerName: "WorldCasino",
      },
      MoneyCart2: {
        href: "/casino/qt-money-cart-2",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MoneyCart2.webp",
        alt: "Money Cart 2",
        name: "Money Cart 2",
        providerName: "WorldCasino",
      },
      TempleTumbleMegaways: {
        href: "/casino/qt-temple-tumble-megaways",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/TempleTumbleMegaways.webp",
        alt: "Temple Tumble Megaways",
        name: "Temple Tumble Megaways",
        providerName: "WorldCasino",
      },
      RIPCity: {
        href: "/casino/qt-rip-city",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/RIPCity.webp",
        alt: "RIP City",
        name: "RIP City",
        providerName: "WorldCasino",
      },
      TemplarTumble: {
        href: "/casino/qt-templar-tumble",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/TemplarTumble.webp",
        alt: "Templar Tumble",
        name: "Templar Tumble",
        providerName: "WorldCasino",
      },
      SakuraFortune: {
        href: "/casino/qt-sakura-fortune",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/SakuraFortune.webp",
        alt: "Sakura Fortune",
        name: "Sakura Fortune",
        providerName: "WorldCasino",
      },
      ArcticFruits: {
        href: "/casino/qt-arctic-fruits",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/ArcticFruits.webp",
        alt: "Arctic Fruits",
        name: "Arctic Fruits",
        providerName: "WorldCasino",
      },
      FaerieNights: {
        href: "/casino/qt-faerie-nights",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/FaerieNights.webp",
        alt: "Faerie Nights",
        name: "Faerie Nights",
        providerName: "WorldCasino",
      },
      NeonFruitCityscape: {
        href: "/casino/qt-neon-fruit-cityscape",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/NeonFruitCityscape.webp",
        alt: "Neon Fruit Cityscape",
        name: "Neon Fruit Cityscape",
        providerName: "WorldCasino",
      },
      MegabloxPyramids: {
        href: "/casino/qt-megablox-pyramids",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MegabloxPyramids.webp",
        alt: "Megablox Pyramids",
        name: "Megablox Pyramids",
        providerName: "WorldCasino",
      },
      SmokingHotFruits: {
        href: "/casino/qt-smoking-hot-fruits",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/SmokingHotFruits.webp",
        alt: "Smoking Hot Fruits",
        name: "Smoking Hot Fruits",
        providerName: "WorldCasino",
      },
      SmokingHotFruits20: {
        href: "/casino/qt-smoking-hot-fruits-20",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/SmokingHotFruits20.webp",
        alt: "Smoking Hot Fruits 20",
        name: "Smoking Hot Fruits 20",
        providerName: "WorldCasino",
      },
      WhiskerJones: {
        href: "/casino/qt-whisker-jones",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/WhiskerJones.webp",
        alt: "Whisker Jones",
        name: "Whisker Jones",
        providerName: "WorldCasino",
      },
      ArcaneElements: {
        href: "/casino/qt-arcane-elements",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/ArcaneElements.webp",
        alt: "Arcane Elements",
        name: "Arcane Elements",
        providerName: "WorldCasino",
      },
      BombsAway: {
        href: "/casino/qt-bombs-away",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/BombsAway.webp",
        alt: "Bombs Away",
        name: "Bombs Away",
        providerName: "WorldCasino",
      },
      CoyoteCrash: {
        href: "/casino/qt-coyote-crash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/CoyoteCrash.webp",
        alt: "Coyote Crash",
        name: "Coyote Crash",
        providerName: "WorldCasino",
      },
      HeySushi: {
        href: "/casino/qt-hey-sushi",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/HeySushi.webp",
        alt: "Hey Sushi",
        name: "Hey Sushi",
        providerName: "WorldCasino",
      },
      JellyfishFlow: {
        href: "/casino/qt-jellyfish-flow",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/JellyfishFlow.webp",
        alt: "Jellyfish Flow",
        name: "Jellyfish Flow",
        providerName: "WorldCasino",
      },
      Jugglenaut: {
        href: "/casino/qt-jugglenaut",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Jugglenaut.webp",
        alt: "Jugglenaut",
        name: "Jugglenaut",
        providerName: "WorldCasino",
      },
      KnockoutFootball: {
        href: "/casino/qt-knockout-football",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/KnockoutFootball.webp",
        alt: "Knockout Football",
        name: "Knockout Football",
        providerName: "WorldCasino",
      },
      LanternLuck: {
        href: "/casino/qt-lantern-luck",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/LanternLuck.webp",
        alt: "Lantern Luck",
        name: "Lantern Luck",
        providerName: "WorldCasino",
      },
      MysticFortuneDeluxe: {
        href: "/casino/qt-mystic-fortune-deluxe",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MysticFortuneDeluxe.webp",
        alt: "Mystic Fortune Deluxe",
        name: "Mystic Fortune Deluxe",
        providerName: "WorldCasino",
      },
      MysticFortune: {
        href: "/casino/qt-mystic-fortune",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/MysticFortune.webp",
        alt: "Mystic Fortune",
        name: "Mystic Fortune",
        providerName: "WorldCasino",
      },
      NaughtySanta: {
        href: "/casino/qt-naughty-santa",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/NaughtySanta.webp",
        alt: "Naughty Santa",
        name: "Naughty Santa",
        providerName: "WorldCasino",
      },
      Prost: {
        href: "/casino/qt-prost",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Prost.webp",
        alt: "Prost!",
        name: "Prost!",
        providerName: "WorldCasino",
      },
      RomanEmpire: {
        href: "/casino/qt-roman-empire",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/RomanEmpire.webp",
        alt: "Roman Empire",
        name: "Roman Empire",
        providerName: "WorldCasino",
      },
      PumpkinPatch: {
        href: "/casino/qt-pumpkin-patch",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/PumpkinPatch.webp",
        alt: "Pumpkin Patch",
        name: "Pumpkin Patch",
        providerName: "WorldCasino",
      },
      WealthInn: {
        href: "/casino/qt-wealth-inn",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/WealthInn.webp",
        alt: "Wealth Inn",
        name: "Wealth Inn",
        providerName: "WorldCasino",
      },
      TheDeadEscape: {
        href: "/casino/qt-the-dead-escape",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/TheDeadEscape.webp",
        alt: "The Dead Escape",
        name: "The Dead Escape",
        providerName: "WorldCasino",
      },
      Cubes: {
        href: "/casino/qt-cubes",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Cubes.webp",
        alt: "Cubes",
        name: "Cubes",
        providerName: "WorldCasino",
      },
      DorkUnit: {
        href: "/casino/qt-dork-unit",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/DorkUnit.webp",
        alt: "Dork Unit",
        name: "Dork Unit",
        providerName: "WorldCasino",
      },
      ForestFortune: {
        href: "/casino/qt-forest-fortune",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/ForestFortune.webp",
        alt: "Forest Fortune",
        name: "Forest Fortune",
        providerName: "WorldCasino",
      },
      Frutz: {
        href: "/casino/qt-frutz",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Frutz.webp",
        alt: "Frutz",
        name: "Frutz",
        providerName: "WorldCasino",
      },
      Hopnpop: {
        href: "/casino/qt-hopnpop",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/Hopnpop.webp",
        alt: "Hop'n'pop",
        name: "Hop'n'pop",
        providerName: "WorldCasino",
      },
      GronksGems: {
        href: "/casino/qt-gronks-gems",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "instantWin",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/instant-win-qt/GronksGems.webp",
        alt: "Gronk's Gems",
        name: "Gronk's Gems",
        providerName: "WorldCasino",
      },
    },
  },

  crash: {
    crash: {
      JungleRun: {
        href: "/casino/qt-jungle-run",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/JungleRun.webp",
        alt: "Jungle Run",
        name: "Jungle Run",
        providerName: "WorldCasino",
      },
      CrashoutFirework: {
        href: "/casino/qt-crashout-firework",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CrashoutFirework.webp",
        alt: "Crashout - Firework",
        name: "Crashout - Firework",
        providerName: "WorldCasino",
      },
      SpaceXY: {
        href: "/casino/qt-space-xy",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/SpaceXY.webp",
        alt: "Space XY",
        name: "Space XY",
        providerName: "WorldCasino",
      },
      CrashX: {
        href: "/casino/qt-crashx",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CrashX.webp",
        alt: "CrashX",
        name: "CrashX",
        providerName: "WorldCasino",
      },
      CrashXFootballEdition: {
        href: "/casino/qt-crashx-football-edition",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CrashXFootballEdition.webp",
        alt: "CrashX Football Edition",
        name: "CrashX Football Edition",
        providerName: "WorldCasino",
      },
      Maverick: {
        href: "/casino/qt-maverick",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Maverick.webp",
        alt: "Maverick",
        name: "Maverick",
        providerName: "WorldCasino",
      },
      Aviator: {
        href: "/casino/qt-aviator",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Aviator.webp",
        alt: "Aviator",
        name: "Aviator",
        providerName: "WorldCasino",
      },
      CoyoteCrash: {
        href: "/casino/qt-coyote-crash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CoyoteCrash.webp",
        alt: "Coyote Crash",
        name: "Coyote Crash",
        providerName: "WorldCasino",
      },
      GemHunterCrash: {
        href: "/casino/qt-gem-hunter-crash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/GemHunterCrash.webp",
        alt: "Gem Hunter Crash",
        name: "Gem Hunter Crash",
        providerName: "WorldCasino",
      },
      CabinCrashers: {
        href: "/casino/qt-cabin-crashers",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CabinCrashers.webp",
        alt: "Cabin Crashers",
        name: "Cabin Crashers",
        providerName: "WorldCasino",
      },
      CashOrCrash: {
        href: "/casino/qt-cash-or-crash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CashOrCrash.webp",
        alt: "Cash or Crash",
        name: "Cash or Crash",
        providerName: "WorldCasino",
      },
      FootballManager: {
        href: "/casino/qt-football-manager",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/FootballManager.webp",
        alt: "Football Manager",
        name: "Football Manager",
        providerName: "WorldCasino",
      },
      GoblinRun: {
        href: "/casino/qt-goblin-run",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/GoblinRun.webp",
        alt: "Goblin Run",
        name: "Goblin Run",
        providerName: "WorldCasino",
      },
      LuckyCrumbling: {
        href: "/casino/qt-lucky-crumbling",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/LuckyCrumbling.webp",
        alt: "Lucky Crumbling",
        name: "Lucky Crumbling",
        providerName: "WorldCasino",
      },
      HighStriker: {
        href: "/casino/qt-high-striker",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/HighStriker.webp",
        alt: "High Striker",
        name: "High Striker",
        providerName: "WorldCasino",
      },
      SaveTheHamster: {
        href: "/casino/qt-save-the-hamster",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/SaveTheHamster.webp",
        alt: "Save the Hamster",
        name: "Save the Hamster",
        providerName: "WorldCasino",
      },
      CashGalaxy: {
        href: "/casino/qt-cash-galaxy",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CashGalaxy.webp",
        alt: "Cash Galaxy",
        name: "Cash Galaxy",
        providerName: "WorldCasino",
      },
      Mriya: {
        href: "/casino/qt-mriya",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Mriya.webp",
        alt: "Mriya",
        name: "Mriya",
        providerName: "WorldCasino",
      },
      DragonOrCrash: {
        href: "/casino/qt-dragon-or-crash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/DragonOrCrash.webp",
        alt: "Dragon or Crash",
        name: "Dragon or Crash",
        providerName: "WorldCasino",
      },
      PilotCoin: {
        href: "/casino/qt-pilot-coin",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/PilotCoin.webp",
        alt: "Pilot Coin",
        name: "Pilot Coin",
        providerName: "WorldCasino",
      },
      Pilot: {
        href: "/casino/qt-pilot",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Pilot.webp",
        alt: "Pilot",
        name: "Pilot",
        providerName: "WorldCasino",
      },
      PilotCup: {
        href: "/casino/qt-pilot-cup",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/PilotCup.webp",
        alt: "Pilot Cup",
        name: "Pilot Cup",
        providerName: "WorldCasino",
      },
      SkyWard: {
        href: "/casino/qt-sky-ward",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/SkyWard.webp",
        alt: "Sky ward",
        name: "Sky ward",
        providerName: "WorldCasino",
      },
      Limbo: {
        href: "/casino/qt-hak-limbo",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Limbo.webp",
        alt: "Limbo",
        name: "Limbo",
        providerName: "WorldCasino",
      },
      SpeedCrash: {
        href: "/casino/qt-hak-speedcrash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/SpeedCrash.webp",
        alt: "Speed Crash",
        name: "Speed Crash",
        providerName: "WorldCasino",
      },
      // BTLcrashlive: {
      //   href: "/casino/qt-btl-crashlive",
      //   code: "",
      //   casino: "Qtech",
      //   provider: "WorldCasino",
      //   category: "crashGames",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "/images/casino/crash-qt/BTLcrashlive.webp",
      //   alt: "BTL-crashlive",
      //   name: "BTL-crashlive",
      //   providerName: "WorldCasino",
      // },
      PaperLanternsCrashGame: {
        href: "/casino/qt-msg-paperlanternscrashgame",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/PaperLanternsCrashGame.webp",
        alt: "Paper Lanterns: Crash Game",
        name: "Paper Lanterns: Crash Game",
        providerName: "WorldCasino",
      },
      BuckingRider: {
        href: "/casino/qt-png-buckingrider",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/BuckingRider.webp",
        alt: "Bucking Rider",
        name: "Bucking Rider",
        providerName: "WorldCasino",
      },
      CrashHamsterCrash: {
        href: "/casino/qt-msg-crashhamstercrash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/CrashHamsterCrash.webp",
        alt: "Crash Hamster Crash",
        name: "Crash Hamster Crash",
        providerName: "WorldCasino",
      },
      GunmanCrash: {
        href: "/casino/qt-msg-gunmancrash",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/GunmanCrash.webp",
        alt: "Gunman crash",
        name: "Gunman crash",
        providerName: "WorldCasino",
      },
      DannyDollar: {
        href: "/casino/qt-hak-dannydollar",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/DannyDollar.webp",
        alt: "Danny Dollar",
        name: "Danny Dollar",
        providerName: "WorldCasino",
      },
      AcrossTheUniverse: {
        href: "/casino/qt-across-the-universe",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/AcrossTheUniverse.webp",
        alt: "Across the Universe",
        name: "Across the Universe",
        providerName: "WorldCasino",
      },
      Munchies: {
        href: "/casino/qt-munchies",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/Munchies.webp",
        alt: "Munchies",
        name: "Munchies",
        providerName: "WorldCasino",
      },
      OutsourcedSlashGame: {
        href: "/casino/qt-outsourced-slash-game",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "crashGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/crash-qt/OutsourcedSlashGame.webp",
        alt: "Outsourced: Slash Game",
        name: "Outsourced: Slash Game",
        providerName: "WorldCasino",
      },
    },
  },

  slots: {
    slots: {
      GoldenShisa: {
        href: "/casino/qt-golden-shisa",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/GoldenShisa.webp",
        alt: "Golden Shisa",
        name: "Golden Shisa",
        providerName: "WorldCasino",
      },
      CaptainGlumPirateHunter: {
        href: "/casino/ qt-captain-glum-pirate-hunter",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/CaptainGlumPirateHunter.webp",
        alt: "Captain Glum: Pirate Hunter",
        name: "Captain Glum: Pirate Hunter",
        providerName: "WorldCasino",
      },
      DevourtheWeak: {
        href: "/casino/qt-devour-the-weak",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/DevourtheWeak.webp",
        alt: "Devour the Weak",
        name: "Devour the Weak",
        providerName: "WorldCasino",
      },
      Disturbed: {
        href: "/casino/qt-disturbed",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Disturbed.webp",
        alt: "Disturbed",
        name: "Disturbed",
        providerName: "WorldCasino",
      },
      Luchamigos: {
        href: "/casino/qt-luchamigos",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Luchamigos.webp",
        alt: "Luchamigos",
        name: "Luchamigos",
        providerName: "WorldCasino",
      },
      NiceCatchDoublemax: {
        href: "/casino/qt-nice-catch-doublemax",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/NiceCatchDoublemax.webp",
        alt: "Nice Catch Doublemax",
        name: "Nice Catch Doublemax",
        providerName: "WorldCasino",
      },
      MayanStackways: {
        href: "/casino/qt-mayan-stackways",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/MayanStackways.webp",
        alt: "Mayan Stackways",
        name: "Mayan Stackways",
        providerName: "WorldCasino",
      },
      NaughtyWukong: {
        href: "/casino/qt-naughty-wukong",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/NaughtyWukong.webp",
        alt: "Naughty Wukong",
        name: "Naughty Wukong",
        providerName: "WorldCasino",
      },
      GerardsGambit: {
        href: "/casino/qt-gerards-gambit",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/GerardsGambit.webp",
        alt: "Gerard's Gambit",
        name: "Gerard's Gambit",
        providerName: "WorldCasino",
      },
      KissMyChainsaw: {
        href: "/casino/qt-kiss-my-chainsaw",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/KissMyChainsaw.webp",
        alt: "Kiss My Chainsaw",
        name: "Kiss My Chainsaw",
        providerName: "WorldCasino",
      },
      RoninsHonour: {
        href: "/casino/qt-ronins-honour",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/RoninsHonour.webp",
        alt: "Ronin's Honour",
        name: "Ronin's Honour",
        providerName: "WorldCasino",
      },
      HolyHandGrenade: {
        href: "/casino/qt-holy-hand-grenade",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/HolyHandGrenade.webp",
        alt: "Holy Hand Grenade",
        name: "Holy Hand Grenade",
        providerName: "WorldCasino",
      },
      VegasHotspots: {
        href: "/casino/qt-vegas-hotspots",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/VegasHotspots.webp",
        alt: "Vegas Hotspots",
        name: "Vegas Hotspots",
        providerName: "WorldCasino",
      },
      TheWildos: {
        href: "/casino/qt-the-wildos",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/TheWildos.webp",
        alt: "The Wildos",
        name: "The Wildos",
        providerName: "WorldCasino",
      },
      WildBandolier: {
        href: "/casino/qt-wild-bandolier",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/WildBandolier.webp",
        alt: "Wild Bandolier",
        name: "Wild Bandolier",
        providerName: "WorldCasino",
      },
      MoonPrincessTrinity: {
        href: "/casino/qt-moon-princess-trinity",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/MoonPrincessTrinity.webp",
        alt: "Moon Princess Trinity",
        name: "Moon Princess Trinity",
        providerName: "WorldCasino",
      },
      MagicPiggy: {
        href: "/casino/qt-magic-piggy",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/MagicPiggy.webp",
        alt: "Magic Piggy",
        name: "Magic Piggy",
        providerName: "WorldCasino",
      },
      FortuneLlama: {
        href: "/casino/qt-fortune-llama",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/FortuneLlama.webp",
        alt: "Fortune Llama",
        name: "Fortune Llama",
        providerName: "WorldCasino",
      },
      PandorasBoxofEvil: {
        href: "/casino/qt-pandoras-box-of-evil",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/PandorasBoxofEvil.webp",
        alt: "Pandora's Box of Evil",
        name: "Pandora's Box of Evil",
        providerName: "WorldCasino",
      },
      VolatileEgypt: {
        href: "/casino/qt-volatile-egypt",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/VolatileEgypt.webp",
        alt: "Volatile Egypt",
        name: "Volatile Egypt",
        providerName: "WorldCasino",
      },
      HighwayLegends: {
        href: "/casino/qt-highway-legends",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/HighwayLegends.webp",
        alt: "Highway Legends",
        name: "Highway Legends",
        providerName: "WorldCasino",
      },
      FreeReelinJoker1000: {
        href: "/casino/qt-free-reelin-joker-1000",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/FreeReelinJoker1000.webp",
        alt: "Free Reelin’ Joker 1000",
        name: "Free Reelin’ Joker 1000",
        providerName: "WorldCasino",
      },
      TempleofTorment: {
        href: "/casino/qt-temple-of-torment",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/TempleofTorment.webp",
        alt: "Temple of Torment",
        name: "Temple of Torment",
        providerName: "WorldCasino",
      },
      CashDefense: {
        href: "/casino/qt-cash-defense",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/CashDefense.webp",
        alt: "Cash Defense",
        name: "Cash Defense",
        providerName: "WorldCasino",
      },
      VikingRunecraftApocalypse: {
        href: "/casino/ qt-viking-runecraft-apocalypse",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/VikingRunecraftApocalypse.webp",
        alt: "Viking Runecraft: Apocalypse",
        name: "Viking Runecraft: Apocalypse",
        providerName: "WorldCasino",
      },
      Ternion: {
        href: "/casino/qt-ternion",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Ternion.webp",
        alt: "Ternion",
        name: "Ternion",
        providerName: "WorldCasino",
      },
      SwordofShoguns: {
        href: "/casino/qt-sword-of-shoguns",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/SwordofShoguns.webp",
        alt: "Sword of Shoguns",
        name: "Sword of Shoguns",
        providerName: "WorldCasino",
      },
      BeastBelow: {
        href: "/casino/qt-beast-below",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/BeastBelow.webp",
        alt: "Beast Below",
        name: "Beast Below",
        providerName: "WorldCasino",
      },
      Hamsta: {
        href: "/casino/qt-hamsta",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Hamsta.webp",
        alt: "Hamsta",
        name: "Hamsta",
        providerName: "WorldCasino",
      },
      Stairs: {
        href: "/casino/qt-stairs",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Stairs.webp",
        alt: "Stairs",
        name: "Stairs",
        providerName: "WorldCasino",
      },
      LimboRider: {
        href: "/casino/qt-limbo-rider",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/LimboRider.webp",
        alt: "Limbo Rider",
        name: "Limbo Rider",
        providerName: "WorldCasino",
      },
      SavethePrincess: {
        href: "/casino/qt-save-the-princess",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/SavethePrincess.webp",
        alt: "Save the Princess",
        name: "Save the Princess",
        providerName: "WorldCasino",
      },
      Fruittowers: {
        href: "/casino/qt-fruit-towers",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Fruittowers.webp",
        alt: "Fruit towers",
        name: "Fruit towers",
        providerName: "WorldCasino",
      },
      DoubleRoll: {
        href: "/casino/qt-double-roll",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/DoubleRoll.webp",
        alt: "Double Roll",
        name: "Double Roll",
        providerName: "WorldCasino",
      },
      ProspectorWilds: {
        href: "/casino/qt-prospector-wilds",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/ProspectorWilds.webp",
        alt: "Prospector Wilds",
        name: "Prospector Wilds",
        providerName: "WorldCasino",
      },
      MagicKeno: {
        href: "/casino/qt-magic-keno",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/MagicKeno.webp",
        alt: "Magic Keno",
        name: "Magic Keno",
        providerName: "WorldCasino",
      },
      BornWild: {
        href: "/casino/qt-born-wild",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/BornWild.webp",
        alt: "Born Wild",
        name: "Born Wild",
        providerName: "WorldCasino",
      },
      TigerTiger: {
        href: "/casino/qt-tiger-tiger",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/TigerTiger.webp",
        alt: "Tiger Tiger",
        name: "Tiger Tiger",
        providerName: "WorldCasino",
      },
      HugoLegacy: {
        href: "/casino/qt-hugo-legacy",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/HugoLegacy.webp",
        alt: "Hugo Legacy",
        name: "Hugo Legacy",
        providerName: "WorldCasino",
      },
      BeastMode: {
        href: "/casino/qt-beast-mode",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/BeastMode.webp",
        alt: "Beast Mode",
        name: "Beast Mode",
        providerName: "WorldCasino",
      },
      DeadRidersTrail: {
        href: "/casino/qt-dead-riders-trail",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/DeadRidersTrail.webp",
        alt: "Dead Riders Trail",
        name: "Dead Riders Trail",
        providerName: "WorldCasino",
      },
      IronBank: {
        href: "/casino/qt-iron-bank",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/IronBank.webp",
        alt: "Iron Bank",
        name: "Iron Bank",
        providerName: "WorldCasino",
      },
      xWaysHoarderxSplit: {
        href: "/casino/qt-xways-hoarder-xsplit",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/xWaysHoarderxSplit.webp",
        alt: "xWays Hoarder xSplit",
        name: "xWays Hoarder xSplit",
        providerName: "WorldCasino",
      },
      FireInTheHolexBomb: {
        href: "/casino/qt-fire-in-the-hole-xbomb",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/FireInTheHolexBomb.webp",
        alt: "Fire In The Hole xBomb",
        name: "Fire In The Hole xBomb",
        providerName: "WorldCasino",
      },
      TheGreatPigsbyMegaways: {
        href: "/casino/qt-the-great-pigsby-megaways",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/TheGreatPigsbyMegaways.webp",
        alt: "The Great Pigsby Megaways",
        name: "The Great Pigsby Megaways",
        providerName: "WorldCasino",
      },
      BananaTown: {
        href: "/casino/qt-banana-town",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/BananaTown.webp",
        alt: "Banana Town",
        name: "Banana Town",
        providerName: "WorldCasino",
      },
      ClusterTumble: {
        href: "/casino/qt-cluster-tumble",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/ClusterTumble.webp",
        alt: "Cluster Tumble",
        name: "Cluster Tumble",
        providerName: "WorldCasino",
      },
      JurassicParty: {
        href: "/casino/qt-jurassic-party",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/JurassicParty.webp",
        alt: "Jurassic Party",
        name: "Jurassic Party",
        providerName: "WorldCasino",
      },
      SnakeArena: {
        href: "/casino/qt-snake-arena",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/SnakeArena.webp",
        alt: "Snake Arena",
        name: "Snake Arena",
        providerName: "WorldCasino",
      },
      Rotten: {
        href: "/casino/qt-rotten",
        code: "",
        casino: "Qtech",
        provider: "WorldCasino",
        category: "slots",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/casino/slots-qt/Rotten.webp",
        alt: "Rotten",
        name: "Rotten",
        providerName: "WorldCasino",
      },
    },
  },

  trendingGames: {
    trendingGames: {
      // ColorPrediction: {
      //   name: "Color Prediction",
      //   href: "/casino/aggapjiligaming-color-prediction",
      //   code: "",
      //   casino: "",
      //   provider: "Jili Gaming",
      //   homeUrl: "",
      //   providerName: "Jili",
      //   imgUrl: "./images/Vivo/ColorPrediction.jpg",
      //   alt: "Color Prediction",
      // },
     
      XXXtremeLightningRoulette: {
        name: "XXXtreme Lightning Roulette",
        href: "/casino/ezgevo-xxxtreme-lightning-roulette",
        code: "mines",
        casino: "spribe",
        provider: "",
        homeUrl: "",
        providerName: "Evolution",
        imgUrl: "./images/trending/xxxtremelightningroulette-new.webp",
        alt: "",
      },
    
      DragonTiger: {
        name: "Dragon Tiger",
        href: "/casino/ezg-dragon-tiger",
        code: "goal",
        casino: "spribe",
        provider: "",
        homeUrl: "",
        providerName: "Ezugi",
        imgUrl: "./images/trending/DragonTiger-new.webp",
        alt: "",
      },
     
      LightningRoulette: {
        name: "Lightning Roulette",
        href: "/casino/ezgevo-lightning-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        providerName: "Evolution",
        imgUrl: "./images/trending/LightningRoulette.webp",
        alt: "",
      },
      Poker: {
        name: "Poker",
        href: "/casino/aura-poker",
        code: "aviator",
        casino: "spribe",
        provider: "",
        homeUrl: "",
        providerName: "Aura",
        imgUrl: "./images/trending/Poker-Aura.webp",
        alt: "",
      },
      
      TeenpattiT20: {
        name: "Teenpatti T20",
        href: "/casino/aura-teenpatti-t20",
        code: "mini-roulette",
        casino: "spribe",
        provider: "",
        homeUrl: "",
        providerName: "Aura",
        imgUrl: "./images/aura/Teenpattit20-new.webp",
        alt: "",
      },
      aviator: {
        href: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Aviator-new.webp",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      // JetXTrd: {
      //   href: "/casino/aggapsmartsoftgaming-jetx",
      //   code: "",
      //   casino: "SmartSoft",
      //   provider: "Qtech",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/casino/smartsoft/JetXOld.webp",
      //   alt: "JetX",
      //   name: "JetX",
      //   providerName: "SmartSoft",
      // },
    },
  },

  newLaunchedGames: {
    newLaunchedGames: {
      aviator: {
        href: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/Aviator-new.webp",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      miniroulette: {
        href: "/casino/spribe/miniroulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "mini-roulette",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/spribe/MiniRoulette-new.webp",
        alt: "",
        name: "Mini Roulette",
        providerName: "Spribe",
      },
      // RockPaperScissors: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Rock Paper Scissors",
      //   name: "Rock Paper Scissors",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl:
      //     "./images/alt-gaming/chicken-games/trending/rockpaperscissorsOld.jpg",
      //   href: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
      // },
      // Pushpa: {
      //   href: "/casino/aggapcrash88gaming-pushpa",
      //   code: "aviator",
      //   casino: "spribe",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/PushpaRani.webp",
      //   alt: "",
      //   name: "Pushpa",
      //   providerName: "ALT_GAMING_GAP",
      // },
      // Vortex: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Vortex",
      //   name: "Vortex",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/vortex.webp",
      //   href: "/casino/aggapmac88gamingvirtual-vortex",
      // },
      // Limbo: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Limbo",
      //   name: "Limbo",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/Limbo.webp",
      //   href: "/casino/aggapmac88gamingvirtual-limbo",
      // },
      // Plinko: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Plinko",
      //   name: "Plinko",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/Plinko.webp",
      //   href: "/casino/aggapmac88gamingvirtual-plinko",
      // },
      // Dice: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Dice",
      //   name: "Dice",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/Dice.webp",
      //   href: "/casino/aggapmac88gamingvirtual-dice",
      // },
      // diamonds: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Diamond",
      //   name: "Diamond",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/Diamonds.webp",
      //   href: "/casino/aggapmac88gamingvirtual-diamonds",
      // },
      // mines: {
      //   code: "",
      //   casino: "Mac88",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Mines",
      //   name: "Mines",
      //   providerName: "Mac88 Gaming Virtual",
      //   imgUrl: "./images/alt-gaming/mac88/Mines.webp",
      //   href: "/casino/aggapmac88gamingvirtual-mines",
      // },
      // DragonTiger: {
      //   code: "",
      //   casino: "Jili",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Dragon & Tiger",
      //   name: "Dragon & Tiger",
      //   providerName: "Jili Gaming",
      //   imgUrl: "./images/alt-gaming/jili-game/Dragontiger-new.webp",
      //   href: "/casino/aggapjiligaming-dragon-and-tiger",
      // },
      // ColorPrediction: {
      //   name: "Color Prediction",
      //   href: "/casino/aggapjiligaming-color-prediction",
      //   code: "",
      //   casino: "",
      //   provider: "Jili Gaming",
      //   homeUrl: "",
      //   providerName: "Jili",
      //   imgUrl:
      //     "./images/alt-gaming/chicken-games/trending/ColorPredictionOld.jpg",
      //   alt: "Color Prediction",
      // },
      // LuckyChicken: {
      //   code: "",
      //   casino: "Jacktop",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Lucky Chicken",
      //   name: "Lucky Chicken",
      //   providerName: "Jacktop Gaming",
      //   imgUrl: "./images/alt-gaming/chicken-games/LuckeyChicken-new.webp",
      //   href: "/casino/aggapjacktopgaming-lucky-chicken-crossing",
      // },
      // ChickenRoad: {
      //   code: "",
      //   casino: "InOut",
      //   provider: "WorldCasino",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Chicken Road",
      //   name: "Chicken Road",
      //   providerName: "inOut Crash",
      //   imgUrl: "./images/alt-gaming/chicken-games/ChickenRoad-new.webp",
      //   href: "/casino/io-chicken-road",
      // },
      EZMarbleRaceMonaco: {
        code: "",
        casino: "Ezugi",
        provider: "Ezugi",
        homeUrl: "http://localhost:3000/Casino",
        alt: "EZ Marble Race Monaco",
        name: "EZ Marble Race Monaco",
        providerName: "Ezugi",
        imgUrl: "./images/popular/ezmarbleracemonaco-new.webp",
        href: "/casino/ezg-ez-marble-race-monaco",
      },
      // BetWithStreamers: {
      //   code: "",
      //   casino: "Ezugi",
      //   provider: "Ezugi",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "Bet With Streamers",
      //   name: "Bet With Streamers",
      //   providerName: "Ezugi",
      //   imgUrl: "./images/popular/betwithstreamers-new.webp",
      //   href: "/casino/ezg-bet-with-streamers",
      // },
    },
  },

  winzeeGames: {
    winzeeGames: {
      // CrazyTime: {
      //   href: "/casino/aggapevolutiongaming-crazy-time",
      //   code: "1000148",
      //   casino: "ezugi",
      //   provider: "Evolution",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/top-games/CrazyTime.jpg",
      //   alt: "Crazy Time",
      //   name: "Crazy Time",
      //   providerName: "Evolution",
      // },
      // SuperAndarbahar: {
      //   code: "98789",
      //   casino: "ezugi",
      //   provider: "Evolution",
      //   homeUrl: "http://localhost:3000/Casino",
      //   alt: "super Andar bahar",
      //   name: "Super Andar Bahar",
      //   providerName: "Evolution",
      //   imgUrl: "./images/top-games/SuperAndarBaharOld.jpg",
      //   href: "/casino/aggapevolutiongaming-super-andar-bahar",
      // },
      aviator: {
        href: "/casino/spribe/aviator",
        code: "aviator",
        casino: "spribe",
        provider: "aviator",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/Aviator-new.webp",
        alt: "",
        name: "Aviator",
        providerName: "Spribe",
      },
      AndarBahar: {
        href: "/casino/ezg-andar-bahar",
        code: "328000",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/AndarBahar-new.webp",
        alt: "",
        name: "Andar Bahar",
        providerName: "Ezugi",
      },
      // CrazyTime2: {
      //   href: "/casino/aggapevolutiongaming-crazy-time-2",
      //   code: "",
      //   casino: "ALT_GAMING_GAP",
      //   provider: "Evolution Gaming",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/top-games/CrazyTime2-new.webp",
      //   alt: "",
      //   name: "Crazy Time 2",
      //   providerName: "Evolution Gaming",
      // },
     
      NamasteRoulette: {
        href: "/casino/ezg-namaste-roulette",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/NamasteRoulette-new.webp",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      Onedayteenpatti1: {
        href: "/casino/ezg-one-day-teen-patti",
        code: "227103",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/OnedayteenpattiOld.jpg",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
      UltimateAndarBahar: {
        href: "/casino/ezg-ultimate-andar-bahar",
        code: "328000",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/UltimateAndarBaharOld.jpg",
        alt: "",
        name: "Ultimate Andar Bahar",
        providerName: "Ezugi",
      },
      ImmersiveRoulette: {
        href: "/casino/ezgevo-immersive-roulette",
        code: "",
        casino: "Evolution",
        provider: "Ezugi",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/immersiveroulette-new.webp",
        alt: "",
        name: "Immersive Roulette",
        providerName: "Evolution",
      },
      XXXtremeLightningRoulette: {
        href: "/casino/ezgevo-xxxtreme-lightning-roulette",
        code: "",
        casino: "Evolution",
        provider: "Ezugi",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/xxxtremelightningroulette-new.webp",
        alt: "",
        name: "XXXtreme Lightning Roulette",
        providerName: "Evolution",
      },
      // LightningSicBo: {
      //   href: "/casino/aggapevolutiongaming-lightning-sic-bo",
      //   code: "",
      //   casino: "Evolution",
      //   provider: "Ezugi",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/top-games/LightningSicBoOld.jpg",
      //   alt: "",
      //   name: "Lightning Sic Bo",
      //   providerName: "Evolution",
      // },
      GoldVaultRoulette: {
        href: "/casino/ezgevo-gold-vault-roulette",
        code: "",
        casino: "Evolution",
        provider: "Ezugi",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/GoldVoltRoulette-new.webp",
        alt: "",
        name: "Gold Vault Roulette",
        providerName: "Evolution",
      },
      FunkyTime: {
        href: "/casino/ezgevo-funky-time",
        code: "",
        casino: "Evolution",
        provider: "Ezugi",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/Funkytime-new.webp",
        alt: "",
        name: "Funky Time",
        providerName: "Evolution",
      },
      SpeedAutoRoulette: {
        href: "/casino/ezgevo-speed-auto-roulette",
        code: "",
        casino: "Evolution",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/top-games/SpeedAutoRoulette-new.webp",
        alt: "",
        name: "Speed Auto Roulette",
        providerName: "Ezugi",
      },

      // goal: {
      //   href: "/casino/spribe/goal",
      //   code: "goal",
      //   casino: "spribe",
      //   provider: "goal",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/InstantGame/Goal.webp",
      //   alt: "",
      //   name: "Goal",
      //   providerName: "Spribe",
      // },
      // dice: {
      //   href: "/casino/spribe/dice",
      //   code: "dice",
      //   casino: "spribe",
      //   provider: "dice",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/InstantGame/Dice.webp",
      //   alt: "",
      //   name: "Dice",
      //   providerName: "Spribe",
      // },
      // plinko: {
      //   href: "/casino/spribe/plinko",
      //   code: "plinko",
      //   casino: "spribe",
      //   provider: "plinko",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/InstantGame/plinko.webp",
      //   alt: "",
      //   name: "Plinko",
      //   providerName: "Spribe",
      // },
      // hilo: {
      //   href: "/casino/spribe/hilo",
      //   code: "hi-lo",
      //   casino: "spribe",
      //   provider: "hi-lo",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/InstantGame/hilo.webp",
      //   alt: "",
      //   name: "Hilo",
      //   providerName: "Spribe",
      // },
      // keno: {
      //   href: "/casino/spribe/keno",
      //   code: "keno",
      //   casino: "spribe",
      //   provider: "keno",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/alt-gaming/InstantGame/Keno.webp",
      //   alt: "keno",
      //   name: "Keno",
      //   providerName: "Spribe",
      // },
      GodOfWealth: {
        href: "/casino/ezgrt-god-of-wealth",
        code: "",
        casino: "ezugi",
        imgUrl: "./images/slots/new/redtiger/GodOfwealth-new.webp",
        homeUrl: "http://localhost:3000/Casino",
        name: "God Of Wealth",
        providerName: "slots",
      },
      ChineseTreasures: {
        href: "/casino/ezgrt-chinese-treasures",
        code: "",
        casino: "ezugi",
        imgUrl: "./images/slots/new/redtiger/chinesetreasure-new.webp",
        homeUrl: "http://localhost:3000/Casino",
        name: "Chinese Treasures",
        providerName: "slots",
      },
      Hand2CasinoHoldem: {
        href: "/casino/ezgevo-2-hand-casino-holdem",
        code: "1000073",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/poker/2HandCasinoHoldem-new.webp",
        alt: "",
        name: " 2 Hand Casino Holdem",
        providerName: "Evolution",
      },
      BetonTeenPatti: {
        href: "/casino/ezg-bet-on-teen-patti",
        code: "227101",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/poker/BetOnTeenPatti-new.webp",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      TeenPatti3card: {
        href: "/casino/ezg-teen-patti-3-card",
        code: "227100",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/poker/TeenPatti3Card-new.webp",
        alt: "",
        name: " Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      BlackjackVIPL: {
        href: "/casino/ezgevo-blackjack-vip-l",
        code: "1000056",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/blackjack/BlackjackVIPL-new.webp",
        alt: "",
        name: "Blackjack VIP L",
        providerName: "Evolution",
      },
      ClassicSpeedBlackjack3: {
        href: "/casino/ezgevo-classic-speed-blackjack-3",
        code: "1000228",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/blackjack/ClassicSpeedBlackjack3-new.webp",
        alt: "",
        name: " Classic Speed Blackjack 3  ",
        providerName: "Evolution",
      },
      OTTAndarBahar: {
        href: "/casino/ezg-casino-marina-andar-bahar",
        code: "328000",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/andarbahar/OTTAndarBahar-new.webp",
        alt: "",
        name: "OTT Andar Bahar",
        providerName: "Ezugi",
      },
      DragonTiger: {
        href: "/casino/ezg-dragon-tiger",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/popular/DragonTiger-new.webp",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
     
      DarkKing: {
        href: "/casino/ezgne-dark-king-forbidden-riches",
        code: "1100081",
        casino: "ezugi",
        imgUrl: "./images/popular/darkkingforbiddenriches.jpg",
        homeUrl: "http://localhost:3000/Casino",
        name: "Dark King: Forbidden Riches",
        providerName: "slots",
      },
      Autoroulette: {
        code: "56768",
        casino: "ezugi",
        provider: "Evolution",
        homeUrl: "http://localhost:3000/Casino",
        alt: "Auto Roulette",
        name: "Auto Roulette",
        providerName: "Evolution",
        imgUrl: "./images/popular/AutoROulette.jpg",
        href: "/casino/ezg-auto-roulette",
      },
      JingleSpin: {
        href: "/casino/ezgne-jingle-spin",
        code: "1100082",
        casino: "ezugi",
        imgUrl: "./images/popular/jinglespin.jpg",
        homeUrl: "http://localhost:3000/Casino",
        name: "Jingle Spin",
        providerName: "slots",
      },
      JackHammer: {
        href: "/casino/ezgne-jack-hammer",
        code: "1100084",
        casino: "ezugi",
        imgUrl: "./images/popular/Jackhammer.jpg",
        homeUrl: "http://localhost:3000/Casino",
        name: "Jack Hammer",
        providerName: "slots",
      },
    },
  },

  // jacktopGames: {
  //   jacktopGames: {
  //     ChickenRoadRace: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Road Race",
  //       name: "Chicken Road Race",
  //       providerName: "inOut FastGames",
  //       imgUrl: "../images/alt-gaming/chicken-games/ChickenRoadRace-new.webp",
  //       href: "/casino/io-chicken-road-race",
  //     },
  //     ChickenRoadVegas: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Road Vegas",
  //       name: "Chicken Road Vegas",
  //       providerName: "inOut Crash",
  //       imgUrl: "../images/alt-gaming/chicken-games/ChickenRoadVegas-new.webp",
  //       href: "/casino/io-chicken-road-vegas",
  //     },
  //     ChickenRoadGold: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Road Gold",
  //       name: "Chicken Road Gold",
  //       providerName: "inOut Crash",
  //       imgUrl: "../images/alt-gaming/chicken-games/CrickenRoadGold-new.webp",
  //       href: "/casino/io-chicken-road-gold",
  //     },
  //     ChickenRoyal: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Royal",
  //       name: "Chicken Royal",
  //       providerName: "inOut Crash",
  //       imgUrl: "../images/alt-gaming/chicken-games/ChickenRoyal-new.webp",
  //       href: "/casino/io-chicken-royal",
  //     },
  //     ChickenRoad2: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Road 2",
  //       name: "Chicken Road 2",
  //       providerName: "inOut Crash",
  //       imgUrl: "../images/alt-gaming/chicken-games/ChickenRoad2-new.webp",
  //       href: "/casino/io-chicken-road-2",
  //     },
  //     ChickenRoad: {
  //       code: "",
  //       casino: "InOut",
  //       provider: "WorldCasino",
  //       homeUrl: "http://localhost:3000/Casino",
  //       alt: "Chicken Road",
  //       name: "Chicken Road",
  //       providerName: "inOut Crash",
  //       imgUrl: "../images/alt-gaming/chicken-games/ChickenRoad-new.webp",
  //       href: "/casino/io-chicken-road",
  //     },
  //     // LuckyChicken: {
  //     //   code: "",
  //     //   casino: "Jacktop",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   alt: "Lucky Chicken",
  //     //   name: "Lucky Chicken",
  //     //   providerName: "Jacktop Gaming",
  //     //   imgUrl: "../images/alt-gaming/chicken-games/LuckeyChicken-new.webp",
  //     //   href: "/casino/aggapjacktopgaming-lucky-chicken-crossing",
  //     // },
  //     // CrossfireChicken: {
  //     //   code: "",
  //     //   casino: "Jacktop",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   alt: "Crossfire Chicken",
  //     //   name: "Crossfire Chicken",
  //     //   providerName: "Jacktop Gaming",
  //     //   imgUrl: "../images/alt-gaming/chicken-games/CrossfireChicken-new.webp",
  //     //   href: "/casino/aggapjacktopgaming-crossfire-chicken",
  //     // },
  //     // ChickenChase: {
  //     //   code: "",
  //     //   casino: "Jacktop",
  //     //   provider: "ALT_GAMING_GAP",
  //     //   homeUrl: "http://localhost:3000/Casino",
  //     //   alt: "chicken Chase",
  //     //   name: "chicken Chase",
  //     //   providerName: "Jacktop Gaming",
  //     //   imgUrl: "../images/alt-gaming/chicken-games/ChickenChase-new.webp",
  //     //   href: "/casino/aggapjacktopgaming-crossfire-chicken",
  //     // },
  //   },
  // },

  aviatorGames: {
    aviatorGames: {
      AviatorPG: {
        href: "/casino/pg-aviator",
        code: "",
        casino: "Power Games",
        provider: "Power Games",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/Aviator-PG.webp",
        alt: "Aviator pg",
        name: "Aviator pg",
      },
      AviatorSP: {
        href: "/casino/spribe-aviator",
        code: "",
        casino: "Spribe",
        provider: "Spribe",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/Aviator-Spribe.webp",
        alt: "Aviator spribe",
        name: "Aviator spribe",
      },
      // AviatorQT: {
      //   href: "/casino/qt-aviator",
      //   code: "",
      //   casino: "Qtech",
      //   provider: "WorldCasino",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/Aviator-Qtech.webp",
      //   alt: "Aviator qtech",
      //   name: "Aviator qtech",
      // },
      AviatorAura: {
        href: "/casino/aura-aviator",
        code: "",
        casino: "Aura Gaming",
        provider: "AURA",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/Aviator-Aura.webp",
        alt: "Aviator aura",
        name: "Aviator aura",
      },
      EliteAviatorClubKM: {
        href: "/casino/km-elite-aviator-club",
        code: "",
        casino: "Kingmaker",
        provider: "KINGMAKER",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/EliteAviatorClubKM.webp",
        alt: "Elite Aviator Club km",
        name: "Elite Aviator Club km",
      },
      CosmoRushAviator: {
        href: "/casino/albertcosmo-cosmo-rush",
        code: "",
        casino: "Cosmo - ALBERT",
        provider: "ALBERT_CASINO",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/CosmoRushAviator.webp",
        alt: "cosmo rush aviator",
        name: "cosmo rush aviator",
      },
      // AviatorxMac88: {
      //   href: "/casino/mac88-aviatorx",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "MAC88",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/AviatorxMac88.webp",
      //   alt: "AVIATORX mac88",
      //   name: "AVIATORX mac88",
      // },
      // AviatorX2Mac88: {
      //   href: "/casino/mac88-aviator-x2",
      //   code: "",
      //   casino: "Mac88",
      //   provider: "MAC88",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/AviatorX2Mac88.webp",
      //   alt: "Aviator X2 mac88",
      //   name: "Aviator X2 mac88",
      // },

      EliteAviatorClubAltMidas: {
        href: "/casino/km-elite-aviator-club",
        code: "",
        casino: "Kingmidas Gaming",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/aviator-games/EliteAviatorClubAltMidas.webp",
        alt: "Elite Aviator Club kingmidas",
        name: "Elite Aviator Club kingmidas",
      },
      // AVIATORXCRASH88: {
      //   href: "/casino/aggapcrash88gaming-aviatorx",
      //   code: "",
      //   casino: "CRASH88 Gaming",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/AVIATORXCRASH88.webp",
      //   alt: "AVIATORX crash88",
      //   name: "AVIATORX crash88",
      // },
      // AviatorXMac88VR: {
      //   href: "/casino/aggapmac88gamingvirtual-aviator-x",
      //   code: "",
      //   casino: "Mac88 Gaming Virtual",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/AviatorXMac88VR.webp",
      //   alt: "Aviator X mac88 vr",
      //   name: "Aviator X mac88 vr",
      // },
      // PushpaRani: {
      //   href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
      //   code: "",
      //   gameType: "crash",
      //   casino: "Mac88 Gaming Virtual",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/PushpaRani.webp",
      //   alt: "Pushpa Rani",
      //   name: "Pushpa Rani",
      // },
      // AviatorX2Mac88VR: {
      //   href: "/casino/aggapmac88gamingvirtual-aviatorx2",
      //   code: "",
      //   casino: "Mac88 Gaming Virtual",
      //   provider: "ALT_GAMING_GAP",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/aviator-games/AviatorX2Mac88VR.webp",
      //   alt: "AviatorX2 mac88 vr",
      //   name: "AviatorX2 mac88 vr",
      // },
    },
  },
};
